// This API schema was generated automatically by TypescriptSchemaGenerator
type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never }
// @ts-ignore XOR may not be used in this file, so suppress error on next line
type XOR<T, U> = T | U extends object ? (Without<T, U> & U) | (Without<U, T> & T) : T | U
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum StandaloneFacebookInstagramTargetingPackSerializerFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum StandaloneFacebookInstagramTargetingPackSerializerFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceDuplicateSerializerFacebook_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceDuplicateSerializerFacebook_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceDuplicateSerializerInstagram_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceDuplicateSerializerInstagram_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
/**
 * 1 = HIGH_SCHOOL
 * 2 = UNDERGRAD
 * 3 = ALUM
 * 4 = HIGH_SCHOOL_GRAD
 * 5 = SOME_COLLEGE
 * 6 = ASSOCIATE_DEGREE
 * 7 = IN_GRAD_SCHOOL
 * 8 = SOME_GRAD_SCHOOL
 * 9 = MASTER_DEGREE
 * 10 = PROFESSIONAL_DEGREE
 * 11 = DOCTORATE_DEGREE
 * 12 = UNSPECIFIED
 * 13 = SOME_HIGH_SCHOOL
 */
export enum BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specEducation_statusesId {
    /** HIGH_SCHOOL */ HIGH_SCHOOL = 1,
    /** UNDERGRAD */ UNDERGRAD = 2,
    /** ALUM */ ALUM = 3,
    /** HIGH_SCHOOL_GRAD */ HIGH_SCHOOL_GRAD = 4,
    /** SOME_COLLEGE */ SOME_COLLEGE = 5,
    /** ASSOCIATE_DEGREE */ ASSOCIATE_DEGREE = 6,
    /** IN_GRAD_SCHOOL */ IN_GRAD_SCHOOL = 7,
    /** SOME_GRAD_SCHOOL */ SOME_GRAD_SCHOOL = 8,
    /** MASTER_DEGREE */ MASTER_DEGREE = 9,
    /** PROFESSIONAL_DEGREE */ PROFESSIONAL_DEGREE = 10,
    /** DOCTORATE_DEGREE */ DOCTORATE_DEGREE = 11,
    /** UNSPECIFIED */ UNSPECIFIED = 12,
    /** SOME_HIGH_SCHOOL */ SOME_HIGH_SCHOOL = 13,
}
/**
 * 1 = SINGLE
 * 2 = IN_RELATIONSHIP
 * 3 = MARRIED
 * 4 = ENGAGED
 * 6 = NOT_SPECIFIED
 */
export enum BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specRelationship_statusesId {
    /** SINGLE */ SINGLE = 1,
    /** IN_RELATIONSHIP */ IN_RELATIONSHIP = 2,
    /** MARRIED */ MARRIED = 3,
    /** ENGAGED */ ENGAGED = 4,
    /** NOT_SPECIFIED */ NOT_SPECIFIED = 6,
}
export type AccountApps = {
  app_store_identifier: string
  app_id: string
  os_type: 'iOS'|'Android'
}
export type PollCard = {
  account_id: string
  name: string
  card_type: string
  card_uri: string
  duration_in_minutes: number
  first_choice: string
  second_choice: string
  third_choice: string|null
  fourth_choice: string|null
  media_key: string|null
}
export type Card = {
  account_id: string
  name: string
  card_type: string
  card_uri: string
}
export type Tweet = {
  id_str: string
  account_id: string
  text: string|null
  name: string|null
  nullcast: boolean
  media_keys: string[]|null
  card_uri: string|null
  poll_card: PollCard|null
  card: Card|null
  created_at: string
}
export type ObjectStorySpec = {
  instagram_actor_id: string|null
  page_id: string
}
export type FbCreative = {
  id: string
  account_id: string
  name: string
  title: string|null
  body: string|null
  effective_object_story_id: string|null
  call_to_action_type: 'OPEN_LINK'|'LIKE_PAGE'|'SHOP_NOW'|'PLAY_GAME'|'INSTALL_APP'|'USE_APP'|'CALL'|'CALL_ME'|'VIDEO_CALL'|'INSTALL_MOBILE_APP'|'USE_MOBILE_APP'|'MOBILE_DOWNLOAD'|'BOOK_TRAVEL'|'LISTEN_MUSIC'|'WATCH_VIDEO'|'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'WATCH_MORE'|'NO_BUTTON'|'VISIT_PAGES_FEED'|'CALL_NOW'|'APPLY_NOW'|'CONTACT'|'BUY_NOW'|'GET_OFFER'|'GET_OFFER_VIEW'|'BUY_TICKETS'|'UPDATE_APP'|'GET_DIRECTIONS'|'BUY'|'MESSAGE_PAGE'|'DONATE'|'SUBSCRIBE'|'SAY_THANKS'|'SELL_NOW'|'SHARE'|'DONATE_NOW'|'GET_QUOTE'|'CONTACT_US'|'ORDER_NOW'|'START_ORDER'|'ADD_TO_CART'|'VIDEO_ANNOTATION'|'MOMENTS'|'RECORD_NOW'|'REFER_FRIENDS'|'REQUEST_TIME'|'GET_SHOWTIMES'|'LISTEN_NOW'|'WOODHENGE_SUPPORT'|'SOTTO_SUBSCRIBE'|'FOLLOW_USER'|'EVENT_RSVP'|'WHATSAPP_MESSAGE'|'FOLLOW_NEWS_STORYLINE'|'SEE_MORE'|'FIND_A_GROUP'|'FIND_YOUR_GROUPS'|'PAY_TO_ACCESS'|'PURCHASE_GIFT_CARDS'|'FOLLOW_PAGE'|'SEND_A_GIFT'|'SWIPE_UP_SHOP'|'SWIPE_UP_PRODUCT'|'SEND_GIFT_MONEY'|'PLAY_GAME_ON_FACEBOOK'|null
  object_type: 'APPLICATION'|'DOMAIN'|'EVENT'|'OFFER'|'PAGE'|'PHOTO'|'SHARE'|'STATUS'|'STORE_ITEM'|'VIDEO'|'INVALID'|'PRIVACY_CHECK_FAIL'|'POST_DELETED'
  actor_id: string
  effective_instagram_story_id: string|null
  instagram_actor_id: string|null
  status: 'ACTIVE'|'IN_PROCESS'|'WITH_ISSUES'|'DELETED'
  video_id: string|null
  object_id: string|null
  link_url: string|null
  object_url: string|null
  object_story_spec: ObjectStorySpec|null
}
export type AdCreative = {
  network: 'twitter'|'facebook'
  account_id: string
  preview_result: string|null
  name: string
  creative_id: string
  created: string|null
  tweet: Tweet|null
  fb_creative: FbCreative|null
}
export type PollCardInput = {
  name: string
  duration_in_minutes: number
  first_choice: string
  second_choice: string
  third_choice: string|null
  fourth_choice: string|null
  media_key: string|null
}
export type DestinationInput = {
  type: 'WEBSITE'
  url: string
}
export type ComponentInput = {
  type: 'MEDIA'|'DETAILS'|'SWIPEABLE_MEDIA'
  media_key?: string|null
  media_keys?: string[]|null
  title?: string|null
  destination?: DestinationInput|null
}
export type CardInput = {
  name: string
  components: ComponentInput[]
}
export type TweetInput = {
  text: string|null
  name: string|null
  nullcast?: boolean
  media_keys?: string[]|null
  card_uri?: string|null
  poll_card: PollCardInput|null
  card: CardInput|null
}
export type AdCreativeInput = {
  network: 'twitter'|'facebook'
  objective: string
  account_id: string
  ad_account: string
  preview_only: boolean
  tweet: TweetInput|null
}
export type _TwitterImage = {
  media_key: string
  created_at: string
  updated_at: string
  media_status: string
  media_type: 'IMAGE'|'VIDEO'
  media_url: string
  tweeted: 'true'|null
  file_name: string|null
  name: string|null
}
export type _TwitterVideo = {
  media_key: string
  created_at: string
  updated_at: string
  media_status: string
  media_type: 'IMAGE'|'VIDEO'
  media_url: string
  aspect_ratio: string
  duration: number|null
  poster_media_url: string|null
  poster_media_key: string|null
  file_name: string|null
}
export type _FacebookImage = {
  id: string
  permalink_url: string
  created_time: string
  updated_time: string
  name: string
  hash: string
  width: number
  height: number
  status: string
}
export type _FacebookPhase = {
  status: string
}
export type _FacebookPublishingPhase = {
  status: string
  publish_status: string
  publish_time: string
}
export type _FacebookVideoStatus = {
  video_status: string
  uploading_phase: _FacebookPhase
  processing_phase: _FacebookPhase
  publishing_phase: _FacebookPublishingPhase
}
export type _FacebookVideo = {
  id: string
  permalink_url: string
  created_time: string
  updated_time: string
  length: number
  title: string|null
  source: string
  published: boolean
  is_instagram_eligible: boolean
  status: _FacebookVideoStatus
}
export type AdMedia = {
  network: 'twitter'|'facebook'
  account_id: string
  name: string
  media_type: 'image'|'video'
  twitter_image: _TwitterImage|null
  twitter_video: _TwitterVideo|null
  facebook_image: _FacebookImage|null
  facebook_video: _FacebookVideo|null
  id: string
  sdb_id: string
  modified: string
  status: string
  thumbnail_url: string
  video_url: string|null
}
export type AdMediaInput = {
  account_id: string
  name: string
  filename: string
  file: any
  media_type: 'image'|'video'
}
export type GetAdSetListQuery = {
  limit?: number
  offset?: number
}
export type CumulativeStats = {
  refdate: string|null
  network: 'facebook'|'twitter'|'linkedin'
  is_latest: boolean
  impressions: number
  engagements: number
  engagement_rate: number|null
  cost_per_engagement: number|null
  social_spend: number|null
  clicks: number
  click_through_rate: number|null
  spent: number|null
  billed_charge_local_micro: number
  reach: number
  call_to_action_clicks: number
  canvas_avg_view_percent: number|null
  canvas_avg_view_time: number|null
  canvas_component_avg_pct_view: number|null
  cost_per_10_sec_video_view: number|null
  cost_per_action_type: number|null
  cost_per_estimated_ad_recallers: number|null
  cost_per_inline_link_click: number|null
  cost_per_inline_post_engagement: number|null
  cost_per_total_action: number|null
  cost_per_unique_action_type: number|null
  cost_per_unique_click: number|null
  cost_per_unique_inline_link_click: number|null
  cpc_fb: number|null
  cpm_fb: number|null
  cpm: number|null
  cpp: number|null
  ctr: number|null
  deeplink_clicks: number
  estimated_ad_recall_rate: number|null
  estimated_ad_recallers: number
  frequency: number|null
  impressions_dummy: number
  inline_link_click_ctr: number|null
  inline_link_clicks: number
  inline_post_engagement: number
  relevance_score: number|null
  social_clicks: number
  social_impressions: number
  social_reach: number
  total_action_value: number|null
  total_actions: number
  total_unique_actions: number
  total_audience_reach: number|null
  unique_actions: number
  unique_clicks: number
  unique_ctr: number|null
  unique_inline_link_click_ctr: number|null
  unique_inline_link_clicks: number
  unique_link_clicks_ctr: number|null
  unique_social_clicks: number
  video_10_sec_watched_actions: number
  video_15_sec_watched_actions: number
  video_30_sec_watched_actions: number
  video_avg_percent_watched_actions: number|null
  video_avg_time_watched_actions: number|null
  video_p100_watched_actions: number
  video_p25_watched_actions: number
  video_p50_watched_actions: number
  video_p75_watched_actions: number
  video_p95_watched_actions: number
  website_clicks: number
  website_ctr: number|null
  comment: number
  landing_page_view: number
  like: number
  unlike: number
  link_click: number
  link_clicks: number
  cost_per_link_click: number|null
  offsite_conversion: number
  offsite_conversion_label: string|null
  page_engagement: number
  photo_view: number
  post_engagement: number
  post_reaction: number
  share: number
  video_view: number
  video_view_rate: number|null
  cost_per_video_view: number|null
  mention: number
  actions: object|null
  follows: number
  unfollows: number
  retweets: number
  replies: number
  media_engagements: number
  media_views: number
  url_clicks: number
  auto_created_conversion_sign_up_initiated: number
  video_views_25: number
  video_views_50: number
  video_views_75: number
  video_views_100: number
  video_3s100pct_views: number
  video_6s50pct_views: number
  video_6s_views: number|null
  video_15s_views: number|null
  video_content_starts: number
  video_mrc_views: number
  video_total_views: number
  tweets_send: number
  poll_card_vote: number
  app_clicks: number
  card_engagements: number
  conversion_custom: number|null
  conversion_downloads: number|null
  conversion_sign_ups: number|null
  conversion_site_visits: number|null
  conversion_purchases: number|null
  auto_created_conversion_purchase: number
  carousel_swipes: number
  video_cta_clicks: number
  auto_created_conversion_download: number|null
  promoted_tweet_profile_impressions: number|null
  promoted_tweet_search_impressions: number|null
  promoted_tweet_timeline_impressions: number|null
  promoted_tweet_app_install_attempts: number|null
  promoted_tweet_app_open_attempts: number|null
  promoted_tweet_search_url_clicks: number|null
  promoted_tweet_timeline_url_clicks: number|null
  promoted_account_follows: number|null
  promoted_account_follow_rate: number|null
  promoted_tweet_search_engagements: number|null
  promoted_tweet_timeline_engagements: number|null
  promoted_tweet_profile_engagements: number|null
  promoted_video_total_views: number|null
  promoted_tweet_profile_url_clicks: number|null
  qualified_impressions: number|null
  mobile_conversion_installs_post_views: number
  mobile_conversion_installs_post_engagements: number
  app_installs: number
  campaign: number|null
  adset: number|null
  ad: number|null
  segmentation: number|null
}
export type Ad = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  created: string
  modified: string
  entity_type: string|null
  ad_id: string
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id: string|null
  creative: object|null
  adset: number
}
export type Adset = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  max_bid: any
  budget: any
  status: any
  lifetime_budget: any
  daily_budget: any
  conversion_window: any
  ads: Ad[]
  created: string
  modified: string
  _campaign_id: string
  name: string|null
  adset_id: string
  targeting: object|null
  start_time: string|null
  end_time: string|null
  budget_type: 'daily'|'lifetime'
  _ads: object|null
  bid_amount: number
  is_autobid: boolean
  rule: string|null
  event_id: string|null
  pixel_id: string|null
  eventtype: string|null
  custom_event_type: string|null
  click_through_days: number
  view_through_days: number
  placement: object|null
  uses_sdb_audience: boolean|null
  uses_sdb_autopilot_audience: boolean|null
  uses_sdb_native_pack: boolean|null
  uses_sdb_autopilot_pack: boolean|null
  targeting_size: object|null
  false_positive: boolean|null
  campaign: number
  _audience: number|null
}
export type AdInput = {
  entity_type?: string|null
  ad_id: string
  status?: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id?: string|null
  creative?: object|null
  adset: number
}
export type AdsetInput = {
  ads: AdInput[]
  _campaign_id: string
  name?: string|null
  adset_id: string
  targeting?: object|null
  start_time?: string|null
  end_time?: string|null
  budget_type?: 'daily'|'lifetime'
  _ads?: object|null
  bid_amount?: number
  is_autobid?: boolean
  rule?: string|null
  event_id?: string|null
  pixel_id?: string|null
  eventtype?: string|null
  custom_event_type?: string|null
  click_through_days?: number
  view_through_days?: number
  placement?: object|null
  uses_sdb_audience?: boolean|null
  uses_sdb_autopilot_audience?: boolean|null
  uses_sdb_native_pack?: boolean|null
  uses_sdb_autopilot_pack?: boolean|null
  targeting_size?: object|null
  false_positive?: boolean|null
  campaign: number
  _audience?: number|null
}
export type DeleteAdSetInstanceQuery = GetAdSetListQuery
export type GetAdSetInstanceQuery = GetAdSetListQuery
export type WriteTwitterAdsetInput = {
  creatives: string[]
  end_time?: string|null
  is_autobid?: boolean
  max_bid?: number|null
  name: string
  start_time: string
  country?: string|null
  age_min?: number|null
  age_max?: number|null
  locations?: any[]
  daily_budget?: number|null
  exclude_audiences?: string[]
  include_audiences?: string[]
  handles?: string[]
  keywords?: string[]
  hashtags?: string[]
  iab_targeting?: string[]
  lifetime_budget: number
  status?: 'active'|'paused'
}
export type PatchAdSetInstanceQuery = GetAdSetListQuery
export type WriteTwitterAdset = {
  end_time: string|null
  is_autobid: boolean
  max_bid: number|null
  name: string
  start_time: string
  country: string|null
  age_min: number|null
  age_max: number|null
  locations: any[]
  daily_budget: number|null
  exclude_audiences: string[]
  include_audiences: string[]
  handles: string[]
  keywords: string[]
  hashtags: string[]
  iab_targeting: string[]
  lifetime_budget: number
  status: 'active'|'paused'
}
export type PutAdSetInstanceQuery = GetAdSetListQuery
export type AdvertiserBusinessCategories = {
  category_id: string
  name: string
  iab_categories: any[]
}
export type AppEvents = {
  event_id: string
  conversion_type: 'ACHIEVEMENT_UNLOCKED'|'ADDED_PAYMENT_INFO'|'ADD_TO_CART'|'ADD_TO_WISHLIST'|'CHECKOUT_INITIATED'|'CONTENT_VIEW'|'INSTALL'|'INVITE'|'LEVEL_ACHIEVED'|'LOGIN'|'PURCHASE'|'RATED'|'RESERVATION'|'RE_ENGAGE'|'SEARCH'|'SHARE'|'SIGN_UP'|'SPENT_CREDITS'|'TUTORIAL_COMPLETE'|'UPDATE'
  status: string
}
export type GetAudienceCategoryListQuery = {
  team?: string
  id?: number
}
export type AudienceCategory = {
  id: number
  created: string
  modified: string
  name: string
  is_default_category: boolean
}
export type GetAudienceCategoryInstanceQuery = GetAudienceCategoryListQuery
export type GetAudienceConfigListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  team?: string
  categories?: string
  regions?: string
  id?: string
}
export type AudiencePlan = {
  id: number
  created: string
  modified: string
  name: string
  description: string
  public: boolean
  is_active: boolean
}
export type TeamPublic = {
  id: number
  slug: string|null
  name: string
  member_count: number
  logo: string|null
}
export type AudienceRegion = {
  id: number
  country_codes: (string)[]
  is_single_country: boolean
  name: string
  m49_code: string|null
}
export type AudienceConfig = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  audience_plan: AudiencePlan
  size: number
  approximate_count: string
  is_active: boolean
  created_by_team: TeamPublic
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
}
export type AudienceConfigInput = {
  name: string
  description?: string|null
  approximate_count: string
  is_active: boolean
  parameters: object
  category_ids: number[]
  region_ids: number[]
  created_by_team_id: number
  audience_plan_id: string
  insights_id: number|null
}
export type AutoCompleteInput = {
  partial_query: string
}
export type AutoComplete = {
  queries: string[]
}
export type SearchPerspectivesInput = {
  keyword: string
}
export type SearchPerspectives = {
  entities: any[]
  countries: string[]
  audience_type: string
  spelling_correction: string
  inapropriate_words_message: string
  account_types: number[]
}
export type GetAudienceConfigInstanceQuery = GetAudienceConfigListQuery
export type Insights = {
  id: number
  insights_counts: any
  is_super_insights: boolean
  influencer_groups: string[]
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
}
export type AudienceConfigDetail = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  audience_plan: AudiencePlan
  size: number
  approximate_count: string
  is_active: boolean
  created_by_team: TeamPublic
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  insights: Insights|null
}
export type PutAudienceConfigInstanceQuery = GetAudienceConfigListQuery
export type AudiencePlanInput = {
  name: string
  description: string
  public?: boolean
  is_active?: boolean
}
export type GetAudienceListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  team?: string
  id?: string
  ad_account?: string
  targetable?: string
}
export type AudienceConfigBasic = {
  id: number
  name: string|null
  description: string|null
  audience_plan: number|null
  is_active: boolean
}
export type Audience = {
  id: number
  created: string
  modified: string
  network: any
  imported: boolean
  audience_id: string|null
  name: string
  targeting: object|null
  approximate_count: number
  is_global_audience: boolean
  config: AudienceConfigBasic
  uploaded_insights_id: number|null
  account_id: string
  uploaded_audience_id: number|null
  targetable: boolean
  reasons_not_targetable: string[]
  top_influencers: any[]
  targetable_keywords: any[]
  targetable_hashtags: any[]
  targeting_package_size: any
}
export type GetAudienceInstanceQuery = GetAudienceListQuery
export type BuildAudienceInput = {
  plan_name: string
  plan_type: string|null
  input_query: string|null
  keywords: string[]
  input_countries?: string[]|null
  exclude_keywords?: string[]|null
  types?: string[]|null
  following_types?: any[]|null
  selected_influencers?: any[]|null
  engagement?: 'high'|'medium'|'low'
  size?: string|null
  config_id: number|null
}
export type BuildAudience = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  insights_counts: any
  following_types: any[]|null
  is_super_insights: boolean
  influencer_groups: string[]
}
export type CreateCampaignPdfInput = {
  campaign_id: number
}
export type CreateCampaignPdf = {
  response: string
}
export type GetCampaignListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
  team?: string
  account_id?: string
  network?: string
  campaign_id?: string
  status?: string
  objective?: string
  completed?: string
  metrics?: string
}
export type CampaignListItem = {
  id: number
  adsets: number[]
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  status: any
  stop_time: any
  lifetime_budget: any
  daily_budget: any
  currency: string
  first_creative_id: string
  has_pro_targeting: any
  via_extension: boolean
  created: string
  modified: string
  account_id: string
  network: 'facebook'|'twitter'|'linkedin'
  campaign_id: string
  name: string
  objective: string
  created_time: string
  start_time: string
  updated_time: string|null
  data: object|null
  completed: boolean
  synced: string|null
  funding_instrument: string|null
  io_header: string|null
  reach: number|null
  average_frequency: number|null
  budget_optimization: 'CAMPAIGN'|'LINE_ITEM'|null
  effective_status: string|null
  stats_lock: any|null
  dbaccount: number
}
export type WriteTwitterCampaignInput = {
  name: string
  account_id: string
  status?: 'active'|'paused'|null
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'ENGAGEMENTS'|'FOLLOWERS'|'LEAD_GENERATION'|'PREROLL_VIEWS'|'REACH'|'VIDEO_VIEWS'|'WEBSITE_CLICKS'|'WEBSITE_CONVERSIONS'
  goal?: string|null
  is_conversions_objective?: boolean
  primary_web_event_tag?: string|null
  funding_instrument?: string|null
  lifetime_budget: number
  daily_budget?: number|null
  adsets: WriteTwitterAdsetInput[]
  app_store_identifier?: string|null
  categories?: string[]
  audience_expansion?: boolean
}
export type WriteTwitterCampaign = {
  name: string
  account_id: string
  status: 'active'|'paused'|null
  id: string
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'ENGAGEMENTS'|'FOLLOWERS'|'LEAD_GENERATION'|'PREROLL_VIEWS'|'REACH'|'VIDEO_VIEWS'|'WEBSITE_CLICKS'|'WEBSITE_CONVERSIONS'
  goal: string|null
  is_conversions_objective: boolean
  primary_web_event_tag: string|null
  funding_instrument: string|null
  daily_budget: number|null
  adsets: WriteTwitterAdset[]
  app_store_identifier: string|null
  categories: string[]
  audience_expansion: boolean
}
export type GetAdsQuery = GetCampaignListQuery
export type CampaignSummary = {
  name: string
  id: number
  network: 'facebook'|'twitter'|'linkedin'
  account_id: string
  currency: string
  objective: string
}
export type AdsetSummary = {
  name: string|null
  id: number
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  campaign: CampaignSummary
  adset_id: string
}
export type AdListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  adset: AdsetSummary
  created: string
  modified: string
  entity_type: string|null
  ad_id: string
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  creative_id: string|null
}
export type GetAdsetsQuery = GetCampaignListQuery
export type AdsetListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  max_bid: any
  budget: any
  status: any
  lifetime_budget: any
  daily_budget: any
  conversion_window: any
  ads: number[]
  campaign: CampaignSummary
  created: string
  modified: string
  _campaign_id: string
  name: string|null
  adset_id: string
  start_time: string|null
  end_time: string|null
  budget_type: 'daily'|'lifetime'
  bid_amount: number
  is_autobid: boolean
  rule: string|null
  event_id: string|null
  pixel_id: string|null
  eventtype: string|null
  custom_event_type: string|null
  click_through_days: number
  view_through_days: number
  placement: object|null
  uses_sdb_audience: boolean|null
  uses_sdb_autopilot_audience: boolean|null
  uses_sdb_native_pack: boolean|null
  uses_sdb_autopilot_pack: boolean|null
  targeting_size: object|null
  false_positive: boolean|null
  _audience: number|null
}
export type GetReachQuery = {
  search?: string
  ordering?: string
  id?: string
  team?: string
  account_id?: string
  network?: string
  campaign_id?: string
  status?: string
  objective?: string
  completed?: string
  metrics?: string
}
export type ReachStats = {
  id: string
  total_audience_reach: number|null
  average_frequency: number|null
}
export type GetSegmentationsQuery = GetCampaignListQuery
export type AdSummary = {
  id: number
  status: 'active'|'paused'|'deleted'|'archived'|'finished'|null
  adset: AdsetSummary
  ad_id: string
}
export type SegmentationListItem = {
  id: number
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  name: any
  ad: AdSummary
  created: string
  modified: string
  segmentation_type: 'AUDIENCES'|'SIMILAR_TO_FOLLOWERS_OF_USER'|'CUSTOM_AUDIENCE_EXPANDED'
  segment_value: string
  segment_name: string|null
}
export type GetStatstotalQuery = GetReachQuery
export type StatsTotal = {
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  lifetime_budget: any
  daily_budget: any
}
export type DeleteCampaignInstanceQuery = GetCampaignListQuery
export type GetCampaignInstanceQuery = GetCampaignListQuery
export type Campaign = {
  id: number
  adsets: Adset[]
  stats_first: CumulativeStats[]
  stats_last: CumulativeStats[]
  status: any
  stop_time: any
  lifetime_budget: any
  daily_budget: any
  currency: string
  first_creative_id: string
  has_pro_targeting: any
  via_extension: boolean
  created: string
  modified: string
  account_id: string
  network: 'facebook'|'twitter'|'linkedin'
  campaign_id: string
  name: string
  objective: string
  created_time: string
  start_time: string
  updated_time: string|null
  data: object|null
  completed: boolean
  synced: string|null
  funding_instrument: string|null
  io_header: string|null
  reach: number|null
  average_frequency: number|null
  budget_optimization: 'CAMPAIGN'|'LINE_ITEM'|null
  effective_status: string|null
  stats_lock: any|null
  dbaccount: number
}
export type PatchCampaignInstanceQuery = GetCampaignListQuery
export type PutCampaignInstanceQuery = GetCampaignListQuery
export type GetCommunitiesListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
}
export type AudienceCommunity = {
  id: number
  created: string
  modified: string
  input_query: string|null
  config: number|null
  count: number
  insights: number|null
  top_influencers: any[]
  community_rank: number
}
export type GetCommunitiesInstanceQuery = GetCommunitiesListQuery
export type GetCommunityListQuery = {
  search?: string
  type_code?: string
}
export type Community = {
  account_id: number
  connectivity: number
  relevancy: number
  profile_pic: string
  handle: string
  name: string
  followers: number
  friends: number
  bio: string
}
export type GetCommunityInstanceQuery = GetCommunityListQuery
export type ContentCategories = {
  name: string
  category_id: string
  iab_categories: any[]
  publishers_in_last_thirty_days: number
  videos_monetized_in_last_thirty_days: number
}
export type CancellationInput = {
  subscription: number
}
export type Cancellation = CancellationInput
export type CheckoutInput = {
  team: number
  plan: number
  audiences?: number
}
export type Checkout = {
  team: number
  plan: number
  audiences: number
  stripe_url: string
}
export type Plan = {
  id: number
  name: string
  price: number
  currency: 'USD'|'EUR'|'YEN'
  ad_budget: number
  audiences_included: number
  audience_price: any
  overages: any
  fixed_price: boolean
  deck: string|null
  description: string|null
  display_name: string|null
}
export type Subscription = {
  id: number
  team: number
  plan: Plan
  start: string
  active: boolean
  audiences: number
}
export type UpgradeInput = {
  subscription: number
  plan: number
  audiences: number
}
export type Upgrade = UpgradeInput
export type ExploreXInput = {
  countries?: string[]|null
  input_query: string|null
}
export type ExploreX = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  influencer_groups: string[]
}
export type GetStandaloneAdAccountListQuery = {
  account_id: string
}
export type StandaloneAdAccount = {
  is_active: boolean
  account_id: string
  name: string
}
export type StandaloneAdAccountInput = {
  account_id: string
  name?: string
}
export type StandaloneAudienceAdAccountInput = {
  account_id: string
  name?: string|null
}
export type StandaloneAudienceAdAccount = {
  account_id: string
  name: string|null
}
export type StandaloneAdAccountFundingSourcesInput = {
  ad_account_id: string
}
export type StandaloneFundingSource = {
  id: string
  description: string
  able_to_fund: boolean
}
export type StandaloneAdAccountFundingSources = {
  funding_sources: StandaloneFundingSource[]
}
export type GetStandaloneAdAccountInstanceQuery = GetStandaloneAdAccountListQuery
export type StandaloneDescriptionAnalyzerInput = {
  email?: string|null
  description: string
}
export type StandaloneDescriptionAnalyzer = {
  analyzed_keyword_groups: string[][]
  analyzed_handles: string[]
  analyzed_countries: string[]
  analyzed_location_states: string[]
  analyzed_gender: 1|2|12|null
  analyzed_age_range: string|null
}
export type StandaloneInsightsAnalyzerInput = {
  email?: string|null
  ad_account_id?: string|null
  query?: string
  query_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
  input_keywords?: string[][]
  alpha_2?: string
}
export type SizeData = {
  min: number
  max: number
}
export type PostCounts = {
  like_count: number|null
  impression_count: number|null
  post_count: number|null
}
export type ChartData = {
  label: string
  value: number
  valueText: string
}
export type StandaloneSubreddits = {
  name: string
  daily_impressions: number
  count: number
}
export type StandaloneAudienceConfigListItem = {
  id: number
  name: string
  description: string
  modified: string
}
export type StandalonePostMetadataCount = {
  image_with_link: number|null
  image_without_link: number|null
  video: number|null
  poll: number|null
  short_form: number|null
  long_form: number|null
  text: number|null
  image: number|null
}
export type DeepThoughtAccount = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
}
export type DeepThoughtPostAccount = {
  accountid: string
  pic: string
  handle: string
  name: string
  verified: boolean
}
export type DeepThoughtImages = {
  url: string|null
  width: number|null
  height: number|null
}
export type DeepThoughtTimelineURLs = {
  start: number|null
  end: number|null
  url: string|null
  expanded_url: string|null
  display_url: string|null
  images: DeepThoughtImages[]|null
  status: number|null
  title: string|null
  description: string|null
  unwound_url: string|null
}
export type DeepThoughtMedia = {
  start: number|null
  end: number|null
  media_key: string|null
  url: string|null
  preview_image_url: string|null
  width: number|null
  height: number|null
  type: 'animated_gif'|'photo'|'video'|null
}
export type DeepThoughtPostTweetTimeline = {
  id: string
  text: string
  like_count: number
  retweet_count: number
  impression_count: number|null
  reply_count: number|null
  quote_count: number|null
  created_at: string
  tweet_time: string|null
  verified_like_count: number|null
  verified_reply_count: number|null
  verified_retweet_count: number|null
  payout_estimation: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  engagements: number|null
  post_type: string|null
  sentiment: string|null
  urls: DeepThoughtTimelineURLs[]
  media: DeepThoughtMedia[]
}
export type DeepThoughtAccountTweet = {
  account: DeepThoughtPostAccount
  tweet: DeepThoughtPostTweetTimeline
}
export type DeepThoughtFollowerGrowth = {
  refdate: string
  followers: number
  verified_count: number|null
}
export type DeepThoughtAccountStats = {
  follower_growth: DeepThoughtFollowerGrowth[]
  account_id: string
}
export type DeepThoughtEnrichmentTopic = {
  id: number
  topic: string
  score: number
  baseline: number|null
  corrected: number|null
  score_ratio: number|null
}
export type DeepThoughtEnrichment = {
  parent: string
  children: DeepThoughtEnrichmentTopic[]
}
export type StandaloneInsightsAnalyzer = {
  size: SizeData|null
  post_counts: PostCounts|null
  hashtags_tweets: ChartData[]
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  emoji_counts: ChartData[]
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  genders: ChartData[]
  languages: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  age_percentages: ChartData[]|null
  query: string
  show_country_message: boolean|null
  seo_keywords: string[]
  seo_phrases: string[]
  audience_configs: StandaloneAudienceConfigListItem[]
  hashtags_handles: ChartData[]
  single_keywords_handles: ChartData[]
  double_keywords_handles: ChartData[]
  emoji_counts_handles: ChartData[]
  handle_posts_analyzed: number|null
  audience_creator_query_id: number
  percentage_active: number|null
  counts: StandalonePostMetadataCount
  summary: string|null
  accounts: DeepThoughtAccount[]
  top_posts_handles: DeepThoughtAccountTweet[]
  account_stats: DeepThoughtAccountStats[]|null
  top_followers: DeepThoughtAccount[]|null
  enrichments: DeepThoughtEnrichment[]|null
  sample_accounts: DeepThoughtAccount[]
  top_accounts: DeepThoughtAccount[]
  top_posts: DeepThoughtAccountTweet[]
}
export type StandaloneInsightsAnalyzerKeywordAccountsInput = {
  keywords: string[]
  countries: string[]
}
export type StandaloneInsightsAnalyzerKeywordAccounts = {
  accounts: DeepThoughtAccount[]
}
export type StandaloneInsightsAnalyzerGenerateSheetInput = {
  data: string[][]
  title: string
  template?: 'handle'|'audience'|'conversation'|'creators'|'creators_with_follower_growth'|'other'
  locale?: 'en'|'ja'
  countries: string[]
  headings?: string[]
}
export type StandaloneInsightsAnalyzerGenerateSheet = {
  url: string
}
export type StandaloneExploreQueryAnalyzerInput = {
  email?: string|null
  ad_account_id?: string|null
  query?: string
  query_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
}
export type StandaloneExploreParameters = {
  handles: string[]|null
  keywords: string[]|null
  countries: string[]|null
  title: string|null
  query: string|null
  input_keywords: string[][]|null
  date_start: string|null
  date_end: string|null
}
export type StandaloneExploreQueryAnalyzer = {
  query: string
  parameters: StandaloneExploreParameters
  audience_creator_query_id: number
}
export type ApexAuthoritiesWithGrowthInput = {
  query: string
  alpha2?: string|null
  order_by?: 'rank'|'signal_growth'|null
  limit?: number
  location?: string|null
  entity_type?: 'all'|'person'|'non-person'
}
export type ApexEntityOutput = {
  sdu: string
  name: string|null
  pic: string|null
  rank: number|null
  authority_score: number|null
  signal_growth: number|null
  country_name: string|null
  topic: string|null
}
export type ApexAuthoritiesWithGrowth = {
  entities: ApexEntityOutput[]
}
export type ApexAuthorityStatsInput = {
  sdu: string
}
export type AccountClassificationOutput = {
  sdu: string
  name: string|null
  country_name: string|null
  authority_score: number|null
}
export type ApexAuthorityStats = {
  engagement_rate: number|null
  signal_growth: number|null
  account_classifications: AccountClassificationOutput[]
}
export type ApexSduSummaryInput = {
  sdu: string
  input_query?: string|null
  days?: 30|90
  max_tweets?: number
}
export type ApexSduSummary = {
  summary: string|null
}
export type GetStandaloneAudienceBuilderListQuery = {
  ad_account_id?: string
  email?: string
}
export type AudienceBuilder = {
  id: number
  created: string
  modified: string
  name: string
  email: string
  parameters: object|null
  ad_account_id: string|null
  size: number|null
  deleted_at: string|null
}
export type StandaloneAudienceBuilderWordsInProfileInput = StandaloneInsightsAnalyzerKeywordAccountsInput
export type StandaloneAudienceBuilderPostedAboutInput = {
  keywords: string[]
  start?: string|null
  end?: string|null
  time_interval: 'last_week'|'last_month'|'last_3_months'|'last_year'
}
export type StandaloneAudienceBuilderFollowersOfInput = {
  handles: string[]
  following_at_least?: number
}
export type StandaloneAudienceBuilderInterestedInInput = StandaloneInsightsAnalyzerKeywordAccountsInput
export type StandaloneAudienceBuilderCriterionInput = {
  words_in_profile?: StandaloneAudienceBuilderWordsInProfileInput
  posted_about?: StandaloneAudienceBuilderPostedAboutInput
  followers_of?: StandaloneAudienceBuilderFollowersOfInput
  interested_in?: StandaloneAudienceBuilderInterestedInInput
}
export type StandaloneAudienceBuilderInput = {
  email?: string|null
  ad_account_id?: string|null
  name: string
  criteria: StandaloneAudienceBuilderCriterionInput[][]
  generate_insights?: boolean
}
export type StandaloneInsightsAnalyzerSync = {
  size: SizeData|null
  post_counts: PostCounts|null
  hashtags_tweets: ChartData[]
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  emoji_counts: ChartData[]
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  genders: ChartData[]
  languages: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  age_percentages: ChartData[]|null
  enrichments: DeepThoughtEnrichment[]|null
  sample_accounts: DeepThoughtAccount[]
  top_accounts: DeepThoughtAccount[]
  top_posts: DeepThoughtAccountTweet[]
}
export type StandaloneAudienceBuilder = {
  audience_size: number|null
  insights: StandaloneInsightsAnalyzerSync|null
  audience_creator_query_id: number|null
  accounts: DeepThoughtAccount[]
}
export type StandaloneAudienceBuilderFollowersOf = {
  audience_size: number|null
  accounts: DeepThoughtAccount[]
}
export type StandaloneAudienceBuilderGenerateInsightsInput = {
  email?: string|null
  ad_account_id?: string|null
  audience_builder_id: number
}
export type StandaloneAudienceBuilderGenerateInsights = {
  insights: StandaloneInsightsAnalyzerSync|null
  audience_creator_query_id: number
}
export type StandaloneAudienceBuilderInterestedIn = StandaloneAudienceBuilderFollowersOf
export type DeepThoughtPostTweet = {
  id: string
  text: string
  like_count: number
  retweet_count: number
  impression_count: number|null
  reply_count: number|null
  quote_count: number|null
  created_at: string
  tweet_time: string|null
  verified_like_count: number|null
  verified_reply_count: number|null
  verified_retweet_count: number|null
  payout_estimation: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  engagements: number|null
  post_type: string|null
  sentiment: string|null
}
export type DeepThoughtPost = {
  account: DeepThoughtPostAccount
  tweet: DeepThoughtPostTweet
}
export type StandaloneAudienceBuilderPostedAbout = {
  post_count: number|null
  accounts: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
}
export type StandaloneAudienceBuilderSuggestInterestsInput = SearchPerspectivesInput
export type ClassifierChild = {
  id: number
  name: string
}
export type StandaloneAudienceBuilderSuggestInterests = {
  classifiers: ClassifierChild[]
}
export type StandaloneAudienceBuilderWordsInProfile = StandaloneAudienceBuilderFollowersOf
export type DeleteStandaloneAudienceBuilderInstanceQuery = GetStandaloneAudienceBuilderListQuery
export type GetStandaloneAudienceCategoryListQuery = GetAudienceCategoryListQuery
export type GetStandaloneAudienceCategoryInstanceQuery = GetAudienceCategoryListQuery
export type GetStandaloneAudienceConfigListQuery = {
  limit?: number
  offset?: number
  search?: string
  categories?: string
  regions?: string
  classic_xpro_id?: string
  ad_account_id?: string
  token?: string
  list_type?: string
}
export type StandaloneAudienceConfig = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  size: number
  approximate_count: string
  is_active: boolean
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  child_count: number
  parent_count: number
  status: 'Imported'|'Processing'|'Done'
}
export type StandaloneAudienceConfigInput = {
  name: string
  description?: string|null
  approximate_count: string
  is_active: boolean
  parameters: object
  insights_id: number|null
  ad_account_id: string
}
export type StandaloneShareViaAccountAudienceConfigInput = {
  ad_account_id: string
  audience_config_id?: string
}
export type StandaloneShareViaAccountAudienceConfig = {
}
export type StandaloneShareAudienceConfigInput = {
  audience_config_id: number
}
export type StandaloneShareAudienceConfig = {
  audiences_url: string
}
export type GetStandaloneAudienceConfigInstanceQuery = GetStandaloneAudienceConfigListQuery
export type RelatedAudienceConfig = {
  id: number
  parent: AudienceConfig
  child: AudienceConfig
}
export type StandaloneAudienceConfigDetail = {
  id: number
  created: string
  modified: string
  name: string
  description: string|null
  size: number
  approximate_count: string
  is_active: boolean
  categories: AudienceCategory[]
  regions: AudienceRegion[]
  plan_type: string
  top_influencers: any[]
  display_name: string
  audience_estimation: string
  native_estimation: string
  insights_id: number|null
  has_native_pack: boolean
  insights: Insights|null
  child: RelatedAudienceConfig[]
  parent: RelatedAudienceConfig[]
  status: 'Imported'|'Processing'|'Done'
  native_pack_link: any
}
export type PutStandaloneAudienceConfigInstanceQuery = GetStandaloneAudienceConfigListQuery
export type GetDownloadTargetingPackageQuery = {
  search?: string
  categories?: string
  regions?: string
  classic_xpro_id?: string
  ad_account_id?: string
  token?: string
  list_type?: string
}
export type StandaloneDownloadTargetingPackage = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneAudienceRequestInput = {
  ad_account_id?: string|null
  advertiser_name?: string|null
  audience_config_id?: number|null
  audience_size?: string|null
  audience_type?: 'custom'|'exclusion'|'abm'|'event'|null
  currency?: string|null
  description?: string|null
  email: string
  funding_source_id?: string|null
  geographic?: string|null
  google_drive_link?: string|null
  input_budget?: string|null
  input_end_date?: string|null
  input_start_date?: string|null
  io_signed?: boolean|null
  name?: string|null
  request_type?: 'native'|'audience'
  salesforce_id?: string|null
  advertiser_handle?: string|null
  form_opened_via?: string|null
}
export type StandaloneAudienceRequest = {
  id: number
  asana_id: string|null
  native_pack_link: string|null
  ad_account_id: string|null
  advertiser_name: string|null
  audience_config_id: number|null
  audience_size: string|null
  audience_type: 'custom'|'exclusion'|'abm'|'event'|null
  currency: string|null
  description: string|null
  email: string
  funding_source_id: string|null
  geographic: string|null
  google_drive_link: string|null
  io_signed: boolean|null
  name: string|null
  request_type: 'native'|'audience'
  salesforce_id: string|null
  advertiser_handle: string|null
  form_opened_via: string|null
}
export type StandaloneFeedbackInput = {
  name?: string|null
  email?: string|null
  feedback: string
}
export type StandaloneFeedback = {
  name: string|null
  email: string|null
  feedback: string
}
export type StandaloneAudienceRequestRedditInput = {
  email: string
  description?: string
  ad_account_id?: string
  advertiser_name?: string
  geographic?: string
  budget?: string
}
export type StandaloneAudienceRequestReddit = StandaloneShareViaAccountAudienceConfig
export type GetSimilarHandlesQuery = {
  handle: string
}
export type StandaloneHandle = {
  handle: string
  id: string
  name: string
  followers: number
  bio: string
  profile_pic_url: string
}
export type StandaloneSimilarHandles = {
  handles: StandaloneHandle[]
}
export type StandaloneCheckAdAccountAccessInput = {
  ad_account_id?: string|null
}
export type StandaloneCheckAdAccountAccess = {
  access: boolean
}
export type PrivateModelInput = {
  email: string
}
export type PrivateModel = StandaloneShareViaAccountAudienceConfig
export type StandaloneHandleInput = GetSimilarHandlesQuery
export type GetStandaloneAudienceUsedInAdsListQuery = {
  limit?: number
  offset?: number
  search?: string
  ad_account_id?: string
  token?: string
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type StandaloneAudienceUsedInAds = {
  id: number
  has_insights: boolean
  state: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  name: string|null
  description: string|null
  ad_account_id: string
  ad_account_name: string
  audience_config_id: number|null
  audience_config_status: 'Imported'|'Processing'|'Done'
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  created: string
  modified: string
  campaign_id: string|null
  campaign_name: string|null
  funding_source_id: string|null
  currency: string|null
  daily_budget: string|null
  total_budget: string|null
  start_date: string|null
  end_date: string|null
  audience_size: string|null
  data: object|null
  reviewed: boolean|null
}
export type StandaloneDetailAudienceUsedInAdsInput = {
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  email?: string|null
  name?: string|null
  description?: string|null
  ad_account_id?: string
  audience_config_id?: number|null
  audience_creator_query_id?: number|null
  countries?: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  campaign_id?: string|null
  campaign_name?: string|null
  funding_source_id?: string|null
  currency?: string|null
  daily_budget?: string|null
  total_budget?: string|null
  start_date?: string|null
  end_date?: string|null
  audience_size?: string|null
  data?: object|null
  targeting_package_extra?: object
  exclusion_audience?: boolean
  reviewed?: boolean|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
}
export type StandaloneDetailAudienceUsedInAds = {
  id: number
  has_insights: boolean
  state: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  name: string|null
  description: string|null
  ad_account_id: string
  ad_account_name: string
  audience_config_id: number|null
  audience_config_status: 'Imported'|'Processing'|'Done'
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  created: string
  modified: string
  campaign_id: string|null
  campaign_name: string|null
  funding_source_id: string|null
  currency: string|null
  daily_budget: string|null
  total_budget: string|null
  start_date: string|null
  end_date: string|null
  audience_size: string|null
  data: object|null
  reviewed: boolean|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
}
export type GetAutopilotSuggestedBudgetQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneAutopilotSuggestedBudget = {
  budget: number
  size: number|null
}
export type GetAutopilotUsageAllowedQuery = {
  ad_account_id?: string
}
export type StandaloneAutopilotUsageAllowedAudienceUsedInAds = {
  allowed: boolean
  enterprise: boolean
}
export type GetAutopilotUsageQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneAutopilotUsageAudienceUsedInAds = {
  campaigns_launched: string
  campaigns_budget: string
}
export type StandaloneAudienceUsedInAdsGenerateSheetInput = {
  id: number
}
export type StandaloneAudienceUsedInAdsGenerateSheet = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneReorderHandlesAudienceUsedInAdsInput = {
  audience_used_in_ads_id: number
  order: 'balanced'|'narrow'|'broad'|'custom'
}
export type StandaloneReorderHandlesAudienceUsedInAds = {
  handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]
}
export type StandaloneShareViaAccountAudienceUsedInAdsInput = {
  ad_account_id: string
  audience_used_in_ads_id?: string
}
export type StandaloneShareViaAccountAudienceUsedInAds = StandaloneShareViaAccountAudienceConfig
export type StandaloneShareAudienceUsedInAdsInput = {
  ad_account_id: string
  audience_used_in_ads_ids?: string
}
export type StandaloneShareAudienceUsedInAds = StandaloneShareAudienceConfig
export type StandaloneSharedAudienceUsedInAdsInput = {
  audience_used_in_ads_id?: string
}
export type StandaloneSharedAudienceUsedInAds = {
  ad_account_ids: string[]
}
export type GetVerifySignedQuery = {
  token?: string
}
export type DeleteStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type GetStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type PatchStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type PutStandaloneAudienceUsedInAdsInstanceQuery = GetStandaloneAudienceUsedInAdsListQuery
export type StandaloneAudienceUsedInAdsInput = {
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
  email?: string|null
  name?: string|null
  description?: string|null
  ad_account_id?: string
  audience_config_id?: number|null
  audience_creator_query_id?: number|null
  countries?: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  campaign_id?: string|null
  campaign_name?: string|null
  funding_source_id?: string|null
  currency?: string|null
  daily_budget?: string|null
  total_budget?: string|null
  start_date?: string|null
  end_date?: string|null
  audience_size?: string|null
  data?: object|null
  targeting_package_extra?: object
  exclusion_audience?: boolean
  reviewed?: boolean|null
}
export type PatchRestoreQuery = {
  search?: string
  ad_account_id?: string
  token?: string
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type CreateProTargetingPdfInput = {
  insights_id: number
}
export type CreateProTargetingPdf = CreateCampaignPdf
export type GetStandaloneAudienceListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  id?: string
  ad_account?: string
  targetable?: string
}
export type GetStandaloneAudienceInstanceQuery = GetStandaloneAudienceListQuery
export type AuthorityIndexEntityOutput = {
  sdu: string
  name: string|null
  bio: string|null
  country_name: string|null
  location: string|null
  pic: string|null
  authority_score: number|null
  reach: number|null
  signal_growth: number|null
  combined_score: number|null
  raw_semantic_score: number|null
  topics: string[]
  rank: number|null
  top_classifier_ids: number[]|null
  top_authority_scores: number[]|null
  topic_connectivities: number[]|null
  topic_relevancies: number[]|null
}
export type AuthorityIndexPeers = {
  results: AuthorityIndexEntityOutput[]
}
export type AuthorityIndexSearch = AuthorityIndexPeers
export type AuthorityIndexV2QueryInput = {
  keywords: string[]
  keywords_all?: string[]
  countries?: string[]|null
  entity_type?: 'persons'|'non-persons'|null
  has_authority_score?: boolean|null
  include_bio?: boolean|null
  core_topics?: boolean|null
  order_by?: 'authority_score'|'reach'|'none'
  limit?: number|null
}
export type AuthorityIndexV2Query = StandaloneShareViaAccountAudienceConfig
export type AuthoritySearchQueryInput = {
  keywords: string[]
  keywords_all?: any[]
  countries?: string[]|null
  locations?: string[]|null
  entity_type?: 'persons'|'non-persons'|null
  limit?: number|null
}
export type AuthoritySearchQuery = StandaloneShareViaAccountAudienceConfig
export type BigDipperTeamAcceptInput = {
  email: string
  token: string
}
export type BigDipperTeamAccept = {
  user_token: string
  team_id: number
}
export type StandaloneMessage = {
  role: 'user'|'assistant'|'system'
  content: string
}
export type GetAnalyzeQueryQuery = {
  user_query: string
  history?: StandaloneMessage[]
  email?: string
  session_id?: number
}
export type AmygdalaAccount = {
  name: string
  pic: string
  country: string
  classifier_names: string[]
}
export type StandaloneAmygdalaAnalyzeQuery = {
  session_id: number|null
  accounts: AmygdalaAccount[]
  n_entities: string|null
  parsed_query: string|null
}
export type GetAnswerQueryQuery = {
  user_query?: string
  history?: string
}
export type NoneType = StandaloneShareViaAccountAudienceConfig
export type GetDiscoverSummaryStreamQuery = {
  topic_name?: string
  location?: string
}
export type StandaloneAmygdalaDiscoverTopics = {
  topics: any
}
export type GetDiscoverQuery = {
  topic_name: string
  location?: string
}
export type AmygdalaEntity = {
  uuid: string|null
  name: string
  pic: string
  rank: number
  country: string
  topics: string[]
  entity_type: string|null
}
export type YouTubeChannel = {
  channel_id: string
  handle: string
  title: string
  description: string|null
  view_count: number|null
  subscriber_count: number|null
  video_count: number|null
  thumbnail_url: string|null
}
export type YouTubeVideo = {
  channel_id: string
  video_id: string
  title: string
  description: string|null
  publish_date: string|null
  thumbnail_url: string|null
  channel: YouTubeChannel
  view_count: number|null
  like_count: number|null
  comment_count: number|null
}
export type DeepThoughtPostMedia = {
  account: DeepThoughtPostAccount
  post: DeepThoughtPostTweetTimeline
}
export type StandaloneAmygdalaDiscover = {
  entities: AmygdalaEntity[]
  youtube_videos: YouTubeVideo[]
  posts: DeepThoughtPostMedia[]
}
export type GetEntityDetailQuery = {
  uuid: string
}
export type StandaloneAmygdalaEntityDetail = {
  uuid: string
  name: string
  pic: string
  country: string
  site: string
  topics: string[]
  entity_type: string|null
  bio: string
  x_handle: string
  x_followers: number|null
  facebook_handle: string
  facebook_followers: number|null
  instagram_handle: string
  instagram_followers: number|null
  linkedin_handle: string
  linkedin_followers: number|null
  reddit_handle: string
  reddit_followers: number|null
  tiktok_handle: string
  tiktok_followers: number|null
  snapchat_handle: string
  snapchat_followers: number|null
  youtube_handle: string
  youtube_followers: number|null
  discord_handle: string
  discord_followers: number|null
  twitch_handle: string
  twitch_followers: number|null
  spotify_id: string
  spotify_handle: string
  spotify_followers: number|null
  pinterest_handle: string
  pinterest_followers: number|null
}
export type GetGenerateContextQuery = {
  user_query: string
  session_id?: number
}
export type SpotifyShow = {
  spotify_id: string
  spotify_handle: string|null
  account_name: string
  pic: string|null
  name: string
  description: string|null
  image_url: string|null
  publisher: string|null
  total_episodes: number|null
}
export type SpotifyArtist = {
  spotify_id: string
  spotify_handle: string|null
  account_name: string
  pic: string|null
  spotify_followers: number|null
  name: string
  description: string|null
  popularity: number|null
  genres: string[]
  image_url: string|null
}
export type Subreddit = {
  subreddit: string
  mentions: number
  comment_count: number|null
  public_description: string|null
  subscribers: number|null
  subreddit_name: string
  daily_impressions: number|null
  img_url: string|null
}
export type GoogleInstance = {
  title: string
  url: string
  text: string
  published_date: string
  icon: string|null
  name: string|null
}
export type StandalonePlatformAccount = {
  name: string
  handle: string
  followers: number|null
  pic: string|null
  description: string|null
}
export type StandaloneAmygdalaContext = {
  spotify_shows: SpotifyShow[]
  spotify_artists: SpotifyArtist[]
  youtube_channels: YouTubeChannel[]
  subreddits: Subreddit[]
  google: GoogleInstance[]
  instagram: StandalonePlatformAccount[]
  tiktok: StandalonePlatformAccount[]
  discord: StandalonePlatformAccount[]
  accounts_posts: DeepThoughtPostMedia[]
  searched_posts: DeepThoughtPostMedia[]
}
export type StandaloneAmygdalaGenerateContext = {
  session_id: number|null
  context: StandaloneAmygdalaContext
}
export type GetAmygdalaSearchQuery = {
  user_query: string
  limit?: number
  append_socials?: string
}
export type StandaloneAmygdalaSearch = {
  entities: AmygdalaEntity[]
}
export type GetSentimentAnalysisQuery = {
  user_query: string
}
export type StandaloneMonitorWeekResultCounts = {
  positive: number|null
  negative: number|null
  neutral: number|null
  offensive: number|null
  non_offensive: number|null
}
export type StandaloneAmygdalaSentimentAnalysis = {
  sentiments: StandaloneMonitorWeekResultCounts
}
export type StandaloneAmygdalaUserSearchSummaryInput = {
  session_id: number
  input_query: string
  summary: string
}
export type StandaloneAmygdalaUserSearchSummary = StandaloneAmygdalaUserSearchSummaryInput
export type GetUserSessionSearchesQuery = {
  session_id?: string
}
export type StandaloneAmygdalaUserSessionSearches = {
  id: number
  session: number
  input_query: string|null
  keywords: object
  countries: object
  entities: object
  n_entities: string|null
  context: object
  summary: string
  created: string
}
export type GetUserSessionsQuery = {
  email?: string
}
export type StandaloneAmygdalaUserSessions = {
  id: number
  user: number
  email: string|null
  created: string
  title: string|null
}
export type GetAnalyzePromptQuery = {
  input_query: string
  countries?: string[]
  email?: string
}
export type StandaloneAnalyzeQuery = {
  analyzed_countries: string[]
  analyzed_keywords: string[]
  search_id: number
}
export type GetAudienceInsightsQuery = {
  keywords: string[]
  countries?: string[]
  user_query?: string
  history?: StandaloneMessage[]
}
export type StandaloneAudienceInsights = {
  professions: ChartData[]
  genders: ChartData[]
  languages: ChartData[]
  output_countries: ChartData[]
  cities: ChartData[]
  enrichments: DeepThoughtEnrichment[]|null
}
export type GetClassifierAutocompleteQuery = {
  query?: string
}
export type StandaloneClassifierAutocomplete = {
  name: string
}
export type BigDipperAudienceRegion = {
  id: number
  country_codes: (string)[]
  is_single_country: boolean
  name: string
  m49_code: string|null
  audience_searchable: boolean
}
export type GetCreateMagicLoginLinkQuery = {
  email: string
  submission_uuid?: string
}
export type StandaloneCreateMagicLoginLink = {
  email: string
  magic_code: string
}
export type StandaloneCreateTeamInput = {
  name: string
  tier?: 'pro'|'business'
}
export type StandaloneCreateTeam = {
  name: string
  tier: 'pro'|'business'
}
export type GetExpertCategoriesQuery = {
  sdu_ids: string[]
}
export type StandaloneExpertCategory = {
  category: string
  sdu_ids: string[]
}
export type StandaloneExpertCategories = {
  categories: StandaloneExpertCategory[]
}
export type GetFacebookAuthParamsQuery = {
  redirect_uri: string
}
export type FacebookAuthParams = {
  redirect_uri: string
  client_id: string
  authorize_url: string
  scope: string
  response_type: string
}
export type GetGoogleAdsAuthParamsQuery = GetFacebookAuthParamsQuery
export type GoogleAdsAuthParams = {
  redirect_uri: string
  client_id: string
  authorize_url: string
  scope: string
}
export type GetGoogleAuthParamsQuery = GetFacebookAuthParamsQuery
export type GoogleAuthParams = GoogleAdsAuthParams
export type GetGoogleSignInParamsQuery = GetFacebookAuthParamsQuery
export type GoogleSignInParams = GoogleAdsAuthParams
export type GoogleSignInInput = {
  code: string
  redirect_uri: string
  partner_code?: string
  submission_uuid?: string
}
export type GoogleSignIn = {
  token: string
  is_new_user: boolean
}
export type GetInstagramAuthParamsQuery = GetFacebookAuthParamsQuery
export type InstagramAuthParams = FacebookAuthParams
export type GetJourneyEmailSubscriptionQuery = GetVerifySignedQuery
export type BigDipperJourneyEmailSubscription = {
  email: string
  opted_in: boolean
}
export type BigDipperJourneyEmailSubscriptionInput = {
  opted_in: boolean
}
export type PatchJourneyEmailSubscriptionQuery = GetVerifySignedQuery
export type GetKeywordsHashtagsQuery = GetAudienceInsightsQuery
export type StandAloneKeywordsHashtags = {
  top_keywords: ChartData[]
  top_hashtags: ChartData[]
}
export type LinkedInAuthParams = {
  client_id: string
  authorize_url: string
  redirect_uri: string
  scope: string
  response_type: string
}
export type BigDipperTeamMember = {
  id: number
  email: string
  username: string
}
export type BigDipperTeamUser = {
  user: BigDipperTeamMember
  role: 'owner'|'admin'|'member'|'billing_admin'|'partner_admin'|'approver'
  paid_seat: boolean
  can_approve: boolean
}
export type BigDipperTeam = {
  tier: 'pro'|'business'|null
  id: number
  is_affiliate_partner: boolean
  affiliate_partner_name: string|null|null
  websites: string[]
  users: BigDipperTeamUser[]
  name: string
  country_code: string|null
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  team_type: 'personal'|'business'|null
  billing_name: string|null
  invitees: {id: number, email: string, role: 'owner'|'admin'|'member'|'billing_admin'|'partner_admin'|'approver'}[]|null|null
  onboarding_experience_level: 'new'|'some'|'advanced'|null
  onboarding_goals: ('organic_content'|'ai_content'|'paid_campaigns'|'measurement'|'audiences')[]
  onboarding_completed_at: string|null
  posting_requires_approval: boolean
}
export type StandaloneUser = {
  email: string
  teams: BigDipperTeam[]
  is_affiliate_partner: boolean
}
export type BigDipperNotificationUnreadCount = {
  team_id: number
  unread: number
}
export type GetPinterestAdsAuthParamsQuery = GetFacebookAuthParamsQuery
export type PinterestAdsAuthParams = FacebookAuthParams
export type GetPinterestProfileQuery = GetSimilarHandlesQuery
export type StandalonePinterestProfile = {
  id: string
  handle: string
  name: string|null
  followers: number|null
  pic: string|null
  description: string|null
}
export type BigDipperPinterestProfile = {
  profile: StandalonePinterestProfile|null
}
export type GetPlaceAutocompleteQuery = {
  q: string
}
export type GooglePlaceAutocomplete = {
  description: string
  place_id: string
}
export type GetPlaceDetailsQuery = {
  place_id: string
}
export type GooglePlaceDetails = {
  latitude: number|null
  longitude: number|null
  name: string|null
  address_string: string|null
  country_code: string|null
}
export type GetPlaceReverseGeocodeQuery = {
  lat?: string
  lng?: string
}
export type RecommendedDimension = {
  width: number
  height: number
  label: string
}
export type WebsiteCardImageSpec = {
  aspect_ratio_min: number
  aspect_ratio_max: number
  min_width: number
  recommended_dimensions: RecommendedDimension[]
}
export type PlatformImageSpec = {
  formats: string[]
  max_file_size_mb: number
  recommended_dimensions: RecommendedDimension[]
  aspect_ratio_min: number
  aspect_ratio_max: number
  min_width: number
  max_images: number
  website_card: WebsiteCardImageSpec
}
export type PlatformTextSpec = {
  max_chars: number
  visible_chars: number
  recommended_chars: number
  headline_max_chars: number
  headline_recommended_chars: number
  website_title_max_chars: number
  website_title_recommended_chars: number
  link_chars: number
}
export type PlatformPublishTypeSpec = {
  image: PlatformImageSpec
  text: PlatformTextSpec
}
export type PlatformSpec = {
  organic: PlatformPublishTypeSpec
  dark: PlatformPublishTypeSpec
}
export type PlatformMediaSpecs = {
  x: PlatformSpec
  facebook: PlatformSpec
  instagram: PlatformSpec
  linkedin: PlatformSpec
  tiktok: PlatformSpec
  pinterest: PlatformSpec
  chatgpt: PlatformSpec
}
export type GetRedditAuthParamsQuery = GetFacebookAuthParamsQuery
export type RedditAuthParams = {
  redirect_uri: string
  client_id: string
  authorize_url: string
  scope: string
  duration: string
  response_type: string
}
export type GetRedditCommentsQuery = {
  subreddit_names: string[]
}
export type RedditSubmission = {
  id: string
  title: string
  author: string|null
  selftext: string
  score: number
  ups: number
  num_comments: number
  subreddit: string
  subreddit_name_prefixed: string
  permalink: string
  url: string
  thumbnail: string
  is_self: boolean
  domain: string
  upvote_ratio: number
  created: string|null
  created_utc: number|null
}
export type RedditComment = {
  id: string
  author: string|null
  body: string
  score: number
  ups: number
  subreddit: string
  subreddit_name_prefixed: string
  permalink: string
  link_title: string
  link_url: string
  num_comments: number
  created: string|null
  created_utc: number|null
  submission: RedditSubmission
}
export type StandaloneRedditComments = {
  comments: RedditComment[]
}
export type SdbDiagnosticsErrorInput = {
  test: 'api_unexpected'|'api_capturable'|'api_uncapturable'|'worker_default'|'worker_platform'
}
export type SdbDiagnosticsError = {
  test: 'api_unexpected'|'api_capturable'|'api_uncapturable'|'worker_default'|'worker_platform'
  task_id: string
}
export type StandaloneDummy = StandaloneShareViaAccountAudienceConfig
export type GetSdbTrackingActivityQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: 'kind'|'-kind'|'title'|'-title'|'team_name'|'-team_name'|'created'|'-created'
  kind?: 'campaign'|'post'|'audience'|'seat'
}
export type SdbTrackingActivity = {
  id: string
  object_id: number
  kind: 'campaign'|'post'|'audience'|'seat'
  title: string
  team_name: string
  team_id: number|null
  platforms: string[]
  created: string
}
export type GetSdbTrackingAudiencesQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: 'name'|'-name'|'team_name'|'-team_name'|'user_email'|'-user_email'|'audience_size'|'-audience_size'|'created'|'-created'
}
export type SdbTrackingAudience = {
  name: string
  team_name: string
  team_id: number|null
  user_email: string
  platforms: string[]
  audience_size: number|null
  created: string
}
export type SdbTrackingCampaignCheckedInput = {
  campaign_id: number
  checked: boolean
}
export type SdbTrackingCampaignChecked = {
  campaign_id: number
  checked: boolean
  checked_by: string
  checked_at: string|null
}
export type GetSdbTrackingCampaignsQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: 'name'|'-name'|'objective'|'-objective'|'team_name'|'-team_name'|'user_email'|'-user_email'|'source'|'-source'|'created'|'-created'
}
export type SdbTrackingCampaign = {
  id: number
  name: string|null
  objective: string|null
  team_name: string
  team_id: number|null
  user_email: string
  platforms: string[]
  source: 'launched'|'grouped'|null
  created: string
  checked: boolean
  checked_by: string
  checked_at: string|null
}
export type GetSdbTrackingCanceledQuery = {
  days?: '7'|'30'|'90'|'all'
}
export type SdbTrackingCanceled = {
  email: string
  team_name: string
  team_id: number|null
  tier: 'pro'|'business'
  seats: number
  reason: string|null
  canceled_at: string|null
}
export type SdbTrackingGrowthPoint = {
  week: string
  count: number
}
export type SdbTrackingGrowth = {
  website_submissions: SdbTrackingGrowthPoint[]
  signups: SdbTrackingGrowthPoint[]
  subscribers: SdbTrackingGrowthPoint[]
  canceled: SdbTrackingGrowthPoint[]
  campaigns: SdbTrackingGrowthPoint[]
  posts: SdbTrackingGrowthPoint[]
  audiences: SdbTrackingGrowthPoint[]
}
export type SdbTrackingJoinTeamInput = {
  team_id: number
}
export type SdbTrackingJoinTeam = {
  team_id: number
  team_name: string
  role: 'owner'|'admin'|'member'|'billing_admin'|'partner_admin'|'approver'
  already_member: boolean
}
export type GetSdbTrackingJourneyEmailPreviewQuery = {
  email_id: number
}
export type SdbTrackingJourneyEmailPreview = {
  html: string
}
export type GetSdbTrackingJourneyEmailReportQuery = {
  days?: '7'|'30'|'90'|'all'
  include_internal?: boolean
}
export type SdbTrackingJourneyEmailReportWeek = {
  week: string
  emails_sent: number
  delivered: number
  bounces: number
  abuse_reports: number
  unique_opens: number
  proxy_excluded_unique_opens: number
  unique_clicks: number
}
export type SdbTrackingJourneyEmailReport = {
  weeks: SdbTrackingJourneyEmailReportWeek[]
}
export type GetSdbTrackingJourneyEmailsQuery = {
  limit?: number
  offset?: number
  days?: '7'|'30'|'90'|'all'
  search?: string
  ordering?: 'created'|'-created'|'user_email'|'-user_email'|'team_name'|'-team_name'|'subject'|'-subject'|'status'|'-status'|'opted_in'|'-opted_in'
  include_internal?: boolean
  team?: number
}
export type SdbTrackingJourneyEmail = {
  id: number
  user_id: number
  user_email: string
  team_name: string
  team_id: number|null
  trigger: 'welcome'|'walkthrough'|'connections'|'audiences'|'campaigns'|'posts'|'members_invited'|'members_joined'|'website'|'analytics'|'searches'|'no_connection'|'no_campaign'|'no_audience'|'no_search'|'subscribed'|'limit_reached'|'offer_discount'
  threshold: number|null
  subject: string
  status: 'pending'|'sent'|'queued'|'scheduled'|'rejected'|'invalid'|'failed'|'superseded'
  reject_reason: string
  card_keys: string[]
  opted_in: boolean
  opt_out_source: ''|'app'|'link'|'one_click'|'hubspot'|'mailchimp'|'admin'|'affiliate'
  created: string
}
export type SdbTrackingJourneyOptInInput = {
  user_id: number
  opted_in: boolean
}
export type SdbTrackingJourneyOptIn = {
  user_id: number
  opted_in: boolean
  opt_out_source: ''|'app'|'link'|'one_click'|'hubspot'|'mailchimp'|'admin'|'affiliate'
}
export type SdbTrackingLeadStatusInput = {
  uuid: string
  lead_status: 'unassigned'|'contacted'|'interested'|'waiting_for_seat_purchase'|'customer'|'not_interested'
  lead_comment?: string
}
export type SdbTrackingLeadStatus = {
  lead_status: 'unassigned'|'contacted'|'interested'|'waiting_for_seat_purchase'|'customer'|'not_interested'
  lead_comment: string
  lead_status_by: string
  lead_status_at: string|null
}
export type SdbTrackingLeaveTeamInput = SdbTrackingJoinTeamInput
export type SdbTrackingLeaveTeam = {
  team_id: number
  team_name: string
}
export type SdbTrackingPartnerTeam = {
  team_id: number
  team_name: string
  created: string
}
export type SdbTrackingPartner = {
  id: number
  name: string
  team_id: number
  partner_code: string
  is_active: boolean
  rev_share_percent: number
  payouts_status: 'enabled'|'onboarding'|'not_started'
  team_count: number
  teams: SdbTrackingPartnerTeam[]
  created: string
}
export type SdbTrackingPaymentIssue = {
  email: string
  team_name: string
  team_id: number|null
  tier: 'pro'|'business'
  seats: number
  subscription_status: 'incomplete'|'past_due'|'unpaid'
  payment_status: 'pending'|'needs_authentication'|'awaiting_payment'|'failed'
  failure_reason: string|null
  amount_due: number
  currency: string
  attempt_count: number
  next_payment_attempt: string|null
  due_date: string|null
  since: string|null
  invoice_url: string|null
}
export type GetSdbTrackingPostsQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: 'post_text'|'-post_text'|'team_name'|'-team_name'|'platform'|'-platform'|'status'|'-status'|'publish_type'|'-publish_type'|'scheduled_at'|'-scheduled_at'|'created'|'-created'
  post_status?: 'published'|'scheduled'
}
export type SdbTrackingPost = {
  post_text: string|null
  team_name: string
  team_id: number|null
  platform: 'x'|'meta'|'facebook'|'instagram'|'linkedin'|'reddit'|'tiktok'
  status: 'published'|'scheduled'
  publish_type: 'organic'|'dark'
  scheduled_at: string|null
  created: string
}
export type SdbTrackingSubscriber = {
  email: string
  team_name: string
  team_id: number|null
  seats: number
  status: 'active'|'trialing'
  days_left_in_trial: number
  first_subscribed_at: string|null
  onboarding_experience_level: 'new'|'some'|'advanced'|null
  onboarding_goals: ('organic_content'|'ai_content'|'paid_campaigns'|'measurement'|'audiences')[]
  onboarding_completed_at: string|null
  actions_last_30_days: number
  actions_total: number
}
export type GetSdbTrackingTeamResearchQuery = SdbTrackingJoinTeamInput
export type SdbTrackingTeamResearchSection = {
  category: 'business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit'|'marketing_funnels'|'campaign_name_format'
  content: string
}
export type SdbTrackingTeamResearch = {
  team_name: string
  websites: string[]
  teaser_summary: string
  sections: SdbTrackingTeamResearchSection[]
}
export type GetSdbTrackingWebsiteSubmissionsQuery = GetSdbTrackingCanceledQuery
export type SdbTrackingWebsiteSubmission = {
  lead_key: string
  source: 'signup'|'partner'|'backend'
  website: string
  domain: string
  email: string|null
  funnel_status: 'submitted'|'email'|'code_requested'|'signed_up'|'invited'
  teaser_status: 'pending'|'running'|'completed'|'error'|null
  team_name: string
  team_id: number|null
  partner_code: string
  partner_name: string
  converted_at: string|null
  created: string
  uuid: string
  lead_status: 'unassigned'|'contacted'|'interested'|'waiting_for_seat_purchase'|'customer'|'not_interested'
  lead_status_by: string
  lead_status_at: string|null
  lead_comment: string
  onboarding_experience_level: 'new'|'some'|'advanced'|null
  onboarding_goals: ('organic_content'|'ai_content'|'paid_campaigns'|'measurement'|'audiences')[]
  onboarding_completed_at: string|null
}
export type SdbTrackingResponse = {
  business_seats: number
  pro_seats: number
  active_business_teams: number
  active_pro_teams: number
  canceled_business_teams: number
  canceled_pro_teams: number
  payment_issue_teams: number
  payment_issue_amount: number
  total_mrr: number
  mrr_currency: string
  mrr_growth_percentage: number|null
}
export type GetShopifyAuthParamsQuery = {
  redirect_uri: string
  shop: string
}
export type ShopifyAuthParams = {
  redirect_uri: string
  client_id: string
  authorize_url: string
  scope: string
  shop_domain: string
}
export type BigDipperSimilarHandles = StandaloneSimilarHandles
export type GetSocialAccountsContentQuery = {
  keywords: string[]
  countries?: string[]
}
export type SpotifyEpisode = {
  episode_id: string
  account_name: string
  pic: string|null
  show_name: string
  episode_name: string
  description: string|null
  image_url: string|null
  audio_preview_url: string|null
  release_date: string|null
  duration: number|null
  show_id: string
}
export type TwitchVideo = {
  video_id: string
  handle: string
  title: string
  description: string|null
  publish_date: string|null
  thumbnail_url: string|null
  view_count: number|null
}
export type StandaloneSocialAccountsContent = {
  spotify_shows: SpotifyShow[]
  spotify_artists: SpotifyArtist[]
  spotify_episodes: SpotifyEpisode[]
  youtube_channels: YouTubeChannel[]
  youtube_videos: YouTubeVideo[]
  subreddits: Subreddit[]
  twitch_channels: StandalonePlatformAccount[]
  twitch_videos: TwitchVideo[]
  posts: DeepThoughtPostMedia[]
}
export type GetSocialAccountsPerPlatformQuery = GetSocialAccountsContentQuery
export type StandalonePlatformUsage = {
  platform: string
  usage: number|null
}
export type StandalonePlatformAccountsPerPlatform = {
  facebook_accounts: StandalonePlatformAccount[]
  instagram_accounts: StandalonePlatformAccount[]
  linkedin_accounts: StandalonePlatformAccount[]
  tiktok_accounts: StandalonePlatformAccount[]
  youtube_accounts: StandalonePlatformAccount[]
  discord_accounts: StandalonePlatformAccount[]
  twitch_accounts: StandalonePlatformAccount[]
  x_accounts: StandalonePlatformAccount[]
  pinterest_accounts: StandalonePlatformAccount[]
  spotify_shows: SpotifyShow[]
  subreddits: Subreddit[]
  platform_usage: StandalonePlatformUsage[]
}
export type TargetingResolveInput = {
  platform: string
  field: string
  items: string[]
  lookup_field?: string|null
}
export type TargetingResolvedOption = {
  label: string
  value: string|null
  targeting_value: string|null
  id: number|null
  name: string|null
  description: string|null
  interest: string|null
  field: string|null
  handle: string|null
  linkedin_url: string|null
  website: string|null
  location: string|null
  category: string|null
  input: string|null
}
export type TargetingDroppedItem = {
  input: string
  reason: 'NOT_FOUND'|'AMBIGUOUS'|'UNSUPPORTED'|'DUPLICATE'|'LOOKUP_FAILED'
  suggestions: TargetingResolvedOption[]
}
export type TargetingResolve = {
  resolved: TargetingResolvedOption[]
  dropped: TargetingDroppedItem[]
}
export type GetTargetingOptionsQuery = {
  platform?: string
  field?: string
  q?: string
}
export type TargetingOption = {
  label: string
  value: string|null
  targeting_value: string|null
  id: number|null
  name: string|null
  description: string|null
  interest: string|null
  field: string|null
  handle: string|null
  linkedin_url: string|null
  website: string|null
  location: string|null
}
export type GetTargetingPackChatgptQuery = {
  input_keywords: string[]
  input_countries?: string[]
}
export type ChatgptTargetingLocation = {
  id: string
  name: string|null
  type: string|null
  country_code: string|null
}
export type ChatgptTargetingGeo = {
  countries: string[]
  locations: ChatgptTargetingLocation[]
  excluded_countries: string[]
  excluded_locations: ChatgptTargetingLocation[]
}
export type ChatgptTargetingCustomAudience = {
  id: string
  name: string|null
  deselected: boolean|null
  ad_account_id: string|null
  ad_account_name: string|null
}
export type StandaloneChatgptTargetingPack = {
  context_hints: string[]
  geo_targeting: ChatgptTargetingGeo
  platforms: ('ios_app'|'android_app'|'web'|'desktop_web'|'ios_web'|'android_web')[]
  custom_audiences: ChatgptTargetingCustomAudience[]
  excluded_custom_audiences: ChatgptTargetingCustomAudience[]
}
export type GetTargetingPackDiscordQuery = GetTargetingPackChatgptQuery
export type StandaloneDiscordTargetingPack = {
  discord_accounts: StandalonePlatformAccount[]
}
export type GetTargetingPackFacebookInstagramQuery = {
  input_keywords: string[]
  input_countries?: string[]
  audience_description?: string
  input_meta_special_ad_categories?: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
  input_interests?: string[]
  input_behaviors?: string[]
  input_job_titles?: string[]
  input_industries?: string[]
  input_companies?: string[]
  input_seniorities?: string[]
  input_skills?: string[]
  input_genders?: string[]
  input_age_min?: number
  input_age_max?: number
}
export type FacebookInstagramCustomLocationItem = {
  latitude: number
  longitude: number
  radius: number
  distance_unit: 'mile'|'kilometer'
  name: string|null
  address_string: string|null
  country_code: string|null
}
export type FacebookInstagramGeoLocations = {
  countries: string[]
  custom_locations: FacebookInstagramCustomLocationItem[]
}
export type FacebookInstagramInterestItem = {
  id: string
  name: string
  audience_size_lower_bound: number|null
  audience_size_upper_bound: number|null
  deselected: boolean|null
}
export type FacebookInstagramDemographicItem = {
  id: string
  name: string
  type: string
  path: string
  description: string|null
  real_time_cluster: boolean
  audience_size_lower_bound: number|null
  audience_size_upper_bound: number|null
  deselected: boolean|null
}
export type FacebookInstagramBehaviorItem = FacebookInstagramInterestItem
export type FacebookInstagramJobTitleItem = {
  id: string
  name: string
  coverage_lower_bound: number|null
  coverage_upper_bound: number|null
  deselected: boolean|null
}
export type FacebookInstagramCustomAudienceItem = ChatgptTargetingCustomAudience
export type StandaloneFacebookInstagramTargetingPack = {
  geo_locations: FacebookInstagramGeoLocations|null
  age_min: number|null
  age_max: number|null
  locales: number[]
  genders: number[]
  interests: FacebookInstagramInterestItem[]
  demographics: FacebookInstagramDemographicItem[]
  behaviors: FacebookInstagramBehaviorItem[]
  job_titles: FacebookInstagramJobTitleItem[]
  device_platforms: string[]
  publisher_platforms: string[]
  custom_audiences: FacebookInstagramCustomAudienceItem[]
  excluded_custom_audiences: FacebookInstagramCustomAudienceItem[]
  flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: StandaloneFacebookInstagramTargetingPackSerializerFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: StandaloneFacebookInstagramTargetingPackSerializerFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]
}
export type GetTargetingPackGoogleQuery = GetTargetingPackChatgptQuery
export type GoogleTargetingKeyword = {
  text: string
  match_type: 'broad'|'phrase'|'exact'
  is_negative: boolean
  deselected: boolean
}
export type GoogleTargetingLocation = {
  id: string
  name: string|null
  is_negative: boolean
  deselected: boolean
}
export type GoogleTargetingRadius = {
  latitude: number
  longitude: number
  radius: number
  unit: 'KILOMETERS'|'MILES'
  address: string|null
  deselected: boolean
}
export type GoogleTargetingGeo = {
  locations: GoogleTargetingLocation[]
  radius_targeting: GoogleTargetingRadius[]
}
export type GoogleTargetingUserInterest = {
  resource_name: string
  name: string|null
  category: 'AFFINITY'|'IN_MARKET'|'LIFE_EVENT'
  deselected: boolean
}
export type GoogleTargetingAudiences = {
  user_interests: GoogleTargetingUserInterest[]
  user_lists: any[]
}
export type GoogleTargetingDevice = {
  type: 'MOBILE'|'DESKTOP'|'TABLET'|'CONNECTED_TV'
  bid_modifier: number
  deselected: boolean
}
export type StandaloneGoogleTargetingPack = {
  keywords: GoogleTargetingKeyword[]
  geo_targeting: GoogleTargetingGeo
  audiences: GoogleTargetingAudiences
  demographics: any
  devices: GoogleTargetingDevice[]
  ad_schedule: any[]
}
export type GetTargetingPackLinkedinQuery = {
  input_keywords: string[]
  input_countries?: string[]
  input_interests?: string[]
  input_behaviors?: string[]
  input_job_titles?: string[]
  input_industries?: string[]
  input_companies?: string[]
  input_seniorities?: string[]
  input_skills?: string[]
  input_genders?: string[]
  input_age_min?: number
  input_age_max?: number
}
export type LinkedInTargetingFacet = {
  facet: 'urn:li:adTargetingFacet:ageRanges'|'urn:li:adTargetingFacet:audienceMatchingSegments'|'urn:li:adTargetingFacet:dynamicSegments'|'urn:li:adTargetingFacet:companyCategory'|'urn:li:adTargetingFacet:degrees'|'urn:li:adTargetingFacet:employers'|'urn:li:adTargetingFacet:employersAll'|'urn:li:adTargetingFacet:employersPast'|'urn:li:adTargetingFacet:fieldsOfStudy'|'urn:li:adTargetingFacet:firstDegreeConnectionCompanies'|'urn:li:adTargetingFacet:followedCompanies'|'urn:li:adTargetingFacet:genders'|'urn:li:adTargetingFacet:groups'|'urn:li:adTargetingFacet:growthRate'|'urn:li:adTargetingFacet:industries'|'urn:li:adTargetingFacet:interests'|'urn:li:adTargetingFacet:interfaceLocales'|'urn:li:adTargetingFacet:jobFunctions'|'urn:li:adTargetingFacet:locations'|'urn:li:adTargetingFacet:memberBehaviors'|'urn:li:adTargetingFacet:profileLocations'|'urn:li:adTargetingFacet:schools'|'urn:li:adTargetingFacet:seniorities'|'urn:li:adTargetingFacet:skills'|'urn:li:adTargetingFacet:staffCountRanges'|'urn:li:adTargetingFacet:titles'|'urn:li:adTargetingFacet:titlesAll'|'urn:li:adTargetingFacet:titlesPast'|'urn:li:adTargetingFacet:yearsOfExperienceRanges'|'urn:li:adTargetingFacet:buyerGroups'
  segments: string[]
  segment_names: any|null
  name: string|null
  deselected: boolean|null
}
export type LinkedInTargetingOrGroup = {
  or: LinkedInTargetingFacet[]
}
export type LinkedInTargetingInclude = {
  and: LinkedInTargetingOrGroup[]
}
export type LinkedInTargetingExclude = {
  or: any
}
export type LinkedInTargetingCriteria = {
  include: LinkedInTargetingInclude
  exclude: LinkedInTargetingExclude
}
export type LinkedInTargetingFacetItem = {
  urn: string
  name: string
  facetUrn: string|null
  deselected: boolean|null
}
export type LinkedInLocationItem = {
  urn: string
  name: string
  country: string|null
  deselected: boolean|null
}
export type LinkedInCustomAudienceItem = ChatgptTargetingCustomAudience
export type StandaloneLinkedInTargetingPack = {
  targetingCriteria: LinkedInTargetingCriteria
  industries: LinkedInTargetingFacetItem[]
  job_functions: LinkedInTargetingFacetItem[]
  seniorities: LinkedInTargetingFacetItem[]
  company_sizes: LinkedInTargetingFacetItem[]
  company_categories: LinkedInTargetingFacetItem[]
  titles: LinkedInTargetingFacetItem[]
  member_skills: LinkedInTargetingFacetItem[]
  fields_of_study: LinkedInTargetingFacetItem[]
  member_schools: LinkedInTargetingFacetItem[]
  locations: LinkedInLocationItem[]
  age_ranges: LinkedInTargetingFacetItem[]
  genders: LinkedInTargetingFacetItem[]
  custom_audiences: LinkedInCustomAudienceItem[]
  excluded_custom_audiences: LinkedInCustomAudienceItem[]
}
export type GetTargetingPackNarrationStreamQuery = {
  audience_summary?: string
}
export type GetTargetingPackPinterestQuery = GetTargetingPackChatgptQuery
export type PinterestTargetingAccount = {
  name: string|null
  handle: string
  followers: number|null
  pic: string|null
  description: string|null
  deselected: boolean|null
}
export type PinterestTargetingDemographics = {
  age_ranges: ('18-24'|'25-34'|'35-44'|'45-49'|'50-54'|'55-64'|'65+')[]
  minimum_age: number|null
  genders: ('male'|'female'|'unknown')[]
  languages: string[]
}
export type PinterestTargetingGeo = {
  countries: string[]
  postal_codes: string[]
}
export type PinterestTargetingCustomAudience = ChatgptTargetingCustomAudience
export type StandalonePinterestTargetingPack = {
  keywords: string[]
  excluded_keywords: string[]
  interests: string[]
  pinterest_accounts: PinterestTargetingAccount[]
  demographics: PinterestTargetingDemographics
  geo_targeting: PinterestTargetingGeo
  devices: ('iphone'|'ipad'|'android_mobile'|'android_tablet'|'web'|'web_mobile')[]
  placements: ('browse'|'search')[]
  expanded_targeting: boolean
  custom_audiences: PinterestTargetingCustomAudience[]
  excluded_custom_audiences: PinterestTargetingCustomAudience[]
}
export type GetTargetingPackRedditQuery = GetTargetingPackChatgptQuery
export type RedditTargetingKeywordItem = {
  label: string
  deselected: boolean|null
}
export type RedditTargetingSubredditItem = {
  subreddit: string
  daily_impressions: number|null
  mentions: number|null
  public_description: string|null
  subscribers: number|null
  img_url: string|null
  deselected: boolean|null
}
export type RedditTargetingInterestItem = {
  interest: string
  audience_size: number|null
  deselected: boolean|null
}
export type StandaloneRedditTargetingPack = {
  keywords: RedditTargetingKeywordItem[]
  subreddits: RedditTargetingSubredditItem[]
  communities: string[]
  excluded_communities: string[]
  excluded_keywords: string[]
  interests: RedditTargetingInterestItem[]
  excluded_interests: string[]
  geolocations: string[]
  excluded_geolocations: string[]
  custom_audiences: string[]
  excluded_custom_audiences: string[]
  devices: string[]
  expand_targeting: boolean
}
export type GetTargetingPackSeoQuery = GetTargetingPackChatgptQuery
export type GoogleKeyword = GoogleTargetingKeyword
export type GoogleLocation = GoogleTargetingLocation
export type GoogleRadiusTargeting = GoogleTargetingRadius
export type GoogleGeoTargeting = {
  locations: GoogleLocation[]
  radius_targeting: GoogleRadiusTargeting[]
}
export type GoogleUserInterest = {
  resource_name: string
  name: string
  category: 'AFFINITY'|'IN_MARKET'|'LIFE_EVENT'
  deselected: boolean
}
export type GoogleUserList = {
  resource_name: string
  name: string
  deselected: boolean
}
export type GoogleAudiences = {
  user_interests: GoogleUserInterest[]
  user_lists: GoogleUserList[]
}
export type GoogleAgeRange = {
  type: 'AGE_RANGE_18_24'|'AGE_RANGE_25_34'|'AGE_RANGE_35_44'|'AGE_RANGE_45_54'|'AGE_RANGE_55_64'|'AGE_RANGE_65_UP'|'AGE_RANGE_UNDETERMINED'
  deselected: boolean
}
export type GoogleGender = {
  type: 'MALE'|'FEMALE'|'UNDETERMINED'
  deselected: boolean
}
export type GoogleDemographics = {
  age_ranges: GoogleAgeRange[]
  genders: GoogleGender[]
}
export type GoogleDevice = GoogleTargetingDevice
export type GoogleAdSchedule = {
  day_of_week: 'MONDAY'|'TUESDAY'|'WEDNESDAY'|'THURSDAY'|'FRIDAY'|'SATURDAY'|'SUNDAY'
  start_hour: number
  start_minute: 'ZERO'|'FIFTEEN'|'THIRTY'|'FORTY_FIVE'
  end_hour: number
  end_minute: 'ZERO'|'FIFTEEN'|'THIRTY'|'FORTY_FIVE'
  deselected: boolean
}
export type StandaloneSeoTargetingPack = {
  keywords: GoogleKeyword[]
  geo_targeting: GoogleGeoTargeting
  audiences: GoogleAudiences
  demographics: GoogleDemographics
  devices: GoogleDevice[]
  ad_schedule: GoogleAdSchedule[]
}
export type GetTargetingPackSpotifyQuery = GetTargetingPackChatgptQuery
export type StandaloneSpotifyTargetingPack = {
  spotify_shows: SpotifyShow[]
  ad_category: string
  interests: string[]
  age_ranges: string[]
}
export type GetTargetingPackTiktokQuery = GetTargetingPackChatgptQuery
export type TiktokTargetingGeo = {
  countries: string[]
  regions: string[]
  cities: string[]
  postal_codes: string[]
}
export type StandaloneTiktokTargetingPack = {
  keywords: string[]
  interests: string[]
  geo_targeting: TiktokTargetingGeo
}
export type GetTargetingPackTwitchQuery = GetTargetingPackChatgptQuery
export type StandaloneTwitchTargetingPack = {
  audience_interests: string[]
  game_category: string
  devices: string
  peak_streaming_times: string
  recommended_ad_formats: string
  bid_optimization_strategy: string
  measurement_kpis: string
  twitch_channels: StandalonePlatformAccount[]
}
export type GetTargetingPackXQuery = GetTargetingPackLinkedinQuery
export type TargetingPackageKeywordItem = {
  label: string
  size: number|null
  deselected: boolean|null
}
export type TargetingPackageHashtagItem = TargetingPackageKeywordItem
export type TargetingPackageHandleItem = {
  picture: string|null
  id: number
  handle: string
  name: string
  followers: number
  deselected: boolean|null
}
export type StandaloneXTargetingPack = {
  keywords: TargetingPackageKeywordItem[]
  hashtags: TargetingPackageHashtagItem[]
  handles: TargetingPackageHandleItem[]
  interests: TargetingPackageKeywordItem[]
  conversation_topics: TargetingPackageKeywordItem[]
  languages: TargetingPackageKeywordItem[]
  movies_tv_shows: TargetingPackageKeywordItem[]
  gender: 'ANY'|'MALE'|'FEMALE'
  age: string
  countries: string[]
  locations: string[]
}
export type GetTargetingPackYoutubeQuery = GetTargetingPackChatgptQuery
export type YoutubeTargetingChannelItem = {
  channel_id: string
  handle: string|null
  title: string|null
  subscriber_count: number|null
  thumbnail_url: string|null
  is_negative: boolean
  deselected: boolean
}
export type YoutubeTargetingVideoItem = {
  video_id: string
  title: string|null
  description: string|null
  thumbnail_url: string|null
  view_count: number|null
  like_count: number|null
  publish_date: string|null
  is_negative: boolean
  deselected: boolean
  channel: YoutubeTargetingChannelItem|null
}
export type YoutubeKeyword = {
  text: string
  is_negative: boolean
  deselected: boolean
}
export type YoutubeTopic = {
  topic_id: string
  name: string|null
  deselected: boolean
}
export type YoutubeAudiences = {
  user_interests: GoogleUserInterest[]
}
export type YoutubeParentalStatus = {
  type: 'PARENT'|'NOT_A_PARENT'|'UNDETERMINED'
  deselected: boolean
}
export type YoutubeDemographics = {
  age_ranges: GoogleAgeRange[]
  genders: GoogleGender[]
  parental_status: YoutubeParentalStatus[]
}
export type YoutubeGeoTargeting = {
  locations: GoogleLocation[]
}
export type YoutubeDevice = {
  type: 'MOBILE'|'DESKTOP'|'TABLET'|'CONNECTED_TV'
  deselected: boolean
}
export type YoutubeAdSchedule = GoogleAdSchedule
export type StandaloneYoutubeTargetingPack = {
  youtube_channels: YoutubeTargetingChannelItem[]
  youtube_videos: YoutubeTargetingVideoItem[]
  keywords: YoutubeKeyword[]
  topics: YoutubeTopic[]
  audiences: YoutubeAudiences
  demographics: YoutubeDemographics
  geo_targeting: YoutubeGeoTargeting
  devices: YoutubeDevice[]
  ad_schedule: YoutubeAdSchedule[]
}
export type StandaloneTargetingReachInput = {
  platform: string
  targeting: any
}
export type StandaloneTargetingReach = {
  min: number
  max: number
  reason: 'no_targeting'|'targeting_too_broad'|'no_country'|null
}
export type StandaloneVagueKeywords = {
  platforms: string[]
  min_length: number
  terms: string[]
  message: string
}
export type StandaloneMinorAgeMarket = {
  market: string
  minimum_age: number
}
export type StandaloneMinorTargeting = {
  platforms: string[]
  age_range: string
  dimensions: string[]
  blocked_objectives: string[]
  minimum_age_by_market: StandaloneMinorAgeMarket[]
  message: string
}
export type StandaloneBlockedCountry = {
  country: string
  reason: string
}
export type StandalonePlatformBlockedCountries = {
  x: StandaloneBlockedCountry[]
  facebook: StandaloneBlockedCountry[]
  instagram: StandaloneBlockedCountry[]
  linkedin: StandaloneBlockedCountry[]
  reddit: StandaloneBlockedCountry[]
  google: StandaloneBlockedCountry[]
  tiktok: StandaloneBlockedCountry[]
  pinterest: StandaloneBlockedCountry[]
  chatgpt: StandaloneBlockedCountry[]
}
export type StandaloneBlockedCountryAlias = {
  name: string
  country: string
}
export type StandaloneSpecialAdCategoryCountries = {
  tiktok: string[]
  meta: string[]
}
export type StandaloneHfss = {
  platforms: string[]
  countries: string[]
  lhf_countries: string[]
  terms: string[]
  min_matches: number
}
export type StandaloneRestrictedCountries = {
  codes: string[]
  names: string[]
  region_terms: string[]
  linkedin_geo_urns: string[]
  google_criterion_ids: string[]
}
export type StandaloneCategoryPlatformPolicy = {
  policy: string
  special_ad_category: string
  min_age: number
  min_age_by_country: any
  prohibited_countries: string[]
  country_notes: any
  blocked_countries: string[]
  allowed_countries: string[]
}
export type StandaloneCategoryPlatforms = {
  x: StandaloneCategoryPlatformPolicy
  facebook: StandaloneCategoryPlatformPolicy
  instagram: StandaloneCategoryPlatformPolicy
  linkedin: StandaloneCategoryPlatformPolicy
  reddit: StandaloneCategoryPlatformPolicy
  google: StandaloneCategoryPlatformPolicy
  tiktok: StandaloneCategoryPlatformPolicy
  pinterest: StandaloneCategoryPlatformPolicy
  chatgpt: StandaloneCategoryPlatformPolicy
}
export type StandaloneTargetingCategory = {
  label: string
  terms: string[]
  platforms: StandaloneCategoryPlatforms
}
export type StandaloneTargetingCategories = {
  gambling: StandaloneTargetingCategory
  alcohol: StandaloneTargetingCategory
  politics: StandaloneTargetingCategory
  housing: StandaloneTargetingCategory
  employment: StandaloneTargetingCategory
  credit: StandaloneTargetingCategory
  drugs: StandaloneTargetingCategory
  weapons: StandaloneTargetingCategory
  tobacco: StandaloneTargetingCategory
  adult: StandaloneTargetingCategory
  dating: StandaloneTargetingCategory
  cryptocurrency: StandaloneTargetingCategory
  healthcare_pharma: StandaloneTargetingCategory
  financial_services: StandaloneTargetingCategory
  weight_loss: StandaloneTargetingCategory
}
export type StandalonePlatformRestriction = {
  name: string
  sensitive_categories_prohibited: boolean
  special_ad_categories: boolean
  notes: string
  reference: string
}
export type StandalonePlatformRestrictions = {
  meta: StandalonePlatformRestriction
  linkedin: StandalonePlatformRestriction
  x: StandalonePlatformRestriction
  reddit: StandalonePlatformRestriction
  tiktok: StandalonePlatformRestriction
  pinterest: StandalonePlatformRestriction
  chatgpt: StandalonePlatformRestriction
}
export type StandaloneTargetingRestrictions = {
  version: number
  sensitive_categories: string[]
  special_ad_categories: string[]
  special_ad_category_min_matches: number
  vague_keywords: StandaloneVagueKeywords
  minor_targeting: StandaloneMinorTargeting
  platform_blocked_countries: StandalonePlatformBlockedCountries
  blocked_country_name_aliases: StandaloneBlockedCountryAlias[]
  special_ad_category_countries: StandaloneSpecialAdCategoryCountries
  hfss: StandaloneHfss
  restricted_countries: StandaloneRestrictedCountries
  alcohol_prohibited_countries: string[]
  categories: StandaloneTargetingCategories
  platforms: StandalonePlatformRestrictions
  warning: string
}
export type StandaloneTargetingSimilarityInput = {
  keywords: string[]
  threshold?: number|null
}
export type StandaloneTargetingSimilarityResult = {
  keyword: string
  similarity: number
  concept: string
  label: string
  kind: string
  flagged: boolean
}
export type StandaloneTargetingSimilarity = {
  threshold_used: number
  results: StandaloneTargetingSimilarityResult[]
}
export type TargetingTreeNode = {
  id: string
  label: string
  value: string|null
  field: string
  is_leaf: boolean
  has_children: boolean
  browseable: boolean
  path: string[]
  audience_size_lower_bound: number|null
  audience_size_upper_bound: number|null
  description: string|null
  metadata: any
}
export type TargetingTreeResponse = {
  platform: string
  parent: any|null
  node_type: string
  children: TargetingTreeNode[]
  total: number
  limit: number
  offset: number
  search_hint: any|null
  error: string|null
}
export type GetTeamInvitationQuery = GetVerifySignedQuery
export type StandaloneTeamInvitation = {
  team_name: string
  accepted: string|null
}
export type GetTiktokAdsAuthParamsQuery = GetFacebookAuthParamsQuery
export type TikTokAdsAuthParams = {
  redirect_uri: string
  app_id: string
  authorize_url: string
}
export type GetUseMagicLoginLinkQuery = {
  magic_code: string
  confirm_code: string
  partner_code?: string
  submission_uuid?: string
}
export type UseMagicLoginLink = GoogleSignIn
export type BigDipperUserPreferences = {
  weekly_digest_opt_in: boolean
  journey_emails_opt_in: boolean
}
export type BigDipperUserPreferencesInput = BigDipperUserPreferences
export type GetUserSearchHistoryQuery = {
  distinct?: boolean
}
export type StandaloneUserSearchHistory = {
  id: number
  created: string
  modified: string
  keywords: string
  countries: string[]
  input_query: string
}
export type WebsiteSubmissionEmailInput = {
  uuid: string
  email: string
}
export type WebsiteSubmissionEmail = {
  attached: boolean
}
export type GetWebsiteSubmissionStreamQuery = {
  uuid?: string
}
export type WebsiteSubmissionStreamEvent = {
  type: 'log'|'image'|'section'|'token'|'error'|null
  message: string|null
  url: string|null
  alt: string|null
  section: 'brand'|'content'|'audience'|'campaigns'|null
  label: string|null
  status: 'in_progress'|'completed'|'error'|null
  text: string|null
}
export type WebsiteSubmissionInput = {
  website: string
}
export type WebsiteSubmission = {
  uuid: string
  normalized_website: string
  domain: string
}
export type StandaloneXAdsRequestToken = {
  oauth_token: string
  oauth_token_secret: string
  authorization_url: string
  callback_url: string
}
export type GetXCodeChallengeQuery = GetFacebookAuthParamsQuery
export type StandaloneXCodeChallenge = {
  redirect_uri: string
  client_id: string
  authorize_url: string
  code_challenge: string
  code_challenge_method: string
  scope: string
  code_verifier: string
}
export type GetYoutubeVideosQuery = {
  channel_ids: string[]
}
export type StandaloneYoutubeVideos = {
  videos: YouTubeVideo[]
}
export type GetTeamAdSuggestionRunsQuery = GetAdSetListQuery
export type AdSuggestionOwnAdRef = {
  platform: 'meta'|'x'|'linkedin'|'tiktok'|'pinterest'|'chatgpt'
  ad_id: string
}
export type AdSuggestionConfig = {
  extra_context: string
  research_categories: ('business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit')[]
  own_ad_refs: AdSuggestionOwnAdRef[]
  own_media_ids: number[]
  competitor_ad_ids: number[]
  clone_competitor_ad_id: number|null
  product_media_ids: number[]
  copy_model: 'gpt-6-astra'|'gemini-2.5-flash'
  image_model: 'gemini-3.1-flash-image-preview'|'marketing-studio/image'|'grok-imagine-image-2.0'|'gpt-image-2.5-flare'
  aspect_ratio: '1:1'|'3:4'|'4:3'|'2:3'|'3:2'|'9:16'|'16:9'
  number_of_ads: number
  auto_references: boolean
  output_format: 'image'|'video'
  video_model: 'bytedance/seedance-2.5/reference-to-video'
  video_duration: number
}
export type AdSuggestionVideoEdit = {
  id: number
  status: 'pending'|'running'|'completed'|'error'
  prompt: string
  summary: string
  video_url: string
  video_thumbnail_url: string
  error: string
  created: string
  completed_at: string|null
}
export type AdSuggestionReference = {
  label: string
  kind: 'competitor_ad'|'own_ad'|'own_media'|'product'|'logo'|'badge'|'watermark'|'portrait'
  id: string
  url: string
}
export type AdSuggestion = {
  id: number
  order: number
  angle: string
  target_audience: string
  inspired_by: string
  primary_text: string
  headline: string
  description: string
  cta: string
  on_image_text: string
  image_url: string
  image_error: string
  video_url: string
  video_thumbnail_url: string
  video_edit: AdSuggestionVideoEdit|null
  completed_video_edit: AdSuggestionVideoEdit|null
  references: AdSuggestionReference[]
  content_id: number|null
}
export type AdSuggestionRun = {
  id: number
  status: 'pending'|'running'|'completed'|'error'
  is_billed: boolean
  is_automatic: boolean
  config: AdSuggestionConfig
  error: string
  created: string
  started_at: string|null
  completed_at: string|null
  suggestions: AdSuggestion[]
}
export type AdSuggestionSavePostInput = {
  video_edit_id?: number|null
}
export type AdSuggestionSavePost = {
  content_id: number
  suggestion: AdSuggestion
}
export type AdSuggestionVideoEditRequestInput = {
  prompt?: string
  media_ids?: number[]
}
export type AdSuggestionVideoEditRequest = {
  video_edit: AdSuggestionVideoEdit
}
export type AdSuggestionLatestVideoEdit = {
  video_edit: AdSuggestionVideoEdit|null
}
export type GetTeamAdSuggestionsQuery = {
  start_first_run?: string
}
export type AdSuggestionCopyModelOption = {
  id: 'gpt-6-astra'|'gemini-2.5-flash'
  provider: string
  label: string
}
export type AdSuggestionImageModelOption = {
  id: 'gemini-3.1-flash-image-preview'|'marketing-studio/image'|'grok-imagine-image-2.0'|'gpt-image-2.5-flare'
  provider: string
  label: string
}
export type AdSuggestionVideoModelOption = {
  id: 'bytedance/seedance-2.5/reference-to-video'
  provider: string
  label: string
}
export type AdSuggestionOptions = {
  copy_models: AdSuggestionCopyModelOption[]
  image_models: AdSuggestionImageModelOption[]
  video_models: AdSuggestionVideoModelOption[]
  aspect_ratios: string[]
  video_aspect_ratios: ('9:16'|'3:4'|'1:1'|'4:3'|'16:9')[]
  research_categories: string[]
  own_ad_platforms: string[]
}
export type AdSuggestionsState = {
  eligible: boolean
  ineligible_reason: string
  run: AdSuggestionRun|null
  defaults: AdSuggestionConfig
  options: AdSuggestionOptions
}
export type AdSuggestionOwnAdRefInput = AdSuggestionOwnAdRef
export type AdSuggestionConfigInput = {
  extra_context?: string
  research_categories?: ('business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit')[]
  own_ad_refs?: AdSuggestionOwnAdRefInput[]
  own_media_ids?: number[]
  competitor_ad_ids?: number[]
  clone_competitor_ad_id?: number|null
  product_media_ids?: number[]
  copy_model?: 'gpt-6-astra'|'gemini-2.5-flash'
  image_model?: 'gemini-3.1-flash-image-preview'|'marketing-studio/image'|'grok-imagine-image-2.0'|'gpt-image-2.5-flare'
  aspect_ratio?: '1:1'|'3:4'|'4:3'|'2:3'|'3:2'|'9:16'|'16:9'
  number_of_ads?: number
  auto_references?: boolean
  output_format?: 'image'|'video'
  video_model?: 'bytedance/seedance-2.5/reference-to-video'
  video_duration?: number
}
export type AdSuggestionsGenerateInput = {
  config?: AdSuggestionConfigInput
}
export type AdSuggestionsGenerate = {
  run: AdSuggestionRun
}
export type AffiliateConnectLoginLinkInput = StandaloneShareViaAccountAudienceConfig
export type AffiliateConnectLoginLink = StandaloneInsightsAnalyzerGenerateSheet
export type AffiliateConnectOnboardingInput = {
  return_url: string
  refresh_url?: string
}
export type AffiliateConnectOnboarding = StandaloneInsightsAnalyzerGenerateSheet
export type AffiliateCreateTeamInput = {
  name: string
  customer_email: string
  send_invitation_email?: boolean
}
export type AffiliateCreateTeam = {
  team_id: number
  invitation_url: string
}
export type AffiliatePendingInvitation = {
  id: number
  email: string
  created: string
  invitation_url: string
}
export type AffiliatePartnerTeam = {
  id: number
  name: string
  affiliate_attributed_at: string|null
  pending_invitation: AffiliatePendingInvitation|null
  partner_stage: 'prospect'|'contacted'|'interested'|'waiting_for_seat_purchase'|'customer'|'not_interested'|null
  partner_stage_by: string|null
  partner_stage_at: string|null
  partner_comment: string
  owner_email: string|null
  tier: 'pro'|'business'|null
  paid_seats: number
}
export type AffiliateInvoiceSummary = {
  id: number
  team_name: string
  commission_amount: number
  currency: string
  status: 'waiting'|'paid_out'|'refunded'|'disputed'|'failed'
  client_paid_at: string
  paid_out_at: string|null
}
export type AffiliatePartner = {
  partner_code: string
  share_url: string
  rev_share_percent: number
  onboarding_started: boolean
  payouts_enabled: boolean
  teams: AffiliatePartnerTeam[]
  invoices: AffiliateInvoiceSummary[]
}
export type AffiliatePayoutAccount = {
  onboarding_started: boolean
  payouts_enabled: boolean
  requirements_due: boolean
  bank_name: string|null
  bank_last4: string|null
  default_currency: string|null
}
export type AffiliateBalanceAmount = {
  amount: number
  currency: string
}
export type AffiliateBalance = {
  available: AffiliateBalanceAmount[]
  pending: AffiliateBalanceAmount[]
}
export type AffiliatePayoutRow = {
  id: string
  amount: number
  currency: string
  status: string
  arrival_date: string
  created: string
}
export type AffiliateTransferRow = {
  invoice_id: number
  team_name: string
  commission_amount: number
  currency: string
  stripe_transfer_id: string
  paid_out_at: string
}
export type AffiliatePayouts = {
  account: AffiliatePayoutAccount
  balance: AffiliateBalance
  payouts: AffiliatePayoutRow[]
  transfers: AffiliateTransferRow[]
}
export type AffiliateResendInvitationInput = SdbTrackingJoinTeamInput
export type AffiliateResendInvitation = {
  email: string
  invitation_url: string
}
export type AffiliateTeamStageInput = {
  team_id: number
  stage: 'prospect'|'contacted'|'interested'|'waiting_for_seat_purchase'|'customer'|'not_interested'
  comment?: string
}
export type AffiliateTeamStage = {
  team: AffiliatePartnerTeam
}
export type AffiliateApplyPartnerCodeInput = {
  partner_code: string
}
export type AffiliateApplyPartnerCode = {
  success: boolean
}
export type BigDipperAudienceDuplicateInput = {
  x_pack_config_id?: number|null
  meta_special_ad_categories?: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
}
export type BigDipperAudienceDuplicate = {
  id: number
  name: string
  description: string|null
  platforms: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform: string|null
  original_platform_id: string|null
  search: number|null
  x_targeting: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  reddit_targeting: { subreddits: { subreddit: string; daily_impressions: number|null; mentions: number|null; relevancy: number|null; public_description: string|null; subscribers: number|null; img_url: string|null; deselected: boolean|null }[]; communities: string[]; excluded_communities: string[]; keywords: { label: string; deselected: boolean|null }[]; excluded_keywords: string[]; interests: { interest: string; audience_size: number|null; deselected: boolean|null }[]; excluded_interests: string[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_retarg: string[] }; custom_audiences: string[]; excluded_custom_audiences: string[]; demographics: { genders: ("male"|"female"|"unknown")[] }; geolocations: string[]; excluded_geolocations: string[]; devices: string[]; placements: ("home_feed"|"popular_feed"|"search"|"conversation"|"profile")[]; inventory_type: ("limited"|"standard"|"expanded"|null); excluded_subreddits: string[]; expand_targeting: boolean; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[] }|null
  youtube_targeting: { youtube_channels: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean; is_negative: boolean }[]; youtube_videos: { video_id: string; title: string|null; description: string|null; thumbnail_url: string|null; view_count: number|null; like_count: number|null; publish_date: string|null; is_negative: boolean; deselected: boolean; channel: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean } }[]; keywords: { text: string; is_negative: boolean; deselected: boolean }[]; topics: { topic_id: string; name: string|null; deselected: boolean }[]; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[]; parental_status: { type: ("PARENT"|"NOT_A_PARENT"|"UNDETERMINED"); deselected: boolean }[] }; geo_targeting: { locations: { id: string; name: string; is_negative: boolean; deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  spotify_targeting: { ad_category: string|null; age_ranges: string[]; interests: string[]; spotify_shows: { spotify_id: string; spotify_handle: string|null; account_name: string|null; pic: string|null; name: string|null; description: string|null; image_url: string|null; publisher: string|null; total_episodes: number|null; deselected: boolean|null }[]; geo_targeting: { countries: string[]; regions: string[]; cities: string[] }; genders: ("male"|"female"|"unknown")[]; genres: string[]; playlists: string[]; moods: ("workout"|"chill"|"focus"|"party"|"sleep"|"commute")[]; moments: string[]; devices: ("mobile"|"desktop"|"tablet"|"connected_tv")[]; platforms: ("ios"|"android"|"web"|"smart_tv"|"gaming_console")[]; audiences: { first_party: string[]; lookalikes: string[] }; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[]; excluded_genres: string[] }|null
  tiktok_targeting: { keywords: string[]; interests: string[]; behaviors: string[]; creators: { username: string; display_name?: string|null; follower_count?: number|null; profile_image?: string|null; category?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("13-17"|"18-24"|"25-34"|"35-44"|"45-54"|"55+")[]; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; regions: string[]; cities: string[]; postal_codes: string[] }; devices: ("mobile"|"tablet")[]; device_os: ("ios"|"android")[]; device_price_range: string[]; carriers: string[]; connection_type: ("wifi"|"4g"|"5g"|"all")[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_audiences: string[]; website_traffic: string[] }; placements: ("tiktok_feed"|"pangle"|"news_feed_apps")[]; excluded_hashtags: string[]; excluded_creators: string[]; excluded_audiences: string[]; custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; ad_schedule: { day: ("monday"|"tuesday"|"wednesday"|"thursday"|"friday"|"saturday"|"sunday"); start_hour: number; end_hour: number; deselected: boolean|null }[]; brand_safety_level: ("standard"|"limited"|"expanded"|null) }|null
  facebook_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDuplicateSerializerFacebook_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDuplicateSerializerFacebook_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  instagram_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDuplicateSerializerInstagram_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDuplicateSerializerInstagram_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  linkedin_targeting: { targetingCriteria: { include: { and: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] }[] }; exclude: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:buyerGroups"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] } }; industries: { urn: string; name: string; deselected: boolean|null }[]; job_functions: { urn: string; name: string; deselected: boolean|null }[]; seniorities: { urn: string; name: string; deselected: boolean|null }[]; company_sizes: { urn: string; name: string; deselected: boolean|null }[]; company_categories: { urn: string; name: string; facetUrn: string|null; deselected: boolean|null }[]; titles: { urn: string; name: string; deselected: boolean|null }[]; member_skills: { urn: string; name: string; deselected: boolean|null }[]; fields_of_study: { urn: string; name: string; deselected: boolean|null }[]; member_schools: { urn: string; name: string; deselected: boolean|null }[]; locations: { urn: string; name: string; country: string|null; deselected: boolean|null }[]; age_ranges: { urn: string; name: string; deselected: boolean|null }[]; genders: { urn: string; name: string; deselected: boolean|null }[]; custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  google_targeting: { keywords: { text: string; match_type: ("broad"|"phrase"|"exact"); is_negative: boolean; deselected?: boolean }[]; geo_targeting: { locations: { id: string; name?: string; is_negative?: boolean; deselected?: boolean }[]; radius_targeting: { latitude: number; longitude: number; radius: number; unit?: ("KILOMETERS"|"MILES"); address?: string; deselected?: boolean }[] }; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[]; user_lists: { resource_name: string; name: string; deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); bid_modifier: number; deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  discord_targeting: any|null
  twitch_targeting: any|null
  pinterest_targeting: { keywords: string[]; excluded_keywords: string[]; interests: string[]; pinterest_accounts: { name?: string|null; handle: string; followers?: number|null; pic?: string|null; description?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("18-24"|"25-34"|"35-44"|"45-49"|"50-54"|"55-64"|"65+")[]; minimum_age: number|null; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; postal_codes: string[] }; devices: ("iphone"|"ipad"|"android_mobile"|"android_tablet"|"web"|"web_mobile")[]; placements: ("browse"|"search")[]; expanded_targeting: boolean; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  chatgpt_targeting: { context_hints: string[]; geo_targeting: { countries: string[]; locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[]; excluded_countries: string[]; excluded_locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[] }; platforms: ("ios_app"|"android_app"|"web"|"desktop_web"|"ios_web"|"android_web")[]; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  audience_size: number|null
  targeting_warnings: any
  meta_special_ad_categories: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
  meta_special_ad_category_issues: string[]
}
export type BigDipperAudienceMetaSpecialAdCategoryInput = {
  special_ad_categories: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
  save_as_copy?: boolean
  ad_account_id?: string|null
}
export type BigDipperAudienceDetail = {
  id: number
  name: string
  description: string|null
  platforms: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform: string|null
  original_platform_id: string|null
  search: number|null
  x_targeting: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  reddit_targeting: { subreddits: { subreddit: string; daily_impressions: number|null; mentions: number|null; relevancy: number|null; public_description: string|null; subscribers: number|null; img_url: string|null; deselected: boolean|null }[]; communities: string[]; excluded_communities: string[]; keywords: { label: string; deselected: boolean|null }[]; excluded_keywords: string[]; interests: { interest: string; audience_size: number|null; deselected: boolean|null }[]; excluded_interests: string[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_retarg: string[] }; custom_audiences: string[]; excluded_custom_audiences: string[]; demographics: { genders: ("male"|"female"|"unknown")[] }; geolocations: string[]; excluded_geolocations: string[]; devices: string[]; placements: ("home_feed"|"popular_feed"|"search"|"conversation"|"profile")[]; inventory_type: ("limited"|"standard"|"expanded"|null); excluded_subreddits: string[]; expand_targeting: boolean; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[] }|null
  youtube_targeting: { youtube_channels: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean; is_negative: boolean }[]; youtube_videos: { video_id: string; title: string|null; description: string|null; thumbnail_url: string|null; view_count: number|null; like_count: number|null; publish_date: string|null; is_negative: boolean; deselected: boolean; channel: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean } }[]; keywords: { text: string; is_negative: boolean; deselected: boolean }[]; topics: { topic_id: string; name: string|null; deselected: boolean }[]; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[]; parental_status: { type: ("PARENT"|"NOT_A_PARENT"|"UNDETERMINED"); deselected: boolean }[] }; geo_targeting: { locations: { id: string; name: string; is_negative: boolean; deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  spotify_targeting: { ad_category: string|null; age_ranges: string[]; interests: string[]; spotify_shows: { spotify_id: string; spotify_handle: string|null; account_name: string|null; pic: string|null; name: string|null; description: string|null; image_url: string|null; publisher: string|null; total_episodes: number|null; deselected: boolean|null }[]; geo_targeting: { countries: string[]; regions: string[]; cities: string[] }; genders: ("male"|"female"|"unknown")[]; genres: string[]; playlists: string[]; moods: ("workout"|"chill"|"focus"|"party"|"sleep"|"commute")[]; moments: string[]; devices: ("mobile"|"desktop"|"tablet"|"connected_tv")[]; platforms: ("ios"|"android"|"web"|"smart_tv"|"gaming_console")[]; audiences: { first_party: string[]; lookalikes: string[] }; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[]; excluded_genres: string[] }|null
  tiktok_targeting: { keywords: string[]; interests: string[]; behaviors: string[]; creators: { username: string; display_name?: string|null; follower_count?: number|null; profile_image?: string|null; category?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("13-17"|"18-24"|"25-34"|"35-44"|"45-54"|"55+")[]; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; regions: string[]; cities: string[]; postal_codes: string[] }; devices: ("mobile"|"tablet")[]; device_os: ("ios"|"android")[]; device_price_range: string[]; carriers: string[]; connection_type: ("wifi"|"4g"|"5g"|"all")[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_audiences: string[]; website_traffic: string[] }; placements: ("tiktok_feed"|"pangle"|"news_feed_apps")[]; excluded_hashtags: string[]; excluded_creators: string[]; excluded_audiences: string[]; custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; ad_schedule: { day: ("monday"|"tuesday"|"wednesday"|"thursday"|"friday"|"saturday"|"sunday"); start_hour: number; end_hour: number; deselected: boolean|null }[]; brand_safety_level: ("standard"|"limited"|"expanded"|null) }|null
  facebook_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  instagram_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  linkedin_targeting: { targetingCriteria: { include: { and: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] }[] }; exclude: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:buyerGroups"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] } }; industries: { urn: string; name: string; deselected: boolean|null }[]; job_functions: { urn: string; name: string; deselected: boolean|null }[]; seniorities: { urn: string; name: string; deselected: boolean|null }[]; company_sizes: { urn: string; name: string; deselected: boolean|null }[]; company_categories: { urn: string; name: string; facetUrn: string|null; deselected: boolean|null }[]; titles: { urn: string; name: string; deselected: boolean|null }[]; member_skills: { urn: string; name: string; deselected: boolean|null }[]; fields_of_study: { urn: string; name: string; deselected: boolean|null }[]; member_schools: { urn: string; name: string; deselected: boolean|null }[]; locations: { urn: string; name: string; country: string|null; deselected: boolean|null }[]; age_ranges: { urn: string; name: string; deselected: boolean|null }[]; genders: { urn: string; name: string; deselected: boolean|null }[]; custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  google_targeting: { keywords: { text: string; match_type: ("broad"|"phrase"|"exact"); is_negative: boolean; deselected?: boolean }[]; geo_targeting: { locations: { id: string; name?: string; is_negative?: boolean; deselected?: boolean }[]; radius_targeting: { latitude: number; longitude: number; radius: number; unit?: ("KILOMETERS"|"MILES"); address?: string; deselected?: boolean }[] }; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[]; user_lists: { resource_name: string; name: string; deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); bid_modifier: number; deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  discord_targeting: any|null
  twitch_targeting: any|null
  pinterest_targeting: { keywords: string[]; excluded_keywords: string[]; interests: string[]; pinterest_accounts: { name?: string|null; handle: string; followers?: number|null; pic?: string|null; description?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("18-24"|"25-34"|"35-44"|"45-49"|"50-54"|"55-64"|"65+")[]; minimum_age: number|null; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; postal_codes: string[] }; devices: ("iphone"|"ipad"|"android_mobile"|"android_tablet"|"web"|"web_mobile")[]; placements: ("browse"|"search")[]; expanded_targeting: boolean; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  chatgpt_targeting: { context_hints: string[]; geo_targeting: { countries: string[]; locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[]; excluded_countries: string[]; excluded_locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[] }; platforms: ("ios_app"|"android_app"|"web"|"desktop_web"|"ios_web"|"android_web")[]; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  audience_size: number|null
  targeting_warnings: any
  meta_special_ad_categories: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
  meta_special_ad_category_issues: string[]
}
export type BigDipperAudienceMetaSpecialAdCategory = {
  audience: BigDipperAudienceDetail
  changes: string[]
}
export type BigDipperAudienceDetailInput = {
  name: string
  description?: string|null
  platforms?: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform?: string|null
  original_platform_id?: string|null
  search?: number|null
  x_pack_config_id?: number|null
  x_targeting?: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  reddit_targeting?: { subreddits: { subreddit: string; daily_impressions: number|null; mentions: number|null; relevancy: number|null; public_description: string|null; subscribers: number|null; img_url: string|null; deselected: boolean|null }[]; communities: string[]; excluded_communities: string[]; keywords: { label: string; deselected: boolean|null }[]; excluded_keywords: string[]; interests: { interest: string; audience_size: number|null; deselected: boolean|null }[]; excluded_interests: string[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_retarg: string[] }; custom_audiences: string[]; excluded_custom_audiences: string[]; demographics: { genders: ("male"|"female"|"unknown")[] }; geolocations: string[]; excluded_geolocations: string[]; devices: string[]; placements: ("home_feed"|"popular_feed"|"search"|"conversation"|"profile")[]; inventory_type: ("limited"|"standard"|"expanded"|null); excluded_subreddits: string[]; expand_targeting: boolean; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[] }|null
  youtube_targeting?: { youtube_channels: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean; is_negative: boolean }[]; youtube_videos: { video_id: string; title: string|null; description: string|null; thumbnail_url: string|null; view_count: number|null; like_count: number|null; publish_date: string|null; is_negative: boolean; deselected: boolean; channel: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean } }[]; keywords: { text: string; is_negative: boolean; deselected: boolean }[]; topics: { topic_id: string; name: string|null; deselected: boolean }[]; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[]; parental_status: { type: ("PARENT"|"NOT_A_PARENT"|"UNDETERMINED"); deselected: boolean }[] }; geo_targeting: { locations: { id: string; name: string; is_negative: boolean; deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  spotify_targeting?: { ad_category: string|null; age_ranges: string[]; interests: string[]; spotify_shows: { spotify_id: string; spotify_handle: string|null; account_name: string|null; pic: string|null; name: string|null; description: string|null; image_url: string|null; publisher: string|null; total_episodes: number|null; deselected: boolean|null }[]; geo_targeting: { countries: string[]; regions: string[]; cities: string[] }; genders: ("male"|"female"|"unknown")[]; genres: string[]; playlists: string[]; moods: ("workout"|"chill"|"focus"|"party"|"sleep"|"commute")[]; moments: string[]; devices: ("mobile"|"desktop"|"tablet"|"connected_tv")[]; platforms: ("ios"|"android"|"web"|"smart_tv"|"gaming_console")[]; audiences: { first_party: string[]; lookalikes: string[] }; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[]; excluded_genres: string[] }|null
  tiktok_targeting?: { keywords: string[]; interests: string[]; behaviors: string[]; creators: { username: string; display_name?: string|null; follower_count?: number|null; profile_image?: string|null; category?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("13-17"|"18-24"|"25-34"|"35-44"|"45-54"|"55+")[]; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; regions: string[]; cities: string[]; postal_codes: string[] }; devices: ("mobile"|"tablet")[]; device_os: ("ios"|"android")[]; device_price_range: string[]; carriers: string[]; connection_type: ("wifi"|"4g"|"5g"|"all")[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_audiences: string[]; website_traffic: string[] }; placements: ("tiktok_feed"|"pangle"|"news_feed_apps")[]; excluded_hashtags: string[]; excluded_creators: string[]; excluded_audiences: string[]; custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; ad_schedule: { day: ("monday"|"tuesday"|"wednesday"|"thursday"|"friday"|"saturday"|"sunday"); start_hour: number; end_hour: number; deselected: boolean|null }[]; brand_safety_level: ("standard"|"limited"|"expanded"|null) }|null
  facebook_targeting?: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDetailSerializerFacebook_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  instagram_targeting?: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceDetailSerializerInstagram_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  linkedin_targeting?: { targetingCriteria: { include: { and: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] }[] }; exclude: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:buyerGroups"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] } }; industries: { urn: string; name: string; deselected: boolean|null }[]; job_functions: { urn: string; name: string; deselected: boolean|null }[]; seniorities: { urn: string; name: string; deselected: boolean|null }[]; company_sizes: { urn: string; name: string; deselected: boolean|null }[]; company_categories: { urn: string; name: string; facetUrn: string|null; deselected: boolean|null }[]; titles: { urn: string; name: string; deselected: boolean|null }[]; member_skills: { urn: string; name: string; deselected: boolean|null }[]; fields_of_study: { urn: string; name: string; deselected: boolean|null }[]; member_schools: { urn: string; name: string; deselected: boolean|null }[]; locations: { urn: string; name: string; country: string|null; deselected: boolean|null }[]; age_ranges: { urn: string; name: string; deselected: boolean|null }[]; genders: { urn: string; name: string; deselected: boolean|null }[]; custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  google_targeting?: { keywords: { text: string; match_type: ("broad"|"phrase"|"exact"); is_negative: boolean; deselected?: boolean }[]; geo_targeting: { locations: { id: string; name?: string; is_negative?: boolean; deselected?: boolean }[]; radius_targeting: { latitude: number; longitude: number; radius: number; unit?: ("KILOMETERS"|"MILES"); address?: string; deselected?: boolean }[] }; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[]; user_lists: { resource_name: string; name: string; deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); bid_modifier: number; deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  discord_targeting?: any|null
  twitch_targeting?: any|null
  pinterest_targeting?: { keywords: string[]; excluded_keywords: string[]; interests: string[]; pinterest_accounts: { name?: string|null; handle: string; followers?: number|null; pic?: string|null; description?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("18-24"|"25-34"|"35-44"|"45-49"|"50-54"|"55-64"|"65+")[]; minimum_age: number|null; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; postal_codes: string[] }; devices: ("iphone"|"ipad"|"android_mobile"|"android_tablet"|"web"|"web_mobile")[]; placements: ("browse"|"search")[]; expanded_targeting: boolean; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  chatgpt_targeting?: { context_hints: string[]; geo_targeting: { countries: string[]; locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[]; excluded_countries: string[]; excluded_locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[] }; platforms: ("ios_app"|"android_app"|"web"|"desktop_web"|"ios_web"|"android_web")[]; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  audience_size?: number|null
  meta_special_ad_categories?: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
}
export type BigDipperAudienceSummary = ApexSduSummary
export type AudienceTargetingEditPickInput = {
  field: 'x_targeting'|'facebook_targeting'|'linkedin_targeting'|'reddit_targeting'|'google_targeting'|'tiktok_targeting'|'pinterest_targeting'|'chatgpt_targeting'
  input: string
  value: string
}
export type AudienceTargetingEditInput = {
  kind: 'locations'|'age'|'gender'|'languages'|'topic'
  mode?: 'replace'|'add'|'remove'
  values?: string[]
  age_min?: number|null
  age_max?: number|null
  packs?: ('x_targeting'|'facebook_targeting'|'linkedin_targeting'|'reddit_targeting'|'google_targeting'|'tiktok_targeting'|'pinterest_targeting'|'chatgpt_targeting')[]
  picks?: AudienceTargetingEditPickInput[]
  dry_run?: boolean
  save_as_copy?: boolean
  preview_id?: string|null
}
export type AudienceTargetingEditChange = {
  field: 'x_targeting'|'facebook_targeting'|'linkedin_targeting'|'reddit_targeting'|'google_targeting'|'tiktok_targeting'|'pinterest_targeting'|'chatgpt_targeting'
  status: 'changed'|'unchanged'|'unsupported'|'failed'
  before: string[]
  after: string[]
  dropped: TargetingDroppedItem[]
  notes: string[]
}
export type AudienceTargetingEdit = {
  preview_id: string|null
  audience: BigDipperAudienceDetail|null
  changes: AudienceTargetingEditChange[]
}
export type BigDipperAudienceUpdateInput = {
  name: string
  description?: string|null
  platforms?: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform?: string|null
  original_platform_id?: string|null
  x_targeting?: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  reddit_targeting?: { subreddits: { subreddit: string; daily_impressions: number|null; mentions: number|null; relevancy: number|null; public_description: string|null; subscribers: number|null; img_url: string|null; deselected: boolean|null }[]; communities: string[]; excluded_communities: string[]; keywords: { label: string; deselected: boolean|null }[]; excluded_keywords: string[]; interests: { interest: string; audience_size: number|null; deselected: boolean|null }[]; excluded_interests: string[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_retarg: string[] }; custom_audiences: string[]; excluded_custom_audiences: string[]; demographics: { genders: ("male"|"female"|"unknown")[] }; geolocations: string[]; excluded_geolocations: string[]; devices: string[]; placements: ("home_feed"|"popular_feed"|"search"|"conversation"|"profile")[]; inventory_type: ("limited"|"standard"|"expanded"|null); excluded_subreddits: string[]; expand_targeting: boolean; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[] }|null
  youtube_targeting?: { youtube_channels: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean; is_negative: boolean }[]; youtube_videos: { video_id: string; title: string|null; description: string|null; thumbnail_url: string|null; view_count: number|null; like_count: number|null; publish_date: string|null; is_negative: boolean; deselected: boolean; channel: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean } }[]; keywords: { text: string; is_negative: boolean; deselected: boolean }[]; topics: { topic_id: string; name: string|null; deselected: boolean }[]; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[]; parental_status: { type: ("PARENT"|"NOT_A_PARENT"|"UNDETERMINED"); deselected: boolean }[] }; geo_targeting: { locations: { id: string; name: string; is_negative: boolean; deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  spotify_targeting?: { ad_category: string|null; age_ranges: string[]; interests: string[]; spotify_shows: { spotify_id: string; spotify_handle: string|null; account_name: string|null; pic: string|null; name: string|null; description: string|null; image_url: string|null; publisher: string|null; total_episodes: number|null; deselected: boolean|null }[]; geo_targeting: { countries: string[]; regions: string[]; cities: string[] }; genders: ("male"|"female"|"unknown")[]; genres: string[]; playlists: string[]; moods: ("workout"|"chill"|"focus"|"party"|"sleep"|"commute")[]; moments: string[]; devices: ("mobile"|"desktop"|"tablet"|"connected_tv")[]; platforms: ("ios"|"android"|"web"|"smart_tv"|"gaming_console")[]; audiences: { first_party: string[]; lookalikes: string[] }; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[]; excluded_genres: string[] }|null
  tiktok_targeting?: { keywords: string[]; interests: string[]; behaviors: string[]; creators: { username: string; display_name?: string|null; follower_count?: number|null; profile_image?: string|null; category?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("13-17"|"18-24"|"25-34"|"35-44"|"45-54"|"55+")[]; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; regions: string[]; cities: string[]; postal_codes: string[] }; devices: ("mobile"|"tablet")[]; device_os: ("ios"|"android")[]; device_price_range: string[]; carriers: string[]; connection_type: ("wifi"|"4g"|"5g"|"all")[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_audiences: string[]; website_traffic: string[] }; placements: ("tiktok_feed"|"pangle"|"news_feed_apps")[]; excluded_hashtags: string[]; excluded_creators: string[]; excluded_audiences: string[]; custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; ad_schedule: { day: ("monday"|"tuesday"|"wednesday"|"thursday"|"friday"|"saturday"|"sunday"); start_hour: number; end_hour: number; deselected: boolean|null }[]; brand_safety_level: ("standard"|"limited"|"expanded"|null) }|null
  facebook_targeting?: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  instagram_targeting?: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  linkedin_targeting?: { targetingCriteria: { include: { and: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] }[] }; exclude: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:buyerGroups"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] } }; industries: { urn: string; name: string; deselected: boolean|null }[]; job_functions: { urn: string; name: string; deselected: boolean|null }[]; seniorities: { urn: string; name: string; deselected: boolean|null }[]; company_sizes: { urn: string; name: string; deselected: boolean|null }[]; company_categories: { urn: string; name: string; facetUrn: string|null; deselected: boolean|null }[]; titles: { urn: string; name: string; deselected: boolean|null }[]; member_skills: { urn: string; name: string; deselected: boolean|null }[]; fields_of_study: { urn: string; name: string; deselected: boolean|null }[]; member_schools: { urn: string; name: string; deselected: boolean|null }[]; locations: { urn: string; name: string; country: string|null; deselected: boolean|null }[]; age_ranges: { urn: string; name: string; deselected: boolean|null }[]; genders: { urn: string; name: string; deselected: boolean|null }[]; custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  google_targeting?: { keywords: { text: string; match_type: ("broad"|"phrase"|"exact"); is_negative: boolean; deselected?: boolean }[]; geo_targeting: { locations: { id: string; name?: string; is_negative?: boolean; deselected?: boolean }[]; radius_targeting: { latitude: number; longitude: number; radius: number; unit?: ("KILOMETERS"|"MILES"); address?: string; deselected?: boolean }[] }; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[]; user_lists: { resource_name: string; name: string; deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); bid_modifier: number; deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  discord_targeting?: any|null
  twitch_targeting?: any|null
  pinterest_targeting?: { keywords: string[]; excluded_keywords: string[]; interests: string[]; pinterest_accounts: { name?: string|null; handle: string; followers?: number|null; pic?: string|null; description?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("18-24"|"25-34"|"35-44"|"45-49"|"50-54"|"55-64"|"65+")[]; minimum_age: number|null; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; postal_codes: string[] }; devices: ("iphone"|"ipad"|"android_mobile"|"android_tablet"|"web"|"web_mobile")[]; placements: ("browse"|"search")[]; expanded_targeting: boolean; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  chatgpt_targeting?: { context_hints: string[]; geo_targeting: { countries: string[]; locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[]; excluded_countries: string[]; excluded_locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[] }; platforms: ("ios_app"|"android_app"|"web"|"desktop_web"|"ios_web"|"android_web")[]; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  audience_size?: number|null
  user: number
  team: number
  search?: number|null
  audience_config?: number|null
}
export type BigDipperAudienceUpdate = {
  id: number
  meta_special_ad_categories: ('HOUSING'|'EMPLOYMENT'|'CREDIT')[]
  meta_special_ad_category_issues: string[]
  created: string
  modified: string
  name: string
  description: string|null
  platforms: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform: string|null
  original_platform_id: string|null
  x_targeting: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  reddit_targeting: { subreddits: { subreddit: string; daily_impressions: number|null; mentions: number|null; relevancy: number|null; public_description: string|null; subscribers: number|null; img_url: string|null; deselected: boolean|null }[]; communities: string[]; excluded_communities: string[]; keywords: { label: string; deselected: boolean|null }[]; excluded_keywords: string[]; interests: { interest: string; audience_size: number|null; deselected: boolean|null }[]; excluded_interests: string[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_retarg: string[] }; custom_audiences: string[]; excluded_custom_audiences: string[]; demographics: { genders: ("male"|"female"|"unknown")[] }; geolocations: string[]; excluded_geolocations: string[]; devices: string[]; placements: ("home_feed"|"popular_feed"|"search"|"conversation"|"profile")[]; inventory_type: ("limited"|"standard"|"expanded"|null); excluded_subreddits: string[]; expand_targeting: boolean; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[] }|null
  youtube_targeting: { youtube_channels: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean; is_negative: boolean }[]; youtube_videos: { video_id: string; title: string|null; description: string|null; thumbnail_url: string|null; view_count: number|null; like_count: number|null; publish_date: string|null; is_negative: boolean; deselected: boolean; channel: { channel_id: string; handle: string|null; title: string|null; subscriber_count: number|null; thumbnail_url: string|null; deselected: boolean } }[]; keywords: { text: string; is_negative: boolean; deselected: boolean }[]; topics: { topic_id: string; name: string|null; deselected: boolean }[]; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[]; parental_status: { type: ("PARENT"|"NOT_A_PARENT"|"UNDETERMINED"); deselected: boolean }[] }; geo_targeting: { locations: { id: string; name: string; is_negative: boolean; deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  spotify_targeting: { ad_category: string|null; age_ranges: string[]; interests: string[]; spotify_shows: { spotify_id: string; spotify_handle: string|null; account_name: string|null; pic: string|null; name: string|null; description: string|null; image_url: string|null; publisher: string|null; total_episodes: number|null; deselected: boolean|null }[]; geo_targeting: { countries: string[]; regions: string[]; cities: string[] }; genders: ("male"|"female"|"unknown")[]; genres: string[]; playlists: string[]; moods: ("workout"|"chill"|"focus"|"party"|"sleep"|"commute")[]; moments: string[]; devices: ("mobile"|"desktop"|"tablet"|"connected_tv")[]; platforms: ("ios"|"android"|"web"|"smart_tv"|"gaming_console")[]; audiences: { first_party: string[]; lookalikes: string[] }; ad_schedule: { day: string; start_hour: number; end_hour: number; deselected: boolean|null }[]; excluded_genres: string[] }|null
  tiktok_targeting: { keywords: string[]; interests: string[]; behaviors: string[]; creators: { username: string; display_name?: string|null; follower_count?: number|null; profile_image?: string|null; category?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("13-17"|"18-24"|"25-34"|"35-44"|"45-54"|"55+")[]; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; regions: string[]; cities: string[]; postal_codes: string[] }; devices: ("mobile"|"tablet")[]; device_os: ("ios"|"android")[]; device_price_range: string[]; carriers: string[]; connection_type: ("wifi"|"4g"|"5g"|"all")[]; audiences: { custom_audiences: string[]; lookalike_audiences: string[]; engagement_audiences: string[]; website_traffic: string[] }; placements: ("tiktok_feed"|"pangle"|"news_feed_apps")[]; excluded_hashtags: string[]; excluded_creators: string[]; excluded_audiences: string[]; custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; type?: string|null; status?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; ad_schedule: { day: ("monday"|"tuesday"|"wednesday"|"thursday"|"friday"|"saturday"|"sunday"); start_hour: number; end_hour: number; deselected: boolean|null }[]; brand_safety_level: ("standard"|"limited"|"expanded"|null) }|null
  facebook_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceUpdateSerializerFacebook_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  instagram_targeting: { geo_locations: { countries: string[]; custom_locations: { latitude: number; longitude: number; radius: number; distance_unit: ("kilometer"|"mile"); name?: string|null; address_string?: string|null; country_code?: string|null }[] }; age_min: number|null; age_max: number|null; genders: (1|2|12)[]; locales: { id: string|null; name: string|null; label: string; value: string; handle: string|null; website: string|null; interest: string|null; location: string|null; description: string|null; linkedin_url: string|null; targeting_value: string|null }[]; interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; demographics: { id: string; name: string; type: string; path: string; description: string|null; real_time_cluster: boolean|null; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; job_titles: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; flexible_spec: { interests: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; behaviors: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; work_positions: { id: string; name: string; coverage_lower_bound: number|null; coverage_upper_bound: number|null; deselected: boolean|null }[]; life_events: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; family_statuses: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; income: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; industries: { id: string; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; education_statuses: { id: BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specEducation_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[]; relationship_statuses: { id: BigDipperAudienceUpdateSerializerInstagram_targetingFlexible_specRelationship_statusesId; name: string; audience_size_lower_bound: number|null; audience_size_upper_bound: number|null; deselected: boolean|null }[] }[]; device_platforms: string[]; publisher_platforms: string[]; custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; description?: string|null; disabled?: boolean|null; status?: string|null; approximate_count?: number|null; countries?: string[]; geo_locations?: { country: string|null; name: string|null; key: string|null; type: string|null }[]; type?: { type: string|null; sub_type: string|null; creation_params: string|null }|string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  linkedin_targeting: { targetingCriteria: { include: { and: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] }[] }; exclude: { or: { facet: ("urn:li:adTargetingFacet:ageRanges"|"urn:li:adTargetingFacet:audienceMatchingSegments"|"urn:li:adTargetingFacet:dynamicSegments"|"urn:li:adTargetingFacet:companyCategory"|"urn:li:adTargetingFacet:degrees"|"urn:li:adTargetingFacet:employers"|"urn:li:adTargetingFacet:employersAll"|"urn:li:adTargetingFacet:employersPast"|"urn:li:adTargetingFacet:fieldsOfStudy"|"urn:li:adTargetingFacet:firstDegreeConnectionCompanies"|"urn:li:adTargetingFacet:followedCompanies"|"urn:li:adTargetingFacet:genders"|"urn:li:adTargetingFacet:buyerGroups"|"urn:li:adTargetingFacet:groups"|"urn:li:adTargetingFacet:growthRate"|"urn:li:adTargetingFacet:industries"|"urn:li:adTargetingFacet:interests"|"urn:li:adTargetingFacet:interfaceLocales"|"urn:li:adTargetingFacet:jobFunctions"|"urn:li:adTargetingFacet:locations"|"urn:li:adTargetingFacet:memberBehaviors"|"urn:li:adTargetingFacet:profileLocations"|"urn:li:adTargetingFacet:schools"|"urn:li:adTargetingFacet:seniorities"|"urn:li:adTargetingFacet:skills"|"urn:li:adTargetingFacet:staffCountRanges"|"urn:li:adTargetingFacet:titles"|"urn:li:adTargetingFacet:titlesAll"|"urn:li:adTargetingFacet:titlesPast"|"urn:li:adTargetingFacet:yearsOfExperienceRanges"); segments: string[]; segment_names?: {  }|null; name?: string|null; deselected?: boolean|null }[] } }; industries: { urn: string; name: string; deselected: boolean|null }[]; job_functions: { urn: string; name: string; deselected: boolean|null }[]; seniorities: { urn: string; name: string; deselected: boolean|null }[]; company_sizes: { urn: string; name: string; deselected: boolean|null }[]; company_categories: { urn: string; name: string; facetUrn: string|null; deselected: boolean|null }[]; titles: { urn: string; name: string; deselected: boolean|null }[]; member_skills: { urn: string; name: string; deselected: boolean|null }[]; fields_of_study: { urn: string; name: string; deselected: boolean|null }[]; member_schools: { urn: string; name: string; deselected: boolean|null }[]; locations: { urn: string; name: string; country: string|null; deselected: boolean|null }[]; age_ranges: { urn: string; name: string; deselected: boolean|null }[]; genders: { urn: string; name: string; deselected: boolean|null }[]; custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  google_targeting: { keywords: { text: string; match_type: ("broad"|"phrase"|"exact"); is_negative: boolean; deselected?: boolean }[]; geo_targeting: { locations: { id: string; name?: string; is_negative?: boolean; deselected?: boolean }[]; radius_targeting: { latitude: number; longitude: number; radius: number; unit?: ("KILOMETERS"|"MILES"); address?: string; deselected?: boolean }[] }; audiences: { user_interests: { resource_name: string; name: string; category: ("AFFINITY"|"IN_MARKET"|"LIFE_EVENT"); deselected: boolean }[]; user_lists: { resource_name: string; name: string; deselected: boolean }[] }; demographics: { age_ranges: { type: ("AGE_RANGE_18_24"|"AGE_RANGE_25_34"|"AGE_RANGE_35_44"|"AGE_RANGE_45_54"|"AGE_RANGE_55_64"|"AGE_RANGE_65_UP"|"AGE_RANGE_UNDETERMINED"); deselected: boolean }[]; genders: { type: ("MALE"|"FEMALE"|"UNDETERMINED"); deselected: boolean }[] }; devices: { type: ("MOBILE"|"DESKTOP"|"TABLET"|"CONNECTED_TV"); bid_modifier: number; deselected: boolean }[]; ad_schedule: { day_of_week: ("MONDAY"|"TUESDAY"|"WEDNESDAY"|"THURSDAY"|"FRIDAY"|"SATURDAY"|"SUNDAY"); start_hour: number; start_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); end_hour: number; end_minute: ("ZERO"|"FIFTEEN"|"THIRTY"|"FORTY_FIVE"); deselected: boolean }[] }|null
  discord_targeting: any|null
  twitch_targeting: any|null
  pinterest_targeting: { keywords: string[]; excluded_keywords: string[]; interests: string[]; pinterest_accounts: { name?: string|null; handle: string; followers?: number|null; pic?: string|null; description?: string|null; deselected?: boolean|null }[]; demographics: { age_ranges: ("18-24"|"25-34"|"35-44"|"45-49"|"50-54"|"55-64"|"65+")[]; minimum_age: number|null; genders: ("male"|"female"|"unknown")[]; languages: string[] }; geo_targeting: { countries: string[]; postal_codes: string[] }; devices: ("iphone"|"ipad"|"android_mobile"|"android_tablet"|"web"|"web_mobile")[]; placements: ("browse"|"search")[]; expanded_targeting: boolean; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  chatgpt_targeting: { context_hints: string[]; geo_targeting: { countries: string[]; locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[]; excluded_countries: string[]; excluded_locations: { id: string; name?: string|null; type?: string|null; country_code?: string|null }[] }; platforms: ("ios_app"|"android_app"|"web"|"desktop_web"|"ios_web"|"android_web")[]; custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[]; excluded_custom_audiences: { id: string; name?: string|null; deselected?: boolean|null; ad_account_id?: string|null; ad_account_name?: string|null }[] }|null
  audience_size: number|null
  meta_special_ad_category_compliance: { categories: ("HOUSING"|"EMPLOYMENT"|"CREDIT")[]; targeting: string }
  targeting_summary: string|null
  targeting_summary_fingerprint: string|null
  user: number
  team: number
  search: number|null
  audience_config: number|null
}
export type StandalonePaymentMethod = {
  type: string
  brand: string|null
  last4: string|null
}
export type StandaloneTeamOffer = {
  percent_off: number
  duration_in_months: number
  expires_at: number
}
export type StandaloneTeamActionRequired = {
  kind: 'invoice_unpaid'|'payment_method_missing'|'card_expiring'
  deadline: number|null
}
export type StandaloneTeamBill = {
  balance: number
  currency: string|null
  tier: 'pro'|'business'|null
  days_left_in_trial: number|null
  actions_left_in_trial: number|null
  feedback_bonus_claimed: boolean
  payment_method: StandalonePaymentMethod|null
  current_period_end: number|null
  cancel_at_period_end: boolean
  cancel_at: number|null
  status: 'active'|'trialing'|'past_due'|'unpaid'|null
  processing_payment: boolean
  past_due: boolean
  grace_period_ends_at: number|null
  amount_due: number|null
  invoice_url: string|null
  offer: StandaloneTeamOffer|null
  actions_required: StandaloneTeamActionRequired[]
}
export type GetCampaignAdsQuery = {
  platform?: string
  adset_id?: string
  ad_account_id?: string
  start_date?: string
  end_date?: string
  placement?: string
}
export type CampaignOverviewConversionAction = {
  key: string
  count: number
  value: number
  cost: number
}
export type CampaignOverviewStats = {
  impressions: number
  engagements: number
  spend: number
  clicks: number
  engagement_rate: number
  ctr: number
  cpm: number
  leads: number
  cpl: number
  reach: number
  frequency: number
  link_clicks: number
  link_ctr: number
  video_views: number
  conversions: number
  cpa: number
  revenue: number
  roas: number
  sessions: number
  users: number
  pageviews: number
  new_users: number
  engaged_sessions: number
  avg_session_duration: number
  key_events: number
  conversion_actions: CampaignOverviewConversionAction[]
}
export type CampaignOverviewCreativeCard = {
  title: string|null
  description: string|null
  call_to_action: string|null
  display_link: string|null
  image_url: string|null
  destination_url: string|null
}
export type CampaignOverviewCreativeAdvertiser = {
  name: string|null
  username: string|null
  picture: string|null
}
export type CampaignOverviewCreative = {
  media_url: string|null
  media_type: 'image'|'video'|null
  text: string
  destination_url: string|null
  card: CampaignOverviewCreativeCard|null
  cards: CampaignOverviewCreativeCard[]
  advertiser: CampaignOverviewCreativeAdvertiser|null
}
export type CampaignOverviewAd = {
  ad_id: string
  name: string|null
  status: string|null
  effective_status: string|null
  effective_status_tone: 'error'|'warning'|'info'|'neutral'|null
  effective_status_reason: string|null
  stats: CampaignOverviewStats
  creative: CampaignOverviewCreative
  preview_url: string|null
}
export type CampaignAdsResponse = {
  ads: CampaignOverviewAd[]
}
export type GetCampaignAdsetsQuery = {
  platform?: string
  campaign_id?: string
  ad_account_id?: string
  start_date?: string
  end_date?: string
  placement?: string
}
export type CampaignOverviewAdSet = {
  adset_id: string
  name: string|null
  status: string|null
  effective_status: string|null
  effective_status_tone: 'error'|'warning'|'info'|'neutral'|null
  effective_status_reason: string|null
  start_time: string|null
  end_time: string|null
  stats: CampaignOverviewStats
}
export type CampaignAdSetsResponse = {
  adsets: CampaignOverviewAdSet[]
}
export type CampaignNameTemplateSegmentInput = {
  type: 'token'|'separator'|'literal'
  token?: 'team_name'|'objective'|'audience'|'platform'|'start_date'|'end_date'|'budget_cap'|'index'|'creative'|'campaign_name'|'campaign_id'|'medium'|'quarter'|'ad_account'|'audience_id'|'ad_group_id'|null
  value?: string|null
  format?: string|null
}
export type CampaignNameTemplateUtmInput = {
  utm_source?: CampaignNameTemplateSegmentInput[]
  utm_medium?: CampaignNameTemplateSegmentInput[]
  utm_campaign?: CampaignNameTemplateSegmentInput[]
  utm_term?: CampaignNameTemplateSegmentInput[]
  utm_content?: CampaignNameTemplateSegmentInput[]
  utm_id?: CampaignNameTemplateSegmentInput[]
}
export type CampaignNameTemplateInput = {
  id: string
  name: string
  is_default?: boolean
  segments: CampaignNameTemplateSegmentInput[]
  ad_group_segments?: CampaignNameTemplateSegmentInput[]
  ad_segments?: CampaignNameTemplateSegmentInput[]
  utm?: CampaignNameTemplateUtmInput
}
export type CampaignNameTemplatesUpdateInput = {
  templates: CampaignNameTemplateInput[]
}
export type CampaignNameTemplateSegment = {
  type: 'token'|'separator'|'literal'
  token: 'team_name'|'objective'|'audience'|'platform'|'start_date'|'end_date'|'budget_cap'|'index'|'creative'|'campaign_name'|'campaign_id'|'medium'|'quarter'|'ad_account'|'audience_id'|'ad_group_id'|null
  value: string|null
  format: string|null
}
export type CampaignNameTemplateUtm = {
  utm_source: CampaignNameTemplateSegment[]
  utm_medium: CampaignNameTemplateSegment[]
  utm_campaign: CampaignNameTemplateSegment[]
  utm_term: CampaignNameTemplateSegment[]
  utm_content: CampaignNameTemplateSegment[]
  utm_id: CampaignNameTemplateSegment[]
}
export type CampaignNameTemplatesUpdate = {
  id: string
  name: string
  is_default: boolean
  segments: CampaignNameTemplateSegment[]
  ad_group_segments: CampaignNameTemplateSegment[]
  ad_segments: CampaignNameTemplateSegment[]
  utm: CampaignNameTemplateUtm
}
export type CampaignNameTemplate = CampaignNameTemplatesUpdate
export type CampaignThumbnailsResponseInput = {
  thumbnails: any
}
export type CampaignThumbnailsResponse = CampaignThumbnailsResponseInput
export type StandaloneTeamCancelSubscriptionInput = StandaloneShareViaAccountAudienceConfig
export type StandaloneTeamCancelSubscription = {
  cancel_at: number|null
}
export type ChatgptAdsConnectInput = {
  api_key: string
}
export type ChatgptAdsConnect = {
  connected: boolean
  ad_account_id: string|null
  name: string|null
  currency: string|null
}
export type TeamCompetitorSocialAccounts = {
  x: string
  instagram: string
  facebook: string
  linkedin: string
  tiktok: string
  youtube: string
}
export type TeamCompetitor = {
  id: number
  team: number
  website: string
  domain: string
  name: string
  logo_url: string
  summary: string
  notes: string
  social_accounts: TeamCompetitorSocialAccounts
  scrape_status: 'pending'|'running'|'completed'|'error'
  scraped_at: string|null
  scrape_error: string
  meta_page_id: string
  meta_page_name: string
  ads_sync_status: 'pending'|'running'|'completed'|'error'
  ads_synced_at: string|null
  ads_sync_error: string
  ads_active_count: number
  ads_inactive_count: number
  created: string
  modified: string
}
export type TeamCompetitorRescrapeInput = StandaloneShareViaAccountAudienceConfig
export type TeamCompetitorRescrape = TeamCompetitor
export type GetTeamCompetitorAdsQuery = {
  limit?: number
  offset?: number
  status?: string
  sort?: string
}
export type BigDipperTeamMedia = {
  id: number
  source: 'website'|'facebook'|'instagram'|'tiktok'|'x'|'linkedin'|'upload'|'bigdipper'|'competitor'
  page_url: string
  created: string
  similarity: number|null
  tags: string[]
  selected: boolean
  disabled: boolean
  media_type: 'image'|'video'
  mime_type: string
  duration: number|null
  aspect_ratio: string|null
  resolution: string|null
  alt: string
  prompt: string|null
  url: string
  thumbnail_url: string|null
}
export type TeamCompetitorAdCreative = {
  id: number
  order: number
  media: BigDipperTeamMedia|null
  body: string
  title: string
  description: string
  display_link: string
  cta_text: string
  cta_type: string
  link_url: string
}
export type TeamCompetitorAd = {
  id: number
  library_id: string
  page_id: string
  page_name: string
  snapshot_url: string
  collation_id: string
  collation_count: number
  is_active: boolean
  started_at: string|null
  ended_at: string|null
  first_seen_at: string|null
  last_seen_at: string|null
  platforms: string[]
  body: string
  title: string
  description: string
  display_link: string
  cta_text: string
  cta_type: string
  link_url: string
  media_type: 'image'|'video'|'carousel'|'none'
  creatives: TeamCompetitorAdCreative[]
  created: string
  modified: string
}
export type TeamCompetitorSocialAccountsInput = {
  x?: string
  instagram?: string
  facebook?: string
  linkedin?: string
  tiktok?: string
  youtube?: string
}
export type TeamCompetitorUpdateInput = {
  website?: string
  name?: string
  logo_url?: string
  summary?: string
  notes?: string
  social_accounts?: TeamCompetitorSocialAccountsInput
  meta_page_id?: string
}
export type TeamCompetitorUpdate = TeamCompetitor
export type TeamCompetitorInput = {
  website: string
  name?: string
}
export type TeamCompetitorSuggestion = {
  name: string
  website: string
}
export type BigDipperTeamInvitationInput = {
  email: string
  role?: 'member'|'billing_admin'|'approver'
}
export type BigDipperTeamInvitation = {
  id: number
  created: string
  accepted: string|null
  token: any
  email: string
  role: 'member'|'billing_admin'|'approver'
}
export type DashboardLayoutInput = {
  widgets: { id: ("ada"|"website"|"paid"|"organic"|"organic_platforms"|"inbox"|"content"|"audiences"|"research"|"leads"|"ad_suggestions"|"explore"); width: number; height: number; days?: (7|30|90); compare?: boolean }[]
}
export type DashboardWidgetLimits = {
  id: 'ada'|'website'|'paid'|'organic'|'organic_platforms'|'inbox'|'content'|'audiences'|'research'|'leads'|'ad_suggestions'|'explore'
  min_width: number
  min_height: number
  max_height: number
  days: 7|30|90|null
  compare: boolean|null
}
export type DashboardTemplate = {
  id: 'overview'|'paid'|'organic'|'ai_content'|'measurement'|'audiences'
  widgets: { id: ("ada"|"website"|"paid"|"organic"|"organic_platforms"|"inbox"|"content"|"audiences"|"research"|"leads"|"ad_suggestions"|"explore"); width: number; height: number; days?: (7|30|90); compare?: boolean }[]
}
export type DashboardLayout = {
  source: 'custom'|'template'
  template: 'overview'|'paid'|'organic'|'ai_content'|'measurement'|'audiences'
  widgets: { id: ("ada"|"website"|"paid"|"organic"|"organic_platforms"|"inbox"|"content"|"audiences"|"research"|"leads"|"ad_suggestions"|"explore"); width: number; height: number; days?: (7|30|90); compare?: boolean }[]
  columns: number
  rows: number
  catalog: DashboardWidgetLimits[]
  templates: DashboardTemplate[]
}
export type DashboardLayoutResetInput = StandaloneShareViaAccountAudienceConfig
export type DashboardLayoutReset = DashboardLayout
export type DashboardUsageFeature = {
  id: 'campaigns'|'audiences'|'content'|'ad_suggestions'|'research'|'competitors'|'leads'|'social_search'
  used: boolean
}
export type DashboardUsage = {
  features: DashboardUsageFeature[]
}
export type BigDipperDisconnectSocialInput = {
  uid: string
  provider: 'twitter'|'facebook'|'instagram'|'twitter_oauth2'|'linkedin_oauth2'|'linkedin_community'|'google_analytics'|'google_ads'|'reddit'|'tiktok_ads'|'pinterest_ads'|'chatgpt_ads'|'shopify'
}
export type BigDipperDisconnectSocial = AffiliateApplyPartnerCode
export type FacebookConnectInput = {
  code: string
  redirect_uri: string
}
export type FacebookConnect = {
  connected: boolean
  name: string|null
  facebook_id: string|null
}
export type BigDipperTeamFeedbackInput = {
  feedback: string
}
export type BigDipperTeamFeedback = {
  feedback: string
  credits_granted: number
}
export type FunnelAngleUpdateInput = {
  title: string
  description?: string
}
export type FunnelExperimentSummary = {
  id: number
  name: string
  format: 'static'|'video'|'ugc'|'native'|'carousel'
  landing_page_url: string
  status: 'draft'|'in_production'|'ready'|'in_campaign'
  content_ids: number[]
  created: string
  modified: string
}
export type FunnelAngleUpdate = {
  id: number
  title: string
  description: string
  order: number
  experiments: FunnelExperimentSummary[]
}
export type FunnelAngleInput = {
  persona_id: number
  title: string
  description?: string
}
export type FunnelAngle = FunnelAngleUpdate
export type FunnelProductContext = {
  id: number
  name: string
  description: string
}
export type FunnelSegmentContext = FunnelProductContext
export type FunnelPersonaInsight = {
  id: number
  kind: 'desire'|'objection'|'failed_alternative'|'benefit'|'pain_point'
  text: string
  order: number
}
export type FunnelPersonaContext = {
  id: number
  name: string
  age: number|null
  description: string
  insights: FunnelPersonaInsight[]
}
export type FunnelAngleContext = {
  id: number
  title: string
  description: string
}
export type FunnelExperiment = {
  id: number
  name: string
  format: 'static'|'video'|'ugc'|'native'|'carousel'
  offer: string
  landing_page_url: string
  status: 'draft'|'in_production'|'ready'|'in_campaign'
  content_ids: number[]
  product: FunnelProductContext
  segment: FunnelSegmentContext
  persona: FunnelPersonaContext
  angle: FunnelAngleContext
  created: string
  modified: string
}
export type FunnelExperimentContentCreateInput = StandaloneShareViaAccountAudienceConfig
export type FunnelExperimentContentCreate = {
  content_id: number
  experiment: FunnelExperiment
}
export type FunnelExperimentUpdateInput = {
  name?: string
  format?: 'static'|'video'|'ugc'|'native'|'carousel'
  offer?: string
  landing_page_url?: string
  status?: 'draft'|'in_production'|'ready'|'in_campaign'
}
export type FunnelExperimentUpdate = FunnelExperiment
export type FunnelExperimentInput = {
  angle_id: number
  name?: string
  format?: 'static'|'video'|'ugc'|'native'|'carousel'
  offer?: string
  landing_page_url?: string
  status?: 'draft'|'in_production'|'ready'|'in_campaign'
}
export type FunnelPersonaInsightUpdateInput = {
  text: string
}
export type FunnelPersonaInsightUpdate = FunnelPersonaInsight
export type FunnelPersonaInsightInput = {
  persona_id: number
  kind: 'desire'|'objection'|'failed_alternative'|'benefit'|'pain_point'
  text: string
}
export type FunnelProductFillInput = StandaloneShareViaAccountAudienceConfig
export type FunnelPersona = {
  id: number
  name: string
  age: number|null
  description: string
  order: number
  insights: FunnelPersonaInsight[]
  angles: FunnelAngle[]
}
export type FunnelSegment = {
  id: number
  name: string
  description: string
  order: number
  personas: FunnelPersona[]
}
export type FunnelProductFill = {
  id: number
  source: 'research'|'builder'
  name: string
  description: string
  order: number
  segments: FunnelSegment[]
}
export type FunnelPersonaUpdateInput = {
  name: string
  age?: number|null
  description?: string
}
export type FunnelPersonaUpdate = FunnelPersona
export type FunnelPersonaInput = {
  segment_id: number
  name: string
  age?: number|null
  description?: string
}
export type FunnelProductInput = {
  name: string
  description?: string
}
export type FunnelProduct = FunnelProductFill
export type FunnelSegmentUpdateInput = FunnelProductInput
export type FunnelSegmentUpdate = FunnelSegment
export type FunnelSegmentInput = {
  product_id: number
  name: string
  description?: string
}
export type GoogleAdsConnectInput = FacebookConnectInput
export type GoogleAdsConnect = {
  connected: boolean
  google_id: string|null
  email: string|null
  name: string|null
  picture: string|null
}
export type GoogleAnalyticsMetadata = {
  dimensions: any[]
  metrics: any[]
}
export type GoogleAnalyticsPageviewsUTM = {
  rows: any[]
  dimensionHeaders: any[]
  metricHeaders: any[]
}
export type GoogleAnalyticsUAViews = {
  items: any[]
}
export type GoogleConnectInput = FacebookConnectInput
export type GoogleConnect = GoogleAdsConnect
export type InstagramConnectInput = FacebookConnectInput
export type InstagramConnect = {
  connected: boolean
  instagram_accounts: any[]
}
export type BigDipperTeamRemoveInvitationInput = StandaloneAudienceUsedInAdsGenerateSheetInput
export type BigDipperTeamRemoveInvitation = StandaloneShareViaAccountAudienceConfig
export type GetTeamInvoicesQuery = {
  limit?: number
  starting_after?: string
}
export type StandaloneInvoiceTax = {
  name: string
  percentage: number|null
  amount: number
  taxable_amount: number|null
  inclusive: boolean
  reverse_charge: boolean
  jurisdiction: string|null
}
export type StandaloneInvoiceTaxId = {
  type: string
  value: string|null
}
export type StandaloneInvoiceDiscount = {
  name: string
  percent_off: number|null
  amount: number
}
export type StandaloneInvoiceLineItem = {
  kind: 'seats'|'usage'|'other'
  name: string
  description: string|null
  quantity: number|null
  unit_price: number|null
  subtotal_price: number|null
  total_price: number
  period_start: number|null
  period_end: number|null
  seats: number|null
  proration_price: number|null
  credits_per_seat: number|null
  credits_included: number|null
  credits_used: number|null
  credits_remaining: number|null
  credits_price: number|null
  discounts: StandaloneInvoiceDiscount[]
}
export type StandaloneInvoiceSummary = {
  id: string
  name: string
  amount: number
  currency: string|null
  date_start: number|null
  date_end: number|null
  invoice_date: number|null
  status: 'draft'|'open'|'paid'|'uncollectible'|'void'|null
  processing_payment: boolean
  paid_at: number|null
  amount_paid: number|null
  amount_remaining: number|null
  amount_due: number|null
  credit_notes_amount: number|null
  balance_applied: number|null
  refunded_amount: number|null
  pdf_url: string|null
  payment_url: string|null
  subtotal: number|null
  tax_amount: number|null
  tax_exempt: 'none'|'exempt'|'reverse'|null
  taxes: StandaloneInvoiceTax[]
  tax_ids: StandaloneInvoiceTaxId[]
  discounts: StandaloneInvoiceDiscount[]
  line_items: StandaloneInvoiceLineItem[]
}
export type LinkedInCommunityConnectResponseInput = StandaloneShareViaAccountAudienceConfig
export type LinkedInCommunityConnectResponse = {
  connected: boolean
  linkedin_id: string|null
  name: string|null
  email: string|null
  organization_ids: string[]
}
export type LinkedInConnectResponseInput = StandaloneShareViaAccountAudienceConfig
export type LinkedInConnectResponse = {
  connected: boolean
  linkedin_id: string|null
  name: string|null
  email: string|null
}
export type BigDipperTeamRemoveMemberInput = {
  user_id: number
}
export type BigDipperTeamRemoveMember = StandaloneShareViaAccountAudienceConfig
export type BigDipperTeamUpdateMemberCanApproveInput = {
  user_id: number
  can_approve: boolean
}
export type BigDipperTeamUpdateMemberCanApprove = BigDipperTeamUpdateMemberCanApproveInput
export type BigDipperTeamUpdateMemberRoleInput = {
  user_id: number
  role: 'member'|'billing_admin'|'approver'
}
export type BigDipperTeamUpdateMemberRole = BigDipperTeamUpdateMemberRoleInput
export type PinterestAdsConnectInput = FacebookConnectInput
export type PinterestAdsConnect = {
  connected: boolean
  pinterest_id: string|null
  username: string|null
  business_name: string|null
  profile_image: string|null
}
export type RedditConnectInput = FacebookConnectInput
export type RedditConnect = {
  connected: boolean
  reddit_id: string|null
  username: string|null
  icon_img: string|null
}
export type StandaloneTeamRefreshSubscriptionInput = StandaloneShareViaAccountAudienceConfig
export type StandaloneTeamRefreshSubscription = StandaloneTeamBill
export type TeamResearchSectionCommentInput = {
  comment: string
  selection: string
  selection_before?: string
  selection_after?: string
}
export type TeamResearchSectionEditInput = {
  category: 'business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit'|'marketing_funnels'|'campaign_name_format'
  prompt?: string
  comments?: TeamResearchSectionCommentInput[]
}
export type TeamResearchSectionEdit = {
  id: number
  team: number
  created: string
  modified: string
  status: 'pending'|'in_progress'|'completed'|'error'
  content: string
  category: 'business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit'|'marketing_funnels'|'campaign_name_format'
}
export type TeamResearchSectionFileLabelInput = {
  label: string|null
}
export type TeamResearchSectionFileLabel = TeamResearchSectionFileLabelInput
export type TeamResearchSectionFileInput = StandaloneShareViaAccountAudienceConfig
export type TeamResearchSectionFile = {
  id: number
  filename: string
  label: string|null
  content_type: string
  size: number
  file_url: string
  parse_status: 'pending'|'in_progress'|'completed'|'used'|'error'
  created: string
}
export type TeamResearchSectionInput = {
  category: 'business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit'|'marketing_funnels'|'campaign_name_format'
  content?: string
  status?: 'pending'|'in_progress'|'completed'|'error'
}
export type TeamResearchSection = {
  id: number
  team: number
  created: string
  modified: string
  files: TeamResearchSectionFile[]
  category: 'business_profile'|'target_audiences'|'competitors'|'brand_guidelines'|'market_research'|'marketing_strategy'|'website_audit'|'marketing_funnels'|'campaign_name_format'
  content: string
  status: 'pending'|'in_progress'|'completed'|'error'
}
export type TeamResearchStreamEvent = {
  type: 'log'|'token'|null
  message: string|null
  text: string|null
  section: string|null
  label: string|null
  status: 'in_progress'|'completed'|'error'|null
  error: string|null
}
export type StandaloneTeamResumeSubscriptionInput = StandaloneShareViaAccountAudienceConfig
export type StandaloneTeamResumeSubscription = {
  renews_at: number|null
}
export type ShopifyConnectInput = {
  code: string
  shop: string
  callback_query?: string
}
export type ShopifyConnect = {
  connected: boolean
  shop_domain: string|null
  name: string|null
  currency: string|null
  plan: string|null
}
export type GetTeamSocialAccountsQuery = {
  provider: 'twitter'|'facebook'|'instagram'|'twitter_oauth2'|'linkedin_oauth2'|'linkedin_community'|'google_analytics'|'google_ads'|'reddit'|'tiktok_ads'|'pinterest_ads'|'chatgpt_ads'|'shopify'
}
export type BigDipperTeamSocialAccountsExtraData = {
  name: string|null
  email: string|null
  username: string|null
  profile_image_url: string|null
  instagram_accounts: string[]|null
  id: string|null
  screen_name: string|null
  verified: boolean|null
}
export type BigDipperTeamSocialAdAccount = {
  account_id: string|null
  name: string|null
  timezone: string|null
  network: string|null
}
export type BigDipperTeamSocialAccounts = {
  extra_data: BigDipperTeamSocialAccountsExtraData
  uid: string
  is_active: boolean
  expires_at: string|null
  provider: 'twitter'|'facebook'|'instagram'|'twitter_oauth2'|'linkedin_oauth2'|'linkedin_community'|'google_analytics'|'google_ads'|'reddit'|'tiktok_ads'|'pinterest_ads'|'chatgpt_ads'|'shopify'
  ad_accounts: BigDipperTeamSocialAdAccount[]
  reconnect_required: boolean
}
export type StandaloneSubscriptionCheckoutInput = {
  tier: 'pro'|'business'
  success_url: string
  cancel_url: string
}
export type StandaloneSubscriptionCheckout = {
  checkout_url: string
}
export type TikTokAdsConnectInput = {
  auth_code: string
}
export type TikTokAdsConnect = {
  connected: boolean
  tiktok_id: string|null
  name: string|null
  email: string|null
}
export type StandaloneTeamUpcomingInvoice = {
  invoice: StandaloneInvoiceSummary|null
}
export type StandaloneTeamUpdateSubscriptionInput = {
  tier: 'pro'|'business'
}
export type StandaloneTeamUpdateSubscription = StandaloneTeamUpdateSubscriptionInput
export type BigDipperTeamUpdateInput = {
  name: string
  country_code?: string|null
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  team_type?: 'personal'|'business'|null
  billing_name?: string|null
}
export type BigDipperTeamUpdate = {
  name: string
  country_code: string|null
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  team_type: 'personal'|'business'|null
  billing_name: string|null
}
export type GetTeamUsageQuery = {
  start?: string
  end?: string
  granularity?: 'month'|'week'|'day'|'hour'|'minute'
}
export type StandaloneAggregatedQuantity = {
  aggregated_created: string
  total_quantity: number
}
export type StandaloneUsage = {
  event_type: 'text_creation'|'image_creation'|'video_creation'|'audience_search'|'campaign'|'post_organic_x'|'post_organic_meta'|'post_organic_linkedin'|'post_organic_reddit'|'post_organic_tiktok'|'post_paid_x'|'post_paid_meta'|'post_paid_linkedin'|'post_paid_reddit'|'post_paid_tiktok'|'post_approval'|'custom_audience_x'|'listening_x'|'listening_other'|'increment_seat'|'decrement_seat'
  aggregated_quantities: StandaloneAggregatedQuantity[]
  count: number
}
export type StandaloneTeamUsage = {
  usages: StandaloneUsage[]
}
export type StandaloneXAdsConnectInput = {
  oauth_token: string
  oauth_token_secret: string
  oauth_verifier: string
}
export type StandaloneXAdsConnect = {
  success: boolean
  twitter_user_id: string|null
  screen_name: string|null
  error: string|null
}
export type StandaloneXConnectInput = {
  code: string
  redirect_uri: string
  code_verifier: string
}
export type StandaloneXConnect = {
  connected: boolean
  username: string|null
}
export type GetTeamQuery = {
  with_tier?: boolean
}
export type BigDipperTeamMemberInput = StandaloneShareViaAccountAudienceConfig
export type BigDipperTeamUserInput = {
  user: BigDipperTeamMemberInput
  role?: 'owner'|'admin'|'member'|'billing_admin'|'partner_admin'|'approver'
}
export type BigDipperTeamInput = {
  websites?: string[]
  users: BigDipperTeamUserInput[]
  with_tier?: boolean
  name: string
  country_code?: string|null
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  team_type?: 'personal'|'business'|null
  billing_name?: string|null
  onboarding_experience_level?: 'new'|'some'|'advanced'|null
  onboarding_goals?: ('organic_content'|'ai_content'|'paid_campaigns'|'measurement'|'audiences')[]
  onboarding_completed_at?: string|null
  posting_requires_approval?: boolean
}
export type PatchTeamQuery = GetTeamQuery
export type AdAccountAudienceCreateInput = {
  platform: 'x'
  ad_account_id: string
  audience_id: number
  name?: string|null
}
export type MetaGeoLocationItem = {
  country: string|null
  name: string|null
  key: string|null
  type: string|null
}
export type AdAccountAudienceItemTypeMeta = {
  type: 'UNKNOWN'|'FILE_IMPORTED'|'EVENT_BASED'|'SEED_BASED'|'THIRD_PARTY_IMPORTED'|'COPY_PASTE'|'CONTACT_IMPORTER'|'HOUSEHOLD_AUDIENCE'
  sub_type: 'ANYTHING'|'NOTHING'|'HASHES'|'USER_IDS'|'HASHES_OR_USER_IDS'|'MOBILE_ADVERTISER_IDS'|'EXTERNAL_IDS'|'MULTI_HASHES'|'TOKENS'|'EXTERNAL_IDS_MIX'|'HOUSEHOLD_EXPANSION'|'SUBSCRIBER_LIST'|'WEB_PIXEL_HITS'|'MOBILE_APP_EVENTS'|'MOBILE_APP_COMBINATION_EVENTS'|'VIDEO_EVENTS'|'WEB_PIXEL_COMBINATION_EVENTS'|'PLATFORM'|'MULTI_DATA_EVENTS'|'IG_BUSINESS_EVENTS'|'STORE_VISIT_EVENTS'|'INSTANT_ARTICLE_EVENTS'|'FB_EVENT_SIGNALS'|'FACEBOOK_WIFI_EVENTS'|'AR_EXPERIENCE_EVENTS'|'AR_EFFECTS_EVENTS'|'MESSENGER_ONSITE_SUBSCRIPTION'|'WHATSAPP_SUBSCRIBER_POOL'|'MARKETPLACE_LISTINGS'|'AD_CAMPAIGN'|'GROUP_EVENTS'|'MESSAGE_CAMPAIGN'|'ENGAGEMENT_EVENT_USERS'|'CUSTOM_AUDIENCE_USERS'|'PAGE_FANS'|'CONVERSION_PIXEL_HITS'|'APP_USERS'|'S_EXPR'|'DYNAMIC_RULE'|'CAMPAIGN_CONVERSIONS'|'WEB_PIXEL_HITS_CUSTOM_AUDIENCE_USERS'|'MOBILE_APP_CUSTOM_AUDIENCE_USERS'|'COMBINATION_CUSTOM_AUDIENCE_USERS'|'VIDEO_EVENT_USERS'|'FB_PIXEL_HITS'|'IG_PROMOTED_POST'|'PLACE_VISITS'|'OFFLINE_EVENT_USERS'|'EXPANDED_AUDIENCE'|'SEED_LIST'|'PARTNER_CATEGORY_USERS'|'PAGE_SMART_AUDIENCE'|'MULTICOUNTRY_COMBINATION'|'PLATFORM_USERS'|'MULTI_EVENT_SOURCE'|'SMART_AUDIENCE'|'LOOKALIKE_PLATFORM'|'SIGNAL_SOURCE'|'MAIL_CHIMP_EMAIL_HASHES'|'CONSTANT_CONTACTS_EMAIL_HASHES'|'COPY_PASTE_EMAIL_HASHES'|'CUSTOM_DATA_TARGETING'|'CONTACT_IMPORTER'|'DATA_FILE'
}
export type AdAccountAudienceItem = {
  id: string
  name: string|null
  description: string|null
  approximate_count: number|null
  status: string|null
  countries: string[]
  geo_locations: MetaGeoLocationItem[]
  type: XOR<'crm', XOR<'BULK'|'RETARGETING'|'MARKET_AUTOMATION', XOR<'CUSTOMER_LIST'|'VISITOR'|'ENGAGEMENT'|'ACTALIKE', XOR<'CUSTOMER_FILE'|'ENGAGEMENT'|'APP_ACTIVITY'|'WEBSITE'|'LOOKALIKE'|'LEAD_GENERATION'|'RULE_BUSINESS_ACCOUNT'|'RULE_AD_SHOP'|'PARTNER'|'CHALLENGE'|'PREFERRED_POPULATION', AdAccountAudienceItemTypeMeta>>>>|null
}
export type AdAccountAudienceCreate = {
  custom_audience: AdAccountAudienceItem|null
  error: string|null
}
export type GetAdAccountAudiencesQuery = {
  platform: string
  ad_account_id: string
}
export type AdAccountAudiencesResponse = {
  platform: string
  ad_account_id: string
  custom_audiences: AdAccountAudienceItem[]
  saved_audiences: AdAccountAudienceItem[]
  error: string|null
}
export type GetAdAccountCampaignOptionsQuery = {
  platform: 'x'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  objective?: 'awareness'|'traffic'|'conversions'|'leads'|'app_installs'
}
export type CampaignOptionsFundingInstrument = {
  id: string
  type: string|null
  description: string|null
}
export type CampaignOptionsWebEventTag = {
  id: string
  name: string
  type: string|null
  conversion_type: string|null
  last_tracked_at: string|null
  valid_objectives: string[]
}
export type CampaignOptionsPixel = {
  id: string
  name: string
  active_events: string[]
}
export type CampaignOptionsAppStore = {
  value: string
  label: string
}
export type CampaignOptionsApp = {
  id: string
  name: string
  os: string|null
  stores: CampaignOptionsAppStore[]
}
export type CampaignOptionsAppEventTag = {
  id: string
  name: string
  conversion_type: string|null
  os: string|null
  status: string|null
}
export type CampaignOptionsPage = {
  id: string
  name: string
}
export type CampaignOptionsConversion = {
  id: string
  name: string
  type: string|null
  url: string|null
  valid_objectives: string[]
}
export type CampaignOptionsConversionGoal = {
  value: string
  label: string
  category: string
  origin: string|null
  valid_objectives: string[]
}
export type CampaignOptionsIdentity = {
  id: string
  name: string
  identity_type: string|null
}
export type AdAccountCampaignOptionsResponse = {
  platform: 'x'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  objective: 'awareness'|'traffic'|'conversions'|'leads'|'app_installs'|null
  funding_instruments: CampaignOptionsFundingInstrument[]
  web_event_tags: CampaignOptionsWebEventTag[]
  pixels: CampaignOptionsPixel[]
  apps: CampaignOptionsApp[]
  app_event_tags: CampaignOptionsAppEventTag[]
  pages: CampaignOptionsPage[]
  conversions: CampaignOptionsConversion[]
  conversion_actions: CampaignOptionsConversionGoal[]
  identities: CampaignOptionsIdentity[]
  error: string|null
}
export type AdaAnalyzeOptionsInput = {
  session_id: number
}
export type AdaOption = {
  label: string
  value: string
  kind: 'inline'|'media_item'|'media'
  media_id: number|null
}
export type AdaAnalyzeOptions = {
  options: AdaOption[]
  allow_multiple: boolean
}
export type AdaChatStreamInput = {
  session_id: number
  message: string
  state: { view: ("audience_list"|"campaign_list"|"campaign_setup"|"campaign_ad_groups"|"campaign_creatives"|"campaign_review"|"saved_posts"|"create_content"|"publish"|"other"); campaign: { name: string; objective: ("awareness"|"traffic"|"conversions"|"leads"|"app_installs"); start_time?: string|null; end_time?: string|null; budget_cap?: number|null; platform_budget_caps?: { x: number|null; meta: number|null; linkedin: number|null; reddit: number|null; tiktok: number|null }; special_ad_categories?: ("HOUSING"|"EMPLOYMENT"|"CREDIT"|"ISSUES_ELECTIONS_POLITICS")[]; tiktok_campaign_budget_optimization?: boolean; tiktok_smart_plus?: boolean; tiktok_hfss?: boolean; google_ads_settings?: { bid_strategy: ("MAXIMIZE_CONVERSIONS"|"MAXIMIZE_CONVERSION_VALUE"|"TARGET_CPA"|"TARGET_ROAS"|"MAXIMIZE_CLICKS"|"MANUAL_CPC"|null); target_cpa: number|null; target_roas: number|null; cpc_bid_ceiling: number|null; enhanced_cpc: boolean|null; conversion_action_ids: string[]; target_search_network: boolean|null; target_content_network: boolean|null; ai_max_enabled: boolean|null; ai_max_search_term_matching: boolean|null; ai_max_text_asset_automation: boolean|null }; global_creatives?: { x: string[]; meta: string[]; linkedin: string[]; reddit: string[] }; ad_groups?: { id: string; name: string; audience_id: number|null; use_one_audience_for_all_platforms: boolean; platformConfigs: { x: { ad_account_id: string; funding_instrument_id?: string|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; placement?: string|null; primary_web_event_tag?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; meta: { ad_account_id: string; page_id?: string|null; cbo?: boolean|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; countries?: string[]; placements?: ("facebook"|"instagram")[]; pixel_id?: string|null; event_type?: string|null; conversion_window?: ("CLICK_DAYS_1"|"CLICK_DAYS_7"|"CLICK_DAYS_1_VIEW_DAYS_1"|"CLICK_DAYS_7_VIEW_DAYS_1"); lead_form_id?: string|null; application_id?: string|null; object_store_url?: string|null; advantage_audience?: boolean|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null; dsa_beneficiary?: string|null; dsa_payor?: string|null }; linkedin: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; cost_type?: ("CPM"|"CPC"); ad_format?: ("STANDARD_UPDATE"|"SINGLE_VIDEO"|"CAROUSEL"); countries?: string[]; conversion_id?: string|null; lead_form_id?: string|null; lead_form_cta?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null }; reddit: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; app_id?: string|null; app_os?: ("iOS"|"Android"); subreddits?: string[]; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; google_ads: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; content_ids?: number[]; enabled: boolean; audience_id?: number|null } } }[] }; creatives: { saved: { id: string|number; name: string|null; template_text: string|null; template_headline: string|null; template_destination_url: string|null; template_call_to_action: string|null; publish_type: ("organic"|"dark"|null); template_media: { id: string|number; url: string; media_type: ("image"|"video"); thumbnail_url: string|null; alt: string|null }[]; platforms: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|"pinterest"|"chatgpt"); status: ("draft"|"scheduled"|"publishing"|"published"|"schedule_failed"); scheduled_at: string|null; published_at: string|null; page_id?: string|null; ig_user_id?: string|null; instagram_user_id?: string|null; author?: string|null; sr?: string|null; account_id?: string|null; as_user_id?: string|null; identity_id?: string|null; post_id?: string|null; ig_media_id?: string|null; creative_id?: string|null; effective_object_story_id?: string|null; ad_id?: string|null; board_id?: string|null; pin_id?: string|null }[] }[]; draft: { template_text: string|null; name: string|null; publish_type: ("organic"|"dark"|null); template_media_ids: (number|string)[]; media: { url: string; media_type: ("image"|"video"|null); thumbnail_url: string|null; alt: string|null; aspect_ratio: string|null; duration: number|null }[]; reference_image_urls: string[] }; publish_composer: { post_id: string|number|null; scheduled_at: string|null; platforms: ("x"|"facebook"|"instagram"|"meta"|"linkedin"|"reddit"|"google_ads"|"tiktok")[] }; published: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|null); text: string|null; media_url: string|null; media_type: ("image"|"video"|null); destination_url: string|null; created_at: string|null; card_uri: string|null; saved_post_id: string|number|null; card: { title: string|null; image_url: string|null; destination_url: string|null }|null }[] }; audiences: { id: number; name: string; description: string|null; audience_size: number|null }[]; audience_draft: { name: string; description: string|null }; lead_form_draft: { page_id: string; ad_group_index: number|null; name: string; headline: string|null; description: string|null; collect_email: boolean; collect_full_name: boolean; collect_phone: boolean; privacy_policy_url: string|null; thank_you_title: string|null; thank_you_body: string|null; thank_you_button_type: ("VIEW_WEBSITE"|"DOWNLOAD"|"CALL_BUSINESS"|null); thank_you_button_text: string|null; thank_you_button_url: string|null; thank_you_phone_number: string|null; custom_questions: { id: string|null; type: ("short_answer"|"multiple_choice"); label: string; options: string[] }[] }|null }
}
export type AdaChatStream = {
  state: { view: ("audience_list"|"campaign_list"|"campaign_setup"|"campaign_ad_groups"|"campaign_creatives"|"campaign_review"|"saved_posts"|"create_content"|"publish"|"other"); campaign: { name: string; objective: ("awareness"|"traffic"|"conversions"|"leads"|"app_installs"); start_time?: string|null; end_time?: string|null; budget_cap?: number|null; platform_budget_caps?: { x: number|null; meta: number|null; linkedin: number|null; reddit: number|null; tiktok: number|null }; special_ad_categories?: ("HOUSING"|"EMPLOYMENT"|"CREDIT"|"ISSUES_ELECTIONS_POLITICS")[]; tiktok_campaign_budget_optimization?: boolean; tiktok_smart_plus?: boolean; tiktok_hfss?: boolean; google_ads_settings?: { bid_strategy: ("MAXIMIZE_CONVERSIONS"|"MAXIMIZE_CONVERSION_VALUE"|"TARGET_CPA"|"TARGET_ROAS"|"MAXIMIZE_CLICKS"|"MANUAL_CPC"|null); target_cpa: number|null; target_roas: number|null; cpc_bid_ceiling: number|null; enhanced_cpc: boolean|null; conversion_action_ids: string[]; target_search_network: boolean|null; target_content_network: boolean|null; ai_max_enabled: boolean|null; ai_max_search_term_matching: boolean|null; ai_max_text_asset_automation: boolean|null }; global_creatives?: { x: string[]; meta: string[]; linkedin: string[]; reddit: string[] }; ad_groups?: { id: string; name: string; audience_id: number|null; use_one_audience_for_all_platforms: boolean; platformConfigs: { x: { ad_account_id: string; funding_instrument_id?: string|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; placement?: string|null; primary_web_event_tag?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; meta: { ad_account_id: string; page_id?: string|null; cbo?: boolean|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; countries?: string[]; placements?: ("facebook"|"instagram")[]; pixel_id?: string|null; event_type?: string|null; conversion_window?: ("CLICK_DAYS_1"|"CLICK_DAYS_7"|"CLICK_DAYS_1_VIEW_DAYS_1"|"CLICK_DAYS_7_VIEW_DAYS_1"); lead_form_id?: string|null; application_id?: string|null; object_store_url?: string|null; advantage_audience?: boolean|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null; dsa_beneficiary?: string|null; dsa_payor?: string|null }; linkedin: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; cost_type?: ("CPM"|"CPC"); ad_format?: ("STANDARD_UPDATE"|"SINGLE_VIDEO"|"CAROUSEL"); countries?: string[]; conversion_id?: string|null; lead_form_id?: string|null; lead_form_cta?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null }; reddit: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; app_id?: string|null; app_os?: ("iOS"|"Android"); subreddits?: string[]; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; google_ads: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; content_ids?: number[]; enabled: boolean; audience_id?: number|null } } }[] }; creatives: { saved: { id: string|number; name: string|null; template_text: string|null; template_headline: string|null; template_destination_url: string|null; template_call_to_action: string|null; publish_type: ("organic"|"dark"|null); template_media: { id: string|number; url: string; media_type: ("image"|"video"); thumbnail_url: string|null; alt: string|null }[]; platforms: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|"pinterest"|"chatgpt"); status: ("draft"|"scheduled"|"publishing"|"published"|"schedule_failed"); scheduled_at: string|null; published_at: string|null; page_id?: string|null; ig_user_id?: string|null; instagram_user_id?: string|null; author?: string|null; sr?: string|null; account_id?: string|null; as_user_id?: string|null; identity_id?: string|null; post_id?: string|null; ig_media_id?: string|null; creative_id?: string|null; effective_object_story_id?: string|null; ad_id?: string|null; board_id?: string|null; pin_id?: string|null }[] }[]; draft: { template_text: string|null; name: string|null; publish_type: ("organic"|"dark"|null); template_media_ids: (number|string)[]; media: { url: string; media_type: ("image"|"video"|null); thumbnail_url: string|null; alt: string|null; aspect_ratio: string|null; duration: number|null }[]; reference_image_urls: string[] }; publish_composer: { post_id: string|number|null; scheduled_at: string|null; platforms: ("x"|"facebook"|"instagram"|"meta"|"linkedin"|"reddit"|"google_ads"|"tiktok")[] }; published: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|null); text: string|null; media_url: string|null; media_type: ("image"|"video"|null); destination_url: string|null; created_at: string|null; card_uri: string|null; saved_post_id: string|number|null; card: { title: string|null; image_url: string|null; destination_url: string|null }|null }[] }; audiences: { id: number; name: string; description: string|null; audience_size: number|null }[]; audience_draft: { name: string; description: string|null }; lead_form_draft: { page_id: string; ad_group_index: number|null; name: string; headline: string|null; description: string|null; collect_email: boolean; collect_full_name: boolean; collect_phone: boolean; privacy_policy_url: string|null; thank_you_title: string|null; thank_you_body: string|null; thank_you_button_type: ("VIEW_WEBSITE"|"DOWNLOAD"|"CALL_BUSINESS"|null); thank_you_button_text: string|null; thank_you_button_url: string|null; thank_you_phone_number: string|null; custom_questions: { id: string|null; type: ("short_answer"|"multiple_choice"); label: string; options: string[] }[] }|null }
  type: 'start'|'text_delta'|'tool_result'|'error'|'done'
  content: XOR<string, object>
}
export type AdaSessionInput = {
  title?: string
  state?: { view: ("audience_list"|"campaign_list"|"campaign_setup"|"campaign_ad_groups"|"campaign_creatives"|"campaign_review"|"saved_posts"|"create_content"|"publish"|"other"); campaign: { name: string; objective: ("awareness"|"traffic"|"conversions"|"leads"|"app_installs"); start_time?: string|null; end_time?: string|null; budget_cap?: number|null; platform_budget_caps?: { x: number|null; meta: number|null; linkedin: number|null; reddit: number|null; tiktok: number|null }; special_ad_categories?: ("HOUSING"|"EMPLOYMENT"|"CREDIT"|"ISSUES_ELECTIONS_POLITICS")[]; tiktok_campaign_budget_optimization?: boolean; tiktok_smart_plus?: boolean; tiktok_hfss?: boolean; google_ads_settings?: { bid_strategy: ("MAXIMIZE_CONVERSIONS"|"MAXIMIZE_CONVERSION_VALUE"|"TARGET_CPA"|"TARGET_ROAS"|"MAXIMIZE_CLICKS"|"MANUAL_CPC"|null); target_cpa: number|null; target_roas: number|null; cpc_bid_ceiling: number|null; enhanced_cpc: boolean|null; conversion_action_ids: string[]; target_search_network: boolean|null; target_content_network: boolean|null; ai_max_enabled: boolean|null; ai_max_search_term_matching: boolean|null; ai_max_text_asset_automation: boolean|null }; global_creatives?: { x: string[]; meta: string[]; linkedin: string[]; reddit: string[] }; ad_groups?: { id: string; name: string; audience_id: number|null; use_one_audience_for_all_platforms: boolean; platformConfigs: { x: { ad_account_id: string; funding_instrument_id?: string|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; placement?: string|null; primary_web_event_tag?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; meta: { ad_account_id: string; page_id?: string|null; cbo?: boolean|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; countries?: string[]; placements?: ("facebook"|"instagram")[]; pixel_id?: string|null; event_type?: string|null; conversion_window?: ("CLICK_DAYS_1"|"CLICK_DAYS_7"|"CLICK_DAYS_1_VIEW_DAYS_1"|"CLICK_DAYS_7_VIEW_DAYS_1"); lead_form_id?: string|null; application_id?: string|null; object_store_url?: string|null; advantage_audience?: boolean|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null; dsa_beneficiary?: string|null; dsa_payor?: string|null }; linkedin: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; cost_type?: ("CPM"|"CPC"); ad_format?: ("STANDARD_UPDATE"|"SINGLE_VIDEO"|"CAROUSEL"); countries?: string[]; conversion_id?: string|null; lead_form_id?: string|null; lead_form_cta?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null }; reddit: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; app_id?: string|null; app_os?: ("iOS"|"Android"); subreddits?: string[]; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; google_ads: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; content_ids?: number[]; enabled: boolean; audience_id?: number|null } } }[] }; creatives: { saved: { id: string|number; name: string|null; template_text: string|null; template_headline: string|null; template_destination_url: string|null; template_call_to_action: string|null; publish_type: ("organic"|"dark"|null); template_media: { id: string|number; url: string; media_type: ("image"|"video"); thumbnail_url: string|null; alt: string|null }[]; platforms: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|"pinterest"|"chatgpt"); status: ("draft"|"scheduled"|"publishing"|"published"|"schedule_failed"); scheduled_at: string|null; published_at: string|null; page_id?: string|null; ig_user_id?: string|null; instagram_user_id?: string|null; author?: string|null; sr?: string|null; account_id?: string|null; as_user_id?: string|null; identity_id?: string|null; post_id?: string|null; ig_media_id?: string|null; creative_id?: string|null; effective_object_story_id?: string|null; ad_id?: string|null; board_id?: string|null; pin_id?: string|null }[] }[]; draft: { template_text: string|null; name: string|null; publish_type: ("organic"|"dark"|null); template_media_ids: (number|string)[]; media: { url: string; media_type: ("image"|"video"|null); thumbnail_url: string|null; alt: string|null; aspect_ratio: string|null; duration: number|null }[]; reference_image_urls: string[] }; publish_composer: { post_id: string|number|null; scheduled_at: string|null; platforms: ("x"|"facebook"|"instagram"|"meta"|"linkedin"|"reddit"|"google_ads"|"tiktok")[] }; published: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|null); text: string|null; media_url: string|null; media_type: ("image"|"video"|null); destination_url: string|null; created_at: string|null; card_uri: string|null; saved_post_id: string|number|null; card: { title: string|null; image_url: string|null; destination_url: string|null }|null }[] }; audiences: { id: number; name: string; description: string|null; audience_size: number|null }[]; audience_draft: { name: string; description: string|null }; lead_form_draft: { page_id: string; ad_group_index: number|null; name: string; headline: string|null; description: string|null; collect_email: boolean; collect_full_name: boolean; collect_phone: boolean; privacy_policy_url: string|null; thank_you_title: string|null; thank_you_body: string|null; thank_you_button_type: ("VIEW_WEBSITE"|"DOWNLOAD"|"CALL_BUSINESS"|null); thank_you_button_text: string|null; thank_you_button_url: string|null; thank_you_phone_number: string|null; custom_questions: { id: string|null; type: ("short_answer"|"multiple_choice"); label: string; options: string[] }[] }|null }
}
export type AdaSession = {
  id: number
  team: number
  user: number
  created: string
  modified: string
  title: string
  state: { view: ("audience_list"|"campaign_list"|"campaign_setup"|"campaign_ad_groups"|"campaign_creatives"|"campaign_review"|"saved_posts"|"create_content"|"publish"|"other"); campaign: { name: string; objective: ("awareness"|"traffic"|"conversions"|"leads"|"app_installs"); start_time?: string|null; end_time?: string|null; budget_cap?: number|null; platform_budget_caps?: { x: number|null; meta: number|null; linkedin: number|null; reddit: number|null; tiktok: number|null }; special_ad_categories?: ("HOUSING"|"EMPLOYMENT"|"CREDIT"|"ISSUES_ELECTIONS_POLITICS")[]; tiktok_campaign_budget_optimization?: boolean; tiktok_smart_plus?: boolean; tiktok_hfss?: boolean; google_ads_settings?: { bid_strategy: ("MAXIMIZE_CONVERSIONS"|"MAXIMIZE_CONVERSION_VALUE"|"TARGET_CPA"|"TARGET_ROAS"|"MAXIMIZE_CLICKS"|"MANUAL_CPC"|null); target_cpa: number|null; target_roas: number|null; cpc_bid_ceiling: number|null; enhanced_cpc: boolean|null; conversion_action_ids: string[]; target_search_network: boolean|null; target_content_network: boolean|null; ai_max_enabled: boolean|null; ai_max_search_term_matching: boolean|null; ai_max_text_asset_automation: boolean|null }; global_creatives?: { x: string[]; meta: string[]; linkedin: string[]; reddit: string[] }; ad_groups?: { id: string; name: string; audience_id: number|null; use_one_audience_for_all_platforms: boolean; platformConfigs: { x: { ad_account_id: string; funding_instrument_id?: string|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; placement?: string|null; primary_web_event_tag?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; meta: { ad_account_id: string; page_id?: string|null; cbo?: boolean|null; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; countries?: string[]; placements?: ("facebook"|"instagram")[]; pixel_id?: string|null; event_type?: string|null; conversion_window?: ("CLICK_DAYS_1"|"CLICK_DAYS_7"|"CLICK_DAYS_1_VIEW_DAYS_1"|"CLICK_DAYS_7_VIEW_DAYS_1"); lead_form_id?: string|null; application_id?: string|null; object_store_url?: string|null; advantage_audience?: boolean|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null; dsa_beneficiary?: string|null; dsa_payor?: string|null }; linkedin: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; cost_type?: ("CPM"|"CPC"); ad_format?: ("STANDARD_UPDATE"|"SINGLE_VIDEO"|"CAROUSEL"); countries?: string[]; conversion_id?: string|null; lead_form_id?: string|null; lead_form_cta?: string|null; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null; saved_audience_id?: string|null }; reddit: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; app_id?: string|null; app_os?: ("iOS"|"Android"); subreddits?: string[]; creative_ids?: string[]; enabled: boolean; use_global_creatives: boolean; audience_id?: number|null }; google_ads: { ad_account_id: string; daily_budget: number|null; bid_strategy?: ("AUTO"|"TARGET"); bid_amount?: number|null; content_ids?: number[]; enabled: boolean; audience_id?: number|null } } }[] }; creatives: { saved: { id: string|number; name: string|null; template_text: string|null; template_headline: string|null; template_destination_url: string|null; template_call_to_action: string|null; publish_type: ("organic"|"dark"|null); template_media: { id: string|number; url: string; media_type: ("image"|"video"); thumbnail_url: string|null; alt: string|null }[]; platforms: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|"pinterest"|"chatgpt"); status: ("draft"|"scheduled"|"publishing"|"published"|"schedule_failed"); scheduled_at: string|null; published_at: string|null; page_id?: string|null; ig_user_id?: string|null; instagram_user_id?: string|null; author?: string|null; sr?: string|null; account_id?: string|null; as_user_id?: string|null; identity_id?: string|null; post_id?: string|null; ig_media_id?: string|null; creative_id?: string|null; effective_object_story_id?: string|null; ad_id?: string|null; board_id?: string|null; pin_id?: string|null }[] }[]; draft: { template_text: string|null; name: string|null; publish_type: ("organic"|"dark"|null); template_media_ids: (number|string)[]; media: { url: string; media_type: ("image"|"video"|null); thumbnail_url: string|null; alt: string|null; aspect_ratio: string|null; duration: number|null }[]; reference_image_urls: string[] }; publish_composer: { post_id: string|number|null; scheduled_at: string|null; platforms: ("x"|"facebook"|"instagram"|"meta"|"linkedin"|"reddit"|"google_ads"|"tiktok")[] }; published: { id: string|number; platform: ("x"|"meta"|"facebook"|"instagram"|"linkedin"|"reddit"|"google_ads"|"tiktok"|null); text: string|null; media_url: string|null; media_type: ("image"|"video"|null); destination_url: string|null; created_at: string|null; card_uri: string|null; saved_post_id: string|number|null; card: { title: string|null; image_url: string|null; destination_url: string|null }|null }[] }; audiences: { id: number; name: string; description: string|null; audience_size: number|null }[]; audience_draft: { name: string; description: string|null }; lead_form_draft: { page_id: string; ad_group_index: number|null; name: string; headline: string|null; description: string|null; collect_email: boolean; collect_full_name: boolean; collect_phone: boolean; privacy_policy_url: string|null; thank_you_title: string|null; thank_you_body: string|null; thank_you_button_type: ("VIEW_WEBSITE"|"DOWNLOAD"|"CALL_BUSINESS"|null); thank_you_button_text: string|null; thank_you_button_url: string|null; thank_you_phone_number: string|null; custom_questions: { id: string|null; type: ("short_answer"|"multiple_choice"); label: string; options: string[] }[] }|null }
}
export type GetAdaSessionsQuery = GetAdSetListQuery
export type AdaMessage = {
  id: number
  role: 'system'|'developer'|'user'|'assistant'|'tool'
  content: any
  tool_calls: { id?: string; type?: ("function"); function: { name: string; arguments: {  } } }[]
  tool_call_id: string|null
}
export type AdaSessionDetail = {
  session: AdaSession
  messages: AdaMessage[]
}
export type GetTeamAdsQuery = {
  platforms?: string
  ad_account_id?: string
  placement?: 'all'|'facebook'|'instagram'
  start_date?: string
  end_date?: string
  limit?: number
  offset?: number
  sort?: 'spend'|'impressions'|'roas'|'recent'|'conversions'|'ctr'|'cpa'
  refresh?: boolean
  bust_cache?: string
}
export type TeamAd = {
  platform: 'x'|'meta'|'linkedin'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  ad_account_name: string
  ad_id: string
  name: string|null
  status: string|null
  campaign_id: string|null
  campaign_name: string|null
  created_at: string|null
  creative_id: string|null
  creative: CampaignOverviewCreative
  preview_url: string|null
  stats: CampaignOverviewStats
}
export type TeamAdsSource = {
  platform: 'x'|'meta'|'linkedin'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string|null
  connected: boolean
  error: string|null
}
export type TeamAdsTotals = {
  ads: number
  impressions: number
  spend: number
  clicks: number
  conversions: number
  revenue: number
  roas: number
  ctr: number
  cpm: number
  cpa: number
}
export type TeamAdsPlatform = {
  platform: 'x'|'meta'|'linkedin'|'tiktok'|'pinterest'|'chatgpt'
  state: 'ok'|'empty'|'error'
  stale: boolean
}
export type TeamAdsResponse = {
  ads: TeamAd[]
  sources: TeamAdsSource[]
  totals: TeamAdsTotals
  has_more: boolean
  platform_status: TeamAdsPlatform[]
}
export type GetAnalyticsCampaignBreakdownQuery = {
  property_id?: string
  campaign_name?: string
  dimension?: 'source'|'content'|'medium'|'term'
  source?: string
  medium?: string
  content?: string
  term?: string
  start_date?: string
  end_date?: string
}
export type CampaignOverviewAnalyticsSegment = {
  platform: 'x'|'meta'|'linkedin'|'google_ads'|'reddit'|'other'
  channel_group: string
  stats: CampaignOverviewStats
}
export type CampaignOverviewCampaign = {
  campaign_id: string
  name: string|null
  status: string|null
  effective_status: string|null
  effective_status_tone: 'error'|'warning'|'info'|'neutral'|null
  effective_status_reason: string|null
  objective: string|null
  start_time: string|null
  end_time: string|null
  stats: CampaignOverviewStats
  segments: CampaignOverviewAnalyticsSegment[]
}
export type AnalyticsCampaignBreakdownResponse = {
  breakdown: CampaignOverviewCampaign[]
}
export type GetAnalyticsPlatformStatsQuery = {
  start_date?: string
  end_date?: string
}
export type AnalyticsPlatformStatsRow = {
  platform: 'x'|'meta'|'linkedin'|'google_ads'|'reddit'
  stats: CampaignOverviewStats
}
export type AnalyticsPlatformStatsResponse = {
  connected: boolean
  platforms: AnalyticsPlatformStatsRow[]
}
export type GetAppStoreNamesQuery = {
  app_ids: string
}
export type AppStoreName = {
  id: string
  name: string
  os: string
  store_url: string
  state: 'ok'|'empty'|'pending'
  stale: boolean
}
export type AppStoreNamesResponse = {
  app_ids: string
  apps: AppStoreName[]
}
export type StandaloneAudiencePromptAnalyzeInput = {
  prompt: string
}
export type AudiencePromptSpecAge = {
  min: number|null
  max: number|null
}
export type AudiencePromptSpec = {
  audience_type: 'b2c'|'b2b'|'mixed'
  keywords: string[]
  countries: string[]
  age: AudiencePromptSpecAge
  genders: string[]
  languages: string[]
  interests: string[]
  behaviors: string[]
  job_titles: string[]
  industries: string[]
  companies: string[]
  seniorities: string[]
  skills: string[]
  handles: string[]
  brand_safe: boolean
}
export type StandaloneAudiencePromptAnalyze = {
  spec: AudiencePromptSpec
  search_id: number
}
export type AudiencePromptSuggestions = {
  prompts: string[]
}
export type GetAudiencesQuery = {
  limit?: number
  offset?: number
  search_name?: string
}
export type BigDipperAudience = {
  id: number
  user: number
  team: number
  name: string
  description: string|null
  platforms: ("x"|"reddit"|"youtube"|"spotify"|"tiktok"|"facebook"|"instagram"|"linkedin"|"google"|"discord"|"twitch"|"pinterest"|"chatgpt")[]|null
  original_platform: string|null
  original_platform_id: string|null
  search: number|null
  audience_size: number|null
}
export type GetCampaignCardsAnalyticsQuery = {
  start_date?: string
  end_date?: string
  bigdipper_campaign_id?: string
}
export type CampaignCardAnalytics = {
  bigdipper_campaign_id: string
  utm_campaign: string|null
  sessions: number
  key_events: number
}
export type CampaignCardsAnalyticsResponse = {
  analytics: CampaignCardAnalytics[]
}
export type CampaignCardChannel = {
  platform: 'x'|'meta'|'linkedin'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string|null
  platform_campaign_id: string|null
}
export type CampaignCard = {
  id: string
  name: string|null
  objective: string|null
  source: 'launched'|'grouped'|'draft'|null
  has_draft: boolean
  channels: CampaignCardChannel[]
}
export type CampaignCardsResponse = {
  cards: CampaignCard[]
}
export type CampaignPlatformBudgetCapsInput = {
  x?: number|null
  meta?: number|null
  linkedin?: number|null
  reddit?: number|null
  google_ads?: number|null
  tiktok?: number|null
  pinterest?: number|null
  chatgpt?: number|null
}
export type CampaignCreateXAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  placement?: string
  primary_web_event_tag?: string
  app_store_identifier?: string
  app_os?: 'iOS'|'Android'
  app_goal?: 'APP_CLICKS'|'APP_INSTALLS'
  primary_app_event_tag?: string
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformXInput = {
  ad_account_id: string
  funding_instrument_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  placement?: string
  primary_web_event_tag?: string
  app_store_identifier?: string
  app_os?: 'iOS'|'Android'
  app_goal?: 'APP_CLICKS'|'APP_INSTALLS'
  primary_app_event_tag?: string
  creative_ids?: string[]
  ad_groups?: CampaignCreateXAdGroupInput[]
}
export type CampaignCreateMetaAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  saved_audience_id?: string|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  countries?: string[]
  placements?: ('facebook'|'instagram')[]
  pixel_id?: string
  event_type?: string
  conversion_window?: 'CLICK_DAYS_1'|'CLICK_DAYS_7'|'CLICK_DAYS_1_VIEW_DAYS_1'|'CLICK_DAYS_7_VIEW_DAYS_1'
  lead_form_id?: string
  application_id?: string
  object_store_url?: string
  advantage_audience?: boolean
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformMetaInput = {
  ad_account_id: string
  page_id?: string
  application_id?: string
  object_store_url?: string
  cbo?: boolean
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  countries?: string[]
  placements?: ('facebook'|'instagram')[]
  pixel_id?: string
  event_type?: string
  conversion_window?: 'CLICK_DAYS_1'|'CLICK_DAYS_7'|'CLICK_DAYS_1_VIEW_DAYS_1'|'CLICK_DAYS_7_VIEW_DAYS_1'
  creative_ids?: string[]
  ad_groups?: CampaignCreateMetaAdGroupInput[]
  dsa_beneficiary?: string
  special_ad_categories?: ('NONE'|'HOUSING'|'CREDIT'|'EMPLOYMENT'|'ISSUES_ELECTIONS_POLITICS')[]
}
export type CampaignCreateLinkedInAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  saved_audience_id?: string|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  cost_type?: 'CPM'|'CPC'
  ad_format?: 'STANDARD_UPDATE'|'SINGLE_VIDEO'|'CAROUSEL'
  countries?: string[]
  conversion_id?: string
  lead_form_id?: string
  lead_form_cta?: 'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'SUBSCRIBE'|'APPLY'|'REGISTER'|'JOIN'|'ATTEND'|'REQUEST_DEMO'|'VIEW_QUOTE'|'UNLOCK_FULL_DOCUMENT'
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformLinkedInInput = {
  ad_account_id: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  cost_type?: 'CPM'|'CPC'
  ad_format?: 'STANDARD_UPDATE'|'SINGLE_VIDEO'|'CAROUSEL'
  countries?: string[]
  conversion_id?: string
  creative_ids?: string[]
  ad_groups?: CampaignCreateLinkedInAdGroupInput[]
}
export type CampaignCreateRedditAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  optimization_goal?: 'PURCHASE'|'LEAD'|'SIGN_UP'|'ADD_TO_CART'|'PAGE_VISIT'
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformRedditInput = {
  ad_account_id: string
  app_id?: string
  app_os?: 'iOS'|'Android'
  ad_groups?: CampaignCreateRedditAdGroupInput[]
}
export type CampaignCreateGoogleAdsAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  content_ids: number[]
}
export type CampaignCreatePlatformGoogleAdsInput = {
  ad_account_id: string
  ad_groups?: CampaignCreateGoogleAdsAdGroupInput[]
  contains_eu_political_advertising?: boolean
  bid_strategy?: 'MAXIMIZE_CONVERSIONS'|'MAXIMIZE_CONVERSION_VALUE'|'TARGET_CPA'|'TARGET_ROAS'|'MAXIMIZE_CLICKS'|'MANUAL_CPC'|null
  target_cpa?: number|null
  target_roas?: number|null
  cpc_bid_ceiling?: number|null
  enhanced_cpc?: boolean
  conversion_action_ids?: string[]
  target_search_network?: boolean
  target_content_network?: boolean
  ai_max_enabled?: boolean
  ai_max_search_term_matching?: boolean
  ai_max_text_asset_automation?: boolean
}
export type CampaignCreateTikTokAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  landing_page_url: string
  ad_text: string
  call_to_action?: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'CONTACT_US'|'APPLY_NOW'|'BOOK_NOW'|'ORDER_NOW'|'SUBSCRIBE'|'WATCH_NOW'
  placements?: ('tiktok_feed'|'pangle'|'news_feed_apps')[]
  frequency?: number
  frequency_schedule?: number
  pixel_id?: string
  countries?: string[]
  optimization_event?: 'ON_WEB_ORDER'|'FORM'|'ON_WEB_REGISTER'|'ON_WEB_ADD_TO_CART'|'ON_WEB_DETAIL'|'ON_WEB_SUBSCRIBE'
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformTikTokInput = {
  ad_account_id: string
  identity_id?: string
  smart_plus?: boolean
  cbo?: boolean
  daily_budget?: number
  is_hfss?: boolean
  is_lhf_compliance?: boolean
  ad_groups?: CampaignCreateTikTokAdGroupInput[]
}
export type CampaignCreatePinterestAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  daily_budget: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  destination_url?: string
  conversion_tag_id?: string
  conversion_event?: 'CHECKOUT'|'ADD_TO_CART'|'SIGNUP'|'LEAD'|'PAGE_VISIT'|'VIEW_CATEGORY'|'SEARCH'|'WATCH_VIDEO'|'CUSTOM'
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformPinterestInput = {
  ad_account_id: string
  ad_groups?: CampaignCreatePinterestAdGroupInput[]
}
export type CampaignCreateChatgptAdGroupInput = {
  id?: string
  name?: string
  audience_id?: number|null
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  destination_url?: string
  conversion_event_setting_id?: string
  creative_ids?: string[]
  creative_names?: any
}
export type CampaignCreatePlatformChatgptInput = {
  ad_account_id: string
  daily_budget?: number
  ad_groups?: CampaignCreateChatgptAdGroupInput[]
}
export type CampaignCreatePlatformsInput = {
  x?: CampaignCreatePlatformXInput
  meta?: CampaignCreatePlatformMetaInput
  linkedin?: CampaignCreatePlatformLinkedInInput
  reddit?: CampaignCreatePlatformRedditInput
  google_ads?: CampaignCreatePlatformGoogleAdsInput
  tiktok?: CampaignCreatePlatformTikTokInput
  pinterest?: CampaignCreatePlatformPinterestInput
  chatgpt?: CampaignCreatePlatformChatgptInput
}
export type CampaignCreateInput = {
  campaign_name: string
  objective: 'awareness'|'traffic'|'conversions'|'leads'|'app_installs'
  start_time?: string|null
  end_time?: string|null
  budget_cap?: number|null
  platform_budget_caps?: CampaignPlatformBudgetCapsInput
  audience_id?: number|null
  bigdipper_campaign_id?: number|null
  platforms: CampaignCreatePlatformsInput
  draft?: object|null
}
export type CampaignCreatePlatformResult = {
  success: boolean
  campaign_id: string|null
  error: string|null
  kind: 'connection'|'targeting'|'budget'|'creative'|'rate_limit'|'validation'|null
  field: string|null
  user_message: string|null
  warning: string|null
  bigdipper_campaign_id: number|null
}
export type CampaignCreateResults = {
  x: CampaignCreatePlatformResult
  meta: CampaignCreatePlatformResult
  linkedin: CampaignCreatePlatformResult
  reddit: CampaignCreatePlatformResult
  google_ads: CampaignCreatePlatformResult
  tiktok: CampaignCreatePlatformResult
  pinterest: CampaignCreatePlatformResult
  chatgpt: CampaignCreatePlatformResult
}
export type CampaignCreate = {
  results: CampaignCreateResults
}
export type GetCampaignCreativesQuery = {
  platform?: string
  ad_account_id?: string
  ad_format?: string
  limit?: string
  offset?: string
  source?: string
  page_id?: string
  after?: string
}
export type CampaignCreativeCard = {
  title: string|null
  image_url: string|null
  destination_url: string|null
  app_store_identifier: string|null
  app_os: string|null
}
export type CampaignCreative = {
  id: string
  text: string
  media_url: string|null
  created_at: string|null
  card_uri: string|null
  card: CampaignCreativeCard|null
  saved_post_id: number|null
  type: string|null
}
export type CampaignCreativesResponse = {
  creatives: CampaignCreative[]
  has_more: boolean
  next_cursor: string|null
}
export type GetCampaignDailyStatsQuery = {
  platform: 'x'|'meta'|'linkedin'|'google_analytics'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  start_date?: string
  end_date?: string
  placement?: 'all'|'facebook'|'instagram'
  campaign_ids?: string[]
  ad_account_ids?: string[]
  property_id?: string
  refresh?: string
}
export type CampaignDailyTrafficSources = {
  x: number
  meta: number
  linkedin: number
  reddit: number
  google_ads: number
  search: number
  direct: number
  other: number
}
export type CampaignDailyStat = {
  date: string
  impressions: number
  engagements: number
  clicks: number
  spend: number
  leads: number
  link_clicks: number
  conversions: number
  sessions: number
  users: number
  pageviews: number
  traffic_sources: CampaignDailyTrafficSources|null
}
export type CampaignDailyPlatform = {
  platform: string
  daily: CampaignDailyStat[]
}
export type CampaignDailyStats = {
  platforms: CampaignDailyPlatform[]
}
export type CampaignDraftGoogleAdsSettingsInput = {
  bid_strategy?: 'MAXIMIZE_CONVERSIONS'|'MAXIMIZE_CONVERSION_VALUE'|'TARGET_CPA'|'TARGET_ROAS'|'MAXIMIZE_CLICKS'|'MANUAL_CPC'
  target_cpa?: number|null
  target_roas?: number|null
  cpc_bid_ceiling?: number|null
  enhanced_cpc?: boolean
  conversion_action_ids?: string[]
  target_search_network?: boolean
  target_content_network?: boolean
  ai_max_enabled?: boolean
  ai_max_search_term_matching?: boolean
  ai_max_text_asset_automation?: boolean
}
export type CampaignDraftXConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  funding_instrument_id?: string
  placement?: string
  primary_web_event_tag?: string
  app_store_identifier?: string
  app_os?: string
  app_goal?: string
  primary_app_event_tag?: string
}
export type CampaignDraftMetaConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  page_id?: string
  countries?: string[]
  placements?: ('facebook'|'instagram')[]
  pixel_id?: string
  event_type?: string
  conversion_window?: 'CLICK_DAYS_1'|'CLICK_DAYS_7'|'CLICK_DAYS_1_VIEW_DAYS_1'|'CLICK_DAYS_7_VIEW_DAYS_1'
  lead_form_id?: string
  application_id?: string
  object_store_url?: string
  saved_audience_id?: string
  advantage_audience?: boolean
}
export type CampaignDraftLinkedInConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  cost_type?: 'CPM'|'CPC'
  ad_format?: 'STANDARD_UPDATE'|'SINGLE_VIDEO'|'CAROUSEL'
  countries?: string[]
  conversion_id?: string
  lead_form_id?: string|null
  lead_form_cta?: 'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'SUBSCRIBE'|'APPLY'|'REGISTER'|'JOIN'|'ATTEND'|'REQUEST_DEMO'|'VIEW_QUOTE'|'UNLOCK_FULL_DOCUMENT'|null
  saved_audience_id?: string
}
export type CampaignDraftRedditConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  optimization_goal?: string
  app_id?: string
  app_os?: ''|'iOS'|'Android'
}
export type CampaignDraftGoogleAdsConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  content_ids?: number[]
}
export type CampaignDraftTikTokConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  identity_id?: string
  landing_page_url?: string
  ad_text?: string
  call_to_action?: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'CONTACT_US'|'APPLY_NOW'|'BOOK_NOW'|'ORDER_NOW'|'SUBSCRIBE'|'WATCH_NOW'
  placements?: ('tiktok_feed'|'pangle'|'news_feed_apps')[]
  pixel_id?: string
  optimization_event?: string
  countries?: string[]
  frequency?: number
  frequency_schedule?: number
}
export type CampaignDraftPinterestConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  destination_url?: string
  conversion_tag_id?: string
  conversion_event?: string
}
export type CampaignDraftChatgptConfigInput = {
  enabled?: boolean
  ad_account_id?: string
  daily_budget?: number
  bid_strategy?: 'AUTO'|'TARGET'
  bid_amount?: number
  use_global_creatives?: boolean
  creative_ids?: string[]
  adset_id?: string|null
  platform_campaign_id?: string|null
  lifetime_budget?: number|null
  audience_id?: number|null
  destination_url?: string
  conversion_event_setting_id?: string
}
export type CampaignDraftPlatformConfigsInput = {
  x?: CampaignDraftXConfigInput
  meta?: CampaignDraftMetaConfigInput
  linkedin?: CampaignDraftLinkedInConfigInput
  reddit?: CampaignDraftRedditConfigInput
  google_ads?: CampaignDraftGoogleAdsConfigInput
  tiktok?: CampaignDraftTikTokConfigInput
  pinterest?: CampaignDraftPinterestConfigInput
  chatgpt?: CampaignDraftChatgptConfigInput
}
export type CampaignDraftPostRefInput = {
  saved_post_id?: number|null
  content_id?: number|null
}
export type CampaignDraftPlatformCreativeInput = {
  kind: 'platform_existing'|'sdb_dark_post'|'unpublished_platform'|'unset'
  platform?: 'x'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id?: string
  creative_id?: string
  snapshot?: object
  saved_post_platform_id?: number
  content_platform_id?: number
  post_id?: string
  row_platform?: 'x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  launch_id?: string
  preview?: object
  destination_url?: string|null
  headline?: string|null
  description?: string|null
  call_to_action?: string|null
  card_title?: string|null
  app_country_code?: string|null
}
export type CampaignDraftAdPlatformSlotInput = {
  post?: CampaignDraftPostRefInput|null
  creative?: CampaignDraftPlatformCreativeInput
}
export type CampaignDraftAdPlatformsInput = {
  x?: CampaignDraftAdPlatformSlotInput
  meta?: CampaignDraftAdPlatformSlotInput
  linkedin?: CampaignDraftAdPlatformSlotInput
  reddit?: CampaignDraftAdPlatformSlotInput
  google_ads?: CampaignDraftAdPlatformSlotInput
  tiktok?: CampaignDraftAdPlatformSlotInput
  pinterest?: CampaignDraftAdPlatformSlotInput
  chatgpt?: CampaignDraftAdPlatformSlotInput
}
export type CampaignDraftAdInput = {
  id: string
  name?: string
  use_one_ad_for_all_platforms?: boolean
  content_source?: 'existing'|'create'|null
  existing_ad_origin?: 'sdb'|'platform'
  post?: CampaignDraftPostRefInput|null
  content?: object|null
  platforms?: CampaignDraftAdPlatformsInput
}
export type CampaignDraftAdGroupInput = {
  id: string
  name?: string
  audience_id?: number|null
  use_one_audience_for_all_platforms?: boolean
  platform_configs?: CampaignDraftPlatformConfigsInput
  ads?: CampaignDraftAdInput[]|null
}
export type CampaignDraftPayloadInput = {
  version?: number
  campaign_name?: string
  objective?: string
  budget_cap?: number|null
  platform_budget_caps?: CampaignPlatformBudgetCapsInput
  start_date?: string|null
  end_date?: string|null
  current_step?: string
  current_nav_id?: string|null
  campaign_daily_budget?: number
  platform_budget_splits?: any
  ad_group_budget_shares?: any
  meta_campaign_budget_optimization?: boolean
  meta_dsa_beneficiary?: string
  meta_special_ad_categories?: ('NONE'|'HOUSING'|'CREDIT'|'EMPLOYMENT'|'ISSUES_ELECTIONS_POLITICS')[]
  meta_saved_audience_countries?: any
  google_contains_eu_political?: boolean
  google_ads_settings?: CampaignDraftGoogleAdsSettingsInput
  tiktok_smart_plus?: boolean
  tiktok_campaign_budget_optimization?: boolean
  tiktok_hfss?: boolean
  tiktok_lhf_compliance?: boolean
  global_creative_ids?: any
  creative_names?: any
  selected_creative_meta?: object
  name_format_segments?: CampaignNameTemplateSegmentInput[]
  selected_name_template_id?: string|null
  name_manually_edited?: boolean
  ad_groups?: CampaignDraftAdGroupInput[]
}
export type CampaignDraftSaveInput = {
  bigdipper_campaign_id?: number|null
  name?: string
  objective?: string
  draft: CampaignDraftPayloadInput
}
export type CampaignDraftSave = {
  card: CampaignCard
}
export type CampaignDuplicateInput = {
  bigdipper_campaign_id: number
}
export type CampaignDuplicate = CampaignDraftSave
export type CampaignEntityStatusInput = {
  platform: 'x'|'meta'|'linkedin'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  entity_type: 'campaign'|'adset'|'ad'
  entity_id: string
  status: 'active'|'paused'
}
export type CampaignEntityStatus = {
  success: boolean
  error: string|null
  kind: 'connection'|'targeting'|'budget'|'creative'|'rate_limit'|'validation'|null
  field: string|null
  user_message: string|null
}
export type CampaignGroupChannelInputInput = {
  platform: 'x'|'meta'|'linkedin'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  platform_campaign_id: string
}
export type CampaignGroupChannelsUpdateInput = {
  bigdipper_campaign_id: number
  add?: CampaignGroupChannelInputInput[]
  remove?: CampaignGroupChannelInputInput[]
}
export type CampaignGroupChannelsUpdate = CampaignDraftSave
export type CampaignGroupCreateInput = {
  name: string
  objective?: string
}
export type CampaignGroupCreate = CampaignDraftSave
export type CampaignGroupDeleteInput = CampaignDuplicateInput
export type CampaignGroupDelete = AffiliateApplyPartnerCode
export type GetCampaignLeadsExportQuery = {
  campaign_id?: string
  platform?: string
  form_id?: string
  search?: string
  start_date?: string
  end_date?: string
}
export type CampaignLeadsSyncResponseInput = {
  campaign_id?: string|null
}
export type CampaignLeadsSyncResponse = {
  synced: number
  error: string|null
  error_code: string|null
}
export type GetCampaignLeadsQuery = {
  campaign_id?: string
  platform?: string
  form_id?: string
  search?: string
  start_date?: string
  end_date?: string
  page?: string
  page_size?: string
}
export type CampaignLeadField = {
  name: string
  values: string[]|null
}
export type CampaignLead = {
  lead_id: string
  platform: 'meta'|'linkedin'
  created_time: string
  campaign_id: string|null
  campaign_name: string|null
  form_id: string|null
  form_name: string|null
  ad_id: string|null
  email: string|null
  full_name: string|null
  phone_number: string|null
  field_data: CampaignLeadField[]
}
export type CampaignLeadFacet = {
  id: string
  name: string|null
  platform: string|null
}
export type CampaignLeadsResponse = {
  total: number
  leads: CampaignLead[]
  campaigns: CampaignLeadFacet[]
  forms: CampaignLeadFacet[]
}
export type CampaignOptionsObjective = {
  value: string
  label: string
  description: string
  supported_platforms: string[]
}
export type CampaignOptionsAdAccount = {
  id: string
  name: string|null
  funding_instruments: CampaignOptionsFundingInstrument[]
  web_event_tags: CampaignOptionsWebEventTag[]
  pixels: CampaignOptionsPixel[]
  apps: CampaignOptionsApp[]
  conversions: CampaignOptionsConversion[]
  page_ids: string[]
  conversion_actions: CampaignOptionsConversionGoal[]
  identities: CampaignOptionsIdentity[]
}
export type CampaignOptionsBidStrategy = CampaignOptionsAppStore
export type CampaignOptionsLabeledValue = CampaignOptionsAppStore
export type CampaignOptionsEventType = {
  value: string
  label: string
  valid_objectives: string[]
}
export type CampaignOptionsPlatform = {
  connected: boolean
  account_name: string|null
  ad_accounts: CampaignOptionsAdAccount[]
  pages: CampaignOptionsPage[]
  bid_strategies: CampaignOptionsBidStrategy[]
  ad_formats: CampaignOptionsLabeledValue[]
  event_types: CampaignOptionsEventType[]
  conversion_windows: CampaignOptionsLabeledValue[]
  call_to_actions: CampaignOptionsLabeledValue[]
}
export type CampaignOptionsPlatforms = {
  x: CampaignOptionsPlatform
  meta: CampaignOptionsPlatform
  linkedin: CampaignOptionsPlatform
  reddit: CampaignOptionsPlatform
  tiktok: CampaignOptionsPlatform
  google_ads: CampaignOptionsPlatform
  pinterest: CampaignOptionsPlatform
  chatgpt: CampaignOptionsPlatform
}
export type CampaignOptionsResponse = {
  objectives: CampaignOptionsObjective[]
  platforms: CampaignOptionsPlatforms
}
export type GetCampaignOverviewQuery = {
  platform: 'x'|'meta'|'linkedin'|'google_analytics'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id?: string
  start_date?: string
  end_date?: string
  placement?: 'all'|'facebook'|'instagram'
  property_id?: string
  refresh?: string
}
export type CampaignOverviewAdAccount = {
  account_id: string
  name: string|null
  currency: string|null
  campaigns: CampaignOverviewCampaign[]
}
export type CampaignOverviewConversionCatalogEntry = {
  key: string
  label: string
}
export type CampaignOverviewError = {
  ad_account_id: string|null
  error: string
  kind: 'connection'|'targeting'|'budget'|'creative'|'rate_limit'|'validation'|null
  user_message: string|null
}
export type CampaignOverviewPlatform = {
  platform: 'x'|'meta'|'linkedin'|'google_analytics'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  connected: boolean
  account_name: string|null
  ad_accounts: CampaignOverviewAdAccount[]
  conversion_action_catalog: CampaignOverviewConversionCatalogEntry[]
  errors: CampaignOverviewError[]
}
export type CampaignOverview = {
  platforms: CampaignOverviewPlatform[]
}
export type CampaignPlatformBudgetCaps = {
  x: number|null
  meta: number|null
  linkedin: number|null
  reddit: number|null
  google_ads: number|null
  tiktok: number|null
  pinterest: number|null
  chatgpt: number|null
}
export type CampaignDraftGoogleAdsSettings = {
  bid_strategy: 'MAXIMIZE_CONVERSIONS'|'MAXIMIZE_CONVERSION_VALUE'|'TARGET_CPA'|'TARGET_ROAS'|'MAXIMIZE_CLICKS'|'MANUAL_CPC'
  target_cpa: number|null
  target_roas: number|null
  cpc_bid_ceiling: number|null
  enhanced_cpc: boolean
  conversion_action_ids: string[]
  target_search_network: boolean
  target_content_network: boolean
  ai_max_enabled: boolean
  ai_max_search_term_matching: boolean
  ai_max_text_asset_automation: boolean
}
export type CampaignDraftXConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  funding_instrument_id: string
  placement: string
  primary_web_event_tag: string
  app_store_identifier: string
  app_os: string
  app_goal: string
  primary_app_event_tag: string
}
export type CampaignDraftMetaConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  page_id: string
  countries: string[]
  placements: ('facebook'|'instagram')[]
  pixel_id: string
  event_type: string
  conversion_window: 'CLICK_DAYS_1'|'CLICK_DAYS_7'|'CLICK_DAYS_1_VIEW_DAYS_1'|'CLICK_DAYS_7_VIEW_DAYS_1'
  lead_form_id: string
  application_id: string
  object_store_url: string
  saved_audience_id: string
  advantage_audience: boolean
}
export type CampaignDraftLinkedInConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  cost_type: 'CPM'|'CPC'
  ad_format: 'STANDARD_UPDATE'|'SINGLE_VIDEO'|'CAROUSEL'
  countries: string[]
  conversion_id: string
  lead_form_id: string|null
  lead_form_cta: 'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'SUBSCRIBE'|'APPLY'|'REGISTER'|'JOIN'|'ATTEND'|'REQUEST_DEMO'|'VIEW_QUOTE'|'UNLOCK_FULL_DOCUMENT'|null
  saved_audience_id: string
}
export type CampaignDraftRedditConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  optimization_goal: string
  app_id: string
  app_os: ''|'iOS'|'Android'
}
export type CampaignDraftGoogleAdsConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  content_ids: number[]
}
export type CampaignDraftTikTokConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  identity_id: string
  landing_page_url: string
  ad_text: string
  call_to_action: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'CONTACT_US'|'APPLY_NOW'|'BOOK_NOW'|'ORDER_NOW'|'SUBSCRIBE'|'WATCH_NOW'
  placements: ('tiktok_feed'|'pangle'|'news_feed_apps')[]
  pixel_id: string
  optimization_event: string
  countries: string[]
  frequency: number
  frequency_schedule: number
}
export type CampaignDraftPinterestConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  destination_url: string
  conversion_tag_id: string
  conversion_event: string
}
export type CampaignDraftChatgptConfig = {
  enabled: boolean
  ad_account_id: string
  daily_budget: number
  bid_strategy: 'AUTO'|'TARGET'
  bid_amount: number
  use_global_creatives: boolean
  creative_ids: string[]
  adset_id: string|null
  platform_campaign_id: string|null
  lifetime_budget: number|null
  audience_id: number|null
  destination_url: string
  conversion_event_setting_id: string
}
export type CampaignDraftPlatformConfigs = {
  x: CampaignDraftXConfig
  meta: CampaignDraftMetaConfig
  linkedin: CampaignDraftLinkedInConfig
  reddit: CampaignDraftRedditConfig
  google_ads: CampaignDraftGoogleAdsConfig
  tiktok: CampaignDraftTikTokConfig
  pinterest: CampaignDraftPinterestConfig
  chatgpt: CampaignDraftChatgptConfig
}
export type CampaignDraftPostRef = {
  saved_post_id: number|null
  content_id: number|null
}
export type CampaignDraftPlatformCreative = {
  kind: 'platform_existing'|'sdb_dark_post'|'unpublished_platform'|'unset'
  platform: 'x'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  ad_account_id: string
  creative_id: string
  snapshot: object
  saved_post_platform_id: number
  content_platform_id: number
  post_id: string
  row_platform: 'x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  launch_id: string
  preview: object
  destination_url: string|null
  headline: string|null
  description: string|null
  call_to_action: string|null
  card_title: string|null
  app_country_code: string|null
}
export type CampaignDraftAdPlatformSlot = {
  post: CampaignDraftPostRef|null
  creative: CampaignDraftPlatformCreative
}
export type CampaignDraftAdPlatforms = {
  x: CampaignDraftAdPlatformSlot
  meta: CampaignDraftAdPlatformSlot
  linkedin: CampaignDraftAdPlatformSlot
  reddit: CampaignDraftAdPlatformSlot
  google_ads: CampaignDraftAdPlatformSlot
  tiktok: CampaignDraftAdPlatformSlot
  pinterest: CampaignDraftAdPlatformSlot
  chatgpt: CampaignDraftAdPlatformSlot
}
export type CampaignDraftAd = {
  id: string
  name: string
  use_one_ad_for_all_platforms: boolean
  content_source: 'existing'|'create'|null
  existing_ad_origin: 'sdb'|'platform'
  post: CampaignDraftPostRef|null
  content: object|null
  platforms: CampaignDraftAdPlatforms
}
export type CampaignDraftAdGroup = {
  id: string
  name: string
  audience_id: number|null
  use_one_audience_for_all_platforms: boolean
  platform_configs: CampaignDraftPlatformConfigs
  ads: CampaignDraftAd[]|null
}
export type CampaignDraftPayload = {
  version: number
  campaign_name: string
  objective: string
  budget_cap: number|null
  platform_budget_caps: CampaignPlatformBudgetCaps
  start_date: string|null
  end_date: string|null
  current_step: string
  current_nav_id: string|null
  campaign_daily_budget: number
  platform_budget_splits: any
  ad_group_budget_shares: any
  meta_campaign_budget_optimization: boolean
  meta_dsa_beneficiary: string
  meta_special_ad_categories: ('NONE'|'HOUSING'|'CREDIT'|'EMPLOYMENT'|'ISSUES_ELECTIONS_POLITICS')[]
  meta_saved_audience_countries: any
  google_contains_eu_political: boolean
  google_ads_settings: CampaignDraftGoogleAdsSettings
  tiktok_smart_plus: boolean
  tiktok_campaign_budget_optimization: boolean
  tiktok_hfss: boolean
  tiktok_lhf_compliance: boolean
  global_creative_ids: any
  creative_names: any
  selected_creative_meta: object
  name_format_segments: CampaignNameTemplateSegment[]
  selected_name_template_id: string|null
  name_manually_edited: boolean
  ad_groups: CampaignDraftAdGroup[]
}
export type CampaignLaunchedStructure = {
  ad_group_ids: string[]
  ad_ids: string[]
}
export type CampaignRead = {
  id: string
  name: string|null
  objective: string|null
  state: 'launched'|'grouped'|'draft'|null
  draft: CampaignDraftPayload|null
  has_unpublished_changes: boolean
  launched_structure: CampaignLaunchedStructure|null
  channels: CampaignCardChannel[]
}
export type CampaignPublishInput = {
  platforms?: string[]
}
export type CampaignPublish = CampaignCreate
export type CampaignUpdateInput = StandaloneShareViaAccountAudienceConfig
export type CampaignUpdate = {
  results: CampaignCreateResults
  applied: boolean
}
export type GetCampaignsQuery = {
  platforms?: string
  kinds?: string
  start_date?: string
  end_date?: string
  placement?: 'all'|'facebook'|'instagram'
  property_id?: string
  ad_account_id?: string
  refresh?: boolean
  bust_cache?: string
}
export type CampaignsOverview = {
  platform: 'x'|'meta'|'linkedin'|'google_analytics'|'google_ads'|'reddit'|'tiktok'|'pinterest'|'chatgpt'
  connected: boolean
  account_name: string|null
  ad_accounts: CampaignOverviewAdAccount[]
  conversion_action_catalog: CampaignOverviewConversionCatalogEntry[]
  errors: CampaignOverviewError[]
  state: 'ok'|'empty'|'error'
  stale: boolean
}
export type CampaignsDaily = {
  platform: string
  daily: CampaignDailyStat[]
  state: 'ok'|'empty'|'error'
  stale: boolean
}
export type Campaigns = {
  overview: CampaignsOverview[]
  daily: CampaignsDaily[]
}
export type GetGetChatgptAdAccountsQuery = {
  selected_only?: string
  refresh?: string
}
export type ChatgptAdAccount = {
  account_id: string
  name: string
  currency: string|null
  timezone: string|null
  selected: boolean
}
export type ChatgptAdAccountsResponse = {
  connected: boolean
  ad_accounts: ChatgptAdAccount[]
}
export type ContentMediaFile = {
  id: number
  url: string
  thumbnail_url: string|null
  media_type: 'image'|'video'
  mime_type: string
  alt: string
}
export type ContentMediaRow = {
  id: number
  order: number
  media_id: number
  media: ContentMediaFile
}
export type ContentApprovalUser = {
  id: number
  email: string
  username: string
  name: string
}
export type ContentApprovalComment = {
  id: number
  author: ContentApprovalUser|null
  text: string
  kind: 'changes_requested'|'approved'|'resubmitted'
  created: string
}
export type ContentPlatform = {
  id: number
  platform: 'x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  text: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  approved: boolean
  scheduled_at: string|null
  published_at: string|null
  publish_attempts: number
  schedule_error: string|null
  changes_requested: boolean
  approval_requested_by: ContentApprovalUser|null
  approval_comments: ContentApprovalComment[]
}
export type XPost = {
  id: number
  media: ContentMediaRow[]
  created: string
  modified: string
  type: 'WEBSITE'|'APP'|null
  text: string|null
  url: string|null
  title: string|null
  label: 'INSTALL'|'PLAY'|'SHOP'|'BOOK'|'CONNECT'|'ORDER'|'OPEN'|null
  country_code: string|null
  googleplay_app_id: string|null
  googleplay_deep_link: string|null
  ios_app_store_identifier: string|null
  ios_deep_link: string|null
  made_with_ai: boolean|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  as_user_id: string|null
  account_id: string|null
  post_id: string|null
}
export type FacebookPost = {
  id: number
  media: ContentMediaRow[]
  created: string
  modified: string
  type: 'TEXT'|'LINK'|'PHOTO'|'VIDEO'|'REELS'|'CAROUSEL'|null
  message: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  page_id: string|null
  post_id: string|null
}
export type InstagramPost = {
  id: number
  media: ContentMediaRow[]
  created: string
  modified: string
  type: 'IMAGE'|'REELS'|'CAROUSEL'|'STORIES'|null
  caption: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  ig_user_id: string|null
  ig_media_id: string|null
  shortcode: string|null
}
export type MetaAdMediaCrop = {
  id: number
  crop_key: '100x100'|'100x72'|'400x150'|'400x500'|'600x360'|'90x160'
  left: number
  top: number
  right: number
  bottom: number
}
export type MetaAdMedia = {
  id: number
  order: number
  media_id: number
  media: ContentMediaFile
  name: string|null
  link: string|null
  description: string|null
  call_to_action: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'INSTALL'|'SUBSCRIBE'|'APPLY_NOW'|'BOOK_NOW'|'CONTACT_US'|'ORDER_NOW'|'GET_QUOTE'|null
  image_crops: MetaAdMediaCrop[]
}
export type MetaAdMediaPlacement = {
  id: number
  publisher_platform: 'facebook'|'instagram'|'messenger'|'audience_network'|'threads'|'whatsapp'
  position: 'feed'|'right_hand_column'|'marketplace'|'video_feeds'|'story'|'search'|'instream_video'|'facebook_reels'|'facebook_reels_overlay'|'profile_feed'|'notification'|'stream'|'explore'|'explore_home'|'reels'|'ig_search'|'profile_reels'|'threads_stream'|'classic'|'rewarded_video'|'sponsored_messages'|'status'
  message: string|null
  media: MetaAdMedia[]
}
export type MetaAd = {
  id: number
  media: MetaAdMedia[]
  placements: MetaAdMediaPlacement[]
  created: string
  modified: string
  type: 'IMAGE'|'VIDEO'|'CAROUSEL'|null
  message: string|null
  lead_gen_form_id: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  account_id: string|null
  page_id: string|null
  instagram_user_id: string|null
  creative_id: string|null
  effective_object_story_id: string|null
}
export type LinkedInPostMedia = {
  id: number
  order: number
  media_id: number
  media: ContentMediaFile
  title: string|null
  landing_page: string|null
}
export type LinkedInPost = {
  id: number
  media: LinkedInPostMedia[]
  created: string
  modified: string
  type: 'text'|'media'|'video'|'multiImage'|'carousel'|'article'|'document'|null
  commentary: string|null
  content_landing_page: string|null
  content_call_to_action_label: 'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'SUBSCRIBE'|'APPLY'|'REGISTER'|'JOIN'|'ATTEND'|'REQUEST_DEMO'|'VIEW_QUOTE'|'UNLOCK_FULL_DOCUMENT'|'BUY_NOW'|'SHOP_NOW'|null
  lead_gen_form_id: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  author: string|null
  account_id: string|null
  post_id: string|null
}
export type RedditPostMedia = {
  id: number
  order: number
  media_id: number
  media: ContentMediaFile
  caption: string|null
  url: string|null
  call_to_action: string|null
  crop_x: number|null
  crop_y: number|null
  crop_width: number|null
  crop_height: number|null
}
export type RedditPost = {
  id: number
  media: RedditPostMedia[]
  created: string
  modified: string
  type: 'TEXT'|'IMAGE'|'VIDEO'|'CAROUSEL'|null
  headline: string|null
  body: string|null
  url: string|null
  call_to_action: 'Download'|'Install'|'Shop Now'|'View More'|'Sign Up'|'Learn More'|'Contact Us'|'Get Showtimes'|'Get a Quote'|'See Menu'|'Apply Now'|'Watch Now'|'Play Now'|'Pre-order Now'|'Order Now'|'Book Now'|'Buy Tickets'|'Get Directions'|'Listen Now'|'Read More'|'Subscribe'|'Visit Store'|'Donate Now'|'Remind Me'|null
  lead_gen_form_id: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  sr: string|null
  account_id: string|null
  post_id: string|null
}
export type GoogleAd = {
  id: number
  created: string
  modified: string
  type: 'RESPONSIVE_SEARCH_AD'|null
  text: string|null
  final_url: string|null
  path1: string|null
  path2: string|null
  headlines: object|null
  descriptions: object|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  account_id: string|null
  ad_id: string|null
}
export type TikTokPost = {
  id: number
  media: ContentMediaRow[]
  cover: ContentMediaFile|null
  created: string
  modified: string
  type: 'SINGLE_VIDEO'|'SINGLE_IMAGE'|'CAROUSEL_ADS'|null
  ad_text: string|null
  call_to_action: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'CONTACT_US'|'APPLY_NOW'|'BOOK_NOW'|'ORDER_NOW'|'SUBSCRIBE'|'WATCH_NOW'|null
  landing_page_url: string|null
  music_id: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  account_id: string|null
  identity_id: string|null
  identity_type: 'CUSTOMIZED_USER'|'TT_USER'|'AUTH_CODE'|'BC_AUTH_TT'|null
  identity_authorized_bc_id: string|null
  ad_id: string|null
}
export type PinterestPinMedia = {
  id: number
  order: number
  media_id: number
  media: ContentMediaFile
  title: string|null
  description: string|null
  link: string|null
}
export type PinterestPin = {
  id: number
  media: PinterestPinMedia[]
  cover: ContentMediaFile|null
  created: string
  modified: string
  type: 'IMAGE'|'VIDEO'|'CAROUSEL'|null
  title: string|null
  description: string|null
  link: string|null
  alt_text: string|null
  dominant_color: string|null
  ai_disclosures: ('AI_MODIFIED'|'SYNTHETIC_PERFORMER')[]|null
  cover_image_key_frame_time: number|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  board_id: string|null
  board_section_id: string|null
  account_id: string|null
  pin_id: string|null
}
export type ChatGPTAd = {
  id: number
  media: ContentMediaRow[]
  campaign_creative_id: string|null
  created: string
  modified: string
  type: 'chat_card'|null
  title: string|null
  body: string|null
  price: string|null
  target_url: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  account_id: string|null
  file_id: string|null
}
export type ContentDetail = {
  id: number
  created: string
  modified: string
  name: string|null
  publish_type: 'organic'|'dark'|null
  template_text: string|null
  template_headline: string|null
  template_destination_url: string|null
  template_call_to_action: string|null
  experiment_id: number|null
  template_media: ContentMediaRow[]
  platforms: ContentPlatform[]
  x_post: XPost|null
  facebook_post: FacebookPost|null
  instagram_post: InstagramPost|null
  meta_ad: MetaAd|null
  linkedin_post: LinkedInPost|null
  reddit_post: RedditPost|null
  google_ad: GoogleAd|null
  tiktok_post: TikTokPost|null
  pinterest_pin: PinterestPin|null
  chatgpt_ad: ChatGPTAd|null
}
export type ContentApprovalRequests = {
  posts: ContentDetail[]
}
export type ContentApprovalInput = {
  action: 'approve'|'request_changes'|'resubmit'
  comment?: string
}
export type ContentApproval = {
  content: ContentDetail
}
export type ContentCancelScheduledInput = StandaloneShareViaAccountAudienceConfig
export type ContentCancelScheduled = ContentApproval
export type XPostDraftInput = {
  scheduled_at?: string|null
  type?: 'WEBSITE'|'APP'|null
  text?: string|null
  url?: string|null
  title?: string|null
  label?: 'INSTALL'|'PLAY'|'SHOP'|'BOOK'|'CONNECT'|'ORDER'|'OPEN'|null
  country_code?: string|null
  googleplay_app_id?: string|null
  googleplay_deep_link?: string|null
  ios_app_store_identifier?: string|null
  ios_deep_link?: string|null
  made_with_ai?: boolean|null
  as_user_id?: string|null
  account_id?: string|null
  media?: number[]
}
export type FacebookPostDraftInput = {
  scheduled_at?: string|null
  type?: 'TEXT'|'LINK'|'PHOTO'|'VIDEO'|'REELS'|'CAROUSEL'|null
  message?: string|null
  page_id?: string|null
  media?: number[]
}
export type InstagramPostDraftInput = {
  scheduled_at?: string|null
  type?: 'IMAGE'|'REELS'|'CAROUSEL'|'STORIES'|null
  caption?: string|null
  ig_user_id?: string|null
  media?: number[]
}
export type MetaCropDraftInput = {
  crop_key: '100x100'|'100x72'|'400x150'|'400x500'|'600x360'|'90x160'
  left: number
  top: number
  right: number
  bottom: number
}
export type MetaMediaDraftInput = {
  id: number
  name?: string|null
  link?: string|null
  description?: string|null
  call_to_action?: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'INSTALL'|'SUBSCRIBE'|'APPLY_NOW'|'BOOK_NOW'|'CONTACT_US'|'ORDER_NOW'|'GET_QUOTE'|null
  image_crops?: MetaCropDraftInput[]
}
export type MetaPlacementDraftInput = {
  publisher_platform: 'facebook'|'instagram'|'messenger'|'audience_network'|'threads'|'whatsapp'
  position: 'feed'|'right_hand_column'|'marketplace'|'video_feeds'|'story'|'search'|'instream_video'|'facebook_reels'|'facebook_reels_overlay'|'profile_feed'|'notification'|'stream'|'explore'|'explore_home'|'reels'|'ig_search'|'profile_reels'|'threads_stream'|'classic'|'rewarded_video'|'sponsored_messages'|'status'
  message?: string|null
  media?: MetaMediaDraftInput[]
}
export type MetaAdDraftInput = {
  scheduled_at?: string|null
  type?: 'IMAGE'|'VIDEO'|'CAROUSEL'|null
  message?: string|null
  lead_gen_form_id?: string|null
  account_id?: string|null
  page_id?: string|null
  instagram_user_id?: string|null
  media?: MetaMediaDraftInput[]
  placements?: MetaPlacementDraftInput[]
}
export type LinkedInMediaDraftInput = {
  id: number
  title?: string|null
  landing_page?: string|null
}
export type LinkedInPostDraftInput = {
  scheduled_at?: string|null
  type?: 'text'|'media'|'video'|'multiImage'|'carousel'|'article'|'document'|null
  commentary?: string|null
  content_landing_page?: string|null
  content_call_to_action_label?: 'LEARN_MORE'|'SIGN_UP'|'DOWNLOAD'|'SUBSCRIBE'|'APPLY'|'REGISTER'|'JOIN'|'ATTEND'|'REQUEST_DEMO'|'VIEW_QUOTE'|'UNLOCK_FULL_DOCUMENT'|'BUY_NOW'|'SHOP_NOW'|null
  lead_gen_form_id?: string|null
  author?: string|null
  account_id?: string|null
  media?: LinkedInMediaDraftInput[]
}
export type RedditMediaDraftInput = {
  id: number
  caption?: string|null
  url?: string|null
  call_to_action?: 'Download'|'Install'|'Shop Now'|'View More'|'Sign Up'|'Learn More'|'Contact Us'|'Get Showtimes'|'Get a Quote'|'See Menu'|'Apply Now'|'Watch Now'|'Play Now'|'Pre-order Now'|'Order Now'|'Book Now'|'Buy Tickets'|'Get Directions'|'Listen Now'|'Read More'|'Subscribe'|'Visit Store'|'Donate Now'|'Remind Me'|null
  crop_x?: number|null
  crop_y?: number|null
  crop_width?: number|null
  crop_height?: number|null
}
export type RedditPostDraftInput = {
  scheduled_at?: string|null
  type?: 'TEXT'|'IMAGE'|'VIDEO'|'CAROUSEL'|null
  headline?: string|null
  body?: string|null
  url?: string|null
  call_to_action?: 'Download'|'Install'|'Shop Now'|'View More'|'Sign Up'|'Learn More'|'Contact Us'|'Get Showtimes'|'Get a Quote'|'See Menu'|'Apply Now'|'Watch Now'|'Play Now'|'Pre-order Now'|'Order Now'|'Book Now'|'Buy Tickets'|'Get Directions'|'Listen Now'|'Read More'|'Subscribe'|'Visit Store'|'Donate Now'|'Remind Me'|null
  lead_gen_form_id?: string|null
  sr?: string|null
  account_id?: string|null
  media?: RedditMediaDraftInput[]
}
export type GoogleAdDraftInput = {
  scheduled_at?: string|null
  type?: 'RESPONSIVE_SEARCH_AD'|null
  text?: string|null
  final_url?: string|null
  path1?: string|null
  path2?: string|null
  headlines?: object|null
  descriptions?: object|null
  account_id?: string|null
}
export type TikTokPostDraftInput = {
  scheduled_at?: string|null
  type?: 'SINGLE_VIDEO'|'SINGLE_IMAGE'|'CAROUSEL_ADS'|null
  ad_text?: string|null
  landing_page_url?: string|null
  call_to_action?: 'LEARN_MORE'|'SHOP_NOW'|'SIGN_UP'|'DOWNLOAD'|'CONTACT_US'|'APPLY_NOW'|'BOOK_NOW'|'ORDER_NOW'|'SUBSCRIBE'|'WATCH_NOW'|null
  music_id?: string|null
  cover?: number|null
  account_id?: string|null
  identity_id?: string|null
  identity_type?: 'CUSTOMIZED_USER'|'TT_USER'|'AUTH_CODE'|'BC_AUTH_TT'|null
  identity_authorized_bc_id?: string|null
  media?: number[]
}
export type PinterestMediaDraftInput = {
  id: number
  title?: string|null
  description?: string|null
  link?: string|null
}
export type PinterestPinDraftInput = {
  scheduled_at?: string|null
  type?: 'IMAGE'|'VIDEO'|'CAROUSEL'|null
  title?: string|null
  description?: string|null
  link?: string|null
  alt_text?: string|null
  dominant_color?: string|null
  ai_disclosures?: ('AI_MODIFIED'|'SYNTHETIC_PERFORMER')[]|null
  cover?: number|null
  cover_image_key_frame_time?: number|null
  board_id?: string|null
  board_section_id?: string|null
  account_id?: string|null
  media?: PinterestMediaDraftInput[]
}
export type ChatGPTAdDraftInput = {
  scheduled_at?: string|null
  type?: 'chat_card'|null
  title?: string|null
  body?: string|null
  price?: string|null
  target_url?: string|null
  account_id?: string|null
  media?: number[]
}
export type ContentPlatformDraftsInput = {
  x?: XPostDraftInput
  facebook?: FacebookPostDraftInput
  instagram?: InstagramPostDraftInput
  meta?: MetaAdDraftInput
  linkedin?: LinkedInPostDraftInput
  reddit?: RedditPostDraftInput
  google_ads?: GoogleAdDraftInput
  tiktok?: TikTokPostDraftInput
  pinterest?: PinterestPinDraftInput
  chatgpt?: ChatGPTAdDraftInput
}
export type ContentDetailInput = {
  name?: string|null
  publish_type?: 'organic'|'dark'|null
  template_text?: string|null
  template_headline?: string|null
  template_destination_url?: string|null
  template_call_to_action?: string|null
  experiment_id?: number|null
  template_media_ids?: number[]
  platform_drafts?: ContentPlatformDraftsInput
}
export type ContentDeleteInput = StandaloneShareViaAccountAudienceConfig
export type ContentDelete = {
  deleted: boolean
}
export type ContentPublishJob = {
  platform: 'x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  status: 'not_started'|'processing'|'completed'|'scheduled'|'failed'
  progress: number
  message: string
  post_id: string|null
}
export type ContentPublish = {
  content_id: number
  jobs: ContentPublishJob[]
}
export type ContentPublishInput = {
  platforms?: ('x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt')[]
  scheduled_at?: string|null
  bypass_approval?: boolean
  notify_user_id?: number|null
  bigdipper_campaign_id?: number|null
  bigdipper_audience_id?: number|null
  bigdipper_ad_group_id?: string|null
}
export type ContentRescheduleInput = {
  scheduled_at: string
}
export type ContentReschedule = ContentApproval
export type GetContentListQuery = {
  limit?: number
  offset?: number
  search?: string
  scheduled_after?: string
  scheduled_before?: string
  publish_type?: 'organic'|'dark'
}
export type ContentPlatformList = {
  id: number
  platform: 'x'|'facebook'|'instagram'|'meta'|'linkedin'|'reddit'|'google_ads'|'tiktok'|'pinterest'|'chatgpt'
  text: string|null
  status: 'draft'|'scheduled'|'publishing'|'published'|'schedule_failed'
  approved: boolean
  scheduled_at: string|null
  published_at: string|null
}
export type ContentList = {
  id: number
  name: string|null
  publish_type: 'organic'|'dark'|null
  template_text: string|null
  template_media: ContentMediaRow[]
  platforms: ContentPlatformList[]
}
export type GetDashboardOrganicQuery = {
  platforms?: string
  start_date?: string
  end_date?: string
  refresh?: boolean
  bust_cache?: boolean
}
export type DashboardOrganicDay = {
  date: string
  impressions: number
  interactions: number
  posts: number
}
export type DashboardOrganicPlatform = {
  platform: 'facebook'|'instagram'|'linkedin'|'x'
  connected: boolean
  state: 'ok'|'empty'|'error'|'pending'
  stale: boolean
  accounts: string[]
  followers: number|null
  impressions: number
  interactions: number
  posts: number
  daily: DashboardOrganicDay[]
  error: 'missing_permission'|'unavailable'|null
  reconnect_required: boolean
}
export type DashboardOrganic = {
  organic: DashboardOrganicPlatform[]
}
export type GetFacebookPagesQuery = GetGetChatgptAdAccountsQuery
export type FacebookPageItem = {
  page_id: string
  name: string
  picture_url: string|null
  category: string|null
  followers_count: number|null
  fan_count: number|null
  selected: boolean
}
export type StandaloneFacebookPages = {
  pages: FacebookPageItem[]
  selected_pages: string[]
}
export type StandaloneFacebookPagesInput = {
  selected_pages: string[]
}
export type GenerateTextInput = {
  prompt: string
  reference_media_ids?: number[]
  search_id?: number
  url?: string|null
  experiment_id?: number|null
}
export type GenerateText = FunnelPersonaInsightUpdateInput
export type GenerateMediaInput = {
  context_prompt?: string
  media_prompt?: string
  media_type: 'video'|'image'
  model?: 'gemini-nano-banana-2.1'|'grok-imagine-image-2.0'|'gpt-image-2.5-flare'|'grok-imagine-video-1.5'
  reference_media_ids?: number[]
  edit_reference_url?: string|null
  aspect_ratio?: '2:3'|'3:2'|'1:1'|'9:16'|'16:9'|'original'
  duration?: number
  mute?: boolean
  search_id?: number
  experiment_id?: number|null
}
export type GenerateMedia = {
  media_prompt: string
  media_type: 'video'|'image'
  reference_media_ids: number[]
  aspect_ratio: '2:3'|'3:2'|'1:1'|'9:16'|'16:9'|'original'
  duration: number
  url: string
  funnel_context: string
  mime_type: string
  alt: string
  resolution: string
  thumbnail_url: string
}
export type GetGetGoogleAdsAccountsQuery = GetGetChatgptAdAccountsQuery
export type GoogleAdsAccount = {
  account_id: string
  name: string
  selected: boolean
}
export type GoogleAdsAccountsResponse = {
  connected: boolean
  ad_accounts: GoogleAdsAccount[]
}
export type GetGetGoogleAnalyticsAccountsQuery = GetGetChatgptAdAccountsQuery
export type GoogleAnalyticsProperty = {
  property_id: string
  name: string
  account_name: string
  selected: boolean
}
export type GoogleAnalyticsAccountsResponse = {
  connected: boolean
  properties: GoogleAnalyticsProperty[]
}
export type GetInstagramPagesQuery = GetGetChatgptAdAccountsQuery
export type InstagramPageItem = {
  instagram_id: string
  username: string
  name: string|null
  page_name: string|null
  fb_page_id: string|null
  profile_picture_url: string|null
  followers_count: number|null
  selected: boolean
  media_count: number|null
  connection: 'instagram_login'|'meta'
}
export type StandaloneInstagramPagesPages = {
  pages: InstagramPageItem[]
}
export type StandaloneInstagramPagesPagesInput = StandaloneFacebookPagesInput
export type GetGetLinkedinAdAccountsQuery = {
  selected_only: boolean
  refresh?: string
}
export type LinkedInAdAccount = {
  account_id: string
  name: string
  account_status: string|null
  currency: string|null
  selected: boolean
}
export type LinkedInAdAccountsResponse = {
  connected: boolean
  ad_accounts: LinkedInAdAccount[]
}
export type GetLinkedinCommunityOrganizationsQuery = GetGetChatgptAdAccountsQuery
export type LinkedInOrganizationItem = {
  organization_id: string
  name: string
  vanity_name: string|null
  logo_url: string|null
  follower_count: number|null
  selected: boolean
  is_personal: boolean
}
export type StandaloneLinkedInOrganizations = {
  organizations: LinkedInOrganizationItem[]
}
export type StandaloneLinkedInOrganizationsInput = {
  selected_organizations: string[]
}
export type GetLinkedinLeadFormDetailQuery = {
  ad_account_id?: string
  form_id?: string
}
export type LinkedInLeadFormDetailQuestion = {
  type: 'short_answer'|'multiple_choice'
  label: string
  options: string[]
}
export type LinkedInLeadFormDetail = {
  form_id: string
  name: string
  status: string|null
  created_time: string|null
  headline: string
  description: string
  collect_email: boolean
  collect_full_name: boolean
  collect_phone: boolean
  privacy_policy_url: string
  legal_disclaimer: string
  thank_you_body: string
  thank_you_button_type: string
  thank_you_button_url: string
  custom_questions: LinkedInLeadFormDetailQuestion[]
}
export type LinkedInLeadFormDetailResponse = {
  connected: boolean
  form: LinkedInLeadFormDetail|null
  error: string|null
}
export type LinkedInLeadFormCustomQuestionInput = {
  type: 'short_answer'|'multiple_choice'
  label: string
  options?: string[]
}
export type LinkedInLeadFormCreateInput = {
  ad_account_id: string
  name: string
  headline?: string
  description?: string
  collect_email?: boolean
  collect_full_name?: boolean
  collect_phone?: boolean
  privacy_policy_url: string
  legal_disclaimer?: string
  thank_you_body?: string
  thank_you_button_type?: 'VISIT_COMPANY_WEBSITE'|'LEARN_MORE'|'VIEW_NOW'|'DOWNLOAD_NOW'|'TRY_NOW'
  thank_you_button_url?: string
  custom_questions?: LinkedInLeadFormCustomQuestionInput[]
}
export type LinkedInLeadFormCreate = {
  form_id: string
  form_name: string
}
export type GetLinkedinLeadFormsQuery = GetAutopilotUsageAllowedQuery
export type LinkedInLeadForm = {
  form_id: string
  name: string|null
  status: string|null
  created_time: string|null
}
export type LinkedInLeadFormsResponse = {
  connected: boolean
  forms: LinkedInLeadForm[]
  error: string|null
}
export type GetLinkedinMentionSearchQuery = {
  q?: string
  organization?: string
}
export type LinkedInMentionAccount = {
  id: string
  name: string
  first_name: string
  last_name: string
}
export type LinkedInMentionSearch = {
  accounts: LinkedInMentionAccount[]
}
export type GetLinkedinMentionQuery = {
  url?: string
  organization?: string
  urn?: string
}
export type LinkedInMention = {
  account: LinkedInMentionAccount
}
export type GetLinkedinOrganizationsQuery = GetGetChatgptAdAccountsQuery
export type BigDipperTeamMediaInput = {
  tags?: string[]
  selected?: boolean
  disabled?: boolean
  media_type: 'image'|'video'
  mime_type?: string
  duration?: number|null
  aspect_ratio?: string|null
  resolution?: string|null
  alt?: string
  prompt?: string|null
  query?: string
  url: string
  thumbnail_url?: string|null
}
export type BigDipperTeamMediaUploadInput = {
  files: any[]
}
export type BigDipperTeamMediaUpload = {
  errors: string
  media: BigDipperTeamMedia[]
  uploaded: number
}
export type GetTeamMediaQuery = {
  limit?: number
  offset?: number
  source?: 'website'|'facebook'|'instagram'|'tiktok'|'x'|'linkedin'|'upload'|'bigdipper'|'competitor'
  selected?: boolean
  include_disabled?: string
  query?: string
}
export type GetTeamMentionStreamQuery = {
  platforms?: string
  limit?: number
}
export type MentionAuthor = {
  id: string|null
  name: string|null
  handle: string|null
  avatar_url: string|null
  follower_count: number|null
  verified: boolean|null
  country: string|null
}
export type MentionTarget = {
  account_id: string|null
  account_name: string|null
  post_id: string|null
  post_url: string|null
}
export type MentionMetrics = {
  likes: number|null
  replies: number|null
  reposts: number|null
  impressions: number|null
}
export type MentionItem = {
  platform: string
  id: string
  type: string
  text: string
  created_at: string|null
  url: string|null
  author: MentionAuthor
  target: MentionTarget
  media: string[]
  metrics: MentionMetrics
}
export type MentionSource = {
  platform: string
  connected: boolean
  permission_required: boolean
  reconnect_required: boolean
  required_scopes: string[]
  error: string|null
}
export type MentionStreamResponse = {
  items: MentionItem[]
  sources: MentionSource[]
}
export type GetGetMetaAdAccountsQuery = GetGetLinkedinAdAccountsQuery
export type MetaAdAccount = {
  account_id: string
  name: string
  account_status: number|null
  currency: string|null
  selected: boolean
}
export type MetaAdAccountsResponse = {
  connected: boolean
  ad_accounts: MetaAdAccount[]
}
export type GetGetMetaDsaRecommendationsQuery = GetAutopilotUsageAllowedQuery
export type MetaDsaRecommendationsResponse = {
  recommendations: string[]
}
export type MetaLeadFormAssetUploadInput = StandaloneShareViaAccountAudienceConfig
export type MetaLeadFormAssetUpload = {
  file_url: string
  file_name: string
}
export type GetMetaLeadFormDetailQuery = {
  page_id?: string
  form_id?: string
}
export type MetaLeadFormDetailQuestion = LinkedInLeadFormDetailQuestion
export type MetaLeadFormDetail = {
  form_id: string
  name: string
  status: string|null
  created_time: string|null
  leads_count: number
  headline: string
  description: string
  collect_email: boolean
  collect_full_name: boolean
  collect_phone: boolean
  privacy_policy_url: string
  thank_you_title: string
  thank_you_body: string
  thank_you_button_type: 'NONE'|'VIEW_WEBSITE'|'DOWNLOAD'|'CALL_BUSINESS'
  thank_you_button_text: string
  thank_you_button_url: string
  thank_you_phone_number: string
  thank_you_country_code: string
  is_optimized_for_quality: boolean
  block_display_for_non_targeted_viewer: boolean
  custom_questions: MetaLeadFormDetailQuestion[]
}
export type MetaLeadFormDetailResponse = {
  connected: boolean
  form: MetaLeadFormDetail|null
  error: string|null
}
export type MetaLeadFormCustomQuestionInput = LinkedInLeadFormCustomQuestionInput
export type MetaLeadFormCreateInput = {
  page_id: string
  name: string
  headline?: string
  description?: string
  collect_email?: boolean
  collect_full_name?: boolean
  collect_phone?: boolean
  privacy_policy_url: string
  thank_you_title?: string
  thank_you_body?: string
  thank_you_button_type?: 'NONE'|'VIEW_WEBSITE'|'DOWNLOAD'|'CALL_BUSINESS'
  thank_you_button_text?: string
  thank_you_button_url?: string
  thank_you_phone_number?: string
  thank_you_country_code?: string
  is_optimized_for_quality?: boolean
  block_display_for_non_targeted_viewer?: boolean
  custom_questions?: MetaLeadFormCustomQuestionInput[]
}
export type MetaLeadFormCreate = LinkedInLeadFormCreate
export type GetMetaLeadFormsQuery = {
  page_id?: string
}
export type MetaLeadForm = {
  form_id: string
  name: string|null
  status: string|null
  created_time: string|null
  leads_count: number
}
export type MetaLeadFormsResponse = {
  connected: boolean
  forms: MetaLeadForm[]
  error: string|null
}
export type BigDipperNotificationMarkReadInput = {
  ids?: number[]
  all?: boolean
  read?: boolean
}
export type BigDipperNotificationMarkRead = {
  ids: number[]
  all: boolean
  read: boolean
  marked: number
}
export type GetTeamNotificationsQuery = {
  type?: 'error'|'report'|'progress'|'approval'
  limit?: string
}
export type BigDipperNotification = {
  id: number
  type: 'error'|'report'|'progress'|'approval'
  flow: 'campaign_create'|'publish_post'|'scheduled_publish'|'report'|'video_upload'|'custom_audience'|'account_connection'|'billing'|'post_approval'
  title: string
  payload: object
  platform: string|null
  error_message: string|null
  developers_aware: boolean
  dismissed_at: string|null
  created: string
  read: boolean
}
export type GetGetPinterestAdAccountsQuery = GetGetChatgptAdAccountsQuery
export type PinterestAdAccount = {
  account_id: string
  name: string
  currency: string|null
  country: string|null
  selected: boolean
}
export type PinterestAdAccountsResponse = {
  connected: boolean
  ad_accounts: PinterestAdAccount[]
}
export type GetPinterestBoardSectionsQuery = GetAutopilotUsageAllowedQuery
export type PinterestBoardSection = CampaignOptionsPage
export type PinterestBoardSectionsResponse = {
  sections: PinterestBoardSection[]
}
export type GetPinterestBoardsQuery = GetAutopilotUsageAllowedQuery
export type PinterestBoard = {
  id: string
  name: string
  privacy: string|null
  is_ads_only: boolean
  image_cover_url: string|null
}
export type PinterestBoardsResponse = {
  connected: boolean
  boards: PinterestBoard[]
}
export type GetPlatformFeedQuery = {
  max_results?: number
}
export type PlatformFeedPost = {
  id: string
  text: string
  created_at: string|null
  url: string|null
  media: string[]
  media_type: string|null
  metrics: any
}
export type XFeed = {
  platform: string
  connected: boolean
  username: string|null
  name: string|null
  profile_image: string|null
  posts: PlatformFeedPost[]
  error: string|null
}
export type FacebookPageFeed = {
  page_id: string
  page_name: string|null
  page_picture: string|null
  posts: PlatformFeedPost[]
  error: string|null
}
export type FacebookFeed = {
  platform: string
  connected: boolean
  pages: FacebookPageFeed[]
}
export type InstagramAccountFeed = {
  account_id: string
  username: string
  name: string|null
  profile_picture: string|null
  posts: PlatformFeedPost[]
  error: string|null
}
export type InstagramFeed = {
  platform: string
  connected: boolean
  accounts: InstagramAccountFeed[]
}
export type LinkedInOrganizationFeed = {
  organization_id: string
  name: string|null
  logo: string|null
  posts: PlatformFeedPost[]
  error: string|null
}
export type LinkedInFeed = {
  platform: string
  connected: boolean
  organizations: LinkedInOrganizationFeed[]
}
export type PlatformFeedResponse = {
  x: XFeed|null
  facebook: FacebookFeed|null
  instagram: InstagramFeed|null
  linkedin: LinkedInFeed|null
}
export type GetGetRedditAdAccountsQuery = GetGetChatgptAdAccountsQuery
export type RedditAdAccount = {
  account_id: string
  name: string
  currency: string|null
  selected: boolean
}
export type RedditAdAccountsResponse = {
  connected: boolean
  ad_accounts: RedditAdAccount[]
}
export type TeamResearchStart = {
  started: boolean
}
export type GetSocialAccountsQuery = {
  keywords?: string[]
  countries?: string[]
  email?: string
  min_reach?: number
  max_reach?: number
  has_social?: ('x'|'instagram'|'youtube'|'facebook'|'tiktok')[]
  entity_type?: 'persons'|'non-persons'
  order_by?: 'raw_semantic_score'|'combined_score'|'authority_score'|'signal_growth'|'reach'
}
export type AccountSocials = {
  name: string
  bio: string
  x_handle: string
  x_followers: number|null
  facebook_handle: string
  facebook_followers: number|null
  instagram_handle: string
  instagram_followers: number|null
  linkedin_handle: string
  linkedin_followers: number|null
  reddit_handle: string
  reddit_followers: number|null
  tiktok_handle: string
  tiktok_followers: number|null
  snapchat_handle: string
  snapchat_followers: number|null
  youtube_handle: string
  youtube_followers: number|null
  discord_handle: string
  discord_followers: number|null
  twitch_handle: string
  twitch_followers: number|null
  spotify_id: string
  spotify_handle: string
  spotify_followers: number|null
  pinterest_handle: string
  pinterest_followers: number|null
  pic: string
  classifier_names: string[]
  website: string
  entity_type: string|null
  sdu: string
  rank: number|null
  followers: number|null
  country: string|null
  reach: any
}
export type StandaloneSocialAccounts = {
  accounts: AccountSocials[]
  analyzed_countries: string[]
  analyzed_keywords: string[]
  search_id: number|null
}
export type SelectedAdAccountsResponse = {
  selected_ad_accounts: any
}
export type SelectedAdAccountsResponseInput = {
  x?: string[]
  meta?: string[]
  linkedin?: string[]
  google_analytics?: string[]
  google_ads?: string[]
  reddit?: string[]
  tiktok?: string[]
  pinterest?: string[]
  chatgpt?: string[]
}
export type GetSyncMediaQuery = {
  platforms?: string
  refresh?: boolean
  bust_cache?: boolean
}
export type SyncMediaPlatform = {
  platform: 'website'|'x'|'linkedin'|'facebook'|'instagram'
  connected: boolean
  state: 'ok'|'pending'|'error'
  stale: boolean
  last_synced_at: string|null
}
export type SyncMedia = {
  syncs: SyncMediaPlatform[]
}
export type GetTargetingPackXBuildStatusQuery = {
  config_id: number
}
export type XTargetingPackBuildPack = StandaloneXTargetingPack
export type StandaloneXTargetingPackBuildStatus = {
  status: 'building'|'ready'|'error'
  pack: XTargetingPackBuildPack|null
}
export type StandaloneXTargetingPackBuildInput = {
  input_keywords: string[]
  input_countries?: string[]|null
  input_interests?: string[]|null
  input_behaviors?: string[]|null
  input_job_titles?: string[]|null
  input_industries?: string[]|null
  input_companies?: string[]|null
  input_seniorities?: string[]|null
  input_skills?: string[]|null
  input_genders?: string[]|null
  input_age_min?: number|null
  input_age_max?: number|null
  search_id?: number|null
}
export type StandaloneXTargetingPackBuild = GetTargetingPackXBuildStatusQuery
export type GetGetTiktokAdAccountsQuery = GetGetChatgptAdAccountsQuery
export type TikTokAdAccount = RedditAdAccount
export type TikTokAdAccountsResponse = {
  connected: boolean
  ad_accounts: TikTokAdAccount[]
}
export type GetGetXAdAccountsQuery = GetGetLinkedinAdAccountsQuery
export type XAdAccount = {
  account_id: string
  name: string
  timezone: string|null
  x_handle: string|null
  profile_image: string|null
  selected: boolean
  missing_permissions: boolean
}
export type XAdsAccountResponse = {
  connected: boolean
  screen_name: string|null
  ad_accounts: XAdAccount[]
}
export type StandaloneCampaignCalculatorInput = {
  objective: 'reach'|'video_views'|'pre_roll_views'|'engagements'|'traffic'|'app_installs'|'app_engagements'
  countries: string[]
  budget: number
  weeks: number
}
export type StandaloneCampaignCalculatorReach = {
  budget: number
  value: number
}
export type StandaloneCampaignCalculatorEstimate = {
  cpm: number
  impressions: number
  reach: number
  frequency: number
  prediction: StandaloneCampaignCalculatorReach[]|null
  budget: number
  weeks: number
}
export type StandaloneCampaignCalculator = {
  objective: 'reach'|'video_views'|'pre_roll_views'|'engagements'|'traffic'|'app_installs'|'app_engagements'
  countries: string[]
  budget: number
  weeks: number
  estimates: StandaloneCampaignCalculatorEstimate[]
}
export type StandaloneWriteTwitterAdsetInput = {
  creatives: string[]
  end_time?: string|null
  is_autobid?: boolean
  max_bid?: number|null
  name: string
  start_time: string
  country?: string|null
  age_min?: number|null
  age_max?: number|null
  locations?: any[]
  daily_budget?: number|null
  exclude_audiences?: string[]
  include_audiences?: string[]
  handles?: string[]
  keywords?: string[]
  hashtags?: string[]
  iab_targeting?: string[]
  lifetime_budget?: number|null
  status?: 'active'|'paused'
}
export type StandaloneCampaignCreateInput = {
  audience_description: string
  countries: string[]
  ad_account_id: string
  funding_instrument_id: string
  name: string
  budget?: number|null
  objective?: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
  adsets: StandaloneWriteTwitterAdsetInput[]
}
export type StandaloneCampaignCreate = StandaloneInsightsAnalyzerGenerateSheet
export type StandaloneCampaignExtractParametersMessagesInput = {
  type: 'ai'|'user'
  response?: string
}
export type StandaloneCampaignExtractParametersInput = {
  audience_description?: string
  countries?: string[]
  ad_account_id?: string
  funding_instrument_id?: string
  name?: string
  messages: StandaloneCampaignExtractParametersMessagesInput[]
  budget?: string
  objective?: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
}
export type StandaloneCampaignExtractParameters = {
  audience_description: string
  countries: string[]
  ad_account_id: string
  funding_instrument_id: string
  name: string
  budget: string
  more_information_required: boolean
  create_campaign: boolean
  start_new_session: boolean
  objective: 'APP_ENGAGEMENTS'|'APP_INSTALLS'|'REACH'|'FOLLOWERS'|'ENGAGEMENTS'|'VIDEO_VIEWS'|'PREROLL_VIEWS'|'WEBSITE_CLICKS'
}
export type GetStandAloneCampaignOptionListQuery = StandaloneAdAccountFundingSourcesInput
export type StandAloneCampaignOption = {
  campaign_id: string
  name: string
  start_time: string
}
export type GetStandAloneCampaignOptionInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type GetStandaloneCheckAgencyAdAccountListQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneCheckAgencyAdAccount = {
  ad_account_ids: string[]
  agency: string
}
export type GetStandaloneCheckAgencyAdAccountInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneCheckCustomAudiencesInput = {
  ad_account_id: string
  audience_config_id?: number
  audience_used_in_ads_id?: number
  custom_audience_names?: string[]
}
export type StandaloneCustomAudienceStatus = {
  name: string
  audience_id: string
  targetable: boolean
  reasons_not_targetable: string[]
}
export type StandaloneCheckCustomAudiences = {
  custom_audiences: StandaloneCustomAudienceStatus[]
}
export type StandAloneCompetitorAnalysisInput = {
  email?: string|null
  ad_account_id?: string|null
  input_handle: string
  input_handles: string[]
  days: number
}
export type DeepThoughtAccountCompetitor = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  percentage_overlap: number|null
  engagement_rate: number|null
  impressions: number|null
  post_count: number|null
  genders: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  percentage_active: number|null
}
export type StandAloneCompetitorAnalysis = {
  audience_creator_query_id: number
  accounts: DeepThoughtAccountCompetitor[]
  top_posts: DeepThoughtPost[]
}
export type StandaloneAccountTopicsInput = {
  handles: string[]
}
export type DeepThoughtEnrichedAccount = {
  account: DeepThoughtAccount
  enrichments: DeepThoughtEnrichment[]
}
export type StandaloneAccountTopics = {
  enriched_accounts: DeepThoughtEnrichedAccount[]
}
export type StandaloneCompetitorAnalysisSuggestCompetitorsInput = GetSimilarHandlesQuery
export type StandaloneCompetitorAnalysisSuggestCompetitors = {
  suggestions: string[]
}
export type StandaloneExploreParametersInput = {
  handles?: string[]|null
  keywords?: string[]|null
  countries?: string[]|null
  title?: string|null
  query?: string|null
  input_keywords?: string[][]|null
  date_start?: string|null
  date_end?: string|null
}
export type StandAloneComputeAgeGroupsInput = {
  parameters?: StandaloneExploreParametersInput|null
  handles: string[]
  countries_alpha_2: string[]
}
export type StandAloneComputeAgeGroups = {
  age_percentages: ChartData[]
}
export type StandaloneConfigGenerateExploreInsightsInput = {
  email?: string|null
  ad_account_id?: string|null
  audience_config_id: number
}
export type StandaloneConfigGenerateExploreInsights = {
  insights: StandaloneInsightsAnalyzerSync|null
}
export type ContentAuthoritiesQueryInput = {
  keywords: string[]
  keywords_all?: string[]
  min_date?: string|null
  max_date?: string|null
  min_engagements?: number|null
  platforms?: string[]|null
  limit_per_platform?: number|null
  global_limit?: number|null
  order_by?: 'engagement_score'|'engagements'|'posted_at'|'none'
  has_link?: boolean|null
  countries?: string[]|null
  enrich_bluesky?: boolean
}
export type ContentAuthoritiesQuery = StandaloneShareViaAccountAudienceConfig
export type StandaloneConversationTopic = {
  label: string
}
export type StandaloneSearchConversationTopicsInput = {
  keywords: string
}
export type StandaloneSearchConversationTopics = {
  conversation_topics: StandaloneConversationTopic[]
}
export type StandAloneCreateExclusionAudienceInput = {
  name: string
  email: string
  use_in_all_campaigns: boolean
  ad_account_id: string
  campaign_ids: string[]
}
export type StandAloneCreateExclusionAudience = {
  name: string
  email: string
  audience_id_link: string
}
export type GetAnalyseSpamQuery = {
  input_handle?: string
}
export type DeepThoughtAnalyseSpam = {
  spam_ratio: number
  posts_per_day: number|null
}
export type GetExtractAccountRanksQuery = GetAnalyseSpamQuery
export type DeepThoughtClassifierRank = {
  classifier_id: number
  classifier_name: string
  rank: number
}
export type DeepThoughtExtractAccountRanks = {
  ranks: DeepThoughtClassifierRank[]
}
export type GetFollowersTokenQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  input_handle?: string
  handle?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order?: string
  order_by?: string
}
export type GetFollowingTokenQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  input_handle?: string
  handle?: string
  classifier_name?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  order?: string
  follows_you?: boolean
}
export type GetPredictPayoutBasedOnEngagementsTokenQuery = {
  input_handle?: string
  like_count?: number
  retweet_count?: number
  quote_count?: number
  reply_count?: number
  bookmark_count?: number
  user_profile_clicks?: number
}
export type DeepThoughtVerifiedEngagementCounts = {
  verified_like_count: number|null
  verified_retweet_count: number|null
  verified_quote_count: number|null
  verified_reply_count: number|null
  verified_engagement_count: number|null
  verified_bookmark_count: number|null
  verified_user_profile_clicks: number|null
}
export type DeepThoughtPredictPayoutBasedOnEngagements = {
  payout: number
  verified_engagements: DeepThoughtVerifiedEngagementCounts
}
export type GetUnfollowersTokenQuery = {
  input_handle?: string
  handle?: string
  follower_gte?: string
  follower_lte?: string
  order?: string
  order_by?: string
}
export type DeepThoughtFollowerOverlap = StandaloneInsightsAnalyzerKeywordAccounts
export type DeepThoughtVerifiedFollowersInput = GetSimilarHandlesQuery
export type DeepThoughtVerifiedFollowers = {
  count: number
  account: DeepThoughtAccount
}
export type DeepThoughtWhoToFollowInput = {
  description: string
  input_handle?: string
  max_followers?: number|null
  is_verified?: boolean|null
  is_not_following?: boolean|null
  limit?: number
}
export type DeepThoughtWhoToFollow = {
  influencers: DeepThoughtAccount[]|null
}
export type DeepThoughtListMemberInput = {
  list_id: string
  account_ids: string[]
}
export type DeepThoughtListMember = AffiliateApplyPartnerCode
export type _DeepThoughtCountryInput = {
  country: string
  percentage: number
}
export type DeepThoughtBestPostTimeInput = {
  countries: _DeepThoughtCountryInput[]
  timezone: string
}
export type DeepThoughtBestPostTime = CreateCampaignPdf
export type SubscriptionCancelInput = StandaloneShareViaAccountAudienceConfig
export type SubscriptionCancel = {
  message: string
}
export type DeepThoughtListInput = {
  name: string
  description: string|null
  private: boolean
}
export type DeepThoughtList = {
  id: string
  name: string
  description: string|null
  private: boolean
}
export type ReferralCreateInput = {
  referred_handle: string
}
export type ReferralCreate = {
  success: boolean
  referral_url: string
}
export type SubscriptionCreateInput = {
  referrer_handle?: string
}
export type SubscriptionCreate = StandaloneSubscriptionCheckout
export type GetEngagersQuery = {
  verified?: boolean
  follower_gte?: number
  follower_lte?: number
  following_gte?: number
  following_lte?: number
  handle?: string
  order?: string
  order_by?: string
}
export type DeepThoughtEngager = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  like_count: number
  reply_count: number
  retweet_count: number
  quote_count: number
  total_engagements: number
}
export type DeepThoughtEngagers = {
  accounts: DeepThoughtEngager[]
}
export type DeepThoughtEnrichmentAccountsInput = {
  classifier_ids?: number[]|null
  already_following?: boolean
  verified?: boolean
  follower_gte?: number
  follower_lte?: number
  following_gte?: number
  following_lte?: number
}
export type DeepThoughtEnrichmentClassifierAccounts = {
  classifier_id: number
  accounts: DeepThoughtAccount[]
}
export type DeepThoughtEnrichmentAccounts = {
  enriched_classifier_accounts: DeepThoughtEnrichmentClassifierAccounts[]
}
export type DeepThoughtEnrichedAccountMany = {
  accounts: DeepThoughtEnrichmentClassifierAccounts[]
  enrichments: DeepThoughtEnrichment[]
}
export type DeepThoughtEnrichmentsInput = StandaloneAccountTopicsInput
export type DeepThoughtEnrichments = StandaloneAccountTopics
export type GetFetchInterestsQuery = {
  name?: string
}
export type DeepThoughtInterest = ClassifierChild
export type DeepThoughtFetchInterests = {
  interests: DeepThoughtInterest[]
}
export type GetFetchTimelineQuery = {
  classifier_ids?: number[]
  account_ids?: number[]
  tweet_ids?: number[]
  locations?: string[]
  order_by?: string
  min_score?: number
  max_score?: number
  limit?: number
  is_verified?: boolean
  max_followers?: number
}
export type DeepThoughtTimelineAccount = {
  accountid: string
  pic: string
  handle: string
  name: string
  verified: boolean
  blue: boolean
  followers: number
  friends: number
  grey: boolean
  gold: boolean
  affiliation_description: string
  affiliation_badge_url: string|null
}
export type DeepThoughtTimeline = {
  account: DeepThoughtTimelineAccount
  post: DeepThoughtPostTweetTimeline
}
export type DeepThoughtFetchTimeline = {
  posts: DeepThoughtTimeline[]
}
export type DeepThoughtFollowAccountInput = GetStandaloneAdAccountListQuery
export type DeepThoughtFollowAccount = {
  following: boolean
}
export type DeepThoughtFollowerIntersectionInput = StandaloneAccountTopicsInput
export type DeepThoughtFollowerIntersection = {
  accounts: DeepThoughtAccount[]
  count: number
}
export type DeepThoughtBotPercentageInput = {
  handles?: string[]
}
export type DeepThoughtBotPercentage = {
  bot_percentage: number
}
export type GetFollowersQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  non_engagers?: string
  spam?: string
  active?: boolean
  handle?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order?: string
  order_by?: string
}
export type GetFollowingQuery = {
  limit?: number
  offset?: number
  verified?: boolean
  spam?: string
  active?: boolean
  handle?: string
  classifier_name?: string
  follower_gte?: string
  follower_lte?: string
  verified_follower_gte?: string
  verified_follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  order?: string
  follows_you?: boolean
}
export type DeepThoughtPayoutActualInput = {
  periods: string[]
  payouts: string[]
}
export type DeepThoughtPayoutActual = AffiliateApplyPartnerCode
export type _DeepThoughtPayoutPredictor = {
  engagement_count: number
  verified_engagement_count: number
  payout: number
  period: string
  verified_like_count: number
  verified_retweet_count: number
  verified_quote_count: number
  verified_reply_count: number
  verified_bookmark_count: number
  verified_user_profile_clicks: number
}
export type DeepThoughtPayoutPredictor = {
  estimation: number
  previous: _DeepThoughtPayoutPredictor
  current: _DeepThoughtPayoutPredictor
  last_updated: string
}
export type DeepThoughtPostsAccountInput = GetStandaloneAdAccountListQuery
export type DeepThoughtPostCounts = {
  total: number|null
  like_count: number|null
  retweet_count: number|null
  reply_count: number|null
  quote_count: number|null
  bookmark_count: number|null
  user_profile_clicks: number|null
  impression_count: number|null
}
export type DeepThoughtViewCounts = {
  retweets: number|null
  replies: number|null
  quotes: number|null
  posts: number|null
  percentage: number|null
  reach: number|null
}
export type DeepThoughtPostsAccount = {
  account: DeepThoughtAccount
  posts: DeepThoughtPost[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
}
export type GetPostsAndLikesQuery = {
  days?: string
  order?: string
  order_by?: string
}
export type DeepThoughtLiker = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  verified_count: number|null
  verified_count_rank: number|null
  auth_token: string|null
  token: string|null
  bot: boolean|null
  active: boolean|null
  gender: string|null
  following: boolean|null
  follows_you: boolean|null
  suspended: boolean|null
  verified_followers_count: number|null
  classifier_names: string[]|null
  updated: string|null
  churn_ratio: number|null
  engager: boolean
  tweets: number|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  location: string|null
  site: string|null
  facebook: string|null
  instagram: string|null
  youtube: string|null
  linkedin: string|null
  tweet_date: string|null
  like_count: number|null
}
export type DeepThoughtPostsAndLikes = {
  posts: DeepThoughtPost[]
  likers: DeepThoughtLiker[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
  verified_engagement_counts: DeepThoughtVerifiedEngagementCounts
}
export type GetPredictPayoutBasedOnEngagementsQuery = {
  like_count?: number
  retweet_count?: number
  quote_count?: number
  reply_count?: number
  bookmark_count?: number
  user_profile_clicks?: number
}
export type DeepThoughtPredictPostPerformanceInput = {
  draft_post: string
}
export type DeepThoughtPredictPost = {
  like_count: number
  reply_count: number
  impression_count: number
}
export type DeepThoughtImprovedPost = {
  like_count: number
  reply_count: number
  impression_count: number
  improved_post: string
}
export type DeepThoughtPredictPostPerformance = {
  prediction_text: string
  predicted_engagements: DeepThoughtPredictPost
  improved_post: DeepThoughtImprovedPost
}
export type DeepThoughtAccountRecentlyJoined = {
  recently_joined: boolean
}
export type GetSearchNotificationsQuery = {
  input_text?: string
}
export type DeepThoughtSearchNotifications = {
  found_likes: DeepThoughtPost[]
  found_engagements: DeepThoughtPost[]
  found_followers: DeepThoughtPostAccount[]
}
export type UserSubscription = {
  id: number
  referral_credit_months: any
  created: string
  modified: string
  invoice_name: string
  website: string|null
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  country: string|null
  phone: string|null
  invoice_email: string|null
  stripe_customer_id: string|null
  accepted_terms_and_conditions: string|null
  is_active: boolean
  cancels_at: string|null
  user: number
}
export type UserSubscriptionInput = {
  invoice_name?: string
  website?: string|null
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  country?: string|null
  phone?: string|null
  invoice_email?: string|null
  accepted_terms_and_conditions?: string|null
  cancels_at?: string|null
  user: number
}
export type DeepThoughtQuestions = {
  questions: string[]
}
export type DeepThoughtTalkToXInput = {
  query: string
}
export type DeepThoughtTalkToX = {
  unmodified_query: string
  user_queries: number
  accounts: DeepThoughtAccount[]
  follower_enrichments: DeepThoughtEnrichedAccountMany
  followers: DeepThoughtAccount[]
  friends: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
  question: string|null
  information_type: string[]
  title: string
  percentage_active: string
  gender_split: any|null
  community_size: string
  enrichments: DeepThoughtEnrichment[]
}
export type DeepThoughtCountry = {
  country: string
  alpha_2: string
  percentage: number
  count: number|null
}
export type DeepThoughtCountries = {
  countries: DeepThoughtCountry[]
}
export type DeepThoughtUnfollowAccountBulkInput = {
  account_ids: string[]
}
export type DeepThoughtUnfollowAccountBulk = AffiliateApplyPartnerCode
export type GetUnfollowersQuery = {
  handle?: string
  follower_gte?: string
  follower_lte?: string
  order?: string
  order_by?: string
}
export type DeepThoughtInputHandleInput = {
  input_handle: string
}
export type DeepThoughtInputHandle = StandaloneShareViaAccountAudienceConfig
export type DeepThoughtXStatsCountryActivity = {
  country: string
  alpha_2: string
  active_users: number
  population_percentage: number|null
}
export type GetXStatsQuery = {
  alpha2_code?: string
}
export type DeepThoughtEstimate = AudiencePromptSpecAge
export type DeepThoughtXStatsAge = {
  age: string
  estimate: DeepThoughtEstimate
}
export type DeepThoughtXStatsCount = {
  country: string
  alpha_2: string
  count: number
}
export type DeepThoughtXStatsTrend = {
  trend_name: string
  tweet_count: number|null
}
export type DeepThoughtXStats = {
  active_users_last_6_months: number
  active_users_last_3_months: number
  active_users_last_month: number
  active_users_age_groups: DeepThoughtXStatsAge[]|null
  verified_users: number
  gold_users: number
  top_accounts: DeepThoughtAccount[]
  top_tweets: DeepThoughtPost[]
  top_countries: DeepThoughtXStatsCountryActivity[]
  verified_users_by_country: DeepThoughtXStatsCount[]
  gold_users_by_country: DeepThoughtXStatsCount[]
  trends: DeepThoughtXStatsTrend[]
  age_groups: DeepThoughtXStatsAge[]|null
}
export type GetPostEngagementsQuery = {
  verified?: string
  spam?: string
  active?: boolean
  handle?: string
  follower_gte?: string
  follower_lte?: string
  following_gte?: string
  following_lte?: string
  order_by?: string
  engagement_type?: string
}
export type DeepThoughtPostEngagement = {
  post: DeepThoughtPost
  likers: DeepThoughtAccount[]
  retweeters: DeepThoughtAccount[]
  retweets: DeepThoughtPost[]
}
export type DeepThoughtReport = {
  mean_eng_rate: number
  reply_percentage: number
  engagement_counts: DeepThoughtPostCounts
  top_posts: DeepThoughtPost[]
  avg_text_length: number
  avg_followers_per_day: number
  avg_friends_per_day: number
  avg_tweets_per_day: number
  top_followers: DeepThoughtAccount[]
}
export type DeepThoughtUpdateListInput = DeepThoughtListInput
export type DeepThoughtUpdateList = DeepThoughtList
export type BlobSocialdatabase = {
  file: any
  preview_file: any|null
  name: string
  description: string|null
  bucket: 'dashboard-storage-msdb'|'xprotargeting-assets'|'xprotargeting-assets-private'
}
export type EventSocialdatabase = {
  id: number
  name: string
  title: string
  description: string
  slides_url: string
  icon: BlobSocialdatabase|null
  header: BlobSocialdatabase
  slides: BlobSocialdatabase
  onepager: BlobSocialdatabase
  targeting_keywords: BlobSocialdatabase
  dashboard: BlobSocialdatabase|null
}
export type StandaloneExploreClustersInput = {
  parent_id?: number
}
export type Cluster = {
  id: number
  name: string
  score: number
  percentage: number
}
export type ClusterChildren = {
  id: number
  name: string
  score: number
  percentage: number
  parent: string|null
  parent_id: number|null
  parent_score: number|null
  parent_percentage: number|null
  children: Cluster[]
}
export type StandaloneExploreClusters = {
  id: number
  name: string
  score: number
  percentage: number
  parent: string|null
  parent_score: number|null
  parent_percentage: number|null
  children: Cluster[]
  cluster_data: ClusterChildren[]
}
export type StandaloneCompareAccountsInput = {
  handles: string[]
  direction?: string|null
}
export type AccountsEnrichments = {
  handle: string
  enrichments: DeepThoughtEnrichment[]|null
}
export type StandaloneCompareAccounts = {
  handles_enrichments: AccountsEnrichments[]|null
}
export type StandaloneCreatorsParametersInput = {
  handles?: string[]|null
  keywords?: string[]|null
  countries?: string[]|null
  title?: string|null
  query?: string|null
  input_keywords?: string[][]|null
  date_start?: string|null
  date_end?: string|null
  min_followers?: number|null
  max_followers?: number|null
  min_friends?: number|null
  max_friends?: number|null
  is_creator?: boolean
}
export type StandAloneExploreExtractCreatorsInput = {
  parameters?: StandaloneCreatorsParametersInput|null
  top_k?: number
}
export type CreatorAccount = {
  accountid: string
  handle: string
  name: string|null
  bio: string|null
  followers: number
  friends: number
  pic: string
  verified: boolean
  classifier_names: string[]|null
  affiliation_description: string|null
  affiliation_badge_url: string|null
  blue: boolean
  grey: boolean
  gold: boolean
  label: string|null
  country: string|null
  gender: string|null
  account_creation_date: string|null
}
export type StandAloneExploreExtractCreators = {
  accounts: CreatorAccount[]
  classifier_name_options: string[]
}
export type StandaloneCreatorClassifierChildrenInput = {
  classifier_name: string
}
export type StandaloneCreatorClassifierChildren = {
  children: string[]
}
export type StandAloneExploreDemographicsInput = {
  parameters: StandaloneExploreParametersInput
}
export type StandAloneExploreDemographics = {
  genders: ChartData[]
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]
  cities: ChartData[]
  languages: ChartData[]
  keywords: ChartData[]
  double_keywords: ChartData[]
  hashtags: ChartData[]
  show_country_message: boolean|null
}
export type GetStandaloneExploreEmailAdAccountsListQuery = {
  email: string
  ad_account_id: string
}
export type StandaloneExploreEmailAdAccounts = {
  id: number
  email: string
  ad_account_id: string
  ad_account_name: string
  ad_account: any
}
export type StandaloneExploreEmailAdAccountsInput = {
  email: string
  ad_account_id: string
  ad_account_name: string
}
export type GetStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type PatchStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type PutStandaloneExploreEmailAdAccountsInstanceQuery = GetStandaloneExploreEmailAdAccountsListQuery
export type StandAloneExploreEnrichmentsInput = {
  parameters: StandaloneExploreParametersInput
  top_k?: number
  input_handle?: string
  query_type?: 'account'|'friends'|'followers'
}
export type StandAloneExploreEnrichments = {
  professions: ChartData[]
  subreddits: StandaloneSubreddits[]|null
  enrichments: DeepThoughtEnrichment[]|null
}
export type StandaloneExploreExtractDataHandlesInput = StandAloneExploreDemographicsInput
export type StandaloneExploreExtractDataHandles = {
  percentage_active: number|null
  percentage_active_tweeter: number|null
  sample_accounts: DeepThoughtAccount[]
  accounts: DeepThoughtAccount[]
}
export type StandaloneExploreExtractDataKeywordsInput = StandAloneExploreDemographicsInput
export type StandaloneExploreExtractDataKeywords = {
  sample_accounts: DeepThoughtAccount[]
}
export type StandaloneExploreExtractDataTweetKeywordsInput = {
  input_keywords?: string[][]
  alpha_2?: string
}
export type StandaloneExploreExtractDataTweetKeywords = {
  parameters: StandaloneExploreParameters
  sample_accounts: DeepThoughtAccount[]
}
export type StandalonePostMetadataHandleInput = {
  handles: string[]
  location?: string|null
}
export type StandalonePostMetadataHandle = {
  counts: StandalonePostMetadataCount
  summary: string|null
}
export type StandAloneExploreFollowerGrowthInput = {
  handles: string[]
  max_months?: number
}
export type StandAloneExploreFollowerGrowth = {
  account_stats: DeepThoughtAccountStats[]|null
}
export type StandaloneExploreExtractPostDataHandlesInput = {
  parameters: StandaloneExploreParametersInput
  days?: number|null
  order_by?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandaloneExploreExtractPostDataHandles = {
  single_keywords_handles: ChartData[]
  double_keywords_handles: ChartData[]
  hashtags_handles: ChartData[]
  emoji_counts_handles: ChartData[]
  top_posts_handles: DeepThoughtAccountTweet[]
}
export type StandAloneExplorePostsDataInput = StandaloneExploreExtractPostDataHandlesInput
export type StandAloneExplorePostsData = {
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  hashtags_tweets: ChartData[]
  post_counts: PostCounts|null
  emoji_counts: ChartData[]
  top_posts: DeepThoughtAccountTweet[]
}
export type GetStandaloneExploreSearchListQuery = {
  email?: string
  ad_account_id?: string
  query_type?: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
}
export type StandaloneAudienceCreatorQuery = {
  id: number
  input_query: string|null
  ad_account_id: string|null
  email: string|null
  parameters: StandaloneExploreParameters|null
  input_type: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'|null
}
export type StandaloneExploreSearch = {
  id: number
  email: string
  audience_creator_query: StandaloneAudienceCreatorQuery
  query_type: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
  name: string
  ad_account_id: string
  size: number
}
export type StandaloneExploreSearchInput = {
  email?: string
  audience_creator_query_id: number
  query_type?: 'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'
  name?: string
  ad_account_id?: string
  size?: number
}
export type DeleteStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type GetStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type PatchStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type PutStandaloneExploreSearchInstanceQuery = GetStandaloneExploreSearchListQuery
export type StandAloneExploreExtractSEOKeywordsInput = StandAloneExploreDemographicsInput
export type StandAloneExploreExtractSEOKeywords = {
  seo_keywords: string[]
  seo_phrases: string[]
}
export type StandaloneFindRelatedAudiencesClassifierInput = {
  classifier_id: number
  location?: string
}
export type StandaloneFindRelatedAudiencesClassifier = {
  audience_configs: StandaloneAudienceConfigListItem[]
}
export type StandaloneFindRelatedAudiencesInput = StandAloneExploreDemographicsInput
export type StandaloneFindRelatedAudiences = StandaloneFindRelatedAudiencesClassifier
export type StandAloneExploreTopAccountsInput = {
  parameters: StandaloneExploreParametersInput
  engages_with?: boolean
}
export type StandAloneExploreTopAccounts = {
  size: SizeData|null
  top_accounts: DeepThoughtAccount[]
}
export type StandAloneExploreTopFollowersInput = StandaloneAccountTopicsInput
export type StandAloneExploreTopFollowers = {
  top_followers: DeepThoughtAccount[]
}
export type StandAloneExploreTopPostsInput = {
  parameters: StandaloneExploreParametersInput
  days?: number|null
  limit?: number
  offset?: number
}
export type StandAloneExploreTopPosts = {
  top_posts: DeepThoughtAccountTweet[]
}
export type StandAloneExtractExclusionSampleInput = {
  ad_account_id: string
  campaign_ids: string[]
}
export type StandAloneExtractExclusionSample = {
  size: number
  counts: StandaloneMonitorWeekResultCounts
}
export type FetchContentAuthoritiesQueryInput = {
  keywords?: string[]|null
  keywords_all?: string[]
  min_date?: string|null
  max_date?: string|null
  min_engagements?: number|null
  platforms?: string[]|null
  limit_per_platform?: number|null
  global_limit?: number|null
  order_by?: 'engagement_score'|'engagements'|'posted_at'|'none'
  has_link?: boolean|null
  enrich_bluesky?: boolean
  sdus: string[]
}
export type FetchContentAuthoritiesQuery = StandaloneShareViaAccountAudienceConfig
export type StandaloneNativePackGeneratorInput = {
  input_keyword_groups?: string[][]|null
  input_handles?: string[]|null
  input_countries?: string[]|null
  input_genders?: ('any'|'male'|'female')[]|null
  input_audience_selectivity?: 'balanced'|'narrow'|'broad'|null
  input_exclude_keywords?: string[]|null
  input_location_states?: string[]|null
  input_budget?: 500|1000|2500|5000|10000|20000|50000|100000|250000|500000|750000|1000000|null
  input_size?: 25000|50000|100000|150000|300000|600000|1500000|3000000|7500000|15000000|22000000|30000000|null
  description?: string|null
  email?: string|null
  ad_account_id?: string|null
  plan_type?: string|null
}
export type StandaloneNativePackGenerator = {
  id: number
  created: string
  modified: string
  status: any|null
  gender: { label: string; value: number; valueText: string }[]|null
  countries: { label: string; value: number; valueText: string; alpha_2: string|null }[]|null
  regions: { label: string; value: number; valueText: string }[]|null
  cities: { label: string; value: number; valueText: string; long: number|null; lat: number|null }[]|null
  specific_interests: { label: string; value: number; valueText: string }[]|null
  interests: { label: string; value: number; valueText: string }[]|null
  interest_fields: { label: string; value: number; valueText: string }[]|null
  professions: { label: string; value: number; valueText: string }[]|null
  profession_fields: { label: string; value: number; valueText: string }[]|null
  income_level: { label: string; value: number; valueText: string }[]|null
  education_level: { label: string; value: number; valueText: string }[]|null
  socioeconomic_status: { label: string; value: number; valueText: string }[]|null
  bio_words: { label: string; value: number; valueText: string }[]
  bio_hashtags: { label: string; value: number; valueText: string }[]|null
  bio_chunks: any
  tweet_words: { label: string; value: number; valueText: string }[]|null
  tweet_keywords: { label: string; value: number; valueText: string }[]|null
  mentioned_hashtags: { label: string; value: number; valueText: string }[]|null
  mentioned_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  most_liked_tweets: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_liked: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  tweets_most_retweeted: { tweet_id: string; handle: string; tweet_text: string; likes: number; retweets: number; picture?: string|null; count: number }[]|null
  most_retweeted_accounts: { id: number; handle: string; bio: string|null; followers: number; name?: string; friends?: number; picture?: string|null; count: number }[]|null
  influencers: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[]
  audience_estimation: { min: number; max: number; warning: string|null }|null
  targeting_package: { hashtags: { label: string; size: number|null; deselected: boolean|null }[]; handles: { picture: string|null; id: number; handle: string; bio: string|null; name: string; size: number|null; followers: number; relevancy: number; connectivity: number|null; country: string|null; deselected: boolean|null }[]; handles_ordered_by: ("balanced"|"narrow"|"default"|"custom"); keywords: { label: string; size: number|null; deselected: boolean|null }[]; excluded_keywords: { label: string; size: number|null; deselected: boolean|null }[]; conversation_topics: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; interests: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; movies_tv_shows: { label: string; size: number|null; targeting_value: string|null; deselected: boolean|null }[]; custom_audiences: string[]; custom_audiences_deselected: string[]|null; included_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; excluded_custom_audiences: { id: string; name: string; deselected: boolean|null; ad_account_id: string|null; ad_account_name: string|null }[]; languages: { label: string; size: number|null; targeting_value: string|null }[]; network_operators: { label: string; size: number|null; targeting_value: string|null }[]; placements: ("homeTimelines"|"profiles"|"searchResults"|"replies")[]; gender: ("ANY"|"MALE"|"FEMALE"|"Women"|"Men"); age: ("AGE_ANY"|"AGE_OVER_13"|"AGE_OVER_18"|"AGE_OVER_21"|"AGE_OVER_25"|"AGE_OVER_35"|"AGE_OVER_50"|"AGE_13_TO_24"|"AGE_13_TO_34"|"AGE_13_TO_49"|"AGE_13_TO_54"|"AGE_18_TO_24"|"AGE_18_TO_34"|"AGE_18_TO_49"|"AGE_18_TO_54"|"AGE_21_TO_34"|"AGE_21_TO_49"|"AGE_21_TO_54"|"AGE_25_TO_49"|"AGE_25_TO_54"|"AGE_35_TO_49"|"AGE_35_TO_54"); locations: string[]; excluded_locations: string[]; countries: string[] }|null
  targeting_package_size: { min: number; max: number }|null
  related_communities: null|string[]|null
  core_accounts: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture?: string|null; likes_per_month?: number|null; tweets_per_month?: number|null; activity_score?: number|null; likes_count?: number|null; tweets_count?: number|null; site?: string|null; gender?: string|null; profession?: string|null; interest?: string|null; sub_interest?: string|null; country?: string|null; region?: string|null; city?: string|null; age?: string|null; secondary_sub_interest?: string|null; tertiary_sub_interest?: string|null }[]
  age: { label: string; value: number; valueText: string }[]|null
  sites: { label: string; value: number; valueText: string }[]|null
  accounts_count: { InitialSearch: number|null; JobTitles: number|null; Influencers: number|null; FollowersCount: number|null }|null
  suggestions: { query: string; metadata: { id: number; handle: string; bio: string|null; followers: number; name: string; friends: number; picture: string|null; connectivity: number; relevancy: number; base_audience_count?: number|null; is_followed?: boolean|null; gender?: string; tertiary_sub_interest?: string|null; secondary_sub_interest?: string|null; profession?: string|null; sub_interest?: string|null; country?: string|null; country_name?: string|null; region?: string|null; city?: string|null; country_id?: number|null; interest?: string|null; following_tertiary_sub_interest?: string|null; following_secondary_sub_interest?: string|null; following_profession?: string|null; following_sub_interest?: string|null; following_country?: string|null; following_interest?: string|null; connectivity_ranking?: number|null; connectivity_percentage?: number|null; relevancy_percentage?: number|null; relevancy_ranking?: number|null; age?: string|null; groups?: string|null[]|null; rscore?: number|null; cscore?: number|null; weighted_connectivity?: number|null; likes_per_tweet?: number|null; tweets_per_month?: number|null; retweets_per_tweet?: number|null; active?: boolean|null; activetweeter?: boolean|null; tweet_id?: string|null; tweet_date?: string|null; facebook?: string|null; instagram?: string|null; linkedin?: string|null; youtube?: string|null; x?: number|null; y?: number|null; height?: number|null; membership?: number|null; size?: number|null }[] }[]|null
  audience_creator_query_id: number
  analyzed_keyword_groups: string[][]
  analyzed_handles: string[]
  analyzed_countries: string[]
  analyzed_location_states: string[]
  analyzed_gender: 1|2|12|null
  analyzed_age_range: string|null
  analyzed_audience_selectivity: 'balanced'|'narrow'|'broad'
  plan_type: string|null
}
export type GetDownloadImageUniqueNameQuery = {
  url?: string
}
export type StandaloneInterest = StandaloneConversationTopic
export type StandaloneSearchInterestsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchInterests = {
  interests: StandaloneInterest[]
}
export type StandAloneJobTitlesSizeEstimatorInput = {
  job_titles: string[]
  countries: string[]
}
export type StandAloneJobTitlesSizeEstimator = {
  size: SizeData
}
export type StandaloneJobTitleTargetingInput = {
  email?: string|null
  ad_account_id: string
  campaign_name?: string|null
  campaign_id?: string|null
  job_titles: string[]
  countries: string[]
}
export type StandaloneJobTitleTargeting = {
  custom_audience_names: string[]
}
export type StandaloneAutopilotKeywordSuggestionUsageInput = {
  keyword_groups?: string[][]|null
  exclude_keywords?: string[]|null
  countries?: string[]|null
  handles?: string[]|null
  suggestions_added?: string[]|null
  suggestions?: string[]|null
  ad_account_id?: string|null
  description?: string|null
}
export type StandaloneAutopilotKeywordSuggestionUsageManyInput = {
  usages: StandaloneAutopilotKeywordSuggestionUsageInput[]
}
export type StandaloneAutopilotKeywordSuggestionUsageMany = AffiliateApplyPartnerCode
export type StandaloneLanguage = StandaloneConversationTopic
export type GetStandaloneTargetingLocationsListQuery = {
  country_code?: string
}
export type StandaloneTargetingLocation = StandaloneConversationTopic
export type StandaloneSearchTargetingLocationsInput = {
  country_code: string
  keywords: string
}
export type StandaloneSearchTargetingLocations = {
  locations: StandaloneTargetingLocation[]
}
export type BlobList = {
  preview_file: any|null
  name: string
  description: string|null
  bucket: 'dashboard-storage-msdb'|'xprotargeting-assets'|'xprotargeting-assets-private'
}
export type MarketingMaterialList = {
  id: number
  name: string
  title: string
  document_type: 'one-pager'|'slides'|'faq'|'case-study'
  file: BlobList
}
export type MarketingMaterialInput = PrivateModelInput
export type MarketingMaterial = {
  id: number
  name: string
  title: string
  document_type: 'one-pager'|'slides'|'faq'|'case-study'
  file: BlobSocialdatabase
}
export type GetStandaloneMonitorListQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneMonitor = ClassifierChild
export type GetStandaloneMonitorInstanceQuery = StandaloneAdAccountFundingSourcesInput
export type StandaloneMoviesTvShows = StandaloneConversationTopic
export type StandaloneSearchMoviesTvShowsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchMoviesTvShows = {
  movies_tv_shows: StandaloneMoviesTvShows[]
}
export type StandaloneNetworkOperator = StandaloneConversationTopic
export type StandaloneSearchNetworkOperatorsInput = StandaloneSearchConversationTopicsInput
export type StandaloneSearchNetworkOperators = {
  network_operators: StandaloneNetworkOperator[]
}
export type StandalonePersonaTokenInput = {
  query?: string|null
  url?: string|null
}
export type StandalonePersonaToken = {
  query: string|null
  url: string|null
}
export type GetMagicQuery = {
  email?: string
  magic_code?: string
  confirm_code?: string
}
export type CreateMagicLoginLink = StandaloneCreateMagicLoginLink
export type GetUseQuery = GetMagicQuery
export type StandAlonePostsAccountInput = GetStandaloneAdAccountListQuery
export type StandAlonePostsAccount = {
  posts: DeepThoughtPost[]
  post_counts: DeepThoughtPostCounts
  view_counts: DeepThoughtViewCounts
}
export type StandAloneXplorePostsSentimentAnalysisInput = {
  ad_account_id?: string|null
  tweet_ids: string[]
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandAloneXplorePostsSentimentAnalysis = {
  tweet_ids: string[]
  sentiments: StandaloneMonitorWeekResultCounts
  audience_creator_query_id: number
  posts: DeepThoughtPost[]
}
export type PulseFindingQueryInput = {
  topic: string
  title?: string
  organization_id?: number|null
}
export type PulseFindingQuery = StandaloneShareViaAccountAudienceConfig
export type PulseKeywordContentInput = {
  keywords: string[]
  start?: string|null
  end?: string|null
  limit?: number
  min_engagement?: number
  include_sdus?: boolean
  update_x_posts?: boolean
  max_tweets?: number
  update_bluesky_posts?: boolean
  max_bluesky_posts?: number
  poll_timeout?: number
}
export type PulseKeywordContent = StandaloneShareViaAccountAudienceConfig
export type PulseKeywordCountsInput = {
  keywords: string[]
  start?: string|null
  end?: string|null
  granularity?: 'month'|'day'
}
export type PulseKeywordCounts = StandaloneShareViaAccountAudienceConfig
export type PulseKeywordTweetsInput = {
  keywords: string[]
  account_ids?: number[]
  start?: string|null
  end?: string|null
  limit?: number
  include_sdus?: boolean
  update_x_posts?: boolean
  max_tweets?: number
  poll_timeout?: number
}
export type PulseKeywordTweets = StandaloneShareViaAccountAudienceConfig
export type PulseNewsQueryInput = DeepThoughtTalkToXInput
export type PulseNewsQuery = StandaloneShareViaAccountAudienceConfig
export type PulseRawKeywordsInput = {
  keywords: string[]
  days?: number
}
export type PulseRawKeywords = StandaloneShareViaAccountAudienceConfig
export type PulseRawSdusInput = {
  input_sdus: string[]
  topic?: string
  days?: number
  limit?: number
}
export type PulseRawSdus = StandaloneShareViaAccountAudienceConfig
export type PulseTerm = {
  term: string
  score: number
  rank: number
}
export type PulseTopic = {
  topic: any
  post_count: any
  created: any
  categories: any
  category_display_names: any
  terms: any
}
export type PulseSourceAccount = {
  sdu: string|null
  name: string|null
  subreddit: string|null
  channel_id: string|null
}
export type PulseSourceMappingItem = {
  sdu: string
  source_ids: string[]
  websites: string[]
  media: string[]
}
export type PulseSimilarFindingOutput = {
  category: string
  subcategory: string
  title: string
  description: string|null
  popularity: number|null
  date: string|null
}
export type PulseFindingDetailOutput = {
  category: string
  subcategory: string
  title: string
  description: string|null
  popularity: number|null
  date: string|null
  attributes: any
  source_accounts: PulseSourceAccount[]
  source_ids: string[]
  signals: string[]
  websites: string[]
  media: string[]
  source_mapping: PulseSourceMappingItem[]|null
  terms: PulseTerm[]
  similar_findings: PulseSimilarFindingOutput[]
}
export type PulseTopicsListItem = {
  topic: string
  requested_by: string|null
  last_finding_modified: string|null
  findings: PulseFindingDetailOutput[]
}
export type PulseUpdateSdusInput = {
  input_sdus: string[]
  topic?: string
  days?: number
  limit?: number
  youtube_skip_fresh_hours?: number
}
export type PulseUpdateSdus = StandaloneShareViaAccountAudienceConfig
export type PulseViaKeywordsInput = {
  keywords: string[]
  topic: string
  organization_id?: number|null
  days?: number
  max_tweets?: number
  run_analysis?: boolean|null
}
export type PulseViaKeywords = StandaloneShareViaAccountAudienceConfig
export type PulseViaSdusQueryInput = {
  input_sdus: string[]
  topic: string
  organization_id?: number|null
  days?: number
  run_analysis?: boolean|null
  youtube_skip_fresh_hours?: number
}
export type PulseViaSdusQuery = StandaloneShareViaAccountAudienceConfig
export type GetStandaloneRecentlyCreatedAudiencesListQuery = GetAutopilotUsageAllowedQuery
export type StandaloneRecentlyCreatedAudienceConfig = {
  id: number
  created: string
}
export type StandaloneRecentlyCreatedAudienceUsedInAds = {
  id: number
  audience_config_status: 'Imported'|'Processing'|'Done'
  created: string
}
export type StandaloneRecentlyCreatedAudiences = {
  audience_configs: StandaloneRecentlyCreatedAudienceConfig[]
  audience_used_in_ads: StandaloneRecentlyCreatedAudienceUsedInAds[]
}
export type GetStandaloneRecentlyCreatedAudiencesInstanceQuery = GetAutopilotUsageAllowedQuery
export type RefreshContentInput = {
  sdu: string
  include_x?: boolean
  priority?: number
}
export type RefreshContent = StandaloneShareViaAccountAudienceConfig
export type StandaloneRelatedKeywordsInput = {
  input_keywords: string[]
  exclude_keywords?: string[]|null
}
export type StandaloneRelatedKeywords = {
  related_keywords: string[]
}
export type StandaloneMe = PrivateModelInput
export type StandaloneTopicAccountsInput = {
  classifier_id?: number
  classifier_name?: string
  order_top_accounts?: 'connectivity'|'relevancy'
  limit?: number
}
export type StandaloneTopicAccounts = {
  classifier_id: number
  published: boolean
  accounts: DeepThoughtAccount[]
}
export type StandAloneUploadAudienceInput = {
  ad_account_id: string
  config_id: number
  state?: 'draft'|'launched'|'saved'|'applied'|'created'|'exclusion'|'job_title'|'explore_upload'
}
export type StandAloneUploadAudience = {
  audience_used_in_ads_id: number
}
export type StandaloneUserActivityEntryInput = {
  action?: string|null
  context?: string|null
  action_at: string
  classifier_id?: number
  audience_creator_query_id?: number
}
export type StandaloneUserActivityEntry = {
  id: number
  user_id: number
  action: string|null
  context: string|null
  action_at: string
  classifier_id: number
  audience_creator_query_id: number
}
export type WebSearchV2QueryInput = {
  question: string
  limit?: number|null
  min_date?: string|null
  max_date?: string|null
  min_authority_voters?: number|null
}
export type WebSearchV2Query = StandaloneShareViaAccountAudienceConfig
export type WebSearchQueryInput = {
  question?: string|null
  keywords?: string[][]|null
  limit?: number|null
  read?: boolean|null
  freshness?: boolean|null
  min_date?: string|null
  max_date?: string|null
  min_engagements?: number|null
  min_authority_score?: number|null
  countries?: string[]|null
  platforms?: string[]|null
  limit_per_platform?: number|null
  global_limit?: number|null
  order_by?: 'engagement_score'|'engagements'|'posted_at'
  timeout_ms?: number|null
}
export type WebSearchQuery = StandaloneShareViaAccountAudienceConfig
export type StandaloneMonitorExtractWeeklyResultsInput = {
  monitor_id: number
}
export type StandaloneMonitorWeekResults = {
  week: string
  counts: StandaloneMonitorWeekResultCounts
}
export type StandaloneMonitorExtractWeeklyResults = {
  weekly_results: StandaloneMonitorWeekResults[]
}
export type StandaloneXConversationInput = {
  email?: string|null
  ad_account_id?: string|null
  keywords: string[][]
  exclude_keywords?: string[]|null
  start?: string|null
  end?: string|null
  skip_sentiments?: boolean
  skip_conversation_volume?: boolean
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
  alpha_2?: string
  input_type?: 'searchbar'|'advanced_settings'|'handle_analysis'|'audience_analysis'|'conversation_analysis'|'post_analysis'|'competitor_analysis'|'audience_builder'|'creator_analysis'
}
export type StandalonePostActivity = {
  end: string
  start: string
  tweet_count: number
}
export type StandaloneXConversation = {
  keywords: string[][]
  sentiments: StandaloneMonitorWeekResultCounts
  post_activity: StandalonePostActivity[]
  pa_const: number|null
  synonym_words: string[]
  audience_creator_query_id: number
  posts: DeepThoughtPost[]
}
export type StandAlonePostActivityInput = {
  keywords: string[][]
  start?: string|null
  end?: string|null
  alpha_2?: string
  pa_const?: number|null
}
export type StandAlonePostActivity = {
  post_activity: StandalonePostActivity[]
  count: number
}
export type StandAloneExploreSentimentAnalysisInput = {
  keywords: string[][]
}
export type StandAloneExploreSentimentAnalysis = {
  keywords: string[][]
  sentiments: StandaloneMonitorWeekResultCounts
}
export type StandAloneGenerateShareOfVoiceAliasesInput = {
  keyword: string
  locale?: 'en'|'ja'
}
export type StandAloneGenerateShareOfVoiceAliases = {
  aliases_keyword: string[]
}
export type StandAloneGenerateShareOfVoiceKeywordsInput = {
  keywords: string[][]
  alpha_2?: string
  locale?: 'en'|'ja'
}
export type StandAloneShareOfVoice = {
  name: string
  aliases: string[]
}
export type StandAloneGenerateShareOfVoiceKeywords = {
  share_of_voice_keywords: StandAloneShareOfVoice[]
}
export type GetTrendingTopicsQuery = GetXStatsQuery
export type StandaloneXploreDetailTrendsInput = {
  classifier_id: number
  country?: string|null
}
export type StandaloneXploreDetailTrends = {
  keywords_tweets: ChartData[]
  double_keywords_tweets: ChartData[]
  hashtags_tweets: ChartData[]
}
export type StandaloneXploreDetailInput = {
  classifier_id?: number
  country?: string
  order_top_accounts?: 'followers'|'connectivity'|'relevancy'
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
  classifier_name?: string
}
export type StandaloneXploreDetail = {
  classifier_id: number
  classifier_name: string
  children: ClassifierChild[]
  audience_size: number|null
  post_activity: StandalonePostActivity[]
  audience_regions: AudienceRegion[]
  parents: ClassifierChild[]
  subreddits: StandaloneSubreddits[]|null
  accounts: DeepThoughtAccount[]
  posts: DeepThoughtPost[]
}
export type StandAloneXplorePostsSentimentInput = {
  sentiment: string
  keywords: string[][]
}
export type StandAloneXplorePostsSentiment = {
  posts: DeepThoughtPost[]
}
export type StandAloneXplorePostsStartEndInput = {
  keywords: string[][]
  exclude_keywords?: string[]
  alpha_2?: string
  start: string
  end: string
  order_posts?: 'impression_count'|'like_count'|'retweet_count'|'reply_count'|'most_recent'|'oldest'|null
}
export type StandAloneXplorePostsStartEnd = StandAloneXplorePostsSentiment
export type StandaloneXploreInput = {
  search?: string
}
export type Account = {
  accountid: number
  handle: string
  pic: string
  connectivity: number
}
export type ClassifierResult = {
  classifier_id: number
  name: string
  accounts: Account[]
  audience_size: number|null
}
export type StandaloneXplore = {
  classifiers: ClassifierResult[]
}
export type GeoLocation = {
  country: string
}
export type HelperDocuments = {
  id: number
  description: string|null
  filename: any
  label: string|null
  created_at: string
  updated_at: string
}
export type GetDownloadQuery = {
  id?: string
  name?: string
}
export type HelperDocumentsDownload = StandaloneInsightsAnalyzerGenerateSheet
export type Icon = {
  id: number
  name: string
  icon_image: any|null
  icon_type: 'group'
  group_id: number|null
  neighbours: number[]
  type_code: number|null
}
export type IconNeighbours = {
  id: number
  name: string
  icon_image: any|null
  icon_type: 'group'
  group_id: number|null
  neighbours: Icon[]
  type_code: number|null
}
export type GetIconoGraphyListQuery = {
  search?: string
  id?: number
  child?: IconNeighbours
  parent?: IconNeighbours
}
export type Iconography = {
  id: number
  child: IconNeighbours|null
  parent: IconNeighbours
  order: number
}
export type GetIconoGraphyInstanceQuery = GetIconoGraphyListQuery
export type GetInsightsInfluencerListQuery = {
  limit?: number
  offset?: number
  search?: string
  ordering?: string
  account_id?: string
  handle: string
}
export type InsightsInfluencer = {
  id: number
  community_name: string|null
  account_id: string
  created: string
  modified: string
  handle: string
  influencer_data: object|null
  rank: number
  insights: number
}
export type GetInsightsInfluencerInstanceQuery = GetInsightsInfluencerListQuery
export type CreateInsightsPdfInput = CreateProTargetingPdfInput
export type CreateInsightsPdf = CreateCampaignPdf
export type JobTitle = ClassifierChild
export type MetricInfo = {
  key: string
  label: string
  description: string
  group: 'delivery'|'engagement'|'spend'|'video'|'website'|'conversions'|'other'
  networks: ('twitter'|'facebook'|'linkedin')[]
  objectives: string[]
  is_super_metric: boolean
  is_featured: boolean
  unit: 'none'|'percent'|'currency'
  aggregate: 'total'|'average'
  abm_phase: 'phase_1_video_views'|'phase_2_engagements'|'phase_3_traffic'|null
}
export type E2E = {
  e2estatus: string
}
export type TargetingCountries = {
  key: string
  name: string
}
export type TargetingInterests = TargetingCountries
export type TargetingLocations = {
  key: string
  name: string
  country_code: string
}
export type GetUserTeamListQuery = {
  ordering?: string
}
export type TeamInput = {
  name: string
  logo?: string|null
  website?: string|null
  invoice_name?: string
  vat_number?: string|null
  address?: string|null
  zip_code?: string|null
  city?: string|null
  country?: string|null
  phone?: string|null
  invoice_email?: string|null
}
export type Team = {
  id: number
  slug: string|null
  validate_email_domain: boolean
  feature_campaigns: boolean
  feature_superinsights: boolean
  region: number|null
  member_count: number
  subscriptions: Subscription[]
  accepted_terms_and_conditions: string|null
  name: string
  logo: string|null
  website: string|null
  invoice_name: string
  vat_number: string|null
  address: string|null
  zip_code: string|null
  city: string|null
  country: string|null
  phone: string|null
  invoice_email: string|null
}
export type GetUserTeamInstanceQuery = GetUserTeamListQuery
export type PatchUserTeamInstanceQuery = GetUserTeamListQuery
export type PutUserTeamInstanceQuery = GetUserTeamListQuery
export type AdAccount = {
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
  timezone: string|null
  default_page_id: string|null
  funding_instruments: any
  timezone_offset_hours_utc: any
  countries: any[]
  id: string
  default_funding_instrument: string|null
  pixels: object|null
  default_pixel_id: string|null
}
export type TeamInvite = {
  id: number
  team_name: string
  invite_url: string
  invited_email: string
  level: 'admin'|'member'
  message: string|null
  accepted_at: string|null
  updated_at: string
  created_at: string
  team: number
  user: number
  invited_user: number|null
}
export type TeamInviteInput = {
  invited_email: string
  level?: 'admin'|'member'
  message?: string|null
}
export type InviteAcceptInput = {
  code: string
}
export type InviteAccept = InviteAcceptInput
export type TeamUser = {
  id: number
  username: string
  first_name: string
  last_name: string
  email: string
  date_joined: string
  last_login: string|null
}
export type TeamMember = {
  user: TeamUser
  team: number
  level: 'admin'|'member'
  updated_at: string
  created_at: string
  accounts: string[]
}
export type UploadedAudiencesInput = {
  ad_account: string
  team: string
  configs_to_upload: number[]
}
export type UploadedAudiences = UploadedAudiencesInput
export type UserAdAccount = {
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
  id: string
}
export type FollowUnfollowInput = {
  insights_id: number
  account_ids: number[]
  is_followed?: boolean|null
}
export type FollowUnfollow = {
  is_followed: boolean|null
}
export type _GrantedAccount = {
  id: number
  account_id: string
  name: string|null
  network: 'facebook'|'twitter'|'linkedin'
}
export type GrantedAccount = {
  id: number
  account: _GrantedAccount
  updated_at: string
  member: number
}
export type _GrantedAccountInput = {
  account_id: string
  name?: string|null
  network: 'facebook'|'twitter'|'linkedin'
}
export type GrantedAccountInput = {
  account: _GrantedAccountInput
  member: number
}
export type TwitterList = {
  id: string|null
  name: string
  description: string|null
  private: boolean
}
export type TwitterListInput = {
  id?: string|null
  name: string
  description: string|null
  private?: boolean
}
export type TwitterListsMembersInput = {
  id?: string|null
  intent: 'create'|'destroy'
  members: number[]
}
export type TwitterListsMembers = {
  id: string|null
  intent: 'create'|'destroy'
  members: number[]
  message: string
}
export type CreateMagicLoginLinkInput = PrivateModelInput
export type UseMagicLoginLinkInput = {
  magic_code: string
  confirm_code: string
}
export type UseMagicLoginLink2 = StandaloneShareViaAccountAudienceConfig
export type SocialAccount = {
  id: number
  uid: string
  provider: string
  name: any
  last_login: string
  date_joined: string
}
export type Membership = {
  id: number
  level: 'admin'|'member'
  team: number
  team_name: string
}
export type Group = StandaloneClassifierAutocomplete
export type User = {
  id: number
  email: string
  first_name: string
  last_name: string
  social_accounts: SocialAccount[]
  memberships: Membership[]
  groups: Group[]
  token: string
  onboarding_completed_at: string|null
  language: 'en'|'ja'|null
  team_invite: any
  company: string|null
  job_title: string|null
}
export type SocialAccountInput = {
  uid: string
  provider: string
}
export type MembershipInput = {
  level: 'admin'|'member'
  team: number
  team_name: string
}
export type GroupInput = StandaloneClassifierAutocomplete
export type UserInput = {
  email?: string
  first_name?: string
  last_name?: string
  social_accounts?: SocialAccountInput[]
  memberships?: MembershipInput[]
  groups?: GroupInput[]
  onboarding_completed_at?: string|null
  language?: 'en'|'ja'|null
  company?: string|null
  job_title?: string|null
}
export type WebEvents = {
  name: string
  event_id: string
  tag_id: string
  status: string
  type: string
}
export type LoginViaTokenInput = {
  token: string
}
export type LoginViaToken = AffiliateApplyPartnerCode
export type SocialAccount2 = {
  id: number
  provider: string
  uid: string
  last_login: string
  date_joined: string
}
export type SocialConnectInput = {
  access_token?: string
  code?: string
  id_token?: string
}
export type SocialConnect = {
  access_token: string
  code: string
  id_token: string
}
export type TwitterLoginInput = {
  access_token: string
  token_secret: string
}
export type TwitterLogin = TwitterLoginInput
export type TwitterAccessToken = {
  access_token: string
  secret_token: string
  csrf_token: string
}
export type TwitterConnectInput = TwitterLoginInput
export type TwitterConnect = TwitterLoginInput
export type TwitterRequestToken = {
  oauth_token: string
}
export type MyLoginInput = SocialConnectInput
export type MyLogin = {
  access_token: string
  code: string
  id_token: string
  auth_token: string
  token: string
}
export type TwitterAuthParams = {
  code_challenge: string
  code_challenge_method: string
  csrf_token: string
}
export const apiErrorCodes = ["ADSETS_PARAMS_REQUIRED", "ADS_PARAMS_REQUIRED", "AD_ACCOUNT_IDS_INVALID", "AD_ACCOUNT_ID_REQUIRED", "AD_ACCOUNT_NOT_SELECTED", "AD_HAS_NO_VIDEO", "AD_SUGGESTIONS_IN_PROGRESS", "AD_SUGGESTIONS_NOT_ELIGIBLE", "ANSWER_QUERY_FAILED", "APPROVAL_ACTION_UNKNOWN", "APPROVAL_ORGANIC_ONLY", "APPROVAL_TIME_TOO_EARLY", "APPROVER_NOT_ALLOWED", "APPROVER_REQUIRED", "AUDIENCE_DESCRIPTION_TOO_VAGUE", "AUDIENCE_DESCRIPTION_UNREADABLE", "AUDIENCE_EDIT_NO_CHANGES", "AUDIENCE_EDIT_NO_TARGETING", "AUDIENCE_EDIT_PREVIEW_EXPIRED", "AUDIENCE_EDIT_PREVIEW_STALE", "AUDIENCE_NOT_FOUND", "AUDIENCE_PLATFORM_INVALID", "AUDIENCE_SUMMARY_FAILED", "AUTHORIZATION_CODE_REQUIRED", "BREAKDOWN_DIMENSION_UNSUPPORTED", "BREAKDOWN_PARAMS_REQUIRED", "CAMPAIGN_ALREADY_IN_GROUP", "CAMPAIGN_CONTENT_NOT_PUBLISHED", "CAMPAIGN_CREATE_FAILED", "CAMPAIGN_DRAFT_NOT_FOUND", "CAMPAIGN_GROUP_NOT_FOUND", "CAMPAIGN_LAUNCHED_COPY_MISSING", "CAMPAIGN_NOTHING_TO_DUPLICATE", "CAMPAIGN_NOTHING_TO_PUBLISH", "CAMPAIGN_NOT_DRAFT", "CAMPAIGN_NOT_FOUND", "CAMPAIGN_NOT_LAUNCHED", "CAMPAIGN_OPTIONS_FAILED", "CAMPAIGN_OPTIONS_PLATFORM_INVALID", "CAMPAIGN_PLATFORM_ALREADY_LAUNCHED", "CAMPAIGN_PLATFORM_INVALID", "CAMPAIGN_PLATFORM_NOT_ENABLED", "CAMPAIGN_UPDATE_FAILED", "CHATGPT_ACCOUNT_TEMPORARY_ERROR", "CHATGPT_ADS_APP_MISSING", "CHATGPT_API_KEY_INVALID", "CHATGPT_API_KEY_REQUIRED", "CHATGPT_CONNECT_FAILED", "COMPETITOR_AD_NOT_FOUND", "CONNECT_UNEXPECTED_ERROR", "CREATIVES_FAILED", "DASHBOARD_LAYOUT_INVALID", "DASHBOARD_WIDGET_DUPLICATE", "DAYS_PARAM_INVALID", "DIAGNOSTICS_CAPTURABLE", "DIAGNOSTICS_TEST_UNKNOWN", "DIAGNOSTICS_UNCAPTURABLE", "DISCOVER_SUMMARY_FAILED", "EMAIL_REQUIRED", "FACEBOOK_ACCESS_TOKEN_MISSING", "FACEBOOK_ACCOUNT_NOT_FOUND", "FACEBOOK_AUTHENTICATION_FAILED", "FACEBOOK_AUTH_PARAMS_FAILED", "FACEBOOK_NOT_CONFIGURED", "FACEBOOK_NOT_ON_POST", "FACEBOOK_PAGES_FAILED", "FACEBOOK_POST_DUE_CANNOT_CANCEL", "FACEBOOK_POST_DUE_CANNOT_RESCHEDULE", "FACEBOOK_PROFILE_FAILED", "FACEBOOK_SCHEDULE_FAILED", "FACEBOOK_USER_ID_MISSING", "FILES_REQUIRED", "FILE_REQUIRED", "FILE_STORE_FAILED", "GOOGLE_ADS_AUTH_PARAMS_FAILED", "GOOGLE_ADS_CONNECT_FAILED", "GOOGLE_ANALYTICS_NOT_CONNECTED", "GOOGLE_ANALYTICS_TOKEN_MISSING", "GOOGLE_AUTH_PARAMS_FAILED", "GOOGLE_CONNECT_FAILED", "GOOGLE_EMAIL_NOT_VERIFIED", "GOOGLE_SIGN_IN_FAILED", "GOOGLE_SIGN_IN_UNAVAILABLE", "INSTAGRAM_AUTHENTICATION_FAILED", "INSTAGRAM_AUTH_PARAMS_FAILED", "INSTAGRAM_NOT_CONFIGURED", "INSTAGRAM_PROFILE_FAILED", "INVALID_CAMPAIGN_ID", "INVALID_CREDENTIALS", "INVALID_PINTEREST_HANDLE", "INVALID_TOKEN", "INVITATION_NOT_FOUND", "JSON_OBJECT_REQUIRED", "LAT_LNG_REQUIRED", "LEAD_FORM_ASSET_TOO_LARGE", "LEAD_FORM_ASSET_TYPE_UNSUPPORTED", "LEAD_FORM_CREATE_FAILED", "LEAD_FORM_INVALID", "LIMIT_OFFSET_INVALID", "LINKEDIN_ACCESS_TOKEN_MISSING", "LINKEDIN_ACCOUNT_NOT_FOUND", "LINKEDIN_AUTHENTICATION_FAILED", "LINKEDIN_AUTH_PARAMS_FAILED", "LINKEDIN_COMMUNITY_ACCOUNT_NOT_FOUND", "LINKEDIN_COMMUNITY_NOT_CONFIGURED", "LINKEDIN_LEAD_FORM_PARAMS_REQUIRED", "LINKEDIN_NOT_CONFIGURED", "LINKEDIN_ORGANIZATIONS_FAILED", "LINKEDIN_ORGANIZATIONS_UNVERIFIED", "LINKEDIN_ORGANIZATION_NOT_SELECTED", "LINKEDIN_ORGANIZATION_REQUIRED", "LINKEDIN_PEOPLE_SEARCH_REFUSED", "LINKEDIN_PROFILE_FAILED", "LINKEDIN_PROFILE_LOOKUP_REFUSED", "LINKEDIN_PROFILE_NOT_FOUND", "LINKEDIN_PROFILE_URL_INVALID", "LINKEDIN_RATE_LIMITED", "LINKEDIN_USER_ID_MISSING", "MAILCHIMP_REPORTS_UNAVAILABLE", "MEDIA_GENERATION_FAILED", "MEDIA_STORE_FAILED", "MEDIA_UPLOAD_FAILED", "META_LEAD_FORM_PARAMS_REQUIRED", "META_NOT_CONNECTED", "META_RECONNECT_REQUIRED", "META_TARGETING_MISSING", "META_TARGETING_SEARCH_FAILED", "NOT_A_MEMBER", "NO_ACCOUNTS_FOUND", "NO_CHANGES_REQUESTED", "OAUTH_CLOCK_MISMATCH", "OAUTH_SESSION_EXPIRED", "OAUTH_TOKEN_AND_VERIFIER_REQUIRED", "OBJECTIVE_INVALID", "ORGANIC_SOURCE_META_ONLY", "OWNER_CANNOT_LEAVE", "PAGEVIEWS_PARAMS_REQUIRED", "PAGE_ID_REQUIRED", "PAYMENT_INFO_MANAGER_ONLY", "PERMISSION_MISSING", "PINTEREST_ADS_APP_MISSING", "PINTEREST_BOARDS_LOOKUP_FAILED", "PINTEREST_CODE_REQUIRED", "PINTEREST_CONNECT_FAILED", "PINTEREST_PROFILE_LOOKUP_FAILED", "PINTEREST_TOKEN_EXCHANGE_FAILED", "PINTEREST_USER_NOT_FOUND", "PLACE_LOOKUP_FAILED", "PLACE_NOT_FOUND", "PLATFORM_CANNOT_BE_SCHEDULED", "PLATFORM_NOT_CONNECTED", "PLATFORM_POST_NOT_FOUND", "PLATFORM_RATE_LIMITED", "PLATFORM_RECONNECT_REQUIRED", "PLATFORM_REJECTED", "PLATFORM_REQUEST_FAILED", "PLATFORM_REQUIRED", "POST_DELETE_FAILED", "POST_HAS_PLATFORMS", "POST_NOT_APPROVABLE", "POST_NOT_AWAITING_APPROVAL", "POST_NOT_FOUND", "POST_NOT_PUBLISHED", "POST_NOT_SCHEDULED", "POST_PUBLISH_FAILED", "PROMPT_OR_COMMENTS_REQUIRED", "PROPERTY_ID_REQUIRED", "PRO_TIER_SINGLE_SEAT", "PUBLISHED_POST_NOT_FOUND", "REDDIT_AUTH_PARAMS_FAILED", "REDDIT_CONNECT_FAILED", "REDDIT_NOT_CONFIGURED", "REDDIT_TOKEN_EXCHANGE_FAILED", "REDIRECT_URI_REQUIRED", "RESCHEDULE_FAILED", "RESEARCH_CATEGORY_INVALID", "RESEARCH_FILE_LIMIT_REACHED", "RESEARCH_SECTION_NOT_FOUND", "RESEARCH_UPLOAD_FAILED", "SCHEDULED_AT_INVALID", "SCHEDULED_AT_TOO_FAR", "SCHEDULED_AT_TOO_SOON", "SCHEDULED_POST_NOT_FOUND", "SCHEDULE_CANCEL_FAILED", "SCHEDULING_ORGANIC_ONLY", "SEARCH_HISTORY_NOT_FOUND", "SEARCH_QUERY_REQUIRED", "SERVER_CLOCK_AHEAD", "SHOPIFY_AUTH_PARAMS_FAILED", "SHOPIFY_CALLBACK_UNVERIFIED", "SHOPIFY_CONNECT_FAILED", "SHOPIFY_CONNECT_REJECTED", "SHOPIFY_NOT_CONFIGURED", "SHOPIFY_STORE_INVALID", "SHOPIFY_STORE_UNAVAILABLE", "SUBSCRIPTION_CANCEL_OWNER_ONLY", "SUBSCRIPTION_NOT_ACTIVE", "SUBSCRIPTION_NOT_CANCELLING", "SUBSCRIPTION_NOT_FOUND", "SUBSCRIPTION_RESUME_OWNER_ONLY", "TARGETING_FIELD_UNSUPPORTED", "TARGETING_LOOKUP_FAILED", "TARGETING_OPTIONS_FAILED", "TARGETING_OPTIONS_PARAMS_REQUIRED", "TARGETING_SIMILARITY_UNAVAILABLE", "TARGETING_TREE_FAILED", "TARGETING_TREE_PARAMS_REQUIRED", "TARGETING_TREE_REQUEST_INVALID", "TIER_PARAM_INVALID", "TIKTOK_ACCESS_TOKEN_MISSING", "TIKTOK_ADS_AUTH_PARAMS_FAILED", "TIKTOK_ADS_CONNECT_FAILED", "TIKTOK_ADS_CONNECT_REJECTED", "TIKTOK_ADS_NOT_CONFIGURED", "TIKTOK_USER_NOT_FOUND", "USER_NOT_FOUND", "VAT_REQUIRED", "VIDEO_EDIT_IN_PROGRESS", "VIDEO_EDIT_NOT_FINISHED", "VIDEO_EDIT_PROMPT_REQUIRED", "VIDEO_EDIT_TOO_MANY_IMAGES", "X_ADS_CONNECT_FAILED", "X_ADS_NOT_CONFIGURED", "X_ADS_REQUEST_TOKEN_FAILED", "X_AUTHENTICATION_FAILED", "X_CODE_CHALLENGE_FAILED", "X_CONNECT_FAILED", "X_NOT_CONFIGURED", "INTERNAL_ERROR"] as const
export const schema = {
  AccountApps: {
    list: {
      /** Account apps list */
      path: '/api/account-apps/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AccountApps[],
      errors: {} as never,
    },
  },
  AdCreatives: {
    list: {
      path: '/api/ad-creatives/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdCreative[],
      errors: {} as never,
    },
    create: {
      path: '/api/ad-creatives/',
      method: 'POST',
      paramsType: {} as {
        body: AdCreativeInput
      },
      responseType: {} as AdCreative,
      errors: {} as never,
    },
    destroy: {
      path: '/api/ad-creatives/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/ad-creatives/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/ad-creatives/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<AdCreativeInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as never,
    },
    update: {
      path: '/api/ad-creatives/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AdCreativeInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdCreative,
      errors: {} as never,
    },
  },
  AdMedia: {
    list: {
      path: '/api/ad-media/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdMedia[],
      errors: {} as never,
    },
    create: {
      path: '/api/ad-media/',
      method: 'POST',
      paramsType: {} as {
        body: AdMediaInput
      },
      responseType: {} as AdMedia,
      errors: {} as never,
    },
    destroy: {
      path: '/api/ad-media/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  Ad: {
    destroy: {
      path: '/api/ads/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
    toggle: {
      path: '/api/ads/{pk}/toggle/',
      method: 'POST',
      paramsType: {} as {
        body: {}
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  AdSet: {
    list: {
      path: '/api/adsets/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdSetListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Adset[]
      },
      errors: {} as never,
    },
    create: {
      path: '/api/adsets/',
      method: 'POST',
      paramsType: {} as {
        body: AdsetInput
      },
      responseType: {} as Adset,
      errors: {} as never,
    },
    destroy: {
      path: '/api/adsets/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteAdSetInstanceQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/adsets/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAdSetInstanceQuery
      },
      responseType: {} as Adset,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/adsets/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<WriteTwitterAdsetInput>
        path: {
          pk: string|number
        }
        query?: PatchAdSetInstanceQuery
      },
      responseType: {} as WriteTwitterAdset,
      errors: {} as never,
    },
    update: {
      path: '/api/adsets/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: WriteTwitterAdsetInput
        path: {
          pk: string|number
        }
        query?: PutAdSetInstanceQuery
      },
      responseType: {} as WriteTwitterAdset,
      errors: {} as never,
    },
  },
  AdvertiserBusinessCategories: {
    list: {
      /** Account advertiser business categories list */
      path: '/api/advertiser-categories/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AdvertiserBusinessCategories[],
      errors: {} as never,
    },
  },
  FileUploadCompleteHandler: {
    post: {
      path: '/api/api/files/complete/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  FilePolicyAPI: {
    post: {
      /** This view is to get the AWS Upload Policy for our s3 bucket.
      What we do here is first create a FileItem object instance in our
      Django backend. This is to include the FileItem instance in the path
      we will use within our bucket as you'll see below. */
      path: '/api/api/files/policy/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  AppEvents: {
    list: {
      /** Account app events list */
      path: '/api/app-events/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AppEvents[],
      errors: {} as never,
    },
  },
  AudienceCategory: {
    list: {
      path: '/api/audience-categories/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceCategoryListQuery
      },
      responseType: {} as AudienceCategory[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/audience-categories/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceCategoryInstanceQuery
      },
      responseType: {} as AudienceCategory,
      errors: {} as never,
    },
  },
  AudienceConfig: {
    list: {
      path: '/api/audience-configs/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceConfigListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AudienceConfig[]
      },
      errors: {} as never,
    },
    create: {
      path: '/api/audience-configs/',
      method: 'POST',
      paramsType: {} as {
        body: AudienceConfigInput
      },
      responseType: {} as AudienceConfig,
      errors: {} as never,
    },
    autocomplete: {
      path: '/api/audience-configs/autocomplete/',
      method: 'POST',
      paramsType: {} as {
        body: AutoCompleteInput
      },
      responseType: {} as AutoComplete,
      errors: {} as never,
    },
    insights: {
      path: '/api/audience-configs/insights/',
      method: 'POST',
      paramsType: {} as {
        body: AudienceConfigInput
      },
      responseType: {} as AudienceConfig,
      errors: {} as never,
    },
    perspectives: {
      path: '/api/audience-configs/perspectives/',
      method: 'POST',
      paramsType: {} as {
        body: SearchPerspectivesInput
      },
      responseType: {} as SearchPerspectives,
      errors: {} as never,
    },
    retrieve: {
      path: '/api/audience-configs/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceConfigInstanceQuery
      },
      responseType: {} as AudienceConfigDetail,
      errors: {} as never,
    },
    update: {
      path: '/api/audience-configs/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AudienceConfigInput
        path: {
          pk: string|number
        }
        query?: PutAudienceConfigInstanceQuery
      },
      responseType: {} as AudienceConfig,
      errors: {} as never,
    },
  },
  Insights: {
    retrieve: {
      path: '/api/audience-insight/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as never,
    },
  },
  AudienceInsights: {
    by_config: {
      path: '/api/audience-insights/{pk}/by_config/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as never,
    },
  },
  AudiencePlan: {
    list: {
      path: '/api/audience-plan/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudiencePlan[],
      errors: {} as never,
    },
    create: {
      path: '/api/audience-plan/',
      method: 'POST',
      paramsType: {} as {
        body: AudiencePlanInput
      },
      responseType: {} as AudiencePlan,
      errors: {} as never,
    },
    destroy: {
      path: '/api/audience-plan/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/audience-plan/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/audience-plan/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<AudiencePlanInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as never,
    },
    update: {
      path: '/api/audience-plan/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: AudiencePlanInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePlan,
      errors: {} as never,
    },
  },
  AudienceRegion: {
    list: {
      path: '/api/audience-regions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudienceRegion[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/audience-regions/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudienceRegion,
      errors: {} as never,
    },
  },
  Audience: {
    list: {
      path: '/api/audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Audience[]
      },
      errors: {} as never,
    },
    retrieve: {
      path: '/api/audiences/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudienceInstanceQuery
      },
      responseType: {} as Audience,
      errors: {} as never,
    },
  },
  BuildAudience: {
    create: {
      path: '/api/build-audience/',
      method: 'POST',
      paramsType: {} as {
        body: BuildAudienceInput
      },
      responseType: {} as BuildAudience,
      errors: {} as never,
    },
  },
  CampaignSummaryPDF: {
    create: {
      path: '/api/campaign-summary-pdf/',
      method: 'POST',
      paramsType: {} as {
        body: CreateCampaignPdfInput
      },
      responseType: {} as CreateCampaignPdf,
      errors: {} as never,
    },
  },
  Campaign: {
    list: {
      path: '/api/campaigns/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCampaignListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: CampaignListItem[]
      },
      errors: {} as never,
    },
    create: {
      path: '/api/campaigns/',
      method: 'POST',
      paramsType: {} as {
        body: WriteTwitterCampaignInput
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as never,
    },
    ads: {
      path: '/api/campaigns/ads/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdListItem[]
      },
      errors: {} as never,
    },
    adsets: {
      path: '/api/campaigns/adsets/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAdsetsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdsetListItem[]
      },
      errors: {} as never,
    },
    reach: {
      path: '/api/campaigns/reach/',
      method: 'GET',
      paramsType: {} as {
        query?: GetReachQuery
      },
      responseType: {} as ReachStats,
      errors: {} as never,
    },
    segmentations: {
      path: '/api/campaigns/segmentations/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSegmentationsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SegmentationListItem[]
      },
      errors: {} as never,
    },
    statstotal: {
      path: '/api/campaigns/statstotal/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStatstotalQuery
      },
      responseType: {} as StatsTotal,
      errors: {} as never,
    },
    destroy: {
      path: '/api/campaigns/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteCampaignInstanceQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/campaigns/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignInstanceQuery
      },
      responseType: {} as Campaign,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/campaigns/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<WriteTwitterCampaignInput>
        path: {
          pk: string|number
        }
        query?: PatchCampaignInstanceQuery
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as never,
    },
    update: {
      path: '/api/campaigns/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: WriteTwitterCampaignInput
        path: {
          pk: string|number
        }
        query?: PutCampaignInstanceQuery
      },
      responseType: {} as WriteTwitterCampaign,
      errors: {} as never,
    },
  },
  Communities: {
    list: {
      path: '/api/communities/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCommunitiesListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AudienceCommunity[]
      },
      errors: {} as never,
    },
    retrieve: {
      path: '/api/communities/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCommunitiesInstanceQuery
      },
      responseType: {} as AudienceCommunity,
      errors: {} as never,
    },
  },
  Community: {
    list: {
      path: '/api/community/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCommunityListQuery
      },
      responseType: {} as Community[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/community/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCommunityInstanceQuery
      },
      responseType: {} as Community,
      errors: {} as never,
    },
  },
  ContentCategories: {
    list: {
      /** Account content categories list */
      path: '/api/content-categories/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as ContentCategories[],
      errors: {} as never,
    },
  },
  Subscription: {
    cancel: {
      path: '/api/customer/subscriptions/cancel/',
      method: 'POST',
      paramsType: {} as {
        body: CancellationInput
      },
      responseType: {} as Cancellation,
      errors: {} as never,
    },
    checkout: {
      path: '/api/customer/subscriptions/checkout/',
      method: 'POST',
      paramsType: {} as {
        body: CheckoutInput
      },
      responseType: {} as Checkout,
      errors: {} as never,
    },
    public_key: {
      path: '/api/customer/subscriptions/public_key/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as Subscription,
      errors: {} as never,
    },
    upgrade: {
      path: '/api/customer/subscriptions/upgrade/',
      method: 'POST',
      paramsType: {} as {
        body: UpgradeInput
      },
      responseType: {} as Upgrade,
      errors: {} as never,
    },
  },
  ExploreX: {
    create: {
      path: '/api/explore-x/',
      method: 'POST',
      paramsType: {} as {
        body: ExploreXInput
      },
      responseType: {} as ExploreX,
      errors: {} as never,
    },
  },
  StandaloneAdAccount: {
    list: {
      path: '/api/external/ad-account/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAdAccountListQuery
      },
      responseType: {} as StandaloneAdAccount[],
      errors: {} as never,
    },
    create: {
      path: '/api/external/ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAdAccountInput
      },
      responseType: {} as StandaloneAdAccount,
      errors: {} as never,
    },
    create_audiences_ad_account: {
      path: '/api/external/ad-account/create-audiences-ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceAdAccountInput
      },
      responseType: {} as StandaloneAudienceAdAccount,
      errors: {} as never,
    },
    funding_instruments: {
      path: '/api/external/ad-account/funding-instruments/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAdAccountFundingSourcesInput
      },
      responseType: {} as StandaloneAdAccountFundingSources,
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/ad-account/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAdAccountInstanceQuery
      },
      responseType: {} as StandaloneAdAccount,
      errors: {} as never,
    },
  },
  StandaloneDescriptionAnalyzer: {
    create: {
      path: '/api/external/analyse-description/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneDescriptionAnalyzerInput
      },
      responseType: {} as StandaloneDescriptionAnalyzer,
      errors: {} as "Brand safety",
    },
  },
  analyze_campaign_creator: {
    post: {
      path: '/api/external/analyze-campaign-creator/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  analyze_chat_query: {
    post: {
      path: '/api/external/analyze-chat-query/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  StandaloneInsightsAnalyzer: {
    create: {
      /** Standalone create for insights */
      path: '/api/external/analyze-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerInput
      },
      responseType: {} as StandaloneInsightsAnalyzer,
      errors: {} as never,
    },
    accounts_for_keywords: {
      /** Standalone accounts for keywords for insights */
      path: '/api/external/analyze-handles/accounts-for-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerKeywordAccountsInput
      },
      responseType: {} as StandaloneInsightsAnalyzerKeywordAccounts,
      errors: {} as never,
    },
    create_sheet: {
      /** Standalone create sheet for insights */
      path: '/api/external/analyze-handles/create-sheet/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInsightsAnalyzerGenerateSheetInput
      },
      responseType: {} as StandaloneInsightsAnalyzerGenerateSheet,
      errors: {} as never,
    },
  },
  StandaloneExploreQueryAnalyzer: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/analyze-query/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreQueryAnalyzerInput
      },
      responseType: {} as StandaloneExploreQueryAnalyzer,
      errors: {} as "Too many requests. Please try again later.",
    },
    create_post: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-query-analyzer/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreQueryAnalyzerInput
      },
      responseType: {} as StandaloneExploreQueryAnalyzer,
      errors: {} as "Too many requests. Please try again later.",
    },
  },
  analyze_topic_posts_sentiments_replies: {
    list: {
      path: '/api/external/analyze-topic-posts-sentiments-replies/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
  },
  analyze_topic_posts_sentiments: {
    list: {
      path: '/api/external/analyze-topic-posts-sentiments/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
  },
  analyze_topic_posts: {
    list: {
      path: '/api/external/analyze-topic-posts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
  },
  ApexAuthoritiesWithGrowth: {
    query: {
      /** Return the Apex index query */
      path: '/api/external/apex-authorities-with-growth/query/',
      method: 'POST',
      paramsType: {} as {
        body: ApexAuthoritiesWithGrowthInput
      },
      responseType: {} as ApexAuthoritiesWithGrowth,
      errors: {} as never,
    },
  },
  ApexAuthorityStats: {
    query: {
      /** Return engagement rate and follower signal growth for an SDU authority */
      path: '/api/external/apex-authority-stats/query/',
      method: 'POST',
      paramsType: {} as {
        body: ApexAuthorityStatsInput
      },
      responseType: {} as ApexAuthorityStats,
      errors: {} as never,
    },
  },
  ApexSduSummary: {
    query: {
      /** Summarise the recent public content of an SDU authority via LLM */
      path: '/api/external/apex-sdu-summary/query/',
      method: 'POST',
      paramsType: {} as {
        body: ApexSduSummaryInput
      },
      responseType: {} as ApexSduSummary,
      errors: {} as never,
    },
  },
  proxy_event_stream: {
    list: {
      path: '/api/external/api/proxy-event-stream/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as "This endpoint is currently paused.",
    },
  },
  StandaloneAudienceBuilder: {
    list: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceBuilderListQuery
      },
      responseType: {} as AudienceBuilder[],
      errors: {} as never,
    },
    create: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderInput
      },
      responseType: {} as StandaloneAudienceBuilder,
      errors: {} as never,
    },
    followers_of: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/followers-of/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderFollowersOfInput
      },
      responseType: {} as StandaloneAudienceBuilderFollowersOf,
      errors: {} as never,
    },
    generate_insights: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/generate-insights/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderGenerateInsightsInput
      },
      responseType: {} as StandaloneAudienceBuilderGenerateInsights,
      errors: {} as never,
    },
    interested_in: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/interested-in/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderInterestedInInput
      },
      responseType: {} as StandaloneAudienceBuilderInterestedIn,
      errors: {} as never,
    },
    posted_abount: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/posted-about/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderPostedAboutInput
      },
      responseType: {} as StandaloneAudienceBuilderPostedAbout,
      errors: {} as never,
    },
    suggest_interests: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/suggest-interests/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderSuggestInterestsInput
      },
      responseType: {} as StandaloneAudienceBuilderSuggestInterests,
      errors: {} as never,
    },
    words_in_profile: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/words-in-profile/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceBuilderWordsInProfileInput
      },
      responseType: {} as StandaloneAudienceBuilderWordsInProfile,
      errors: {} as never,
    },
    destroy: {
      /** Standalone audience builder */
      path: '/api/external/audience-builder/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteStandaloneAudienceBuilderInstanceQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  StandaloneAudienceCategory: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-categories/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceCategoryListQuery
      },
      responseType: {} as AudienceCategory[],
      errors: {} as never,
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-categories/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceCategoryInstanceQuery
      },
      responseType: {} as AudienceCategory,
      errors: {} as never,
    },
  },
  StandaloneAudienceConfig: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceConfigListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: StandaloneAudienceConfig[]
      },
      errors: {} as never,
    },
    create: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as never,
    },
    autocomplete: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/autocomplete/',
      method: 'POST',
      paramsType: {} as {
        body: AutoCompleteInput
      },
      responseType: {} as AutoComplete,
      errors: {} as never,
    },
    insights: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/insights/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as never,
    },
    perspectives: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/perspectives/',
      method: 'POST',
      paramsType: {} as {
        body: SearchPerspectivesInput
      },
      responseType: {} as SearchPerspectives,
      errors: {} as never,
    },
    share_via_account: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/share-via-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareViaAccountAudienceConfigInput
      },
      responseType: {} as StandaloneShareViaAccountAudienceConfig,
      errors: {} as never,
    },
    share: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/share/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareAudienceConfigInput
      },
      responseType: {} as StandaloneShareAudienceConfig,
      errors: {} as never,
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceConfigInstanceQuery
      },
      responseType: {} as StandaloneAudienceConfigDetail,
      errors: {} as never,
    },
    update: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneAudienceConfigInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneAudienceConfigInstanceQuery
      },
      responseType: {} as StandaloneAudienceConfig,
      errors: {} as never,
    },
    download_targeting_package: {
      /** Standalone view for audiences */
      path: '/api/external/audience-configs/{pk}/download_targeting_package/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetDownloadTargetingPackageQuery
      },
      responseType: {} as StandaloneDownloadTargetingPackage,
      errors: {} as never,
    },
  },
  StandaloneAudienceRegion: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audience-regions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AudienceRegion[],
      errors: {} as never,
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audience-regions/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudienceRegion,
      errors: {} as never,
    },
  },
  StandaloneAudienceRequest: {
    create: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceRequestInput
      },
      responseType: {} as StandaloneAudienceRequest,
      errors: {} as never,
    },
    feedback: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/feedback/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFeedbackInput
      },
      responseType: {} as StandaloneFeedback,
      errors: {} as never,
    },
    reddit: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/reddit/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceRequestRedditInput
      },
      responseType: {} as StandaloneAudienceRequestReddit,
      errors: {} as never,
    },
    similar_handles: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/similar-handles/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSimilarHandlesQuery
      },
      responseType: {} as StandaloneSimilarHandles,
      errors: {} as never,
    },
    validate_ad_account: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-ad-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCheckAdAccountAccessInput
      },
      responseType: {} as StandaloneCheckAdAccountAccess,
      errors: {} as never,
    },
    validate_email: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-email/',
      method: 'POST',
      paramsType: {} as {
        body: PrivateModelInput
      },
      responseType: {} as PrivateModel,
      errors: {} as never,
    },
    validate_handle: {
      /** Standalone create for audience requests */
      path: '/api/external/audience-request/validate-handle/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneHandleInput
      },
      responseType: {} as StandaloneHandle,
      errors: {} as never,
    },
  },
  StandaloneAudienceUsedInAds: {
    list: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceUsedInAdsListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: StandaloneAudienceUsedInAds[]
      },
      errors: {} as never,
    },
    create: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneDetailAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as "No email found",
    },
    autopilot_suggested_budget: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-suggested-budget/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotSuggestedBudgetQuery
      },
      responseType: {} as StandaloneAutopilotSuggestedBudget,
      errors: {} as never,
    },
    autopilot_usage_allowed: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-usage-allowed/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotUsageAllowedQuery
      },
      responseType: {} as StandaloneAutopilotUsageAllowedAudienceUsedInAds,
      errors: {} as never,
    },
    autopilot_usage: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/autopilot-usage/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAutopilotUsageQuery
      },
      responseType: {} as StandaloneAutopilotUsageAudienceUsedInAds,
      errors: {} as never,
    },
    generate_sheet: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/generate-sheet/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudienceUsedInAdsGenerateSheetInput
      },
      responseType: {} as StandaloneAudienceUsedInAdsGenerateSheet,
      errors: {} as "A sheet can not be generated as this audience is not associated with an audience created by Socialdatabase.",
    },
    reorder_handles: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/reorder-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneReorderHandlesAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneReorderHandlesAudienceUsedInAds,
      errors: {} as never,
    },
    share_via_account: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/share-via-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareViaAccountAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneShareViaAccountAudienceUsedInAds,
      errors: {} as never,
    },
    share: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/share/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneShareAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneShareAudienceUsedInAds,
      errors: {} as never,
    },
    shared_with: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/shared-with/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSharedAudienceUsedInAdsInput
      },
      responseType: {} as StandaloneSharedAudienceUsedInAds,
      errors: {} as never,
    },
    verify_signed: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/verify-signed/',
      method: 'GET',
      paramsType: {} as {
        query?: GetVerifySignedQuery
      },
      responseType: {} as StandaloneAudienceUsedInAds,
      errors: {} as never,
    },
    destroy: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as never,
    },
    partial_update: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneDetailAudienceUsedInAdsInput>
        path: {
          pk: string|number
        }
        query?: PatchStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as never,
    },
    update: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneDetailAudienceUsedInAdsInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneAudienceUsedInAdsInstanceQuery
      },
      responseType: {} as StandaloneDetailAudienceUsedInAds,
      errors: {} as never,
    },
    restore: {
      /** Standalone viewset for audiences used in ads */
      path: '/api/external/audience-usages/{pk}/restore/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneAudienceUsedInAdsInput>
        path: {
          pk: string|number
        }
        query?: PatchRestoreQuery
      },
      responseType: {} as StandaloneAudienceUsedInAds,
      errors: {} as never,
    },
  },
  StandaloneInsights: {
    retrieve: {
      /** Standalone view for insights */
      path: '/api/external/audiences-insights/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Insights,
      errors: {} as never,
    },
  },
  StandaloneProTargetingSummaryPDF: {
    create: {
      path: '/api/external/audiences-pro-targeting-summary/',
      method: 'POST',
      paramsType: {} as {
        body: CreateProTargetingPdfInput
      },
      responseType: {} as CreateProTargetingPdf,
      errors: {} as never,
    },
  },
  StandaloneAudience: {
    list: {
      /** Standalone view for audiences */
      path: '/api/external/audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneAudienceListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: Audience[]
      },
      errors: {} as never,
    },
    retrieve: {
      /** Standalone view for audiences */
      path: '/api/external/audiences/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneAudienceInstanceQuery
      },
      responseType: {} as Audience,
      errors: {} as never,
    },
  },
  AuthorityIndexPeers: {
    peers: {
      /** Find peers in the authority index via the dock get_peers endpoint. */
      path: '/api/external/authority-index-peers/peers/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AuthorityIndexPeers,
      errors: {} as never,
    },
  },
  AuthorityIndexSearch: {
    search: {
      /** Search the authority index via the dock search_authority_index endpoint. */
      path: '/api/external/authority-index-search/search/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as AuthorityIndexSearch,
      errors: {} as never,
    },
  },
  AuthorityIndexV2: {
    query: {
      /** Accounts matching a keyword set, ranked by the authority index (dock v2).
      The account-first counterpart to ContentAuthoritiesViewSet: that one matches post text and tells
      you who wrote it, this one ranks accounts and returns their topics. One dock call. */
      path: '/api/external/authority-index-v2/query/',
      method: 'POST',
      paramsType: {} as {
        body: AuthorityIndexV2QueryInput
      },
      responseType: {} as AuthorityIndexV2Query,
      errors: {} as never,
    },
  },
  AuthoritySearch: {
    query: {
      /** Accounts matching a keyword set — sdu, name, bio, reach, main platform/handle, authority
      score and topics.
      Leaner than AuthorityIndexV2ViewSet: no ordering, a flat `topics` list instead of v2's parallel
      topics/scores arrays, and `keywords_all` entries may each be a list of alternatives. Filters on
      countries (alpha-2) and/or locations (free text). One dock call. */
      path: '/api/external/authority-search/query/',
      method: 'POST',
      paramsType: {} as {
        body: AuthoritySearchQueryInput
      },
      responseType: {} as AuthoritySearchQuery,
      errors: {} as never,
    },
  },
  BigDipper: {
    accept_invitation: {
      /** Accept a BigDipper team invitation. */
      path: '/api/external/bigdipper/accept-invitation/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamAcceptInput
      },
      responseType: {} as BigDipperTeamAccept,
      errors: {} as never,
    },
    analyze_query: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-analyze-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyzeQueryQuery
      },
      responseType: {} as StandaloneAmygdalaAnalyzeQuery,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    answer_query: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-answer-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnswerQueryQuery
      },
      responseType: {} as {},
      errors: {} as "ANSWER_QUERY_FAILED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    discover_summary_stream: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover-summary-stream/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDiscoverSummaryStreamQuery
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"DISCOVER_SUMMARY_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    discover_topics: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover-topics/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneAmygdalaDiscoverTopics,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    discover: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-discover/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDiscoverQuery
      },
      responseType: {} as StandaloneAmygdalaDiscover,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    entity_detail: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-entity-detail/',
      method: 'GET',
      paramsType: {} as {
        query?: GetEntityDetailQuery
      },
      responseType: {} as StandaloneAmygdalaEntityDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    generate_context: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-generate-context/',
      method: 'GET',
      paramsType: {} as {
        query?: GetGenerateContextQuery
      },
      responseType: {} as StandaloneAmygdalaGenerateContext,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    amygdala_search: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-search/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAmygdalaSearchQuery
      },
      responseType: {} as StandaloneAmygdalaSearch,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    sentiment_analysis: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/amygdala-sentiment-analysis/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSentimentAnalysisQuery
      },
      responseType: {} as StandaloneAmygdalaSentimentAnalysis,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    user_search_summary: {
      /** Updates a search with the generated summary. */
      path: '/api/external/bigdipper/amygdala-user-search-summary/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAmygdalaUserSearchSummaryInput
      },
      responseType: {} as StandaloneAmygdalaUserSearchSummary,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    user_session_searches: {
      /** Get all searches for a given session_id, ordered by recency (latest first). */
      path: '/api/external/bigdipper/amygdala-user-session-searches/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserSessionSearchesQuery
      },
      responseType: {} as StandaloneAmygdalaUserSessionSearches[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    user_sessions: {
      /** Get all sessions for a user/email, ordered by recency (latest first). */
      path: '/api/external/bigdipper/amygdala-user-sessions/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserSessionsQuery
      },
      responseType: {} as StandaloneAmygdalaUserSessions[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"Either parameter 'email' or logged in user is required"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    analyze_prompt: {
      /** Analyze a given prompt and return the analyzed keywords */
      path: '/api/external/bigdipper/analyze-query/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyzePromptQuery
      },
      responseType: {} as StandaloneAnalyzeQuery,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_insights: {
      /** Audience insights for bigdipper. */
      path: '/api/external/bigdipper/audience-insights/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAudienceInsightsQuery
      },
      responseType: {} as StandaloneAudienceInsights,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    classifier_autocomplete: {
      /** Returns classifiers for typeahead/autocomplete. */
      path: '/api/external/bigdipper/classifier-autocomplete/',
      method: 'GET',
      paramsType: {} as {
        query?: GetClassifierAutocompleteQuery
      },
      responseType: {} as StandaloneClassifierAutocomplete[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    countries: {
      /** Countries for bigdipper. */
      path: '/api/external/bigdipper/countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as BigDipperAudienceRegion[],
      errors: {} as never,
    },
    create_magic_login_link: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/create-magic-login-link/',
      method: 'GET',
      paramsType: {} as {
        query?: GetCreateMagicLoginLinkQuery
      },
      responseType: {} as StandaloneCreateMagicLoginLink,
      errors: {} as "EMAIL_REQUIRED",
    },
    create_team: {
      /** Create a new BigDipper team. */
      path: '/api/external/bigdipper/create-team/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCreateTeamInput
      },
      responseType: {} as StandaloneCreateTeam,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    expert_categories: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/expert-categories/',
      method: 'GET',
      paramsType: {} as {
        query?: GetExpertCategoriesQuery
      },
      responseType: {} as StandaloneExpertCategories,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    facebook_auth_params: {
      /** Get Facebook OAuth2 parameters for the authorization flow.
      Frontend calls this first to get the auth URL parameters. */
      path: '/api/external/bigdipper/facebook-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFacebookAuthParamsQuery
      },
      responseType: {} as FacebookAuthParams,
      errors: {} as "FACEBOOK_AUTH_PARAMS_FAILED"|"FACEBOOK_NOT_CONFIGURED",
    },
    google_ads_auth_params: {
      /** Generate Google OAuth2 authorization parameters for the Google Ads connector.
      Returns client_id, authorize_url, scope and redirect_uri for the frontend. */
      path: '/api/external/bigdipper/google-ads-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetGoogleAdsAuthParamsQuery
      },
      responseType: {} as GoogleAdsAuthParams,
      errors: {} as "GOOGLE_ADS_AUTH_PARAMS_FAILED",
    },
    google_auth_params: {
      /** Generate Google OAuth2 authorization parameters for frontend.
      Returns client_id, authorize_url, scope, redirect_uri, state, etc. */
      path: '/api/external/bigdipper/google-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetGoogleAuthParamsQuery
      },
      responseType: {} as GoogleAuthParams,
      errors: {} as "GOOGLE_AUTH_PARAMS_FAILED",
    },
    google_sign_in_params: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/google-sign-in-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetGoogleSignInParamsQuery
      },
      responseType: {} as GoogleSignInParams,
      errors: {} as "GOOGLE_SIGN_IN_UNAVAILABLE"|"REDIRECT_URI_REQUIRED",
    },
    google_sign_in: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/google-sign-in/',
      method: 'POST',
      paramsType: {} as {
        body: GoogleSignInInput
      },
      responseType: {} as GoogleSignIn,
      errors: {} as "GOOGLE_EMAIL_NOT_VERIFIED"|"GOOGLE_SIGN_IN_FAILED"|"GOOGLE_SIGN_IN_UNAVAILABLE",
    },
    instagram_auth_params: {
      /** Get Instagram OAuth parameters for initiating the official Instagram Business Login flow.
      This is the dedicated Instagram-only OAuth (not Facebook Login), so it lets users
      connect Instagram Business/Creator accounts that are not linked to a Facebook account. */
      path: '/api/external/bigdipper/instagram-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetInstagramAuthParamsQuery
      },
      responseType: {} as InstagramAuthParams,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"INSTAGRAM_AUTH_PARAMS_FAILED"|"INSTAGRAM_NOT_CONFIGURED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    journey_email_subscription: {
      /** Read or change a user's journey email subscription with the signed token from an email link. */
      path: '/api/external/bigdipper/journey-email-subscription/',
      method: 'GET',
      paramsType: {} as {
        query?: GetJourneyEmailSubscriptionQuery
      },
      responseType: {} as BigDipperJourneyEmailSubscription,
      errors: {} as "INVALID_TOKEN",
    },
    journey_email_subscription_patch: {
      /** Read or change a user's journey email subscription with the signed token from an email link. */
      path: '/api/external/bigdipper/journey-email-subscription/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<BigDipperJourneyEmailSubscriptionInput>
        query?: PatchJourneyEmailSubscriptionQuery
      },
      responseType: {} as BigDipperJourneyEmailSubscription,
      errors: {} as "INVALID_TOKEN",
    },
    journey_email_subscription_post: {
      /** Read or change a user's journey email subscription with the signed token from an email link. */
      path: '/api/external/bigdipper/journey-email-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperJourneyEmailSubscriptionInput
      },
      responseType: {} as BigDipperJourneyEmailSubscription,
      errors: {} as "INVALID_TOKEN",
    },
    keywords_hashtags: {
      /** Audience insights for bigdipper. */
      path: '/api/external/bigdipper/keywords-hashtags/',
      method: 'GET',
      paramsType: {} as {
        query?: GetKeywordsHashtagsQuery
      },
      responseType: {} as StandAloneKeywordsHashtags,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_auth_params: {
      /** Get LinkedIn OAuth2 parameters for the authorization flow. */
      path: '/api/external/bigdipper/linkedin-auth-params/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as LinkedInAuthParams,
      errors: {} as "LINKEDIN_AUTH_PARAMS_FAILED"|"LINKEDIN_NOT_CONFIGURED",
    },
    linkedin_community_auth_params: {
      /** OAuth2 parameters for the LinkedIn Community Management app (Social Listening). */
      path: '/api/external/bigdipper/linkedin-community-auth-params/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as LinkedInAuthParams,
      errors: {} as "LINKEDIN_AUTH_PARAMS_FAILED"|"LINKEDIN_NOT_CONFIGURED",
    },
    me: {
      /** Retreive the personal data of the logged in user. */
      path: '/api/external/bigdipper/me/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneUser,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"USER_NOT_FOUND",
    },
    notifications_unread_counts: {
      /** Per-team unread notification counts across every team the user belongs to. */
      path: '/api/external/bigdipper/notifications-unread-counts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as BigDipperNotificationUnreadCount[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    pinterest_ads_auth_params: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/pinterest-ads-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPinterestAdsAuthParamsQuery
      },
      responseType: {} as PinterestAdsAuthParams,
      errors: {} as "PINTEREST_ADS_APP_MISSING",
    },
    pinterest_profile: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/pinterest-profile/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPinterestProfileQuery
      },
      responseType: {} as BigDipperPinterestProfile,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PINTEREST_PROFILE_LOOKUP_FAILED"|"Team subscription is not active",
    },
    place_autocomplete: {
      /** Proxy Google Places Autocomplete for map location targeting. Returns a list of place suggestions. */
      path: '/api/external/bigdipper/place-autocomplete/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPlaceAutocompleteQuery
      },
      responseType: {} as GooglePlaceAutocomplete[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PLACE_LOOKUP_FAILED"|"Team subscription is not active",
    },
    place_details: {
      /** Proxy Google Place Details to resolve a place_id to coordinates for map location targeting. */
      path: '/api/external/bigdipper/place-details/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPlaceDetailsQuery
      },
      responseType: {} as GooglePlaceDetails,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PLACE_LOOKUP_FAILED"|"PLACE_NOT_FOUND"|"Team subscription is not active",
    },
    place_reverse_geocode: {
      /** Proxy Google reverse geocoding to resolve coordinates to the nearest place name for map location targeting. */
      path: '/api/external/bigdipper/place-reverse-geocode/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPlaceReverseGeocodeQuery
      },
      responseType: {} as GooglePlaceDetails,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LAT_LNG_REQUIRED"|"NOT_A_MEMBER"|"PLACE_LOOKUP_FAILED"|"Team subscription is not active",
    },
    platform_media_specs: {
      /** Return the platform media specifications for image publishing. */
      path: '/api/external/bigdipper/platform-media-specs/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as PlatformMediaSpecs,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    reddit_auth_params: {
      /** Generate Reddit OAuth2 authorization parameters for the Reddit Ads connector.
      Returns client_id, authorize_url, scope, duration and redirect_uri for the frontend. */
      path: '/api/external/bigdipper/reddit-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetRedditAuthParamsQuery
      },
      responseType: {} as RedditAuthParams,
      errors: {} as "REDDIT_AUTH_PARAMS_FAILED"|"REDDIT_NOT_CONFIGURED",
    },
    reddit_comments: {
      /** Fetch Reddit comments from specified subreddits. */
      path: '/api/external/bigdipper/reddit-comments/',
      method: 'GET',
      paramsType: {} as {
        query?: GetRedditCommentsQuery
      },
      responseType: {} as StandaloneRedditComments,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    sdb_diagnostics_error: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/sdb-diagnostics-error/',
      method: 'POST',
      paramsType: {} as {
        body: SdbDiagnosticsErrorInput
      },
      responseType: {} as SdbDiagnosticsError,
      errors: {} as "DIAGNOSTICS_CAPTURABLE"|"DIAGNOSTICS_TEST_UNKNOWN"|"DIAGNOSTICS_UNCAPTURABLE",
    },
    sdb_diagnostics_stream: {
      path: '/api/external/bigdipper/sdb-diagnostics-stream/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneDummy,
      errors: {} as never,
    },
    sdb_tracking_activity: {
      /** Campaigns, posts, audiences and seat changes as one feed, newest first.
      Searchable on name and team. ``kind`` limits the feed to one type. */
      path: '/api/external/bigdipper/sdb-tracking-activity/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingActivityQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SdbTrackingActivity[]
      },
      errors: {} as never,
    },
    sdb_tracking_audiences: {
      /** All audiences created in the platform, newest first. Searchable on name, team and creator. */
      path: '/api/external/bigdipper/sdb-tracking-audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingAudiencesQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SdbTrackingAudience[]
      },
      errors: {} as never,
    },
    sdb_tracking_campaign_checked: {
      /** Mark a campaign as reviewed by the signed-in @socialdatabase.com user, or clear the review. */
      path: '/api/external/bigdipper/sdb-tracking-campaign-checked/',
      method: 'POST',
      paramsType: {} as {
        body: SdbTrackingCampaignCheckedInput
      },
      responseType: {} as SdbTrackingCampaignChecked,
      errors: {} as "Campaign not found",
    },
    sdb_tracking_campaigns: {
      /** All campaigns created in the platform, newest first. Searchable on name, objective, team and creator. */
      path: '/api/external/bigdipper/sdb-tracking-campaigns/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingCampaignsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SdbTrackingCampaign[]
      },
      errors: {} as never,
    },
    sdb_tracking_canceled: {
      /** Canceled Business and Pro subscriptions, most recently canceled first. */
      path: '/api/external/bigdipper/sdb-tracking-canceled/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingCanceledQuery
      },
      responseType: {} as SdbTrackingCanceled,
      errors: {} as "DAYS_PARAM_INVALID",
    },
    sdb_tracking_growth: {
      /** Weekly counts for the last 12 weeks across tracking metrics. */
      path: '/api/external/bigdipper/sdb-tracking-growth/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SdbTrackingGrowth,
      errors: {} as never,
    },
    sdb_tracking_join_team: {
      /** Add the signed-in @socialdatabase.com user to a customer team as admin. */
      path: '/api/external/bigdipper/sdb-tracking-join-team/',
      method: 'POST',
      paramsType: {} as {
        body: SdbTrackingJoinTeamInput
      },
      responseType: {} as SdbTrackingJoinTeam,
      errors: {} as "Team not found",
    },
    sdb_tracking_journey_email_preview: {
      /** The HTML of one journey email, rendered again from the values it was sent with. */
      path: '/api/external/bigdipper/sdb-tracking-journey-email-preview/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingJourneyEmailPreviewQuery
      },
      responseType: {} as SdbTrackingJourneyEmailPreview,
      errors: {} as "Email not found",
    },
    sdb_tracking_journey_email_report: {
      /** Weekly Mailchimp sends, deliveries, bounces, abuse reports, opens and clicks of the journey emails.
      Window is 7, 30, 90 or "all" days (defaults to 30). Cached for 15 minutes. */
      path: '/api/external/bigdipper/sdb-tracking-journey-email-report/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingJourneyEmailReportQuery
      },
      responseType: {} as SdbTrackingJourneyEmailReport,
      errors: {} as "MAILCHIMP_REPORTS_UNAVAILABLE",
    },
    sdb_tracking_journey_emails: {
      /** Customer-journey emails within the requested window (7, 30, 90 or "all"; defaults to 30), newest first.
      Superseded rows are left out: they only mark lower milestones that were never sent.
      Searchable on recipient, team and subject. Set include_internal to keep @socialdatabase.com recipients in.
      Pass ``team`` to only list the emails of one team. */
      path: '/api/external/bigdipper/sdb-tracking-journey-emails/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingJourneyEmailsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SdbTrackingJourneyEmail[]
      },
      errors: {} as never,
    },
    sdb_tracking_journey_opt_in: {
      /** Stop or resume journey emails for a user. Mailchimp and HubSpot are updated like any other opt-out. */
      path: '/api/external/bigdipper/sdb-tracking-journey-opt-in/',
      method: 'POST',
      paramsType: {} as {
        body: SdbTrackingJourneyOptInInput
      },
      responseType: {} as SdbTrackingJourneyOptIn,
      errors: {} as "User not found",
    },
    sdb_tracking_lead_status: {
      /** Set the manual follow-up status (and optional comment) of a lead.
      The signed-in @socialdatabase.com user is recorded as the assigner. */
      path: '/api/external/bigdipper/sdb-tracking-lead-status/',
      method: 'POST',
      paramsType: {} as {
        body: SdbTrackingLeadStatusInput
      },
      responseType: {} as SdbTrackingLeadStatus,
      errors: {} as "Lead not found",
    },
    sdb_tracking_leave_team: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/sdb-tracking-leave-team/',
      method: 'POST',
      paramsType: {} as {
        body: SdbTrackingLeaveTeamInput
      },
      responseType: {} as SdbTrackingLeaveTeam,
      errors: {} as "NOT_A_MEMBER"|"OWNER_CANNOT_LEAVE"|"Team not found",
    },
    sdb_tracking_partners: {
      /** Certified affiliate partners with their payouts setup and attributed teams, most teams first. */
      path: '/api/external/bigdipper/sdb-tracking-partners/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SdbTrackingPartner,
      errors: {} as never,
    },
    sdb_tracking_payment_issues: {
      /** Business and Pro subscriptions whose payment is pending or failed, the most recent issue first. */
      path: '/api/external/bigdipper/sdb-tracking-payment-issues/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SdbTrackingPaymentIssue,
      errors: {} as never,
    },
    sdb_tracking_posts: {
      /** Published and scheduled posts, one row per platform record, newest first.
      Searchable on post, team and platform. */
      path: '/api/external/bigdipper/sdb-tracking-posts/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingPostsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: SdbTrackingPost[]
      },
      errors: {} as never,
    },
    sdb_tracking_subscribers: {
      /** List customers for a given tier (business or pro). */
      path: '/api/external/bigdipper/sdb-tracking-subscribers/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SdbTrackingSubscriber,
      errors: {} as "TIER_PARAM_INVALID",
    },
    sdb_tracking_team_research: {
      /** Company research for one team, so the sales team knows who a customer is. */
      path: '/api/external/bigdipper/sdb-tracking-team-research/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingTeamResearchQuery
      },
      responseType: {} as SdbTrackingTeamResearch,
      errors: {} as "Team not found",
    },
    sdb_tracking_website_submissions: {
      /** Leads within the requested time window, newest first.
      Most leads are website submissions: URLs entered on the logged-out home page
      before an account exists. ``funnel_status`` shows how far the visitor got
      (submitted, email, code requested, or signed up). Teams created without a
      submission (by a partner, in the office tool or admin, or as an extra team)
      are listed too, with ``source`` ``partner`` or ``backend``. Leads whose email was
      invited into a team before the lead came in are left out, unless it was an owner
      invitation to the lead's own team. The window is controlled by the ``days``
      query param (7, 30, 90 or "all"; defaults to 7). */
      path: '/api/external/bigdipper/sdb-tracking-website-submissions/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSdbTrackingWebsiteSubmissionsQuery
      },
      responseType: {} as SdbTrackingWebsiteSubmission,
      errors: {} as "DAYS_PARAM_INVALID",
    },
    sdb_tracking: {
      /** Internal dashboard: subscription metrics for SDB staff. */
      path: '/api/external/bigdipper/sdb-tracking/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SdbTrackingResponse,
      errors: {} as never,
    },
    shopify_auth_params: {
      /** Generate Shopify OAuth2 authorization parameters for a single store.
      Shopify's authorize endpoint lives on the merchant's own store host, so
      `shop` is required and is normalized here: the returned authorize_url is
      where the browser sends the merchant and where the code is later
      exchanged, and an unvalidated store address would point both at whatever
      host it named. */
      path: '/api/external/bigdipper/shopify-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetShopifyAuthParamsQuery
      },
      responseType: {} as ShopifyAuthParams,
      errors: {} as "SHOPIFY_AUTH_PARAMS_FAILED"|"SHOPIFY_NOT_CONFIGURED"|"SHOPIFY_STORE_INVALID",
    },
    similar_handles: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/similar-handles/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSimilarHandlesQuery
      },
      responseType: {} as BigDipperSimilarHandles,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    social_accounts_content: {
      /** Platform content for bigdipper. */
      path: '/api/external/bigdipper/social-accounts-content/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSocialAccountsContentQuery
      },
      responseType: {} as StandaloneSocialAccountsContent,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    social_accounts_per_platform: {
      /** Social accounts per platform for bigdipper. */
      path: '/api/external/bigdipper/social-accounts-per-platform/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSocialAccountsPerPlatformQuery
      },
      responseType: {} as StandalonePlatformAccountsPerPlatform,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_options_resolve: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-options-resolve/',
      method: 'POST',
      paramsType: {} as {
        body: TargetingResolveInput
      },
      responseType: {} as TargetingResolve,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"TARGETING_FIELD_UNSUPPORTED"|"TARGETING_LOOKUP_FAILED"|"Team subscription is not active",
    },
    targeting_options: {
      /** Search targeting options for a given platform and field. Returns a list of selectable options. */
      path: '/api/external/bigdipper/targeting-options/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingOptionsQuery
      },
      responseType: {} as TargetingOption[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"TARGETING_OPTIONS_FAILED"|"TARGETING_OPTIONS_PARAMS_REQUIRED"|"Team subscription is not active",
    },
    targeting_pack_chatgpt: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-chatgpt/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackChatgptQuery
      },
      responseType: {} as StandaloneChatgptTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_discord: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-discord/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackDiscordQuery
      },
      responseType: {} as StandaloneDiscordTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_facebook_instagram: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-facebook-instagram/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackFacebookInstagramQuery
      },
      responseType: {} as StandaloneFacebookInstagramTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"META_NOT_CONNECTED"|"META_TARGETING_SEARCH_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_google: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-google/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackGoogleQuery
      },
      responseType: {} as StandaloneGoogleTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_linkedin: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-linkedin/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackLinkedinQuery
      },
      responseType: {} as StandaloneLinkedInTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_narration_stream: {
      /** SSE stream with a Mistral-generated narration of the targeting pack build.
      Cosmetic companion to the targeting-pack-* endpoints: it streams short status
      lines describing the background work while the real packs are being built. */
      path: '/api/external/bigdipper/targeting-pack-narration-stream/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackNarrationStreamQuery
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_pinterest: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-pinterest/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackPinterestQuery
      },
      responseType: {} as StandalonePinterestTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_reddit: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-reddit/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackRedditQuery
      },
      responseType: {} as StandaloneRedditTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_seo: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-seo/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackSeoQuery
      },
      responseType: {} as StandaloneSeoTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_spotify: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-spotify/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackSpotifyQuery
      },
      responseType: {} as StandaloneSpotifyTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_tiktok: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-tiktok/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackTiktokQuery
      },
      responseType: {} as StandaloneTiktokTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_twitch: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-twitch/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackTwitchQuery
      },
      responseType: {} as StandaloneTwitchTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_x: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-x/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackXQuery
      },
      responseType: {} as StandaloneXTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_youtube: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/targeting-pack-youtube/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTargetingPackYoutubeQuery
      },
      responseType: {} as StandaloneYoutubeTargetingPack,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_reach: {
      /** Get estimated audience reach for any platform targeting criteria. */
      path: '/api/external/bigdipper/targeting-reach/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTargetingReachInput
      },
      responseType: {} as StandaloneTargetingReach,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_restrictions: {
      /** Ad-platform targeting restrictions (single source of truth): sanctioned
      countries, regulated categories (gambling/alcohol/politics) with per-platform
      policies, sensitive-attribute and Special Ad Category definitions, and the
      general warning text. Drives the spotlight contextual warnings. */
      path: '/api/external/bigdipper/targeting-restrictions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneTargetingRestrictions,
      errors: {} as never,
    },
    targeting_schema: {
      /** Returns JSON schemas defining all available targeting fields per platform. */
      path: '/api/external/bigdipper/targeting-schema/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneDummy,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_similarity_check: {
      /** Semantic check: flag keywords whose embedding is too close to a constrained
      targeting concept (sensitive attribute or regulated category), catching proxies
      the term lists miss. Advisory only. Requires the embeddings artifact built by
      `manage.py build_constrained_targeting_embeddings`. */
      path: '/api/external/bigdipper/targeting-similarity-check/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTargetingSimilarityInput
      },
      responseType: {} as StandaloneTargetingSimilarity,
      errors: {} as "TARGETING_SIMILARITY_UNAVAILABLE",
    },
    targeting_tree: {
      /** Browsable targeting tree for Meta, LinkedIn and X locations.
      Query params:
        - platform: facebook | instagram | linkedin | x (required when node_id is omitted)
        - node_id: encoded node path; omit to get platform roots
        - q: optional case-insensitive substring filter on children labels
        - limit: pagination cap (default 100, max 500)
        - offset: pagination offset (default 0) */
      path: '/api/external/bigdipper/targeting-tree/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TargetingTreeResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LIMIT_OFFSET_INVALID"|"NOT_A_MEMBER"|"TARGETING_TREE_FAILED"|"TARGETING_TREE_PARAMS_REQUIRED"|"TARGETING_TREE_REQUEST_INVALID"|"Team subscription is not active",
    },
    team_invitation: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/team-invitation/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTeamInvitationQuery
      },
      responseType: {} as StandaloneTeamInvitation,
      errors: {} as "INVITATION_NOT_FOUND",
    },
    tiktok_ads_auth_params: {
      /** Generate TikTok Marketing API authorization parameters for the TikTok Ads connector.
      Returns app_id, authorize_url and redirect_uri for the frontend, which appends
      its own CSRF state before redirecting the user to TikTok. */
      path: '/api/external/bigdipper/tiktok-ads-auth-params/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTiktokAdsAuthParamsQuery
      },
      responseType: {} as TikTokAdsAuthParams,
      errors: {} as "TIKTOK_ADS_AUTH_PARAMS_FAILED"|"TIKTOK_ADS_NOT_CONFIGURED",
    },
    use_magic_login_link: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/use-magic-login-link/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUseMagicLoginLinkQuery
      },
      responseType: {} as UseMagicLoginLink,
      errors: {} as "INVALID_CREDENTIALS",
    },
    user_preferences: {
      /** GET or PATCH the logged-in user's Big Dipper preferences (weekly digest opt-in). */
      path: '/api/external/bigdipper/user-preferences/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as BigDipperUserPreferences,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    user_preferences_patch: {
      /** GET or PATCH the logged-in user's Big Dipper preferences (weekly digest opt-in). */
      path: '/api/external/bigdipper/user-preferences/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<BigDipperUserPreferencesInput>
      },
      responseType: {} as BigDipperUserPreferences,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    user_search_history: {
      /** Retrieve the user's search history from BigDipperSearch objects. */
      path: '/api/external/bigdipper/user-search-history/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserSearchHistoryQuery
      },
      responseType: {} as StandaloneUserSearchHistory[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    website_submission_email: {
      /** Attach an email to a website submission, before any login code is verified.
      This is what makes an abandoned signup visible: the submission keeps the email
      while `converted_at` stays null. */
      path: '/api/external/bigdipper/website-submission-email/',
      method: 'POST',
      paramsType: {} as {
        body: WebsiteSubmissionEmailInput
      },
      responseType: {} as WebsiteSubmissionEmail,
      errors: {} as "Website submission not found",
    },
    website_submission_stream: {
      /** SSE stream of the anonymous website teaser: brand images, then the plan. */
      path: '/api/external/bigdipper/website-submission-stream/',
      method: 'GET',
      paramsType: {} as {
        query?: GetWebsiteSubmissionStreamQuery
      },
      responseType: {} as WebsiteSubmissionStreamEvent,
      errors: {} as "Website submission not found",
    },
    website_submission: {
      /** Record a website entered on the logged-out home page and return its handle.
      No team or user exists yet: the returned uuid is what the visitor's browser
      uses to stream the teaser and, if they sign up, to link the submission to
      their new team. */
      path: '/api/external/bigdipper/website-submission/',
      method: 'POST',
      paramsType: {} as {
        body: WebsiteSubmissionInput
      },
      responseType: {} as WebsiteSubmission,
      errors: {} as never,
    },
    get_x_account: {
      /** Get connected X account info for the authenticated user.
      Returns connection status and account details if connected. */
      path: '/api/external/bigdipper/x-account/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneDummy,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    x_ads_request_token: {
      /** Get OAuth 1.0a request token for X Ads API connection.
      This is step 1 of the OAuth 1.0a flow for connecting ad accounts.
      Returns oauth_token to construct the X authorization URL. */
      path: '/api/external/bigdipper/x-ads-request-token/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneXAdsRequestToken,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"X_ADS_NOT_CONFIGURED"|"X_ADS_REQUEST_TOKEN_FAILED",
    },
    x_code_challenge: {
      /** Generate PKCE code challenge for X OAuth2 flow.
      Frontend calls this first to get the challenge parameters.
      Used for connecting X account (not login). */
      path: '/api/external/bigdipper/x-code-challenge/',
      method: 'GET',
      paramsType: {} as {
        query?: GetXCodeChallengeQuery
      },
      responseType: {} as StandaloneXCodeChallenge,
      errors: {} as "X_CODE_CHALLENGE_FAILED"|"X_NOT_CONFIGURED",
    },
    youtube_videos: {
      /** Fetch YouTube videos from specified channel IDs. */
      path: '/api/external/bigdipper/youtube-videos/',
      method: 'GET',
      paramsType: {} as {
        query?: GetYoutubeVideosQuery
      },
      responseType: {} as StandaloneYoutubeVideos,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ad_suggestion_runs: {
      /** Earlier ad suggestion runs that produced ads, newest first. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestion-runs/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamAdSuggestionRunsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdSuggestionRun[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ad_suggestion_delete: {
      /** Delete one suggested ad; a draft post saved from it is kept. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestion/{suggestion_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          suggestion_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ad_suggestion_save_post: {
      /** Turn a suggested ad into a draft post (its primary text and image, or the raw or edited video). */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestion/{suggestion_id}/save-post/',
      method: 'POST',
      paramsType: {} as {
        body: AdSuggestionSavePostInput
        path: {
          pk: string|number
          suggestion_id: string|number
        }
      },
      responseType: {} as AdSuggestionSavePost,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"VIDEO_EDIT_NOT_FINISHED",
    },
    team_ad_suggestion_video_edit: {
      /** Re-edit a UGC video: the prompt (and library images) change the latest edit, an empty prompt retries a
      failed first edit. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestion/{suggestion_id}/video-edit/',
      method: 'POST',
      paramsType: {} as {
        body: AdSuggestionVideoEditRequestInput
        path: {
          pk: string|number
          suggestion_id: string|number
        }
      },
      responseType: {} as AdSuggestionVideoEditRequest,
      errors: {} as "AD_HAS_NO_VIDEO"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"VIDEO_EDIT_IN_PROGRESS"|"VIDEO_EDIT_PROMPT_REQUIRED"|"VIDEO_EDIT_TOO_MANY_IMAGES",
    },
    team_ad_suggestion_latest_video_edit: {
      /** The latest edit of a UGC video, polled while it is being made. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestion/{suggestion_id}/video-edit/latest/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          suggestion_id: string|number
        }
      },
      responseType: {} as AdSuggestionLatestVideoEdit,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ad_suggestions: {
      /** The latest AI ad suggestions; an eligible team's first visit starts the free automatic run.
      `?start_first_run=false` only reads the state, for views that open the custom flow. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestions/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamAdSuggestionsQuery
      },
      responseType: {} as AdSuggestionsState,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ad_suggestions_generate: {
      /** Start a new (billed) ad suggestion run with the defaults, overridden by any config given. */
      path: '/api/external/bigdipper/{pk}/team-ad-suggestions/generate/',
      method: 'POST',
      paramsType: {} as {
        body: AdSuggestionsGenerateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdSuggestionsGenerate,
      errors: {} as "AD_SUGGESTIONS_IN_PROGRESS"|"AD_SUGGESTIONS_NOT_ELIGIBLE"|"Billing admins can only access team management endpoints"|"COMPETITOR_AD_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    affiliate_connect_login_link: {
      /** A one-time link into the partner's Stripe Express dashboard (bank details, payout history). */
      path: '/api/external/bigdipper/{pk}/team-affiliate-connect-login-link/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateConnectLoginLinkInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateConnectLoginLink,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_connect_onboarding: {
      /** Create (if needed) the partner's Stripe Connect Express account and return an onboarding link. */
      path: '/api/external/bigdipper/{pk}/team-affiliate-connect-onboarding/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateConnectOnboardingInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateConnectOnboarding,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_create_team: {
      /** Create a team for a customer, attributed to the affiliate partner. */
      path: '/api/external/bigdipper/{pk}/team-affiliate-create-team/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateCreateTeamInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateCreateTeam,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_partner: {
      /** Affiliate partner dashboard data: share link, Connect onboarding state, teams and commissions. */
      path: '/api/external/bigdipper/{pk}/team-affiliate-partner/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliatePartner,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_payouts: {
      /** The partner's Stripe Connect account state, balance, bank payouts and our commission transfers. */
      path: '/api/external/bigdipper/{pk}/team-affiliate-payouts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliatePayouts,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_resend_invitation: {
      /** Send the customer of a partner-created team their owner invitation email (again). */
      path: '/api/external/bigdipper/{pk}/team-affiliate-resend-invitation/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateResendInvitationInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateResendInvitation,
      errors: {} as "Not an affiliate partner",
    },
    affiliate_team_stage: {
      /** Move one of the partner's customer teams to another stage of the partner's pipeline. */
      path: '/api/external/bigdipper/{pk}/team-affiliate-team-stage/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateTeamStageInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateTeamStage,
      errors: {} as "Not an affiliate partner",
    },
    team_apply_partner_code: {
      /** Connect the current team to an affiliate partner via their partner code. */
      path: '/api/external/bigdipper/{pk}/team-apply-partner-code/',
      method: 'POST',
      paramsType: {} as {
        body: AffiliateApplyPartnerCodeInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AffiliateApplyPartnerCode,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_delete: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-audience-delete/{audience_id}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_duplicate: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-audience-duplicate/{audience_id}/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperAudienceDuplicateInput
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as BigDipperAudienceDuplicate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_meta_special_ad_category: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-audience-meta-special-ad-category/{audience_id}/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperAudienceMetaSpecialAdCategoryInput
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as BigDipperAudienceMetaSpecialAdCategory,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"META_NOT_CONNECTED"|"META_TARGETING_MISSING"|"META_TARGETING_SEARCH_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_save: {
      /** Create and save a BigDipper audience. POST body: all BigDipperAudience fields (user/team set from request). */
      path: '/api/external/bigdipper/{pk}/team-audience-save/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperAudienceDetailInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperAudienceDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_summary: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-audience-summary/{audience_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as BigDipperAudienceSummary,
      errors: {} as "AUDIENCE_NOT_FOUND"|"AUDIENCE_SUMMARY_FAILED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_targeting_edit: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-audience-targeting-edit/{audience_id}/',
      method: 'POST',
      paramsType: {} as {
        body: AudienceTargetingEditInput
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as AudienceTargetingEdit,
      errors: {} as "AUDIENCE_EDIT_NO_CHANGES"|"AUDIENCE_EDIT_NO_TARGETING"|"AUDIENCE_EDIT_PREVIEW_EXPIRED"|"AUDIENCE_EDIT_PREVIEW_STALE"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"TARGETING_LOOKUP_FAILED"|"Team subscription is not active",
    },
    audience_update: {
      /** Update an existing BigDipper audience. PATCH body: BigDipperAudience fields to update. */
      path: '/api/external/bigdipper/{pk}/team-audience-update/{audience_id}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<BigDipperAudienceUpdateInput>
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as BigDipperAudienceUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_bill: {
      /** Get billing info for the current team. */
      path: '/api/external/bigdipper/{pk}/team-bill/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamBill,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_ads: {
      /** Get ads for a specific ad set.
      Lazy-loaded when user expands an ad set row.
      Platform mapping:
        - X: promoted tweets under a line item
        - Meta: ads under an ad set
        - LinkedIn: creatives under a campaign
      Query params:
        - platform: required, 'x', 'meta', or 'linkedin'
        - adset_id: required, the ad set / line item / campaign ID
        - ad_account_id: required, the ad account ID
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram' */
      path: '/api/external/bigdipper/{pk}/team-campaign-ads/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignAdsQuery
      },
      responseType: {} as CampaignAdsResponse,
      errors: {} as "ADS_PARAMS_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"Team subscription is not active",
    },
    campaign_adsets: {
      /** Get ad sets for a specific campaign.
      Lazy-loaded when user expands a campaign row.
      Platform mapping:
        - X: line items under a campaign
        - Meta: ad sets under a campaign
        - LinkedIn: campaigns under a campaign group
      Query params:
        - platform: required, 'x', 'meta', or 'linkedin'
        - campaign_id: required, the campaign ID (campaign group ID on LinkedIn)
        - ad_account_id: required, the ad account ID
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram' */
      path: '/api/external/bigdipper/{pk}/team-campaign-adsets/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignAdsetsQuery
      },
      responseType: {} as CampaignAdSetsResponse,
      errors: {} as "ADSETS_PARAMS_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"Team subscription is not active",
    },
    campaign_name_templates_edit: {
      /** Replace the team's campaign-name format templates.
      Stored on the team's single CAMPAIGN_NAME_FORMAT research section. PATCH replaces the
      whole list; add/edit/delete/set-default are performed client-side then saved as one array. */
      path: '/api/external/bigdipper/{pk}/team-campaign-name-templates-edit/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<CampaignNameTemplatesUpdateInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignNameTemplatesUpdate[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_name_templates: {
      /** Get the team's campaign-name format templates.
      Stored on the team's single CAMPAIGN_NAME_FORMAT research section. */
      path: '/api/external/bigdipper/{pk}/team-campaign-name-templates/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignNameTemplate[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_thumbnails: {
      /** Return a representative ad-creative thumbnail per campaign for a given platform / ad account.
      Lazy-loaded from the frontend after the campaign overview table renders, so the main
      overview API stays fast. Only campaigns whose thumbnail could be resolved are returned;
      the frontend renders a placeholder square for any missing entry.
      POST body:
        - platform: required, 'x' | 'meta' | 'linkedin' | 'google_ads'
        - ad_account_id: required
        - campaign_ids: required, list of campaign IDs (or LinkedIn campaign group IDs) */
      path: '/api/external/bigdipper/{pk}/team-campaign-thumbnails/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignThumbnailsResponseInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignThumbnailsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_cancel_subscription: {
      /** Cancel the current team's subscription at the end of the paid period. */
      path: '/api/external/bigdipper/{pk}/team-cancel-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTeamCancelSubscriptionInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamCancelSubscription,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"SUBSCRIPTION_CANCEL_OWNER_ONLY"|"SUBSCRIPTION_NOT_ACTIVE"|"Team subscription is not active",
    },
    chatgpt_ads_connect: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-chatgpt-ads-connect/',
      method: 'POST',
      paramsType: {} as {
        body: ChatgptAdsConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as ChatgptAdsConnect,
      errors: {} as "Billing admins can only access team management endpoints"|"CHATGPT_ACCOUNT_TEMPORARY_ERROR"|"CHATGPT_ADS_APP_MISSING"|"CHATGPT_API_KEY_INVALID"|"CHATGPT_API_KEY_REQUIRED"|"CHATGPT_CONNECT_FAILED"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor: {
      /** One tracked competitor. Opening it refreshes the ads when they are older than 12 hours. */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          competitor_id: string|number
        }
      },
      responseType: {} as TeamCompetitor,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_ads_sync: {
      /** Read the competitor's ads from the Meta Ad Library again. */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/ads-sync/',
      method: 'POST',
      paramsType: {} as {
        body: TeamCompetitorRescrapeInput
        path: {
          pk: string|number
          competitor_id: string|number
        }
      },
      responseType: {} as TeamCompetitorRescrape,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_ads: {
      /** The competitor's ads from the Meta Ad Library.
      `status` = active | inactive | all (default), `sort` = newest (default) | longest. */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/ads/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          competitor_id: string|number
        }
        query?: GetTeamCompetitorAdsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: TeamCompetitorAd[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_delete: {
      /** Stop tracking a competitor. */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          competitor_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_rescrape: {
      /** Queue a fresh scrape; it only fills in what is still empty. */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/rescrape/',
      method: 'POST',
      paramsType: {} as {
        body: TeamCompetitorRescrapeInput
        path: {
          pk: string|number
          competitor_id: string|number
        }
      },
      responseType: {} as TeamCompetitorRescrape,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_update: {
      /** Correct a competitor's profile by hand (name, website, socials, notes). */
      path: '/api/external/bigdipper/{pk}/team-competitor/{competitor_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<TeamCompetitorUpdateInput>
        path: {
          pk: string|number
          competitor_id: string|number
        }
      },
      responseType: {} as TeamCompetitorUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_create: {
      /** Start tracking a competitor by website and queue the profile scrape. */
      path: '/api/external/bigdipper/{pk}/team-competitors-create/',
      method: 'POST',
      paramsType: {} as {
        body: TeamCompetitorInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamCompetitor,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitor_suggestions: {
      /** Competitors Ada named in the research section that are not tracked yet. */
      path: '/api/external/bigdipper/{pk}/team-competitors-suggestions/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamCompetitorSuggestion[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_competitors: {
      /** The competitors this team tracks, oldest first.
      Teams researched before competitor tracking existed get their first few competitors
      from Ada's research the first time this list is opened (once, see `competitors_seeded_at`). */
      path: '/api/external/bigdipper/{pk}/team-competitors/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamCompetitor[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    create_invitation: {
      /** Create a new BigDipper team invitation. */
      path: '/api/external/bigdipper/{pk}/team-create-invitation/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamInvitationInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamInvitation,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    dashboard_layout_edit: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-dashboard-layout-edit/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<DashboardLayoutInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as DashboardLayout,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"DASHBOARD_LAYOUT_INVALID"|"DASHBOARD_WIDGET_DUPLICATE"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    dashboard_layout_reset: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-dashboard-layout-reset/',
      method: 'POST',
      paramsType: {} as {
        body: DashboardLayoutResetInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as DashboardLayoutReset,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    dashboard_layout: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-dashboard-layout/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as DashboardLayout,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    dashboard_usage: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-dashboard-usage/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as DashboardUsage,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    disconnect_social: {
      /** Disconnect social account from the team. */
      path: '/api/external/bigdipper/{pk}/team-disconnect-social/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperDisconnectSocialInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperDisconnectSocial,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You don't have permissions to execute this task",
    },
    facebook_connect: {
      /** Connect Facebook account to authenticated user.
      Receives an OAuth authorization code from the frontend callback,
      exchanges it for an access token, and stores/refreshes the social account. */
      path: '/api/external/bigdipper/{pk}/team-facebook-connect/',
      method: 'POST',
      paramsType: {} as {
        body: FacebookConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FacebookConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"CONNECT_UNEXPECTED_ERROR"|"Could not extract team id from path"|"FACEBOOK_ACCESS_TOKEN_MISSING"|"FACEBOOK_AUTHENTICATION_FAILED"|"FACEBOOK_NOT_CONFIGURED"|"FACEBOOK_PROFILE_FAILED"|"FACEBOOK_USER_ID_MISSING"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"REDIRECT_URI_REQUIRED"|"Team subscription is not active",
    },
    team_feedback: {
      /** Submit feedback for the platform and claim the one-time bonus trial credits. */
      path: '/api/external/bigdipper/{pk}/team-feedback/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamFeedbackInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamFeedback,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_angle_delete: {
      /** Remove an angle with its experiments. */
      path: '/api/external/bigdipper/{pk}/team-funnel-angle/{angle_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          angle_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_angle_update: {
      /** Reword an angle; only the fields sent are changed. */
      path: '/api/external/bigdipper/{pk}/team-funnel-angle/{angle_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelAngleUpdateInput>
        path: {
          pk: string|number
          angle_id: string|number
        }
      },
      responseType: {} as FunnelAngleUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_angle_create: {
      /** Add an angle to a persona. */
      path: '/api/external/bigdipper/{pk}/team-funnel-angles-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelAngleInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelAngle,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_experiment: {
      /** One experiment with its brief, its ads and the product, segment, persona and angle above it. */
      path: '/api/external/bigdipper/{pk}/team-funnel-experiment/{experiment_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          experiment_id: string|number
        }
      },
      responseType: {} as FunnelExperiment,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_experiment_content_create: {
      /** A new ad for the experiment: a promoted draft post, prefilled with its name and landing page. */
      path: '/api/external/bigdipper/{pk}/team-funnel-experiment/{experiment_id}/content-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelExperimentContentCreateInput
        path: {
          pk: string|number
          experiment_id: string|number
        }
      },
      responseType: {} as FunnelExperimentContentCreate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_experiment_delete: {
      /** Remove an experiment. Its ads stay in Content as posts without an experiment. */
      path: '/api/external/bigdipper/{pk}/team-funnel-experiment/{experiment_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          experiment_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_experiment_update: {
      /** Change the brief or the status of an experiment; only the fields sent are changed. */
      path: '/api/external/bigdipper/{pk}/team-funnel-experiment/{experiment_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelExperimentUpdateInput>
        path: {
          pk: string|number
          experiment_id: string|number
        }
      },
      responseType: {} as FunnelExperimentUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_experiment_create: {
      /** Start an experiment for an angle with its brief: one format, one offer and one landing page. */
      path: '/api/external/bigdipper/{pk}/team-funnel-experiments-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelExperimentInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelExperiment,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_insight_delete: {
      /** Remove an insight. */
      path: '/api/external/bigdipper/{pk}/team-funnel-insight/{insight_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          insight_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_insight_update: {
      /** Reword an insight. */
      path: '/api/external/bigdipper/{pk}/team-funnel-insight/{insight_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelPersonaInsightUpdateInput>
        path: {
          pk: string|number
          insight_id: string|number
        }
      },
      responseType: {} as FunnelPersonaInsightUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_insight_create: {
      /** Add a desire, objection, failed alternative, benefit or pain point to a persona. */
      path: '/api/external/bigdipper/{pk}/team-funnel-insights-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelPersonaInsightInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelPersonaInsight,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_persona_delete: {
      /** Remove a persona with its insights, angles and experiments. */
      path: '/api/external/bigdipper/{pk}/team-funnel-persona/{persona_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          persona_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_persona_fill: {
      /** Ada adds the insights and angles the persona is missing; returns its product. */
      path: '/api/external/bigdipper/{pk}/team-funnel-persona/{persona_id}/fill/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelProductFillInput
        path: {
          pk: string|number
          persona_id: string|number
        }
      },
      responseType: {} as FunnelProductFill,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_persona_update: {
      /** Change a persona's name, age or description; only the fields sent are changed. */
      path: '/api/external/bigdipper/{pk}/team-funnel-persona/{persona_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelPersonaUpdateInput>
        path: {
          pk: string|number
          persona_id: string|number
        }
      },
      responseType: {} as FunnelPersonaUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_persona_create: {
      /** Add a persona to a segment. */
      path: '/api/external/bigdipper/{pk}/team-funnel-personas-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelPersonaInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelPersona,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_product_delete: {
      /** Remove a product with everything below it. */
      path: '/api/external/bigdipper/{pk}/team-funnel-product/{product_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          product_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_product_fill: {
      /** Ada adds the segments, personas and angles the product is missing; returns the product. */
      path: '/api/external/bigdipper/{pk}/team-funnel-product/{product_id}/fill/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelProductFillInput
        path: {
          pk: string|number
          product_id: string|number
        }
      },
      responseType: {} as FunnelProductFill,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_product_update: {
      /** Rename or describe a product; only the fields sent are changed. */
      path: '/api/external/bigdipper/{pk}/team-funnel-product/{product_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelProductInput>
        path: {
          pk: string|number
          product_id: string|number
        }
      },
      responseType: {} as FunnelProduct,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_product_create: {
      /** Add a product. */
      path: '/api/external/bigdipper/{pk}/team-funnel-products-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelProductInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelProduct,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_products: {
      /** The team's funnels. The first time they are opened they are filled from the research (once). */
      path: '/api/external/bigdipper/{pk}/team-funnel-products/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelProduct[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_research: {
      /** The marketing funnels Ada suggested in the latest research run. */
      path: '/api/external/bigdipper/{pk}/team-funnel-research/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelProduct[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_segment_delete: {
      /** Remove a segment with everything below it. */
      path: '/api/external/bigdipper/{pk}/team-funnel-segment/{segment_id}/delete/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          segment_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_segment_fill: {
      /** Ada adds the personas and angles the segment is missing; returns its product. */
      path: '/api/external/bigdipper/{pk}/team-funnel-segment/{segment_id}/fill/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelProductFillInput
        path: {
          pk: string|number
          segment_id: string|number
        }
      },
      responseType: {} as FunnelProductFill,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_segment_update: {
      /** Rename or describe a segment; only the fields sent are changed. */
      path: '/api/external/bigdipper/{pk}/team-funnel-segment/{segment_id}/update/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<FunnelSegmentUpdateInput>
        path: {
          pk: string|number
          segment_id: string|number
        }
      },
      responseType: {} as FunnelSegmentUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_funnel_segment_create: {
      /** Add a segment to a product. */
      path: '/api/external/bigdipper/{pk}/team-funnel-segments-create/',
      method: 'POST',
      paramsType: {} as {
        body: FunnelSegmentInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as FunnelSegment,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    google_ads_connect: {
      /** Connect a Google Ads account to the authenticated user/team.
      Receives an authorization code and exchanges it for tokens, storing them
      in SocialAccount/SocialToken and BigDipperTeamSocial for future use. */
      path: '/api/external/bigdipper/{pk}/team-google-ads-connect/',
      method: 'POST',
      paramsType: {} as {
        body: GoogleAdsConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as GoogleAdsConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"GOOGLE_ADS_CONNECT_FAILED"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"Team subscription is not active",
    },
    google_analytics_metadata: {
      /** List all available dimensions/metrics for a GA4 property.
      Query param: property_id (e.g. properties/123456789) */
      path: '/api/external/bigdipper/{pk}/team-google-analytics-metadata/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as GoogleAnalyticsMetadata,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"GOOGLE_ANALYTICS_NOT_CONNECTED"|"GOOGLE_ANALYTICS_TOKEN_MISSING"|"NOT_A_MEMBER"|"PROPERTY_ID_REQUIRED"|"Team subscription is not active",
    },
    google_analytics_pageviews_utm: {
      /** Get pageviews with UTM parameters for a GA4 property.
      Query params: property_id, start_date, end_date, limit (optional) */
      path: '/api/external/bigdipper/{pk}/team-google-analytics-pageviews-utm/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as GoogleAnalyticsPageviewsUTM,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"GOOGLE_ANALYTICS_NOT_CONNECTED"|"GOOGLE_ANALYTICS_TOKEN_MISSING"|"NOT_A_MEMBER"|"PAGEVIEWS_PARAMS_REQUIRED"|"Team subscription is not active",
    },
    google_analytics_ua_views: {
      /** List all Universal Analytics (UA) accounts, properties, and views the user has access to. */
      path: '/api/external/bigdipper/{pk}/team-google-analytics-ua-views/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as GoogleAnalyticsUAViews,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"GOOGLE_ANALYTICS_NOT_CONNECTED"|"GOOGLE_ANALYTICS_TOKEN_MISSING"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    google_connect: {
      /** Connect Google account to authenticated user/team.
      Receives authorization code and exchanges it for tokens.
      Stores tokens in SocialAccount/SocialToken for future use. */
      path: '/api/external/bigdipper/{pk}/team-google-connect/',
      method: 'POST',
      paramsType: {} as {
        body: GoogleConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as GoogleConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"GOOGLE_CONNECT_FAILED"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"Team subscription is not active",
    },
    instagram_connect: {
      /** Connect an Instagram Business/Creator account via the official Instagram Business Login.
      Receives an OAuth authorization code from the frontend callback, performs the
      Instagram-only token exchange (short-lived -> long-lived), and stores the resulting
      IG user identity. The connected account is the IG user that authorized the app —
      a single account per connection (vs. the legacy FB-Page-walk that returned multiple). */
      path: '/api/external/bigdipper/{pk}/team-instagram-connect/',
      method: 'POST',
      paramsType: {} as {
        body: InstagramConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as InstagramConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"CONNECT_UNEXPECTED_ERROR"|"Could not extract team id from path"|"INSTAGRAM_AUTHENTICATION_FAILED"|"INSTAGRAM_NOT_CONFIGURED"|"INSTAGRAM_PROFILE_FAILED"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"REDIRECT_URI_REQUIRED"|"Team subscription is not active",
    },
    team_invitation_remove: {
      /** Remove a pending (not yet accepted) invitation from the current team. */
      path: '/api/external/bigdipper/{pk}/team-invitation-remove/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamRemoveInvitationInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamRemoveInvitation,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You don't have permissions to execute this task",
    },
    team_invoices: {
      /** Get past invoices for the current team, cursor-paginated for infinite scroll. */
      path: '/api/external/bigdipper/{pk}/team-invoices/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamInvoicesQuery
      },
      responseType: {} as {
        results: StandaloneInvoiceSummary[]
        next_cursor: string|null
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_community_connect: {
      /** Connect the LinkedIn Community Management app for Social Listening.
      Same exchange as ``linkedin_connect`` but against the second LinkedIn
      app, stored under its own provider so the two tokens never get mixed
      up. Also records which organizations the member administers, which is
      what Social Listening reads when the team has not selected organizations
      through the advertising connection. */
      path: '/api/external/bigdipper/{pk}/team-linkedin-community-connect/',
      method: 'POST',
      paramsType: {} as {
        body: LinkedInCommunityConnectResponseInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as LinkedInCommunityConnectResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_ACCESS_TOKEN_MISSING"|"LINKEDIN_AUTHENTICATION_FAILED"|"LINKEDIN_COMMUNITY_NOT_CONFIGURED"|"LINKEDIN_PROFILE_FAILED"|"LINKEDIN_USER_ID_MISSING"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"Team subscription is not active",
    },
    linkedin_connect: {
      /** Connect LinkedIn account to authenticated user.
      Receives an OAuth authorization code from the frontend callback,
      exchanges it for an access token via LinkedIn's token endpoint,
      fetches the user profile, and stores the social account at both
      user and team level. */
      path: '/api/external/bigdipper/{pk}/team-linkedin-connect/',
      method: 'POST',
      paramsType: {} as {
        body: LinkedInConnectResponseInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as LinkedInConnectResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_ACCESS_TOKEN_MISSING"|"LINKEDIN_AUTHENTICATION_FAILED"|"LINKEDIN_NOT_CONFIGURED"|"LINKEDIN_PROFILE_FAILED"|"LINKEDIN_USER_ID_MISSING"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"Team subscription is not active",
    },
    team_member_remove: {
      /** Remove a member from the current team. */
      path: '/api/external/bigdipper/{pk}/team-member-remove/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamRemoveMemberInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamRemoveMember,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You cannot remove an owner from the team."|"You cannot remove yourself from the team."|"You don't have permissions to execute this task",
    },
    team_member_update_can_approve: {
      /** Turn post approval on or off for an owner, admin, or member. */
      path: '/api/external/bigdipper/{pk}/team-member-update-can-approve/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamUpdateMemberCanApproveInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamUpdateMemberCanApprove,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You don't have permissions to execute this task",
    },
    team_member_update_role: {
      /** Switch a team member between the paid 'member' role and the free 'billing_admin' or 'approver' roles. */
      path: '/api/external/bigdipper/{pk}/team-member-update-role/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamUpdateMemberRoleInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamUpdateMemberRole,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PRO_TIER_SINGLE_SEAT"|"Team subscription is not active"|"The owner and partner admin cannot have their role changed."|"You don't have permissions to execute this task",
    },
    pinterest_ads_connect: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team-pinterest-ads-connect/',
      method: 'POST',
      paramsType: {} as {
        body: PinterestAdsConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as PinterestAdsConnect,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"PINTEREST_ADS_APP_MISSING"|"PINTEREST_CODE_REQUIRED"|"PINTEREST_CONNECT_FAILED"|"PINTEREST_TOKEN_EXCHANGE_FAILED"|"PINTEREST_USER_NOT_FOUND"|"Team subscription is not active",
    },
    reddit_connect: {
      /** Connect a Reddit account to the authenticated user/team.
      Receives an authorization code and exchanges it for tokens, storing them
      in SocialAccount/SocialToken and BigDipperTeamSocial for future use. */
      path: '/api/external/bigdipper/{pk}/team-reddit-connect/',
      method: 'POST',
      paramsType: {} as {
        body: RedditConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as RedditConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"REDDIT_CONNECT_FAILED"|"REDDIT_NOT_CONFIGURED"|"REDDIT_TOKEN_EXCHANGE_FAILED"|"Team subscription is not active",
    },
    team_refresh_subscription: {
      /** Re-read the current team's subscription from Stripe and return the fresh billing info. */
      path: '/api/external/bigdipper/{pk}/team-refresh-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTeamRefreshSubscriptionInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamRefreshSubscription,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_research_section_edit: {
      /** Edit a research section via AI prompt, streaming progress over SSE. */
      path: '/api/external/bigdipper/{pk}/team-research-section-edit/',
      method: 'POST',
      paramsType: {} as {
        body: TeamResearchSectionEditInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchSectionEdit,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_research_section_file_delete: {
      /** Delete an uploaded research file and remove it from S3. */
      path: '/api/external/bigdipper/{pk}/team-research-section-file/{file_id}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
          file_id: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_research_section_file_label: {
      /** Set or clear the label that marks an uploaded research file to be used as is. */
      path: '/api/external/bigdipper/{pk}/team-research-section-file/{file_id}/label/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<TeamResearchSectionFileLabelInput>
        path: {
          pk: string|number
          file_id: string|number
        }
      },
      responseType: {} as TeamResearchSectionFileLabel,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_research_section_file_reparse: {
      /** Re-run parsing for an uploaded research file. */
      path: '/api/external/bigdipper/{pk}/team-research-section-file/{file_id}/reparse/',
      method: 'POST',
      paramsType: {} as {
        body: TeamResearchSectionFileInput
        path: {
          pk: string|number
          file_id: string|number
        }
      },
      responseType: {} as TeamResearchSectionFile,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_research_section_files: {
      /** List or upload files for a research section.
      GET  ?category=<category> -> files for that section (all sections if omitted).
      POST multipart/form-data with `category` and one or more `files`. Each file is
           stored in S3 and queued for async parsing to text. */
      path: '/api/external/bigdipper/{pk}/team-research-section-files/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchSectionFile,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FILES_REQUIRED"|"NOT_A_MEMBER"|"RESEARCH_CATEGORY_INVALID"|"RESEARCH_FILE_LIMIT_REACHED"|"RESEARCH_UPLOAD_FAILED"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_research_section_files_post: {
      /** List or upload files for a research section.
      GET  ?category=<category> -> files for that section (all sections if omitted).
      POST multipart/form-data with `category` and one or more `files`. Each file is
           stored in S3 and queued for async parsing to text. */
      path: '/api/external/bigdipper/{pk}/team-research-section-files/',
      method: 'POST',
      paramsType: {} as {
        body: TeamResearchSectionFileInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchSectionFile,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FILES_REQUIRED"|"NOT_A_MEMBER"|"RESEARCH_CATEGORY_INVALID"|"RESEARCH_FILE_LIMIT_REACHED"|"RESEARCH_UPLOAD_FAILED"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_research_section_update: {
      /** Update a specific research section's content. */
      path: '/api/external/bigdipper/{pk}/team-research-section/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<TeamResearchSectionInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchSection,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"RESEARCH_SECTION_NOT_FOUND"|"Team subscription is not active",
    },
    team_research_stream: {
      /** SSE endpoint that subscribes to Redis pub/sub for live research progress. */
      path: '/api/external/bigdipper/{pk}/team-research-stream/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchStreamEvent,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_research: {
      /** Return all research sections for the team. */
      path: '/api/external/bigdipper/{pk}/team-research/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchSection[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_resume_subscription: {
      /** Undo a pending cancellation on the current team's subscription. */
      path: '/api/external/bigdipper/{pk}/team-resume-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTeamResumeSubscriptionInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamResumeSubscription,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"SUBSCRIPTION_NOT_CANCELLING"|"SUBSCRIPTION_NOT_FOUND"|"SUBSCRIPTION_RESUME_OWNER_ONLY"|"Team subscription is not active",
    },
    shopify_connect: {
      /** Connect a Shopify store to the authenticated team.
      Exchanges the callback's authorization code for an expiring offline
      access token and stores the token pair in BigDipperTeamSocial. The store
      is keyed by its myshopify domain, which is what every later Admin API
      call is addressed to. */
      path: '/api/external/bigdipper/{pk}/team-shopify-connect/',
      method: 'POST',
      paramsType: {} as {
        body: ShopifyConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as ShopifyConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"SHOPIFY_CALLBACK_UNVERIFIED"|"SHOPIFY_CONNECT_FAILED"|"SHOPIFY_CONNECT_REJECTED"|"SHOPIFY_NOT_CONFIGURED"|"SHOPIFY_STORE_INVALID"|"SHOPIFY_STORE_UNAVAILABLE"|"Team subscription is not active",
    },
    team_social_accounts: {
      /** Retrieve all BigDipperTeamSocial accounts for a given team. */
      path: '/api/external/bigdipper/{pk}/team-social-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamSocialAccountsQuery
      },
      responseType: {} as BigDipperTeamSocialAccounts[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    subscription_checkout: {
      /** Checkout to update subscription payment info. */
      path: '/api/external/bigdipper/{pk}/team-subscription-checkout/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSubscriptionCheckoutInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneSubscriptionCheckout,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PAYMENT_INFO_MANAGER_ONLY"|"PRO_TIER_SINGLE_SEAT"|"Team subscription is not active"|"VAT_REQUIRED",
    },
    tiktok_ads_connect: {
      /** Connect a TikTok Ads account to the authenticated user/team.
      Receives the auth_code from the TikTok callback and exchanges it for an
      access token, storing it in SocialAccount/SocialToken and BigDipperTeamSocial. */
      path: '/api/external/bigdipper/{pk}/team-tiktok-ads-connect/',
      method: 'POST',
      paramsType: {} as {
        body: TikTokAdsConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TikTokAdsConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"TIKTOK_ACCESS_TOKEN_MISSING"|"TIKTOK_ADS_CONNECT_FAILED"|"TIKTOK_ADS_CONNECT_REJECTED"|"TIKTOK_ADS_NOT_CONFIGURED"|"TIKTOK_USER_NOT_FOUND"|"Team subscription is not active",
    },
    team_upcoming_invoice: {
      /** Get the upcoming invoice for the current team. */
      path: '/api/external/bigdipper/{pk}/team-upcoming-invoice/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamUpcomingInvoice,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_update_subscription: {
      /** Update subscription for the current team. */
      path: '/api/external/bigdipper/{pk}/team-update-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTeamUpdateSubscriptionInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneTeamUpdateSubscription,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PRO_TIER_SINGLE_SEAT"|"Team subscription is not active",
    },
    team_update: {
      /** Update a member in the current team. */
      path: '/api/external/bigdipper/{pk}/team-update/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamUpdateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_usage: {
      /** Get usage info for the current team. */
      path: '/api/external/bigdipper/{pk}/team-usage/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamUsageQuery
      },
      responseType: {} as StandaloneTeamUsage,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    x_ads_connect: {
      /** Complete OAuth 1.0a flow for X Ads API.
      Exchanges oauth_token and oauth_verifier for access token.
      Creates SocialAccount and SocialToken, then syncs ad accounts. */
      path: '/api/external/bigdipper/{pk}/team-x-ads-connect/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXAdsConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneXAdsConnect,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"OAUTH_SESSION_EXPIRED"|"OAUTH_TOKEN_AND_VERIFIER_REQUIRED"|"Team subscription is not active"|"X_ADS_CONNECT_FAILED",
    },
    x_connect: {
      /** Connect X account to authenticated user.
      Receives authorization code and exchanges it for tokens.
      Stores tokens in SocialAccount/SocialToken for future use. */
      path: '/api/external/bigdipper/{pk}/team-x-connect/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneXConnect,
      errors: {} as "AUTHORIZATION_CODE_REQUIRED"|"Billing admins can only access team management endpoints"|"CONNECT_UNEXPECTED_ERROR"|"Could not extract team id from path"|"NOT_A_MEMBER"|"OAUTH_CLOCK_MISMATCH"|"Team subscription is not active"|"X_AUTHENTICATION_FAILED"|"X_CONNECT_FAILED"|"X_NOT_CONFIGURED",
    },
    team: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamQuery
      },
      responseType: {} as BigDipperTeam,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Only an owner or admin can change whether posts need approval."|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_patch: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<BigDipperTeamInput>
        path: {
          pk: string|number
        }
        query?: PatchTeamQuery
      },
      responseType: {} as BigDipperTeam,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Only an owner or admin can change whether posts need approval."|"Team subscription is not active"|"You are not a member of this team.",
    },
    ad_account_audience_create: {
      /** Create a custom audience on a connected ad account and upload the members
      of a BigDipper audience into it.
      POST body:
        - platform: required, currently only 'x'
        - ad_account_id: required, must belong to the team's selected ad accounts for that platform
        - audience_id: required, the BigDipper audience whose members are uploaded
        - name: optional, defaults to the audience name
      Response shape: { custom_audience: {...} | null, error }
      Client errors are returned as HTTP 200 with an `error` string so the UI can render them inline. */
      path: '/api/external/bigdipper/{pk}/team/ad-account-audience-create/',
      method: 'POST',
      paramsType: {} as {
        body: AdAccountAudienceCreateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdAccountAudienceCreate,
      errors: {} as "AD_ACCOUNT_NOT_SELECTED"|"AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ad_account_audiences: {
      /** List existing audiences from a connected ad account.
      Query params:
        - platform: required, 'meta', 'x', 'linkedin', 'pinterest', 'tiktok' or 'chatgpt'
        - ad_account_id: required, must belong to the team's selected ad accounts for that platform
      Response shape: { platform, ad_account_id, custom_audiences: [...], saved_audiences: [...], error }
      Client errors (invalid token, missing permissions) are returned as HTTP 200 with an `error` string
      so the UI can render per-account error states without breaking the rest of the page. A Meta token
      that is no longer valid is the exception: it fails the request with `META_RECONNECT_REQUIRED` so
      the UI can send the user to reconnect. */
      path: '/api/external/bigdipper/{pk}/team/ad-account-audiences/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAdAccountAudiencesQuery
      },
      responseType: {} as AdAccountAudiencesResponse,
      errors: {} as "AD_ACCOUNT_ID_REQUIRED"|"AD_ACCOUNT_NOT_SELECTED"|"AUDIENCE_PLATFORM_INVALID"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"META_RECONNECT_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ad_account_campaign_options: {
      /** Vendor picklists for campaign create on one ad account.
      Called when that platform/account is actually in use, instead of the
      all-platforms `campaign-options` fan-out. Optional `objective` skips
      vendor calls this objective does not need (e.g. no X web event tags
      on awareness). Omit it to fetch every list for the account.
      Query params:
        - platform: required, x | meta | linkedin | reddit | google_ads | tiktok | pinterest
        - ad_account_id: required
        - objective: optional, awareness | traffic | conversions | leads | app_installs */
      path: '/api/external/bigdipper/{pk}/team/ad-account-campaign-options/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAdAccountCampaignOptionsQuery
      },
      responseType: {} as AdAccountCampaignOptionsResponse,
      errors: {} as "AD_ACCOUNT_ID_REQUIRED"|"Ad account is not selected for this team"|"Billing admins can only access team management endpoints"|"CAMPAIGN_OPTIONS_FAILED"|"CAMPAIGN_OPTIONS_PLATFORM_INVALID"|"Could not extract team id from path"|"META_RECONNECT_REQUIRED"|"NOT_A_MEMBER"|"OBJECTIVE_INVALID"|"PLATFORM_NOT_CONNECTED"|"Team subscription is not active",
    },
    ada_analyze_options: {
      /** Extract the clickable options offered by Ada's latest reply. */
      path: '/api/external/bigdipper/{pk}/team/ada/analyze-options/',
      method: 'POST',
      paramsType: {} as {
        body: AdaAnalyzeOptionsInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdaAnalyzeOptions,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ask_ada: {
      /** SSE endpoint that asks Ada. */
      path: '/api/external/bigdipper/{pk}/team/ada/ask-ada/',
      method: 'POST',
      paramsType: {} as {
        body: AdaChatStreamInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdaChatStream,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ada_session_create: {
      /** Create a new Ada session. */
      path: '/api/external/bigdipper/{pk}/team/ada/session-create/',
      method: 'POST',
      paramsType: {} as {
        body: AdaSessionInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as AdaSession,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ada_sessions: {
      /** List recent Ada sessions for the current team/user. */
      path: '/api/external/bigdipper/{pk}/team/ada/sessions/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAdaSessionsQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: AdaSession[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ada_session: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/ada/sessions/{session_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          session_id: string|number
        }
      },
      responseType: {} as AdaSessionDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    ada_session_update: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/ada/sessions/{session_id}/patch/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<AdaSessionInput>
        path: {
          pk: string|number
          session_id: string|number
        }
      },
      responseType: {} as AdaSession,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_ads: {
      /** Get every ad creative that ran in a window, flattened across the team's ad accounts.
      Backs the creative card grid below the campaign table: the same window and
      ad-account filters as the campaign overview, but grouped by creative rather
      than by campaign. Also backs Research > Your Ads, which reads it over a
      longer window and compares each ad with `totals`. Ads that neither delivered in the window nor were created
      inside it are left out.
      Answers from cache only and never calls an ad platform: a platform whose
      entry is missing or stale is queued for a background rebuild, and the
      client polls until every platform it asked for is present in
      `platform_status` and not stale. The merged list is partial until then.
      Partial failures are reported per source instead of failing the request, so
      one broken connection does not empty the grid.
      Query params:
        - platforms: optional CSV of 'meta', 'x', 'linkedin', 'tiktok'; defaults to all four
        - ad_account_id: optional, restrict to a single ad account
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram'
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - limit / offset: paging over the merged, sorted list
        - sort: 'spend' (default), 'impressions', 'roas', 'recent', 'conversions', 'ctr', or 'cpa'
          (lowest first). 'ctr' and 'cpa' rank ads with too little delivery last
        - refresh: optional, 'true' to drop this request's cached answers and rebuild them
        - bust_cache: optional, 'true' to drop them with no cooldown, for exercising
          the cold path end to end. Internal users only */
      path: '/api/external/bigdipper/{pk}/team/ads/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamAdsQuery
      },
      responseType: {} as TeamAdsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    analytics_campaign_breakdown: {
      /** UTM breakdown for a single Google Analytics campaign (utm_campaign).
      Lazy-loaded when the user expands an analytics campaign row. Returns one
      row per value of the requested breakdown dimension, shaped like the
      campaign rows so the same UI cells can render it.
      Query params:
        - property_id: GA4 property the campaign belongs to (required)
        - campaign_name: the utm_campaign value to break down (required)
        - dimension: one of source (default), content, medium, term
        - source / medium / content / term: optional, keep only sessions whose UTM value for that
          dimension equals the given value, so a breakdown row can be broken down further
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days */
      path: '/api/external/bigdipper/{pk}/team/analytics-campaign-breakdown/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAnalyticsCampaignBreakdownQuery
      },
      responseType: {} as AnalyticsCampaignBreakdownResponse,
      errors: {} as "BREAKDOWN_DIMENSION_UNSUPPORTED"|"BREAKDOWN_PARAMS_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    analytics_platform_stats: {
      /** Google Analytics metrics per ad platform, attributed by traffic source.
      Backs the GA columns on the campaign overview's platform table: sessions
      are grouped by source/medium and rolled up into the ad platforms, summed
      across every GA4 property the team selected. Sources that don't belong to
      an ad platform (organic search, direct, ...) are left out.
      Query params:
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days */
      path: '/api/external/bigdipper/{pk}/team/analytics-platform-stats/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAnalyticsPlatformStatsQuery
      },
      responseType: {} as AnalyticsPlatformStatsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    app_store_names: {
      /** Resolve App Store / Google Play identifiers to the app names behind them.
      The ad platforms hand out store identifiers with no display name, so the
      name has to come from the store. Answers from cache only and never calls
      a store while the request is open: an identifier nothing has been fetched
      for comes back `pending` and is queued for a background lookup, so one
      request is not an answer, a series of them is.
      An identifier that resolved to nothing comes back `empty` rather than
      `pending` - that is the caller's signal to stop polling and label the app
      with its bare identifier. A numeric id is always an App Store id and a
      dotted one always a Play package, which is what decides the store asked;
      anything shaped like neither is `empty` immediately.
      Query params:
        - app_ids: required, comma-separated store identifiers (numeric App
          Store ids or Play package names). Ids past the 25 one lookup covers
          come back `empty` */
      path: '/api/external/bigdipper/{pk}/team/app-store-names/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAppStoreNamesQuery
      },
      responseType: {} as AppStoreNamesResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience_prompt_analyze: {
      /** Analyze a free-text audience prompt into a structured audience spec.
      POST body: prompt (string). Returns spec (audience_type, keywords, countries,
      age, genders, B2C interests/behaviors, B2B job titles/industries/companies/
      seniorities/skills, handles) plus a search_id to pass to team-audience-save. */
      path: '/api/external/bigdipper/{pk}/team/audience-prompt-analyze/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAudiencePromptAnalyzeInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneAudiencePromptAnalyze,
      errors: {} as "AUDIENCE_DESCRIPTION_TOO_VAGUE"|"AUDIENCE_DESCRIPTION_UNREADABLE"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"The audience description is not brand safe",
    },
    team_audience_prompts: {
      /** Suggest up to 5 prompts for creating a new audience.
      Each suggestion corresponds to one audience segment from the team's
      completed Target Audiences research. The suggestions are cached per
      team for one hour. Returns an empty list when there is no completed
      research to analyze. */
      path: '/api/external/bigdipper/{pk}/team/audience-prompts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as AudiencePromptSuggestions,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audience: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/audience/{audience_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          audience_id: string|number
        }
      },
      responseType: {} as BigDipperAudienceDetail,
      errors: {} as "AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    audiences: {
      /** List bigdipper audiences. */
      path: '/api/external/bigdipper/{pk}/team/audiences/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetAudiencesQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: BigDipperAudience[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_cards_analytics: {
      /** Best-effort Google Analytics sessions per BigDipper campaign. */
      path: '/api/external/bigdipper/{pk}/team/campaign-cards-analytics/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignCardsAnalyticsQuery
      },
      responseType: {} as CampaignCardsAnalyticsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"INVALID_CAMPAIGN_ID"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_cards: {
      /** List the team's BigDipper campaigns for the overview grid (DB only). */
      path: '/api/external/bigdipper/{pk}/team/campaign-cards/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignCardsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_create: {
      /** Create a campaign on one or more platforms.
      Accepts a unified payload with campaign-level fields and per-platform settings.
      Currently supports X only. */
      path: '/api/external/bigdipper/{pk}/team/campaign-create/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignCreateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignCreate,
      errors: {} as "AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"CAMPAIGN_CREATE_FAILED"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_creatives: {
      /** Get promotable content for a given platform and ad account.
      Query params:
        - platform: x | meta | linkedin | reddit | google_ads (required)
        - ad_account_id: the ad account to fetch creatives for (required)
        - ad_format: LinkedIn campaign format to filter creatives by (optional)
        - limit: max number of creatives to return (optional, default 20)
        - offset: number of creatives to skip for pagination (optional, default 0)
        - source: 'ads' (default) | 'organic'. When 'organic' on Meta, returns
          the page's published posts (newest first) via Meta's `/ads_posts`
          edge instead of the ad account's existing AdCreatives.
        - page_id: Meta page id, required when source == 'organic'.
        - after: cursor for organic pagination (Meta `paging.cursors.after`). */
      path: '/api/external/bigdipper/{pk}/team/campaign-creatives/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignCreativesQuery
      },
      responseType: {} as CampaignCreativesResponse,
      errors: {} as "AD_ACCOUNT_ID_REQUIRED"|"Billing admins can only access team management endpoints"|"CREATIVES_FAILED"|"Could not extract team id from path"|"NOT_A_MEMBER"|"ORGANIC_SOURCE_META_ONLY"|"PAGE_ID_REQUIRED"|"PLATFORM_REQUIRED"|"Team subscription is not active",
    },
    campaign_daily_stats: {
      /** Get daily campaign stats for charting purposes.
      Returns aggregated daily impressions, engagements, clicks, and spend per platform.
      Query params:
        - platform: required, the platform to fetch ('x', 'meta',
          'linkedin', or 'google_analytics')
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram'
        - campaign_ids: optional, repeatable campaign IDs to restrict the
          aggregation to (LinkedIn uses campaign group IDs). When omitted, stats
          are aggregated across all campaigns.
        - ad_account_ids: optional, repeatable ad account IDs to restrict the
          aggregation to. When omitted, all of the team's selected ad accounts are
          aggregated.
        - property_id: optional, for google_analytics only: restrict to a single
          GA4 property.
        - refresh: optional, 'true' to skip the cached answer and call the platform again
      Answers are cached per team, platform and window (see
      ``bigdipper_stats_cache``), shared with the campaign overview's cache. */
      path: '/api/external/bigdipper/{pk}/team/campaign-daily-stats/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignDailyStatsQuery
      },
      responseType: {} as CampaignDailyStats,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_PLATFORM_INVALID"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_draft_save: {
      /** Save the wizard setup on a campaign. Stored in our database only, never sent to the ad platforms.
      Omit ``bigdipper_campaign_id`` to create a draft. Pass it to overwrite that
      campaign's draft, including after the campaign has been launched. */
      path: '/api/external/bigdipper/{pk}/team/campaign-draft-save/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignDraftSaveInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignDraftSave,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_duplicate: {
      /** Copy a draft or launched campaign into a new draft. Nothing is sent to the ad platforms. */
      path: '/api/external/bigdipper/{pk}/team/campaign-duplicate/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignDuplicateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignDuplicate,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_NOTHING_TO_DUPLICATE"|"CAMPAIGN_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_entity_set_status: {
      /** Activate or pause a campaign / ad set / ad on the requested platform.
      Returns ``200`` with ``{success, status, error?}``. Combinations the
      platform clients do not support (e.g. ad-level pause on X or LinkedIn)
      respond with ``success=False`` and an explanatory ``error`` rather than
      a 4xx/5xx, to keep the front-end toggle UX simple. */
      path: '/api/external/bigdipper/{pk}/team/campaign-entity-set-status/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignEntityStatusInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignEntityStatus,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_group_channels_update: {
      /** Link/unlink existing platform campaigns on a BigDipper campaign group. */
      path: '/api/external/bigdipper/{pk}/team/campaign-group-channels-update/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignGroupChannelsUpdateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignGroupChannelsUpdate,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_ALREADY_IN_GROUP"|"CAMPAIGN_GROUP_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_group_create: {
      /** Create an empty BigDipper campaign group to link platform campaigns to. */
      path: '/api/external/bigdipper/{pk}/team/campaign-group-create/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignGroupCreateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignGroupCreate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_group_delete: {
      /** Delete a BigDipper campaign group. Platform campaigns are not touched. */
      path: '/api/external/bigdipper/{pk}/team/campaign-group-delete/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignGroupDeleteInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignGroupDelete,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_GROUP_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_leads_export: {
      /** Export the filtered leads as a CSV download. */
      path: '/api/external/bigdipper/{pk}/team/campaign-leads-export/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignLeadsExportQuery
      },
      responseType: {} as StandaloneDummy,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_leads_sync: {
      /** On-demand, rate-limited pull of new leads for a campaign's forms.
      Syncs Meta instant forms and LinkedIn lead gen forms in one pass. Omit
      campaign_id to sync every lead form the team has. */
      path: '/api/external/bigdipper/{pk}/team/campaign-leads-sync/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignLeadsSyncResponseInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignLeadsSyncResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"Leads are already up to date. Please try again in a moment."|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_leads: {
      /** List synced Meta instant-form and LinkedIn lead gen form leads, newest first.
      Omit campaign_id to list every lead the team has across all campaigns, and
      omit platform to list both platforms merged into one timeline.
      Query params: campaign_id, platform, form_id, search, start_date, end_date,
      page, page_size. */
      path: '/api/external/bigdipper/{pk}/team/campaign-leads/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignLeadsQuery
      },
      responseType: {} as CampaignLeadsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_options: {
      /** Get available objectives, connected ad accounts, funding instruments,
      and bid strategies for campaign creation. */
      path: '/api/external/bigdipper/{pk}/team/campaign-options/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as CampaignOptionsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_OPTIONS_FAILED"|"Could not extract team id from path"|"META_RECONNECT_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_overview: {
      /** Get campaign overview stats across connected social ad accounts.
      Uses the user's own OAuth tokens to fetch data on-the-fly from the platform APIs.
      Only includes ad accounts the team has selected; none selected returns none.
      For google_analytics, each GA4 property maps to an ad account and each row of the
      sessionCampaignName breakdown maps to a campaign, shaped like the campaign overview
      so the same Big Dipper UI can render it. Stats include
      sessions / users / pageviews / engagement_rate.
      Query params:
        - platform: required, the platform to fetch ('x', 'meta', 'linkedin',
          'google_analytics', 'google_ads', 'reddit', 'tiktok', 'pinterest', or 'chatgpt')
        - ad_account_id: optional, filter to a specific ad account within the platform
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram'
        - property_id: optional, for google_analytics only: populate campaigns for that GA4
          property only (other properties still appear in the list with empty campaigns so
          the property picker can show them)
        - refresh: optional, 'true' to skip the cached answer and call the platform again
      Answers are cached per team, platform and window (see
      ``bigdipper_stats_cache``), so a burst of dashboard renders costs the
      platforms one call rather than one per render. */
      path: '/api/external/bigdipper/{pk}/team/campaign-overview/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignOverviewQuery
      },
      responseType: {} as CampaignOverview,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_PLATFORM_INVALID"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/campaign/{campaign_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          campaign_id: string|number
        }
      },
      responseType: {} as CampaignRead,
      errors: {} as "Billing admins can only access team management endpoints"|"CAMPAIGN_NOT_FOUND"|"Could not extract team id from path"|"INVALID_CAMPAIGN_ID"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_publish: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/campaign/{campaign_id}/publish/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignPublishInput
        path: {
          pk: string|number
          campaign_id: string|number
        }
      },
      responseType: {} as CampaignPublish,
      errors: {} as "AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"CAMPAIGN_CONTENT_NOT_PUBLISHED"|"CAMPAIGN_CREATE_FAILED"|"CAMPAIGN_DRAFT_NOT_FOUND"|"CAMPAIGN_NOTHING_TO_PUBLISH"|"CAMPAIGN_NOT_DRAFT"|"CAMPAIGN_NOT_FOUND"|"CAMPAIGN_PLATFORM_ALREADY_LAUNCHED"|"CAMPAIGN_PLATFORM_INVALID"|"CAMPAIGN_PLATFORM_NOT_ENABLED"|"Could not extract team id from path"|"INVALID_CAMPAIGN_ID"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaign_update_from_draft: {
      /** Send the difference between the saved draft and the launched copy.
      The body is empty. The campaign id is in the path. Nothing here publishes posts. */
      path: '/api/external/bigdipper/{pk}/team/campaign/{campaign_id}/update/',
      method: 'POST',
      paramsType: {} as {
        body: CampaignUpdateInput
        path: {
          pk: string|number
          campaign_id: string|number
        }
      },
      responseType: {} as CampaignUpdate,
      errors: {} as "AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"CAMPAIGN_CONTENT_NOT_PUBLISHED"|"CAMPAIGN_DRAFT_NOT_FOUND"|"CAMPAIGN_LAUNCHED_COPY_MISSING"|"CAMPAIGN_NOTHING_TO_PUBLISH"|"CAMPAIGN_NOT_FOUND"|"CAMPAIGN_NOT_LAUNCHED"|"CAMPAIGN_PLATFORM_ALREADY_LAUNCHED"|"CAMPAIGN_PLATFORM_INVALID"|"CAMPAIGN_PLATFORM_NOT_ENABLED"|"CAMPAIGN_UPDATE_FAILED"|"Could not extract team id from path"|"INVALID_CAMPAIGN_ID"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    campaigns: {
      /** Get every requested platform's campaign overview and daily series in one response.
      Answers from cache only and never calls an ad platform: a platform whose
      entry is missing or stale is queued for a background rebuild, and the
      client polls until it lands. A platform absent from either list is not
      ready yet - the client derives that from what it asked for.
      Query params:
        - platforms: comma-separated subset of 'x', 'meta', 'linkedin',
          'google_analytics', 'google_ads', 'reddit', 'tiktok', 'pinterest', 'chatgpt'; defaults to all of them
        - kinds: comma-separated subset of 'overview', 'daily'; defaults to both. A kind
          that is not asked for is neither served nor queued, and comes back as an empty list
        - start_date / end_date: reporting window (ISO YYYY-MM-DD); defaults to the last 7 days
        - placement: optional, for meta only: 'all' (default), 'facebook', or 'instagram'
        - property_id: optional, for google_analytics only: the GA4 property to populate
        - ad_account_id: optional, narrows the served overview to a single ad account
        - refresh: optional, 'true' to drop this request's cached answers and rebuild them
        - bust_cache: optional, 'true' to drop them with no cooldown, for exercising
          the cold path end to end. Internal users only - it bypasses the refresh
          cooldown that keeps reload-spam off the build queue */
      path: '/api/external/bigdipper/{pk}/team/campaigns/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetCampaignsQuery
      },
      responseType: {} as Campaigns,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_chatgpt_ad_accounts: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/chatgpt-ads-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetChatgptAdAccountsQuery
      },
      responseType: {} as ChatgptAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    content_approval_requests: {
      /** Every organic content post with a platform waiting for approval.
      Not paginated, so the queue is complete. A post is waiting when one of
      its platforms is scheduled and not approved. */
      path: '/api/external/bigdipper/{pk}/team/content-approval-requests/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as ContentApprovalRequests,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_approval: {
      /** Approve, send back, or resubmit one organic platform row. */
      path: '/api/external/bigdipper/{pk}/team/content-approval/{platform_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentApprovalInput
        path: {
          pk: string|number
          platform_id: string|number
        }
      },
      responseType: {} as ContentApproval,
      errors: {} as "APPROVAL_ACTION_UNKNOWN"|"APPROVAL_ORGANIC_ONLY"|"APPROVAL_TIME_TOO_EARLY"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FACEBOOK_NOT_ON_POST"|"FACEBOOK_SCHEDULE_FAILED"|"NOT_A_MEMBER"|"NO_CHANGES_REQUESTED"|"Only someone who can approve posts can approve this post."|"Only someone who can approve posts can request changes."|"PLATFORM_CANNOT_BE_SCHEDULED"|"PLATFORM_POST_NOT_FOUND"|"POST_NOT_APPROVABLE"|"POST_NOT_AWAITING_APPROVAL"|"POST_PUBLISH_FAILED"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_cancel_scheduled: {
      /** Cancel one scheduled platform. The creative stays as a draft.
      An approved Facebook schedule is deleted on Graph unless it is already
      due. A Facebook post still waiting was never sent. X, Instagram,
      LinkedIn and Reddit are local. */
      path: '/api/external/bigdipper/{pk}/team/content-cancel-scheduled/{platform_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentCancelScheduledInput
        path: {
          pk: string|number
          platform_id: string|number
        }
      },
      responseType: {} as ContentCancelScheduled,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FACEBOOK_POST_DUE_CANNOT_CANCEL"|"NOT_A_MEMBER"|"POST_NOT_SCHEDULED"|"SCHEDULED_POST_NOT_FOUND"|"SCHEDULE_CANCEL_FAILED"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_create: {
      /** Create one post from the whole draft. Later saves use the save action. */
      path: '/api/external/bigdipper/{pk}/team/content-create/',
      method: 'POST',
      paramsType: {} as {
        body: ContentDetailInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as ContentDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_delete_published: {
      /** Delete one published network post.
      Other platforms on the same content post are left alone. Refuses if
      the post is used in a live ad campaign. Instagram, TikTok, Reddit and ChatGPT
      are not supported. Scheduled rows must be cancelled, not deleted here. */
      path: '/api/external/bigdipper/{pk}/team/content-delete-published/{platform_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentCancelScheduledInput
        path: {
          pk: string|number
          platform_id: string|number
        }
      },
      responseType: {} as ContentCancelScheduled,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_DELETE_FAILED"|"POST_NOT_PUBLISHED"|"PUBLISHED_POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_delete: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/content-delete/{content_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentDeleteInput
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentDelete,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_HAS_PLATFORMS"|"POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_duplicate: {
      /** Clone one post into a new draft. Published ids and the schedule are cleared. */
      path: '/api/external/bigdipper/{pk}/team/content-duplicate/{content_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentDetailInput
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_publish_status: {
      /** Progress for a content publish. Poll this until every job is completed or failed. */
      path: '/api/external/bigdipper/{pk}/team/content-publish-status/{content_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentPublish,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_publish: {
      /** Publish or schedule one content post.
      Organic posts wait for approval when the team requires it. Dark posts
      publish immediately and cannot be scheduled. A video publish now is
      queued and this returns immediately. */
      path: '/api/external/bigdipper/{pk}/team/content-publish/{content_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentPublishInput
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentPublish,
      errors: {} as "APPROVER_NOT_ALLOWED"|"APPROVER_REQUIRED"|"AUDIENCE_NOT_FOUND"|"Billing admins can only access team management endpoints"|"CAMPAIGN_NOT_FOUND"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Only someone who can approve posts can bypass approval."|"POST_NOT_FOUND"|"SCHEDULED_AT_INVALID"|"SCHEDULED_AT_TOO_FAR"|"SCHEDULED_AT_TOO_SOON"|"SCHEDULING_ORGANIC_ONLY"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_reschedule: {
      /** Move one scheduled platform to a new time.
      An approved Facebook schedule is updated on Graph unless it is already
      due. A waiting Facebook post, and X, Instagram, LinkedIn and Reddit,
      only store the new time. */
      path: '/api/external/bigdipper/{pk}/team/content-reschedule/{platform_id}/',
      method: 'POST',
      paramsType: {} as {
        body: ContentRescheduleInput
        path: {
          pk: string|number
          platform_id: string|number
        }
      },
      responseType: {} as ContentReschedule,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FACEBOOK_POST_DUE_CANNOT_RESCHEDULE"|"NOT_A_MEMBER"|"POST_NOT_SCHEDULED"|"RESCHEDULE_FAILED"|"SCHEDULED_AT_INVALID"|"SCHEDULED_AT_TOO_FAR"|"SCHEDULED_AT_TOO_SOON"|"SCHEDULED_POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_save: {
      /** Save the whole draft onto an existing post. */
      path: '/api/external/bigdipper/{pk}/team/content-save/{content_id}/',
      method: 'PUT',
      paramsType: {} as {
        body: ContentDetailInput
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_list: {
      /** One page of content posts, each with its platform rows.
      A platform row is the short list: platform, text, status, and dates.
      It is not the X, Facebook, or other network post.
      Filter with search (text), scheduled_after / scheduled_before
      (ISO date or datetime), and publish_type (organic or dark).
      Paginate with limit and offset. */
      path: '/api/external/bigdipper/{pk}/team/content/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetContentListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: ContentList[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    content_detail: {
      /** Fetch one post and every network on it. */
      path: '/api/external/bigdipper/{pk}/team/content/{content_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          content_id: string|number
        }
      },
      responseType: {} as ContentDetail,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"POST_NOT_FOUND"|"Team subscription is not active"|"You are not a member of this team.",
    },
    dashboard_organic: {
      /** Organic followers, impressions, interactions and posts per platform, from cache, with a daily series. */
      path: '/api/external/bigdipper/{pk}/team/dashboard-organic/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetDashboardOrganicQuery
      },
      responseType: {} as DashboardOrganic,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    facebook_pages: {
      path: '/api/external/bigdipper/{pk}/team/facebook-pages/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetFacebookPagesQuery
      },
      responseType: {} as StandaloneFacebookPages,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FACEBOOK_ACCOUNT_NOT_FOUND"|"FACEBOOK_PAGES_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    facebook_pages_post: {
      path: '/api/external/bigdipper/{pk}/team/facebook-pages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFacebookPagesInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneFacebookPages,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FACEBOOK_ACCOUNT_NOT_FOUND"|"FACEBOOK_PAGES_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    generate_text: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/generate-text/',
      method: 'POST',
      paramsType: {} as {
        body: GenerateTextInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as GenerateText,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    generate_media: {
      /** Generate images or videos based on a prompt and reference media */
      path: '/api/external/bigdipper/{pk}/team/generate_media/',
      method: 'POST',
      paramsType: {} as {
        body: GenerateMediaInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as GenerateMedia,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"MEDIA_GENERATION_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_google_ads_accounts: {
      /** Get the Google Ads customer accounts available to the authenticated team.
      Returns connection status and all accessible customer accounts, each flagged
      with whether it is currently selected for this team. */
      path: '/api/external/bigdipper/{pk}/team/google-ads-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetGoogleAdsAccountsQuery
      },
      responseType: {} as GoogleAdsAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_google_analytics_accounts: {
      /** Get the Google Analytics 4 properties available to the authenticated team.
      Returns connection status and all accessible properties, each flagged with
      whether it is currently selected for this team. */
      path: '/api/external/bigdipper/{pk}/team/google-analytics-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetGoogleAnalyticsAccountsQuery
      },
      responseType: {} as GoogleAnalyticsAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    instagram_pages: {
      path: '/api/external/bigdipper/{pk}/team/instagram-pages/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetInstagramPagesQuery
      },
      responseType: {} as StandaloneInstagramPagesPages,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    instagram_pages_post: {
      path: '/api/external/bigdipper/{pk}/team/instagram-pages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneInstagramPagesPagesInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneInstagramPagesPages,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_linkedin_ad_accounts: {
      /** Get user's LinkedIn ad accounts for dark post publishing.
      Returns ad accounts the user has access to via the LinkedIn Ads API. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetLinkedinAdAccountsQuery
      },
      responseType: {} as LinkedInAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_community_organizations: {
      path: '/api/external/bigdipper/{pk}/team/linkedin-community-organizations/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinCommunityOrganizationsQuery
      },
      responseType: {} as StandaloneLinkedInOrganizations,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_COMMUNITY_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATIONS_UNVERIFIED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_community_organizations_post: {
      path: '/api/external/bigdipper/{pk}/team/linkedin-community-organizations/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneLinkedInOrganizationsInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneLinkedInOrganizations,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_COMMUNITY_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATIONS_UNVERIFIED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_lead_form_detail: {
      /** Fetch one LinkedIn lead gen form, mapped onto the dashboard's form shape.
      Query params:
        - ad_account_id: required, the ad account the form belongs to.
        - form_id: required, the lead gen form to fetch.
      LinkedIn only allows editing a few fields of a published form, so this
      backs a read-only preview. Client errors come back as HTTP 200 with an
      `error` string. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-lead-form-detail/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinLeadFormDetailQuery
      },
      responseType: {} as LinkedInLeadFormDetailResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_LEAD_FORM_PARAMS_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_lead_forms_create: {
      /** Create a LinkedIn lead gen form on an ad account and record it for lead syncing. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-lead-forms-create/',
      method: 'POST',
      paramsType: {} as {
        body: LinkedInLeadFormCreateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as LinkedInLeadFormCreate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LEAD_FORM_CREATE_FAILED"|"LEAD_FORM_INVALID"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"Team subscription is not active",
    },
    linkedin_lead_forms: {
      /** List the LinkedIn lead gen forms for an ad account.
      Query params:
        - ad_account_id: required, the LinkedIn ad account the forms belong to.
      Client errors are returned as HTTP 200 with an `error` string so the UI
      can render an inline error without breaking the ad-group form. A LinkedIn
      token that predates the lead-form permissions is the exception: the user
      can only fix it by reconnecting, so it is raised. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-lead-forms/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinLeadFormsQuery
      },
      responseType: {} as LinkedInLeadFormsResponse,
      errors: {} as "AD_ACCOUNT_ID_REQUIRED"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PERMISSION_MISSING"|"Team subscription is not active",
    },
    linkedin_mention_search: {
      /** Followers whose name starts with the typed prefix, via the Community connection.
      ``q`` is the prefix with or without a leading @. LinkedIn returns at
      most ten people per organization. A prefix that is too short returns
      an empty list. ``organization`` limits the search to one selected
      community page; otherwise every selected page is searched. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-mention-search/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinMentionSearchQuery
      },
      responseType: {} as LinkedInMentionSearch,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_COMMUNITY_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATION_NOT_SELECTED"|"LINKEDIN_ORGANIZATION_REQUIRED"|"LINKEDIN_PEOPLE_SEARCH_REFUSED"|"LINKEDIN_RATE_LIMITED"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"SEARCH_QUERY_REQUIRED"|"Team subscription is not active",
    },
    linkedin_mention: {
      /** The person or company behind a LinkedIn link, for an @mention.
      ``url`` is a public profile link (https://www.linkedin.com/in/…) or a
      company page (https://www.linkedin.com/company/…). A person link needs
      one selected community page the member administers; otherwise the
      first selected page is used. A company page does not. ``urn`` reloads
      a person who is already tagged, without a profile link. A link wins
      when both are sent. The name is the localized name. For a person,
      first_name and last_name are the other texts LinkedIn will accept.
      The post text has to match one of them. */
      path: '/api/external/bigdipper/{pk}/team/linkedin-mention/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinMentionQuery
      },
      responseType: {} as LinkedInMention,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_COMMUNITY_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATION_NOT_SELECTED"|"LINKEDIN_ORGANIZATION_REQUIRED"|"LINKEDIN_PROFILE_LOOKUP_REFUSED"|"LINKEDIN_PROFILE_NOT_FOUND"|"LINKEDIN_PROFILE_URL_INVALID"|"LINKEDIN_RATE_LIMITED"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"Team subscription is not active",
    },
    linkedin_organizations: {
      path: '/api/external/bigdipper/{pk}/team/linkedin-organizations/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetLinkedinOrganizationsQuery
      },
      responseType: {} as StandaloneLinkedInOrganizations,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATIONS_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    linkedin_organizations_post: {
      path: '/api/external/bigdipper/{pk}/team/linkedin-organizations/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneLinkedInOrganizationsInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneLinkedInOrganizations,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LINKEDIN_ACCOUNT_NOT_FOUND"|"LINKEDIN_ORGANIZATIONS_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_media_save: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/media-save/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamMediaInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamMedia,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"MEDIA_STORE_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_media_upload: {
      /** Upload media to the team
      Accepts multipart/form-data with one or more image files.
      POST body (multipart/form-data):
          images: File or list of files - The image(s) to upload
          alt: string (optional) - Alt text for the image(s)
      Per-file size limits: images 25MB, videos 100MB. Oversized files are
      reported in `errors` and the rest of the batch still uploads.
      Query params (Social Database users only, ignored for everyone else):
          skip_compression: bool - upload the original bytes as-is
          skip_thumbnail: bool - do not generate a video thumbnail
          skip_hash: bool - do not compute image perceptual hashes */
      path: '/api/external/bigdipper/{pk}/team/media-upload/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperTeamMediaUploadInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperTeamMediaUpload,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FILES_REQUIRED"|"MEDIA_UPLOAD_FAILED"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    team_media: {
      /** Get all media objects for the user's team. */
      path: '/api/external/bigdipper/{pk}/team/media/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamMediaQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: BigDipperTeamMedia[]
      },
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_media_update: {
      /** Update a team media object (toggle selected/disabled).
      Body params:
          selected: boolean (optional)
          disabled: boolean (optional) */
      path: '/api/external/bigdipper/{pk}/team/media/{media_id}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<BigDipperTeamMediaInput>
        path: {
          pk: string|number
          media_id: string|number
        }
      },
      responseType: {} as BigDipperTeamMedia,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_mention_stream: {
      /** Unified @mention and reply stream across the team's connected social accounts.
      Returns `items` (one time-sorted list across platforms) plus `sources`
      (per-platform status, so the UI can explain an empty stream).
      Query params:
          platforms: CSV filter, e.g. `x,linkedin`. Defaults to all platforms.
          limit: Maximum items to return (default 50, max 200) */
      path: '/api/external/bigdipper/{pk}/team/mention-stream/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamMentionStreamQuery
      },
      responseType: {} as MentionStreamResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_meta_ad_accounts: {
      /** Get user's Meta ad accounts for dark post publishing.
      Works for both Facebook and Instagram dark posts.
      Returns ad accounts the user has access to via the Marketing API. */
      path: '/api/external/bigdipper/{pk}/team/meta-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetMetaAdAccountsQuery
      },
      responseType: {} as MetaAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_meta_dsa_recommendations: {
      /** Return the Meta-suggested DSA advertiser/payor strings for an ad account.
      Meta's `/act_<id>/dsa_recommendations` endpoint surfaces up to ~10
      likely beneficiary/payor strings based on the ad account's recent
      activity. We expose them so the user can pick one from a dropdown
      instead of typing it from scratch. See: */
      path: '/api/external/bigdipper/{pk}/team/meta-dsa-recommendations/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetMetaDsaRecommendationsQuery
      },
      responseType: {} as MetaDsaRecommendationsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    meta_lead_form_asset_upload: {
      /** Upload a file to offer as an instant form's thank-you page download.
      Accepts multipart/form-data with a single `file`. Returns the hosted URL
      to pass back as the form's thank-you website_url. */
      path: '/api/external/bigdipper/{pk}/team/meta-lead-form-asset-upload/',
      method: 'POST',
      paramsType: {} as {
        body: MetaLeadFormAssetUploadInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as MetaLeadFormAssetUpload,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"FILE_REQUIRED"|"FILE_STORE_FAILED"|"LEAD_FORM_ASSET_TOO_LARGE"|"LEAD_FORM_ASSET_TYPE_UNSUPPORTED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    meta_lead_form_detail: {
      /** Fetch one Meta instant form, mapped onto the dashboard's form shape.
      Query params:
        - page_id: required, the Meta page the form belongs to.
        - form_id: required, the instant form to fetch.
      Meta forms cannot be edited once live, so this only backs a read-only
      preview. Client errors come back as HTTP 200 with an `error` string. */
      path: '/api/external/bigdipper/{pk}/team/meta-lead-form-detail/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetMetaLeadFormDetailQuery
      },
      responseType: {} as MetaLeadFormDetailResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"META_LEAD_FORM_PARAMS_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    meta_lead_forms_create: {
      /** Create a Meta instant form on a page and record it for lead syncing. */
      path: '/api/external/bigdipper/{pk}/team/meta-lead-forms-create/',
      method: 'POST',
      paramsType: {} as {
        body: MetaLeadFormCreateInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as MetaLeadFormCreate,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"LEAD_FORM_CREATE_FAILED"|"LEAD_FORM_INVALID"|"NOT_A_MEMBER"|"PLATFORM_RATE_LIMITED"|"PLATFORM_RECONNECT_REQUIRED"|"PLATFORM_REJECTED"|"PLATFORM_REQUEST_FAILED"|"Team subscription is not active",
    },
    meta_lead_forms: {
      /** List the Meta instant (lead generation) forms for a page.
      Query params:
        - page_id: required, the Meta page to list forms for.
      Client errors are returned as HTTP 200 with an `error` string so the UI
      can render an inline error without breaking the ad-group form. A Meta
      token that predates the lead-form permissions is the exception: the user
      can only fix it by reconnecting, so it is raised. */
      path: '/api/external/bigdipper/{pk}/team/meta-lead-forms/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetMetaLeadFormsQuery
      },
      responseType: {} as MetaLeadFormsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PAGE_ID_REQUIRED"|"PERMISSION_MISSING"|"Team subscription is not active",
    },
    team_notifications_mark_read: {
      /** Set per-user read state for notifications. */
      path: '/api/external/bigdipper/{pk}/team/notifications-mark-read/',
      method: 'POST',
      paramsType: {} as {
        body: BigDipperNotificationMarkReadInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as BigDipperNotificationMarkRead,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_notifications: {
      /** List the team's async publish-error and report notifications, newest first, annotated with read state.
      Sync errors other than account-connection errors are omitted: they were already returned to the user
      in the failing request's response, so they only need to be persisted (for the weekly digest), not
      resurfaced here. */
      path: '/api/external/bigdipper/{pk}/team/notifications/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTeamNotificationsQuery
      },
      responseType: {} as BigDipperNotification[],
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_pinterest_ad_accounts: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/pinterest-ads-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetPinterestAdAccountsQuery
      },
      responseType: {} as PinterestAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    pinterest_board_sections: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/pinterest-board-sections/{board_id}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
          board_id: string|number
        }
        query?: GetPinterestBoardSectionsQuery
      },
      responseType: {} as PinterestBoardSectionsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PINTEREST_BOARDS_LOOKUP_FAILED"|"Team subscription is not active",
    },
    pinterest_boards: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/pinterest-boards/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetPinterestBoardsQuery
      },
      responseType: {} as PinterestBoardsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"PINTEREST_BOARDS_LOOKUP_FAILED"|"Team subscription is not active",
    },
    platform_feed: {
      /** Fetch a feed of recent posts from all connected social platforms.
      Returns up to 10 posts per connected platform (X, Facebook, Instagram, LinkedIn).
      Used for the feeds on the home dashboard and the Content Wall (TweetDeck-style multi-column view).
      Query params:
          max_results: Maximum posts to fetch per platform (default 10, max 10) */
      path: '/api/external/bigdipper/{pk}/team/platform-feed/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetPlatformFeedQuery
      },
      responseType: {} as PlatformFeedResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_reddit_ad_accounts: {
      /** Get the Reddit ad accounts available to the authenticated team.
      Returns connection status and accessible ad accounts, each flagged
      with whether it is currently selected for this team.
      Pass ``selected_only=true`` to return only the ad accounts currently
      selected for this team. */
      path: '/api/external/bigdipper/{pk}/team/reddit-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetRedditAdAccountsQuery
      },
      responseType: {} as RedditAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    team_research_start: {
      /** Create pending research sections and trigger the Celery research task. */
      path: '/api/external/bigdipper/{pk}/team/research-start/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TeamResearchStart,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    social_accounts: {
      /** Social accounts for bigdipper.
      Sending no keywords & countries returns a cached response of the top 100 accounts globally across all topics. */
      path: '/api/external/bigdipper/{pk}/team/search-social-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetSocialAccountsQuery
      },
      responseType: {} as StandaloneSocialAccounts,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"NO_ACCOUNTS_FOUND"|"Team subscription is not active",
    },
    selected_ad_accounts: {
      path: '/api/external/bigdipper/{pk}/team/selected-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as SelectedAdAccountsResponse,
      errors: {} as "AD_ACCOUNT_IDS_INVALID"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"JSON_OBJECT_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    selected_ad_accounts_post: {
      path: '/api/external/bigdipper/{pk}/team/selected-ad-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: SelectedAdAccountsResponseInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as SelectedAdAccountsResponse,
      errors: {} as "AD_ACCOUNT_IDS_INVALID"|"Billing admins can only access team management endpoints"|"Could not extract team id from path"|"JSON_OBJECT_REQUIRED"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    sync_media: {
      /** endpoints for socialdatabase.com */
      path: '/api/external/bigdipper/{pk}/team/sync-media/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetSyncMediaQuery
      },
      responseType: {} as SyncMedia,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    targeting_pack_x_build_status: {
      /** Poll the status of an async X targeting pack build. Returns {status, pack}. */
      path: '/api/external/bigdipper/{pk}/team/targeting-pack-x-build-status/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetTargetingPackXBuildStatusQuery
      },
      responseType: {} as StandaloneXTargetingPackBuildStatus,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"No X targeting pack build found for this config"|"Team subscription is not active"|"This targeting pack build belongs to another team",
    },
    targeting_pack_x_build: {
      /** Start the async build of the final X targeting pack (autopilot phase 1).
      POST body: input_keywords, input_countries, optional spec hints and search_id.
      Returns config_id to poll targeting-pack-x-build-status with, and to pass
      back to team-audience-save as x_pack_config_id. */
      path: '/api/external/bigdipper/{pk}/team/targeting-pack-x-build/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXTargetingPackBuildInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneXTargetingPackBuild,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    get_tiktok_ad_accounts: {
      /** Get the TikTok advertiser accounts available to the authenticated team.
      Returns connection status and accessible advertisers, each flagged
      with whether it is currently selected for this team.
      Pass ``selected_only=true`` to return only the advertisers currently
      selected for this team. */
      path: '/api/external/bigdipper/{pk}/team/tiktok-ads-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetTiktokAdAccountsQuery
      },
      responseType: {} as TikTokAdAccountsResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    website_urls: {
      /** Discover internal URLs from a website.
      Query params:
          url: The URL to discover from (optional, falls back to the team websites)
          max_urls: Maximum URLs to return (default 10) */
      path: '/api/external/bigdipper/{pk}/team/website-urls/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as StandaloneDummy,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active"|"You are not a member of this team.",
    },
    get_x_ad_accounts: {
      /** Get connected X Ads account info for the authenticated user.
      Returns connection status and available ad accounts.
      Queries X API directly to get accurate list of accounts. */
      path: '/api/external/bigdipper/{pk}/team/x-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetGetXAdAccountsQuery
      },
      responseType: {} as XAdsAccountResponse,
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"Team subscription is not active",
    },
    delete_search_history: {
      /** Delete the user's search history from BigDipperSearch objects. */
      path: '/api/external/bigdipper/{pk}/user-search-history/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Billing admins can only access team management endpoints"|"Could not extract team id from path"|"NOT_A_MEMBER"|"SEARCH_HISTORY_NOT_FOUND"|"Team subscription is not active",
    },
  },
  StandaloneCampaignCalculator: {
    create: {
      /** Standalone campaign calculator */
      path: '/api/external/campaign-calculator/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCampaignCalculatorInput
      },
      responseType: {} as StandaloneCampaignCalculator,
      errors: {} as never,
    },
  },
  StandaloneCampaignCreate: {
    create: {
      path: '/api/external/campaign-create/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCampaignCreateInput
      },
      responseType: {} as StandaloneCampaignCreate,
      errors: {} as never,
    },
    extract_parameters: {
      path: '/api/external/campaign-create/extract-parameters/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCampaignExtractParametersInput
      },
      responseType: {} as StandaloneCampaignExtractParameters,
      errors: {} as never,
    },
  },
  StandAloneCampaignOption: {
    list: {
      path: '/api/external/campaign-options/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandAloneCampaignOptionListQuery
      },
      responseType: {} as StandAloneCampaignOption[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/campaign-options/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandAloneCampaignOptionInstanceQuery
      },
      responseType: {} as StandAloneCampaignOption,
      errors: {} as never,
    },
  },
  StandaloneCheckAgencyAdAccount: {
    list: {
      path: '/api/external/check-agency-ad-account/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneCheckAgencyAdAccountListQuery
      },
      responseType: {} as StandaloneCheckAgencyAdAccount[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/check-agency-ad-account/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneCheckAgencyAdAccountInstanceQuery
      },
      responseType: {} as StandaloneCheckAgencyAdAccount,
      errors: {} as never,
    },
  },
  StandaloneCheckCustomAudiences: {
    create: {
      path: '/api/external/check-custom-audiences/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCheckCustomAudiencesInput
      },
      responseType: {} as StandaloneCheckCustomAudiences,
      errors: {} as never,
    },
  },
  StandAloneCompetitorAnalysis: {
    create: {
      /** Standalone get competitor analysis of handles */
      path: '/api/external/competitor-analysis/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneCompetitorAnalysisInput
      },
      responseType: {} as StandAloneCompetitorAnalysis,
      errors: {} as never,
    },
    account_topics: {
      /** Standalone topics for accounts for xprotargeting.com */
      path: '/api/external/competitor-analysis/account-topics/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAccountTopicsInput
      },
      responseType: {} as StandaloneAccountTopics,
      errors: {} as never,
    },
    suggest_competitors: {
      /** Standalone suggest competitors for account for xprotargeting.com */
      path: '/api/external/competitor-analysis/suggest-competitors/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCompetitorAnalysisSuggestCompetitorsInput
      },
      responseType: {} as StandaloneCompetitorAnalysisSuggestCompetitors,
      errors: {} as never,
    },
  },
  StandAloneComputeAgeGroups: {
    create: {
      /** Standalone get age groups of accounts */
      path: '/api/external/compute-age-groups/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneComputeAgeGroupsInput
      },
      responseType: {} as StandAloneComputeAgeGroups,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandaloneConfigGenerateExploreInsights: {
    create: {
      /** Standalone create Explore Insights for Audience Configs */
      path: '/api/external/config-explore-insights/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneConfigGenerateExploreInsightsInput
      },
      responseType: {} as StandaloneConfigGenerateExploreInsights,
      errors: {} as never,
    },
  },
  ContentAuthorities: {
    query: {
      /** Posts matching a keyword set across X / Bluesky / Instagram / OpenAlex, with their authors.
      CONTENT-first: it matches post TEXT and reports who wrote it, where the authority-index
      endpoints rank accounts. One dock call, no post-processing. */
      path: '/api/external/content-authorities/query/',
      method: 'POST',
      paramsType: {} as {
        body: ContentAuthoritiesQueryInput
      },
      responseType: {} as ContentAuthoritiesQuery,
      errors: {} as never,
    },
  },
  StandaloneConversationTopics: {
    list: {
      path: '/api/external/conversation-topics/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneConversationTopic[],
      errors: {} as never,
    },
    search: {
      path: '/api/external/conversation-topics/search/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSearchConversationTopicsInput
      },
      responseType: {} as StandaloneSearchConversationTopics,
      errors: {} as never,
    },
  },
  StandAloneCreateExclusionAudience: {
    create: {
      path: '/api/external/create-exclusion-audience/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneCreateExclusionAudienceInput
      },
      responseType: {} as StandAloneCreateExclusionAudience,
      errors: {} as never,
    },
  },
  DeepThoughtToken: {
    analyse_spam: {
      /** analyse handle endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/analyse-spam/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyseSpamQuery
      },
      responseType: {} as DeepThoughtAnalyseSpam,
      errors: {} as never,
    },
    extract_account_ranks: {
      /** extract ranks endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/extract-ranks/',
      method: 'GET',
      paramsType: {} as {
        query?: GetExtractAccountRanksQuery
      },
      responseType: {} as DeepThoughtExtractAccountRanks,
      errors: {} as never,
    },
    followers_token: {
      /** followers endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/followers-token/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFollowersTokenQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: DeepThoughtAccount[]
      },
      errors: {} as never,
    },
    following_token: {
      /** following endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/following-token/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFollowingTokenQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: DeepThoughtAccount[]
      },
      errors: {} as never,
    },
    predict_payout_based_on_engagements_token: {
      /** get prediction based on engagements for xdeepthought extension */
      path: '/api/external/deepthought-token/predict-payout-based-on-engagements-token/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPredictPayoutBasedOnEngagementsTokenQuery
      },
      responseType: {} as DeepThoughtPredictPayoutBasedOnEngagements,
      errors: {} as never,
    },
    unfollowers_token: {
      /** recent unfollowers endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/unfollowers-token/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUnfollowersTokenQuery
      },
      responseType: {} as DeepThoughtFollowerOverlap,
      errors: {} as never,
    },
    verified_followers: {
      /** verified-followers endpoint for xdeepthought.com */
      path: '/api/external/deepthought-token/verified-followers/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtVerifiedFollowersInput
      },
      responseType: {} as DeepThoughtVerifiedFollowers,
      errors: {} as never,
    },
    who_to_follow: {
      /** who-to-follow endpoint for xdeepthought extension */
      path: '/api/external/deepthought-token/who-to-follow/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtWhoToFollowInput
      },
      responseType: {} as DeepThoughtWhoToFollow,
      errors: {} as never,
    },
  },
  DeepThought: {
    account_stats: {
      /** accounts-stats endpoint for xdeepthought.com */
      path: '/api/external/deepthought/accounts-stats/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtAccountStats,
      errors: {} as "This endpoint is currently paused.",
    },
    add_members_to_list: {
      /** Add members to a list */
      path: '/api/external/deepthought/add-members-to-list/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtListMemberInput
      },
      responseType: {} as DeepThoughtListMember,
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    analyse_spam: {
      /** analyse handle endpoint for xdeepthought extension */
      path: '/api/external/deepthought/analyse-spam/',
      method: 'GET',
      paramsType: {} as {
        query?: GetAnalyseSpamQuery
      },
      responseType: {} as DeepThoughtAnalyseSpam,
      errors: {} as "This endpoint is currently paused.",
    },
    best_post_time: {
      /** endpoints for xdeepthought.com */
      path: '/api/external/deepthought/best-post-time/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtBestPostTimeInput
      },
      responseType: {} as DeepThoughtBestPostTime,
      errors: {} as "This endpoint is currently paused.",
    },
    cancel_subscription: {
      /** Cancels the user's Stripe subscription */
      path: '/api/external/deepthought/cancel-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: SubscriptionCancelInput
      },
      responseType: {} as SubscriptionCancel,
      errors: {} as "This endpoint is currently paused.",
    },
    create_list: {
      /** Create a new list for the user */
      path: '/api/external/deepthought/create-list/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtListInput
      },
      responseType: {} as DeepThoughtList,
      errors: {} as "Failed to create list."|"Insufficient permission"|"This endpoint is currently paused.",
    },
    create_referral: {
      /** Create a referral between two users */
      path: '/api/external/deepthought/create-referral/',
      method: 'POST',
      paramsType: {} as {
        body: ReferralCreateInput
      },
      responseType: {} as ReferralCreate,
      errors: {} as "This endpoint is currently paused.",
    },
    create_subscription: {
      /** Creates a Stripe checkout session for subscription */
      path: '/api/external/deepthought/create-subscription/',
      method: 'POST',
      paramsType: {} as {
        body: SubscriptionCreateInput
      },
      responseType: {} as SubscriptionCreate,
      errors: {} as "This endpoint is currently paused.",
    },
    engagers: {
      /** enagers endpoint for xdeepthought.com */
      path: '/api/external/deepthought/engagers/',
      method: 'GET',
      paramsType: {} as {
        query?: GetEngagersQuery
      },
      responseType: {} as DeepThoughtEngagers,
      errors: {} as "This endpoint is currently paused.",
    },
    enrichment_accounts: {
      /** enrichment accounts endpoint for xdeepthought.com */
      path: '/api/external/deepthought/enrichment-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtEnrichmentAccountsInput
      },
      responseType: {} as DeepThoughtEnrichmentAccounts,
      errors: {} as "This endpoint is currently paused.",
    },
    enrichment_followers: {
      /** enrichment of my followers endpoint for xdeepthought.com */
      path: '/api/external/deepthought/enrichment-followers/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtEnrichedAccountMany,
      errors: {} as "This endpoint is currently paused.",
    },
    enrichments: {
      /** enrichments endpoint for xdeepthought.com */
      path: '/api/external/deepthought/enrichments/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtEnrichmentsInput
      },
      responseType: {} as DeepThoughtEnrichments,
      errors: {} as "This endpoint is currently paused.",
    },
    extract_account_ranks: {
      /** extract ranks endpoint for xdeepthought extension */
      path: '/api/external/deepthought/extract-ranks/',
      method: 'GET',
      paramsType: {} as {
        query?: GetExtractAccountRanksQuery
      },
      responseType: {} as DeepThoughtExtractAccountRanks,
      errors: {} as "This endpoint is currently paused.",
    },
    fetch_interests: {
      /** endpoints for xdeepthought.com */
      path: '/api/external/deepthought/fetch-interests/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchInterestsQuery
      },
      responseType: {} as DeepThoughtFetchInterests,
      errors: {} as "This endpoint is currently paused.",
    },
    fetch_timeline: {
      /** Fetch timeline endpoint for xdeepthought extension */
      path: '/api/external/deepthought/fetch-timeline/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchTimelineQuery
      },
      responseType: {} as DeepThoughtFetchTimeline,
      errors: {} as "This endpoint is currently paused.",
    },
    follow_account: {
      /** follow account endpoint for xdeepthought.com */
      path: '/api/external/deepthought/follow-account/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtFollowAccountInput
      },
      responseType: {} as DeepThoughtFollowAccount,
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    follower_intersection: {
      /** follower-intersection endpoint for xdeepthought.com */
      path: '/api/external/deepthought/follower-intersection/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtFollowerIntersectionInput
      },
      responseType: {} as DeepThoughtFollowerIntersection,
      errors: {} as "This endpoint is currently paused.",
    },
    follower_overlap: {
      /** follower-overlap endpoint for xdeepthought.com */
      path: '/api/external/deepthought/follower-overlap/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtFollowerOverlap,
      errors: {} as "This endpoint is currently paused.",
    },
    followers_bot_percentage: {
      /** followers bot percentage for xdeepthought.com */
      path: '/api/external/deepthought/followers-bot-percentage/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtBotPercentageInput
      },
      responseType: {} as DeepThoughtBotPercentage,
      errors: {} as "This endpoint is currently paused.",
    },
    followers: {
      /** followers endpoint for xdeepthought.com */
      path: '/api/external/deepthought/followers/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFollowersQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: DeepThoughtAccount[]
      },
      errors: {} as "This endpoint is currently paused.",
    },
    following: {
      /** following endpoint for xdeepthought.com */
      path: '/api/external/deepthought/following/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFollowingQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: DeepThoughtAccount[]
      },
      errors: {} as "This endpoint is currently paused.",
    },
    lists: {
      /** Lists ther user's lists */
      path: '/api/external/deepthought/lists/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtList[],
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    me: {
      /** me endpoint for xdeepthought.com */
      path: '/api/external/deepthought/me/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtAccount,
      errors: {} as "This endpoint is currently paused.",
    },
    payout_actual: {
      /** payout-actual endpoint for xdeepthought.com */
      path: '/api/external/deepthought/payout-actual/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtPayoutActualInput
      },
      responseType: {} as DeepThoughtPayoutActual,
      errors: {} as "This endpoint is currently paused.",
    },
    payout_predictor: {
      /** payout-predictor endpoint for xdeepthought.com */
      path: '/api/external/deepthought/payout-predictor/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtPayoutPredictor,
      errors: {} as "This endpoint is currently paused.",
    },
    get_posts_account: {
      /** endpoints for xdeepthought.com */
      path: '/api/external/deepthought/posts-account/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtPostsAccountInput
      },
      responseType: {} as DeepThoughtPostsAccount,
      errors: {} as "This endpoint is currently paused.",
    },
    posts_and_likes: {
      /** posts-and-likes endpoint for xdeepthought.com */
      path: '/api/external/deepthought/posts-and-likes/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPostsAndLikesQuery
      },
      responseType: {} as DeepThoughtPostsAndLikes,
      errors: {} as "This endpoint is currently paused.",
    },
    predict_payout_based_on_engagements: {
      /** get prediction based on engagements for xdeepthought.com */
      path: '/api/external/deepthought/predict-payout-based-on-engagements/',
      method: 'GET',
      paramsType: {} as {
        query?: GetPredictPayoutBasedOnEngagementsQuery
      },
      responseType: {} as DeepThoughtPredictPayoutBasedOnEngagements,
      errors: {} as "This endpoint is currently paused.",
    },
    predict_post_performance: {
      /** endpoints for xdeepthought.com */
      path: '/api/external/deepthought/predict-post-performance/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtPredictPostPerformanceInput
      },
      responseType: {} as DeepThoughtPredictPostPerformance,
      errors: {} as "This endpoint is currently paused.",
    },
    recently_joined: {
      /** recently joined account check for xdeepthought.com */
      path: '/api/external/deepthought/recently-joined/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtAccountRecentlyJoined,
      errors: {} as "This endpoint is currently paused.",
    },
    remove_members_from_list: {
      /** Remove members from a list */
      path: '/api/external/deepthought/remove-members-from-list/',
      method: 'DELETE',
      paramsType: {} as {},
      responseType: {} as {},
      errors: {} as "Failed to delete member(s) from list."|"Insufficient permission"|"This endpoint is currently paused.",
    },
    search_notifications: {
      /** analyse handle endpoint for xdeepthought extension */
      path: '/api/external/deepthought/search-notifications/',
      method: 'GET',
      paramsType: {} as {
        query?: GetSearchNotificationsQuery
      },
      responseType: {} as DeepThoughtSearchNotifications,
      errors: {} as "This endpoint is currently paused.",
    },
    user_subscription: {
      /** Retrieve or update the user's subscription info */
      path: '/api/external/deepthought/subscription-info/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as UserSubscription,
      errors: {} as "This endpoint is currently paused.",
    },
    user_subscription_patch: {
      /** Retrieve or update the user's subscription info */
      path: '/api/external/deepthought/subscription-info/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<UserSubscriptionInput>
      },
      responseType: {} as UserSubscription,
      errors: {} as "This endpoint is currently paused.",
    },
    talk_to_x_questions: {
      /** Get summary and follow up questions for Talk to X */
      path: '/api/external/deepthought/talk-to-x-questions/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtQuestions,
      errors: {} as "This endpoint is currently paused.",
    },
    talk_to_x: {
      /** Talk to X endpoint for xdeepthought.com, logic in serializer */
      path: '/api/external/deepthought/talk-to-x/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtTalkToXInput
      },
      responseType: {} as DeepThoughtTalkToX,
      errors: {} as "This endpoint is currently paused.",
    },
    top_countries: {
      /** top-countries endpoint for xdeepthought.com */
      path: '/api/external/deepthought/top-countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtCountries,
      errors: {} as "This endpoint is currently paused.",
    },
    unfollow_account_bulk: {
      /** unfollow account in bulk endpoint for xdeepthought.com */
      path: '/api/external/deepthought/unfollow-account-bulk/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtUnfollowAccountBulkInput
      },
      responseType: {} as DeepThoughtUnfollowAccountBulk,
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    unfollow_account: {
      /** unfollow account endpoint for xdeepthought.com */
      path: '/api/external/deepthought/unfollow-account/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtFollowAccountInput
      },
      responseType: {} as DeepThoughtFollowAccount,
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    unfollowers: {
      /** recent unfollowers endpoint for xdeepthought.com */
      path: '/api/external/deepthought/unfollowers/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUnfollowersQuery
      },
      responseType: {} as DeepThoughtFollowerOverlap,
      errors: {} as "This endpoint is currently paused.",
    },
    update_user: {
      /** extract ranks endpoint for xdeepthought extension */
      path: '/api/external/deepthought/update-user/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtInputHandleInput
      },
      responseType: {} as DeepThoughtInputHandle,
      errors: {} as "This endpoint is currently paused.",
    },
    verified_followers: {
      /** verified-followers endpoint for xdeepthought.com */
      path: '/api/external/deepthought/verified-followers/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtVerifiedFollowersInput
      },
      responseType: {} as DeepThoughtVerifiedFollowers,
      errors: {} as "This endpoint is currently paused.",
    },
    who_to_follow: {
      /** who-to-follow endpoint for xdeepthought.com */
      path: '/api/external/deepthought/who-to-follow/',
      method: 'POST',
      paramsType: {} as {
        body: DeepThoughtWhoToFollowInput
      },
      responseType: {} as DeepThoughtWhoToFollow,
      errors: {} as "This endpoint is currently paused.",
    },
    x_stats_countries: {
      /** x-stats-countries endpoint for xdeepthought.com */
      path: '/api/external/deepthought/x-stats-countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtXStatsCountryActivity,
      errors: {} as "This endpoint is currently paused.",
    },
    x_stats: {
      /** x-stats endpoint for xdeepthought.com */
      path: '/api/external/deepthought/x-stats/',
      method: 'GET',
      paramsType: {} as {
        query?: GetXStatsQuery
      },
      responseType: {} as DeepThoughtXStats,
      errors: {} as "This endpoint is currently paused.",
    },
    delete_list: {
      /** Delete a list */
      path: '/api/external/deepthought/{pk}/delete-list/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Failed to delete list."|"Insufficient permission"|"This endpoint is currently paused.",
    },
    list_members: {
      /** Lists list members */
      path: '/api/external/deepthought/{pk}/list-members/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as DeepThoughtAccount[],
      errors: {} as "Insufficient permission"|"This endpoint is currently paused.",
    },
    post_engagements: {
      /** get post engagements endpoint for xdeepthought.com */
      path: '/api/external/deepthought/{pk}/post-engagements/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetPostEngagementsQuery
      },
      responseType: {} as DeepThoughtPostEngagement,
      errors: {} as "This endpoint is currently paused.",
    },
    report: {
      /** report endpoint for xdeepthought.com */
      path: '/api/external/deepthought/{pk}/report/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as DeepThoughtReport,
      errors: {} as "This endpoint is currently paused.",
    },
    update_list: {
      /** Update a list */
      path: '/api/external/deepthought/{pk}/update-list/',
      method: 'PUT',
      paramsType: {} as {
        body: DeepThoughtUpdateListInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as DeepThoughtUpdateList,
      errors: {} as "Failed to update list."|"Insufficient permission"|"This endpoint is currently paused.",
    },
  },
  StandaloneEvent: {
    list: {
      path: '/api/external/events/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as EventSocialdatabase[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/events/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as EventSocialdatabase,
      errors: {} as never,
    },
  },
  StandaloneExploreClusters: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-clusters/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreClustersInput
      },
      responseType: {} as StandaloneExploreClusters,
      errors: {} as never,
    },
  },
  StandaloneCompareAccounts: {
    create: {
      path: '/api/external/explore-compare-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCompareAccountsInput
      },
      responseType: {} as StandaloneCompareAccounts,
      errors: {} as never,
    },
  },
  StandAloneExploreExtractCreators: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-creators/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreExtractCreatorsInput
      },
      responseType: {} as StandAloneExploreExtractCreators,
      errors: {} as never,
    },
    classifier_children: {
      /** Standalone classifier children for insights */
      path: '/api/external/explore-creators/classifier-children/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneCreatorClassifierChildrenInput
      },
      responseType: {} as StandaloneCreatorClassifierChildren,
      errors: {} as never,
    },
  },
  StandAloneExploreDemographics: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-demographics/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreDemographicsInput
      },
      responseType: {} as StandAloneExploreDemographics,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandaloneExploreEmailAdAccounts: {
    list: {
      path: '/api/external/explore-email-ad-accounts/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneExploreEmailAdAccountsListQuery
      },
      responseType: {} as StandaloneExploreEmailAdAccounts[],
      errors: {} as never,
    },
    create: {
      path: '/api/external/explore-email-ad-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreEmailAdAccountsInput
      },
      responseType: {} as StandaloneExploreEmailAdAccounts,
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/explore-email-ad-accounts/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneExploreEmailAdAccountsInstanceQuery
      },
      responseType: {} as StandaloneExploreEmailAdAccounts,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/external/explore-email-ad-accounts/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneExploreEmailAdAccountsInput>
        path: {
          pk: string|number
        }
        query?: PatchStandaloneExploreEmailAdAccountsInstanceQuery
      },
      responseType: {} as StandaloneExploreEmailAdAccounts,
      errors: {} as never,
    },
    update: {
      path: '/api/external/explore-email-ad-accounts/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneExploreEmailAdAccountsInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneExploreEmailAdAccountsInstanceQuery
      },
      responseType: {} as StandaloneExploreEmailAdAccounts,
      errors: {} as never,
    },
  },
  StandAloneExploreEnrichments: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-enrichments/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreEnrichmentsInput
      },
      responseType: {} as StandAloneExploreEnrichments,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandaloneExploreExtractDataHandles: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-extract-data-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreExtractDataHandlesInput
      },
      responseType: {} as StandaloneExploreExtractDataHandles,
      errors: {} as "No audience found"|"Unfortnately, we cannot process your request. We couldn't process the inputted handle(s), because it does not exist or it may be that the user is 'protected' on X.",
    },
  },
  StandaloneExploreExtractDataKeywords: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-extract-data-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreExtractDataKeywordsInput
      },
      responseType: {} as StandaloneExploreExtractDataKeywords,
      errors: {} as never,
    },
  },
  StandaloneExploreExtractDataTweetKeywords: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-extract-data-tweet-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreExtractDataTweetKeywordsInput
      },
      responseType: {} as StandaloneExploreExtractDataTweetKeywords,
      errors: {} as never,
    },
  },
  StandalonePostMetadataHandle: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-extract-post-metadata-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandalonePostMetadataHandleInput
      },
      responseType: {} as StandalonePostMetadataHandle,
      errors: {} as never,
    },
  },
  StandaloneFetchTimeline: {
    fetch_timeline: {
      /** Fetch timeline endpoint for xdeepthought extension */
      path: '/api/external/explore-fetch-timeline/fetch-timeline/',
      method: 'GET',
      paramsType: {} as {
        query?: GetFetchTimelineQuery
      },
      responseType: {} as DeepThoughtFetchTimeline,
      errors: {} as never,
    },
  },
  StandAloneExploreFollowerGrowth: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-follower-growth/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreFollowerGrowthInput
      },
      responseType: {} as StandAloneExploreFollowerGrowth,
      errors: {} as never,
    },
  },
  StandaloneExploreExtractPostDataHandles: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-post-data-handles/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreExtractPostDataHandlesInput
      },
      responseType: {} as StandaloneExploreExtractPostDataHandles,
      errors: {} as never,
    },
  },
  StandAloneExplorePostsData: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-post-data/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExplorePostsDataInput
      },
      responseType: {} as StandAloneExplorePostsData,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandaloneExploreSearch: {
    list: {
      path: '/api/external/explore-searches/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneExploreSearchListQuery
      },
      responseType: {} as StandaloneExploreSearch[],
      errors: {} as never,
    },
    create: {
      path: '/api/external/explore-searches/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneExploreSearchInput
      },
      responseType: {} as StandaloneExploreSearch,
      errors: {} as never,
    },
    destroy: {
      path: '/api/external/explore-searches/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: DeleteStandaloneExploreSearchInstanceQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/explore-searches/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneExploreSearchInstanceQuery
      },
      responseType: {} as StandaloneExploreSearch,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/external/explore-searches/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<StandaloneExploreSearchInput>
        path: {
          pk: string|number
        }
        query?: PatchStandaloneExploreSearchInstanceQuery
      },
      responseType: {} as StandaloneExploreSearch,
      errors: {} as never,
    },
    update: {
      path: '/api/external/explore-searches/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: StandaloneExploreSearchInput
        path: {
          pk: string|number
        }
        query?: PutStandaloneExploreSearchInstanceQuery
      },
      responseType: {} as StandaloneExploreSearch,
      errors: {} as never,
    },
  },
  StandAloneExploreExtractSEOKeywords: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-seo-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreExtractSEOKeywordsInput
      },
      responseType: {} as StandAloneExploreExtractSEOKeywords,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandaloneFindRelatedAudiencesClassifier: {
    create: {
      path: '/api/external/explore-similar-audiences-classifier/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFindRelatedAudiencesClassifierInput
      },
      responseType: {} as StandaloneFindRelatedAudiencesClassifier,
      errors: {} as never,
    },
  },
  StandaloneFindRelatedAudiences: {
    create: {
      path: '/api/external/explore-similar-audiences/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneFindRelatedAudiencesInput
      },
      responseType: {} as StandaloneFindRelatedAudiences,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandAloneExploreTopAccounts: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-top-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreTopAccountsInput
      },
      responseType: {} as StandAloneExploreTopAccounts,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandAloneExploreTopFollowers: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-top-followers/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreTopFollowersInput
      },
      responseType: {} as StandAloneExploreTopFollowers,
      errors: {} as never,
    },
  },
  StandAloneExploreTopPosts: {
    create: {
      /** Standalone Explore endpoint */
      path: '/api/external/explore-top-posts/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreTopPostsInput
      },
      responseType: {} as StandAloneExploreTopPosts,
      errors: {} as "The request could not be processed, please try again later.",
    },
  },
  StandAloneExtractExclusionSample: {
    create: {
      path: '/api/external/extract-exclusion-sample/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExtractExclusionSampleInput
      },
      responseType: {} as StandAloneExtractExclusionSample,
      errors: {} as never,
    },
  },
  FetchContentAuthorities: {
    query: {
      /** The content OF a known set of authorities, optionally narrowed by keywords and dates.
      The inverse of ContentAuthoritiesViewSet: there keywords select and the result tells you who is
      talking; here `sdus` select and keywords are an optional narrowing. One dock call. */
      path: '/api/external/fetch-content-authorities/query/',
      method: 'POST',
      paramsType: {} as {
        body: FetchContentAuthoritiesQueryInput
      },
      responseType: {} as FetchContentAuthoritiesQuery,
      errors: {} as never,
    },
  },
  StandaloneNativePackGenerator: {
    create: {
      /** Standalone create for audience requests */
      path: '/api/external/generate-native-pack/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneNativePackGeneratorInput
      },
      responseType: {} as StandaloneNativePackGenerator,
      errors: {} as "Brand safety"|"Failed to process request"|"No audience found"|"No input found",
    },
  },
  StandaloneImageDownloader: {
    download_image_unique_name: {
      path: '/api/external/image-downloader/download_image_unique_name/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDownloadImageUniqueNameQuery
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  StandaloneInterests: {
    list: {
      path: '/api/external/interests/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneInterest[],
      errors: {} as never,
    },
    search: {
      path: '/api/external/interests/search/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSearchInterestsInput
      },
      responseType: {} as StandaloneSearchInterests,
      errors: {} as never,
    },
  },
  StandAloneJobTitlesSizeEstimator: {
    create: {
      /** Standalone create for audience requests */
      path: '/api/external/job-title-size-estimator/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneJobTitlesSizeEstimatorInput
      },
      responseType: {} as StandAloneJobTitlesSizeEstimator,
      errors: {} as never,
    },
  },
  StandaloneJobTitleTargeting: {
    create: {
      /** Standalone viewset for job title targeting */
      path: '/api/external/job-title-targeting/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneJobTitleTargetingInput
      },
      responseType: {} as StandaloneJobTitleTargeting,
      errors: {} as never,
    },
  },
  StandaloneAutopilotKeywordSuggestionUsage: {
    create: {
      path: '/api/external/keyword-suggestion-usages/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneAutopilotKeywordSuggestionUsageManyInput
      },
      responseType: {} as StandaloneAutopilotKeywordSuggestionUsageMany,
      errors: {} as never,
    },
  },
  StandaloneLanguages: {
    list: {
      path: '/api/external/languages/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneLanguage[],
      errors: {} as never,
    },
  },
  StandaloneTargetingLocations: {
    list: {
      path: '/api/external/locations/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneTargetingLocationsListQuery
      },
      responseType: {} as StandaloneTargetingLocation[],
      errors: {} as never,
    },
    search: {
      path: '/api/external/locations/search/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSearchTargetingLocationsInput
      },
      responseType: {} as StandaloneSearchTargetingLocations,
      errors: {} as never,
    },
  },
  StandaloneMarketingMaterial: {
    list: {
      path: '/api/external/marketing-materials/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as MarketingMaterialList[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/marketing-materials/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as MarketingMaterialList,
      errors: {} as never,
    },
    download: {
      path: '/api/external/marketing-materials/{pk}/download/',
      method: 'POST',
      paramsType: {} as {
        body: MarketingMaterialInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as MarketingMaterial,
      errors: {} as never,
    },
  },
  StandaloneMonitor: {
    list: {
      path: '/api/external/monitors/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneMonitorListQuery
      },
      responseType: {} as StandaloneMonitor[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/monitors/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneMonitorInstanceQuery
      },
      responseType: {} as StandaloneMonitor,
      errors: {} as never,
    },
  },
  StandaloneMoviesTvShows: {
    list: {
      path: '/api/external/movies-tv-shows/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneMoviesTvShows[],
      errors: {} as never,
    },
    search: {
      path: '/api/external/movies-tv-shows/search/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSearchMoviesTvShowsInput
      },
      responseType: {} as StandaloneSearchMoviesTvShows,
      errors: {} as never,
    },
  },
  StandaloneNetworkOperators: {
    list: {
      path: '/api/external/network-operators/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneNetworkOperator[],
      errors: {} as never,
    },
    search: {
      path: '/api/external/network-operators/search/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneSearchNetworkOperatorsInput
      },
      responseType: {} as StandaloneSearchNetworkOperators,
      errors: {} as never,
    },
  },
  StandalonePersona: {
    create_signed: {
      /** Standalone Persona endpoint */
      path: '/api/external/persona/create-signed/',
      method: 'POST',
      paramsType: {} as {
        body: StandalonePersonaTokenInput
      },
      responseType: {} as StandalonePersonaToken,
      errors: {} as never,
    },
    verify_signed: {
      /** Standalone Persona endpoint */
      path: '/api/external/persona/verify-signed/',
      method: 'GET',
      paramsType: {} as {
        query?: GetVerifySignedQuery
      },
      responseType: {} as StandaloneExploreQueryAnalyzer,
      errors: {} as "Too many requests. Please try again later.",
    },
  },
  StandaloneMagicLoginLink: {
    magic: {
      path: '/api/external/personal-magic-link/magic/',
      method: 'GET',
      paramsType: {} as {
        query?: GetMagicQuery
      },
      responseType: {} as CreateMagicLoginLink,
      errors: {} as never,
    },
    use: {
      path: '/api/external/personal-magic-link/use/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUseQuery
      },
      responseType: {} as UseMagicLoginLink,
      errors: {} as never,
    },
  },
  StandAlonePostsAccount: {
    create: {
      /** Standalone get posts of account */
      path: '/api/external/posts-account/',
      method: 'POST',
      paramsType: {} as {
        body: StandAlonePostsAccountInput
      },
      responseType: {} as StandAlonePostsAccount,
      errors: {} as never,
    },
  },
  StandAloneXplorePostsSentimentAnalysis: {
    create: {
      path: '/api/external/posts-sentiment-analysis/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneXplorePostsSentimentAnalysisInput
      },
      responseType: {} as StandAloneXplorePostsSentimentAnalysis,
      errors: {} as never,
    },
  },
  PulseFindingQuery: {
    query: {
      /** Return all PulseFinding rows matching a topic + title query. */
      path: '/api/external/pulse-finding/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseFindingQueryInput
      },
      responseType: {} as PulseFindingQuery,
      errors: {} as never,
    },
  },
  PulseKeywordContent: {
    query: {
      /** The actual Bluesky posts, OpenAlex works and X tweets behind a set of keywords. */
      path: '/api/external/pulse-keyword-content/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseKeywordContentInput
      },
      responseType: {} as PulseKeywordContent,
      errors: {} as never,
    },
  },
  PulseKeywordCounts: {
    query: {
      /** Monthly keyword volume across X, Bluesky and OpenAlex — no analysis, nothing persisted. */
      path: '/api/external/pulse-keyword-counts/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseKeywordCountsInput
      },
      responseType: {} as PulseKeywordCounts,
      errors: {} as never,
    },
  },
  PulseKeywordTweets: {
    query: {
      /** Tweets BY specific accounts whose text contains each keyword — earliest first, unranked. */
      path: '/api/external/pulse-keyword-tweets/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseKeywordTweetsInput
      },
      responseType: {} as PulseKeywordTweets,
      errors: {} as never,
    },
  },
  PulseNews: {
    query: {
      /** Run a fresh ad-hoc pulse_news analysis for a query and return findings grouped by category. */
      path: '/api/external/pulse-news/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseNewsQueryInput
      },
      responseType: {} as PulseNewsQuery,
      errors: {} as never,
    },
  },
  PulseRawKeywords: {
    query: {
      /** Return the raw tweets matching a set of keywords — no analysis. */
      path: '/api/external/pulse-raw-keywords/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseRawKeywordsInput
      },
      responseType: {} as PulseRawKeywords,
      errors: {} as never,
    },
  },
  PulseRawSdus: {
    query: {
      /** Return the raw recent posts (tweets + YouTube videos) for a set of sdus — no analysis. */
      path: '/api/external/pulse-raw-sdus/query/',
      method: 'POST',
      paramsType: {} as {
        body: PulseRawSdusInput
      },
      responseType: {} as PulseRawSdus,
      errors: {} as never,
    },
  },
  PulseTerm: {
    get_terms: {
      /** Return trending terms for a given topic, ordered by rank. */
      path: '/api/external/pulse-term/terms/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as PulseTerm,
      errors: {} as never,
    },
  },
  PulseTopic: {
    get_topic: {
      /** Return a PulseTopic with all findings (grouped by category) and trending terms. */
      path: '/api/external/pulse-topic/topic/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as PulseTopic,
      errors: {} as never,
    },
  },
  PulseTopicsList: {
    get_topics: {
      /** Return the distinct topic strings available in PulseTopic. */
      path: '/api/external/pulse-topics/list/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as PulseTopicsListItem,
      errors: {} as never,
    },
  },
  PulseUpdateSdus: {
    run: {
      /** Dispatch update_sdus_data_task: only refresh collector data (tweets + YouTube videos) for a
      set of sdus — no analysis. */
      path: '/api/external/pulse-update-sdus/run/',
      method: 'POST',
      paramsType: {} as {
        body: PulseUpdateSdusInput
      },
      responseType: {} as PulseUpdateSdus,
      errors: {} as never,
    },
  },
  PulseViaKeywords: {
    run: {
      /** Dispatch run_pulse_via_keywords: fire a collector search per keyword to ingest the latest
      matching tweets — no analysis. */
      path: '/api/external/pulse-via-keywords/run/',
      method: 'POST',
      paramsType: {} as {
        body: PulseViaKeywordsInput
      },
      responseType: {} as PulseViaKeywords,
      errors: {} as never,
    },
  },
  PulseViaSdus: {
    run: {
      /** Dispatch a pulse_via_sdus_task: refresh content for a set of sdus, then build a digest. */
      path: '/api/external/pulse-via-sdus/run/',
      method: 'POST',
      paramsType: {} as {
        body: PulseViaSdusQueryInput
      },
      responseType: {} as PulseViaSdusQuery,
      errors: {} as never,
    },
  },
  StandaloneRecentlyCreatedAudiences: {
    list: {
      path: '/api/external/recent-audiences/',
      method: 'GET',
      paramsType: {} as {
        query?: GetStandaloneRecentlyCreatedAudiencesListQuery
      },
      responseType: {} as StandaloneRecentlyCreatedAudiences[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/external/recent-audiences/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetStandaloneRecentlyCreatedAudiencesInstanceQuery
      },
      responseType: {} as StandaloneRecentlyCreatedAudiences,
      errors: {} as never,
    },
  },
  RefreshContent: {
    run: {
      /** Dispatch the collector's refresh_content task for a single sdu — pulls the latest content for
      that account. Fire-and-forget; returns the task id. */
      path: '/api/external/refresh-content/run/',
      method: 'POST',
      paramsType: {} as {
        body: RefreshContentInput
      },
      responseType: {} as RefreshContent,
      errors: {} as never,
    },
  },
  StandaloneRelatedKeywords: {
    create: {
      path: '/api/external/related-keywords/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneRelatedKeywordsInput
      },
      responseType: {} as StandaloneRelatedKeywords,
      errors: {} as never,
    },
  },
  StandaloneMe: {
    standalone_me: {
      path: '/api/external/standalone-me/standalone_me/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as StandaloneMe,
      errors: {} as never,
    },
  },
  StandaloneTopicAccounts: {
    create: {
      /** Standalone get accounts of topic */
      path: '/api/external/topic-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneTopicAccountsInput
      },
      responseType: {} as StandaloneTopicAccounts,
      errors: {} as never,
    },
  },
  StandAloneUploadAudience: {
    create: {
      path: '/api/external/upload-audience/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneUploadAudienceInput
      },
      responseType: {} as StandAloneUploadAudience,
      errors: {} as "No ad account found",
    },
  },
  StandaloneUserActivityEntry: {
    create: {
      path: '/api/external/user-activity-entry/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneUserActivityEntryInput
      },
      responseType: {} as StandaloneUserActivityEntry,
      errors: {} as never,
    },
  },
  WebSearchV2: {
    query: {
      /** Ranked pages AND papers from dock's own crawled corpus, with the sdus that linked them.
      A different source from WebSearchViewSet, not a newer one: that endpoint starts from posts on
      five platforms and follows their links outward, this searches what is already crawled and
      indexed, across two arms — pages and papers — interleaved, with `source` on each row saying
      which produced it.
      Takes a `question` (required) plus four optional filters; see WebSearchV2QuerySerializer. The
      result being thin usually means the subject was never crawled rather than that ranking failed,
      and `query.arms` is what tells those apart — per-arm, where a null `candidates` means that arm
      FAILED rather than matched nothing.
      Returns no authors map: a row's `sdus` are the bare ids of the accounts that linked to it. */
      path: '/api/external/web-search-v2/query/',
      method: 'POST',
      paramsType: {} as {
        body: WebSearchV2QueryInput
      },
      responseType: {} as WebSearchV2Query,
      errors: {} as never,
    },
  },
  WebSearch: {
    query: {
      /** Ranked WEB PAGES for a question, with the authorities who shared them.
      The page-level counterpart to ContentAuthoritiesViewSet: that one returns the POSTS matching a
      keyword set, this one follows the links those posts point at, reads the pages and ranks them. So
      the unit of the result is a page, with its sharers attached.
      Takes EXACTLY ONE of `question` (a model turns it into keyword groups) or `keywords` (the groups
      directly). SLOW BY DESIGN — 10-20s is normal and uncached; `read=false` drops the page-fetching
      half. See WebSearchQuerySerializer. */
      path: '/api/external/web-search/query/',
      method: 'POST',
      paramsType: {} as {
        body: WebSearchQueryInput
      },
      responseType: {} as WebSearchQuery,
      errors: {} as never,
    },
  },
  StandAloneExtractWeeklyResultsMonitor: {
    create: {
      path: '/api/external/weekly-results-monitor/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneMonitorExtractWeeklyResultsInput
      },
      responseType: {} as StandaloneMonitorExtractWeeklyResults,
      errors: {} as never,
    },
  },
  StandaloneXConversation: {
    create: {
      /** Standalone get conversation */
      path: '/api/external/x-conversations/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXConversationInput
      },
      responseType: {} as StandaloneXConversation,
      errors: {} as never,
    },
  },
  StandAlonePostActivity: {
    create: {
      /** Standalone get conversation */
      path: '/api/external/x-post-activity/',
      method: 'POST',
      paramsType: {} as {
        body: StandAlonePostActivityInput
      },
      responseType: {} as StandAlonePostActivity,
      errors: {} as never,
    },
  },
  StandAloneExploreSentimentAnalysis: {
    create: {
      /** Standalone get sentiment analysis */
      path: '/api/external/x-sentiment-analysis/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneExploreSentimentAnalysisInput
      },
      responseType: {} as StandAloneExploreSentimentAnalysis,
      errors: {} as never,
    },
  },
  StandAloneGenerateShareOfVoiceAliases: {
    create: {
      /** Standalone get conversation */
      path: '/api/external/x-share-of-voice-aliases/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneGenerateShareOfVoiceAliasesInput
      },
      responseType: {} as StandAloneGenerateShareOfVoiceAliases,
      errors: {} as never,
    },
  },
  StandAloneGenerateShareOfVoiceKeywords: {
    create: {
      /** Standalone get conversation */
      path: '/api/external/x-share-of-voice/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneGenerateShareOfVoiceKeywordsInput
      },
      responseType: {} as StandAloneGenerateShareOfVoiceKeywords,
      errors: {} as never,
    },
  },
  StandaloneXStats: {
    trending_topics: {
      /** x-stats trending topics endpoint for xprotaregting.com */
      path: '/api/external/x-stats/trending-topics/',
      method: 'GET',
      paramsType: {} as {
        query?: GetTrendingTopicsQuery
      },
      responseType: {} as DeepThoughtXStatsTrend,
      errors: {} as never,
    },
    x_stats_countries: {
      /** x-stats-countries endpoint for xprotargeting.com */
      path: '/api/external/x-stats/x-stats-countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as DeepThoughtXStatsCountryActivity,
      errors: {} as never,
    },
    x_stats: {
      /** x-stats endpoint for xprotaregting.com */
      path: '/api/external/x-stats/x-stats/',
      method: 'GET',
      paramsType: {} as {
        query?: GetXStatsQuery
      },
      responseType: {} as DeepThoughtXStats,
      errors: {} as never,
    },
  },
  StandaloneXploreDetailTrends: {
    create: {
      path: '/api/external/xplore-detail-trends/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXploreDetailTrendsInput
      },
      responseType: {} as StandaloneXploreDetailTrends,
      errors: {} as never,
    },
  },
  StandAloneXploreDetail: {
    create: {
      path: '/api/external/xplore-detail/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXploreDetailInput
      },
      responseType: {} as StandaloneXploreDetail,
      errors: {} as "Topic not published",
    },
  },
  StandAloneXplorePostsSentiment: {
    create: {
      path: '/api/external/xplore-posts-sentiment/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneXplorePostsSentimentInput
      },
      responseType: {} as StandAloneXplorePostsSentiment,
      errors: {} as never,
    },
  },
  StandAloneXplorePostsStartEnd: {
    create: {
      path: '/api/external/xplore-posts-start-end/',
      method: 'POST',
      paramsType: {} as {
        body: StandAloneXplorePostsStartEndInput
      },
      responseType: {} as StandAloneXplorePostsStartEnd,
      errors: {} as never,
    },
  },
  StandAloneXplore: {
    create: {
      path: '/api/external/xplore/',
      method: 'POST',
      paramsType: {} as {
        body: StandaloneXploreInput
      },
      responseType: {} as StandaloneXplore,
      errors: {} as never,
    },
  },
  GeoLocationUser: {
    geo_location: {
      path: '/api/geo-location/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as GeoLocation,
      errors: {} as never,
    },
  },
  CheckHasPixel: {
    has_pixel: {
      path: '/api/has-pixel/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {},
      errors: {} as never,
    },
  },
  HelperDocuments: {
    list: {
      path: '/api/helper-documents/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as HelperDocuments[],
      errors: {} as never,
    },
    download: {
      path: '/api/helper-documents/download/',
      method: 'GET',
      paramsType: {} as {
        query?: GetDownloadQuery
      },
      responseType: {} as HelperDocumentsDownload,
      errors: {} as "File not found",
    },
    retrieve: {
      path: '/api/helper-documents/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as HelperDocuments,
      errors: {} as never,
    },
  },
  IconoGraphy: {
    list: {
      path: '/api/iconography/',
      method: 'GET',
      paramsType: {} as {
        query?: GetIconoGraphyListQuery
      },
      responseType: {} as Iconography[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/iconography/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetIconoGraphyInstanceQuery
      },
      responseType: {} as Iconography,
      errors: {} as never,
    },
  },
  Icon: {
    list: {
      path: '/api/icons/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as Icon[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/icons/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as Icon,
      errors: {} as never,
    },
  },
  InsightsInfluencer: {
    list: {
      path: '/api/insights-influencer/',
      method: 'GET',
      paramsType: {} as {
        query?: GetInsightsInfluencerListQuery
      },
      responseType: {} as {
        count: number
        next: string
        previous: string
        results: InsightsInfluencer[]
      },
      errors: {} as never,
    },
    retrieve: {
      path: '/api/insights-influencer/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
        query?: GetInsightsInfluencerInstanceQuery
      },
      responseType: {} as InsightsInfluencer,
      errors: {} as never,
    },
  },
  ProTargetingSummaryPDF: {
    create: {
      path: '/api/insights-pro-targeting-summary/',
      method: 'POST',
      paramsType: {} as {
        body: CreateProTargetingPdfInput
      },
      responseType: {} as CreateProTargetingPdf,
      errors: {} as never,
    },
  },
  InsightsSummaryPDF: {
    create: {
      path: '/api/insights-summary/',
      method: 'POST',
      paramsType: {} as {
        body: CreateInsightsPdfInput
      },
      responseType: {} as CreateInsightsPdf,
      errors: {} as never,
    },
  },
  JobTitles: {
    list: {
      path: '/api/job-titles/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as JobTitle[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/job-titles/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as JobTitle,
      errors: {} as never,
    },
  },
  Metrics: {
    list: {
      /** Meta information about available campaign metrics */
      path: '/api/metrics/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as MetricInfo[],
      errors: {} as never,
    },
  },
  ResetE2E: {
    mock: {
      path: '/api/reset-e2e/mock/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as E2E,
      errors: {} as never,
    },
  },
  TypescriptSchemaView: {
    list: {
      path: '/api/schema/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
  },
  TargetingCountries: {
    list: {
      /** Targeting countries list */
      path: '/api/targeting-countries/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TargetingCountries[],
      errors: {} as never,
    },
  },
  TargetingInterests: {
    list: {
      /** Targeting interests list */
      path: '/api/targeting-interests/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TargetingInterests[],
      errors: {} as never,
    },
  },
  TargetingLocations: {
    list: {
      /** Targeting cities list */
      path: '/api/targeting-locations/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TargetingLocations[],
      errors: {} as never,
    },
  },
  TeamPublic: {
    retrieve: {
      /** Used to show public name/picture on login page for team */
      path: '/api/teaminfo/{slug}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          slug: string|number
        }
      },
      responseType: {} as TeamPublic,
      errors: {} as never,
    },
  },
  UserTeam: {
    list: {
      /** Viewset for my teams (teams). Retrieve by slug. */
      path: '/api/teams/',
      method: 'GET',
      paramsType: {} as {
        query?: GetUserTeamListQuery
      },
      responseType: {} as TeamPublic[],
      errors: {} as never,
    },
    create: {
      /** Viewset for my teams (teams). Retrieve by slug. */
      path: '/api/teams/',
      method: 'POST',
      paramsType: {} as {
        body: TeamInput
      },
      responseType: {} as Team,
      errors: {} as never,
    },
    retrieve: {
      /** Viewset for my teams (teams). Retrieve by slug. */
      path: '/api/teams/{slug}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          slug: string|number
        }
        query?: GetUserTeamInstanceQuery
      },
      responseType: {} as Team,
      errors: {} as never,
    },
    partial_update: {
      /** Viewset for my teams (teams). Retrieve by slug. */
      path: '/api/teams/{slug}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<TeamInput>
        path: {
          slug: string|number
        }
        query?: PatchUserTeamInstanceQuery
      },
      responseType: {} as Team,
      errors: {} as never,
    },
    update: {
      /** Viewset for my teams (teams). Retrieve by slug. */
      path: '/api/teams/{slug}/',
      method: 'PUT',
      paramsType: {} as {
        body: TeamInput
        path: {
          slug: string|number
        }
        query?: PutUserTeamInstanceQuery
      },
      responseType: {} as Team,
      errors: {} as never,
    },
  },
  TeamAccount: {
    list: {
      path: '/api/teams/{team_id}/accounts/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
        }
      },
      responseType: {} as AdAccount[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/teams/{team_id}/accounts/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
          pk: string|number
        }
      },
      responseType: {} as AdAccount,
      errors: {} as never,
    },
  },
  TeamInvite: {
    list: {
      path: '/api/teams/{team_id}/invites/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
        }
      },
      responseType: {} as TeamInvite[],
      errors: {} as never,
    },
    create: {
      path: '/api/teams/{team_id}/invites/',
      method: 'POST',
      paramsType: {} as {
        body: TeamInviteInput
        path: {
          team_id: string|number
        }
      },
      responseType: {} as TeamInvite,
      errors: {} as never,
    },
    accept: {
      path: '/api/teams/{team_id}/invites/accept/',
      method: 'POST',
      paramsType: {} as {
        body: InviteAcceptInput
        path: {
          team_id: string|number
        }
      },
      responseType: {} as InviteAccept,
      errors: {} as never,
    },
    retrieve: {
      path: '/api/teams/{team_id}/invites/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
          pk: string|number
        }
      },
      responseType: {} as TeamInvite,
      errors: {} as never,
    },
  },
  TeamMember: {
    list: {
      path: '/api/teams/{team_id}/members/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
        }
      },
      responseType: {} as TeamMember[],
      errors: {} as never,
    },
    retrieve: {
      path: '/api/teams/{team_id}/members/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          team_id: string|number
          pk: string|number
        }
      },
      responseType: {} as TeamMember,
      errors: {} as never,
    },
  },
  UploadedAudience: {
    create: {
      path: '/api/uploaded-audiences/',
      method: 'POST',
      paramsType: {} as {
        body: UploadedAudiencesInput
      },
      responseType: {} as UploadedAudiences,
      errors: {} as never,
    },
    destroy: {
      path: '/api/uploaded-audiences/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  UserAdAccount: {
    list: {
      /** List user ad accounts */
      path: '/api/user/accounts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as UserAdAccount[],
      errors: {} as never,
    },
    retrieve: {
      /** List user ad accounts */
      path: '/api/user/accounts/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as UserAdAccount,
      errors: {} as never,
    },
  },
  FollowUnfollow: {
    create: {
      path: '/api/user/follow-unfollow/',
      method: 'POST',
      paramsType: {} as {
        body: FollowUnfollowInput
      },
      responseType: {} as FollowUnfollow,
      errors: {} as never,
    },
  },
  GrantedAdAccount: {
    list: {
      /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
      path: '/api/user/granted-accounts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as GrantedAccount[],
      errors: {} as never,
    },
    create: {
      /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
      path: '/api/user/granted-accounts/',
      method: 'POST',
      paramsType: {} as {
        body: GrantedAccountInput
      },
      responseType: {} as GrantedAccount,
      errors: {} as "Member object does not belong to current user",
    },
    destroy: {
      /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
      path: '/api/user/granted-accounts/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as "Member object does not belong to current user",
    },
    retrieve: {
      /** List/Create/Delete (aka Grant/revoke) access to ad accounts through team memberships */
      path: '/api/user/granted-accounts/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as GrantedAccount,
      errors: {} as never,
    },
  },
  TwitterLists: {
    list: {
      path: '/api/user/lists/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TwitterList[],
      errors: {} as never,
    },
    create: {
      path: '/api/user/lists/',
      method: 'POST',
      paramsType: {} as {
        body: TwitterListInput
      },
      responseType: {} as TwitterList,
      errors: {} as never,
    },
    destroy: {
      path: '/api/user/lists/{pk}/',
      method: 'DELETE',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as {},
      errors: {} as never,
    },
    retrieve: {
      path: '/api/user/lists/{pk}/',
      method: 'GET',
      paramsType: {} as {
        path: {
          pk: string|number
        }
      },
      responseType: {} as TwitterList,
      errors: {} as never,
    },
    partial_update: {
      path: '/api/user/lists/{pk}/',
      method: 'PATCH',
      paramsType: {} as {
        body: Partial<TwitterListInput>
        path: {
          pk: string|number
        }
      },
      responseType: {} as TwitterList,
      errors: {} as never,
    },
    update: {
      path: '/api/user/lists/{pk}/',
      method: 'PUT',
      paramsType: {} as {
        body: TwitterListInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TwitterList,
      errors: {} as never,
    },
    members: {
      path: '/api/user/lists/{pk}/members/',
      method: 'POST',
      paramsType: {} as {
        body: TwitterListsMembersInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as TwitterListsMembers,
      errors: {} as never,
    },
  },
  MagicLoginLink: {
    create: {
      path: '/api/user/magic-link/',
      method: 'POST',
      paramsType: {} as {
        body: CreateMagicLoginLinkInput
      },
      responseType: {} as CreateMagicLoginLink,
      errors: {} as never,
    },
    use: {
      path: '/api/user/magic-link/use/',
      method: 'POST',
      paramsType: {} as {
        body: UseMagicLoginLinkInput
      },
      responseType: {} as UseMagicLoginLink2,
      errors: {} as never,
    },
  },
  User: {
    me: {
      /** Update user profile (name, etc) */
      path: '/api/user/me/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as User,
      errors: {} as never,
    },
    me_put: {
      /** Update user profile (name, etc) */
      path: '/api/user/me/',
      method: 'PUT',
      paramsType: {} as {
        body: UserInput
      },
      responseType: {} as User,
      errors: {} as never,
    },
  },
  WebEvents: {
    list: {
      /** Account web events list */
      path: '/api/web-events/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as WebEvents[],
      errors: {} as never,
    },
  },
  TwitterWebhookView: {
    list: {
      path: '/api/webhook/twitter/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
    post: {
      path: '/api/webhook/twitter/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  LoginViaToken: {
    create: {
      path: '/rest-auth/login-via-token/',
      method: 'POST',
      paramsType: {} as {
        body: LoginViaTokenInput
      },
      responseType: {} as LoginViaToken,
      errors: {} as "Invalid token",
    },
  },
  LogoutView: {
    list: {
      /** Calls Django logout method and delete the Token object
      assigned to the current User object.
      Accepts/Returns nothing. */
      path: '/rest-auth/logout/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as {}[],
      errors: {} as never,
    },
    post: {
      /** Calls Django logout method and delete the Token object
      assigned to the current User object.
      Accepts/Returns nothing. */
      path: '/rest-auth/logout/',
      method: 'POST',
      paramsType: {} as {
        body: {}
      },
      responseType: {} as {},
      errors: {} as never,
    },
  },
  SocialAccountListView: {
    list: {
      /** List SocialAccounts for the currently logged in user */
      path: '/rest-auth/socialaccounts/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as SocialAccount2[],
      errors: {} as never,
    },
  },
  SocialAccountDisconnectView: {
    post: {
      /** Disconnect SocialAccount from remote service for
      the currently logged in user */
      path: '/rest-auth/socialaccounts/{pk}/disconnect/',
      method: 'POST',
      paramsType: {} as {
        body: SocialConnectInput
        path: {
          pk: string|number
        }
      },
      responseType: {} as SocialConnect,
      errors: {} as never,
    },
  },
  TwitterLogin: {
    post: {
      path: '/rest-auth/twitter/',
      method: 'POST',
      paramsType: {} as {
        body: TwitterLoginInput
      },
      responseType: {} as TwitterLogin,
      errors: {} as never,
    },
  },
  TwitterAccessTokenView: {
    get: {
      /** Receives Twitter redirect
      Requests access token
      Returns token to be used on TwitterConnect/TwitterLogin */
      path: '/rest-auth/twitter/access_token/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TwitterAccessToken,
      errors: {} as never,
    },
  },
  TwitterConnect: {
    post: {
      path: '/rest-auth/twitter/connect/',
      method: 'POST',
      paramsType: {} as {
        body: TwitterConnectInput
      },
      responseType: {} as TwitterConnect,
      errors: {} as never,
    },
  },
  TwitterRequestTokenView: {
    get: {
      /** Receives oauth_callback
      Requests request token
      Returns oauth_token which is need to redirect to Twitter */
      path: '/rest-auth/twitter/request_token/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TwitterRequestToken,
      errors: {} as never,
    },
  },
  TwitterOauth2Login: {
    post: {
      path: '/rest-auth/twitter_oauth2/',
      method: 'POST',
      paramsType: {} as {
        body: MyLoginInput
      },
      responseType: {} as MyLogin,
      errors: {} as never,
    },
  },
  TwitterCodeChallenge: {
    code_challenge: {
      path: '/rest-auth/twitter_oauth2_challenge/code-challenge/',
      method: 'GET',
      paramsType: {} as {},
      responseType: {} as TwitterAuthParams,
      errors: {} as never,
    },
  },
} as const
